//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    isTenantAvailable(input: IsTenantAvailableInput | null | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    register(input: RegisterInput | null | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resetPasswordRequest(input: ResetPasswordRequestInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPasswordRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetPasswordRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resetPassword(input: ResetPasswordInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAddressDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAddressDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @param cityId (optional) 
     * @param authorizationId (optional) 
     * @return Success
     */
    getUserUnAssignedAddresses(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, userId: number | null | undefined, cityId: number | null | undefined, authorizationId: number | null | undefined): Observable<PagedResultDtoOfAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/GetUserUnAssignedAddresses?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (cityId !== undefined && cityId !== null)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (authorizationId !== undefined && authorizationId !== null)
            url_ += "authorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedAddresses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAddressDto>;
        }));
    }

    protected processGetUserUnAssignedAddresses(response: HttpResponseBase): Observable<PagedResultDtoOfAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAddressDto>(null as any);
    }

    /**
     * @param cityId (optional) 
     * @param categoryIds (optional) 
     * @return Success
     */
    getListBy(cityId: number | null | undefined, categoryIds: number[] | null | undefined): Observable<AddressDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/GetListBy?";
        if (cityId !== undefined && cityId !== null)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (categoryIds !== undefined && categoryIds !== null)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListBy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListBy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressDto[]>;
        }));
    }

    protected processGetListBy(response: HttpResponseBase): Observable<AddressDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AddressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressDto[]>(null as any);
    }

    /**
     * @param address (optional) 
     * @param cityId (optional) 
     * @return Success
     */
    checkSimilarityAddresses(address: AddressSimilarityDto | null | undefined, cityId: number | null | undefined): Observable<AddressSimilarityResultDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/CheckSimilarityAddresses?";
        if (cityId !== undefined && cityId !== null)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(address);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckSimilarityAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSimilarityAddresses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressSimilarityResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressSimilarityResultDto[]>;
        }));
    }

    protected processCheckSimilarityAddresses(response: HttpResponseBase): Observable<AddressSimilarityResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AddressSimilarityResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressSimilarityResultDto[]>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    generateCustomerAddressDraftExcel(customerId: number | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/GenerateCustomerAddressDraftExcel?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateCustomerAddressDraftExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCustomerAddressDraftExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcelFileResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcelFileResultDto>;
        }));
    }

    protected processGenerateCustomerAddressDraftExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    uploadCustomerAddressExcel(input: CustomerAddressExcelUploadDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/UploadCustomerAddressExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCustomerAddressExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCustomerAddressExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadCustomerAddressExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<AddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateAddressDto | null | undefined): Observable<AddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: AddressDto | null | undefined): Observable<AddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AdminToolsTranspopPortalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param orderDetailId (optional) 
     * @return Success
     */
    orderQueueManualSync(orderDetailId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AdminToolsTranspopPortal/OrderQueueManualSync?";
        if (orderDetailId !== undefined && orderDetailId !== null)
            url_ += "orderDetailId=" + encodeURIComponent("" + orderDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderQueueManualSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderQueueManualSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderQueueManualSync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    logTest(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AdminToolsTranspopPortal/LogTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AIPlatomServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    openAISqlQueryGenerate(input: PlatomAIInputDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/platom/portal/AIPlatom/OpenAISqlQueryGenerate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenAISqlQueryGenerate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenAISqlQueryGenerate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOpenAISqlQueryGenerate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getAITraingModels(): Observable<PlatomAITrainModelDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/AIPlatom/GetAITraingModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAITraingModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAITraingModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlatomAITrainModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlatomAITrainModelDto[]>;
        }));
    }

    protected processGetAITraingModels(response: HttpResponseBase): Observable<PlatomAITrainModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PlatomAITrainModelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlatomAITrainModelDto[]>(null as any);
    }

    /**
     * @param modelId (optional) 
     * @param userPrompt (optional) 
     * @return Success
     */
    getAIResponse(modelId: string | null | undefined, userPrompt: string | null | undefined): Observable<PlatomAIResponseDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/AIPlatom/GetAIResponse?";
        if (modelId !== undefined && modelId !== null)
            url_ += "modelId=" + encodeURIComponent("" + modelId) + "&";
        if (userPrompt !== undefined && userPrompt !== null)
            url_ += "userPrompt=" + encodeURIComponent("" + userPrompt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAIResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAIResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlatomAIResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlatomAIResponseDto>;
        }));
    }

    protected processGetAIResponse(response: HttpResponseBase): Observable<PlatomAIResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlatomAIResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlatomAIResponseDto>(null as any);
    }
}

@Injectable()
export class AuthorizationTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AuthorizationType/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuthorizationDomainAuthTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAuthorizationDomainAuthTypeDto>(null as any);
    }

    /**
     * @param table (optional) 
     * @return Success
     */
    getAuthorizationsByTable(table: Table | null | undefined): Observable<AuthorizationDomainAuthTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AuthorizationType/GetAuthorizationsByTable?";
        if (table !== undefined && table !== null)
            url_ += "table=" + encodeURIComponent("" + table) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorizationsByTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorizationsByTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorizationDomainAuthTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorizationDomainAuthTypeDto[]>;
        }));
    }

    protected processGetAuthorizationsByTable(response: HttpResponseBase): Observable<AuthorizationDomainAuthTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuthorizationDomainAuthTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthorizationDomainAuthTypeDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getUserUnAssignedAuthorizations(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, userId: number | null | undefined): Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AuthorizationType/GetUserUnAssignedAuthorizations?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedAuthorizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedAuthorizations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto>;
        }));
    }

    protected processGetUserUnAssignedAuthorizations(response: HttpResponseBase): Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuthorizationDomainAuthTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAuthorizationDomainAuthTypeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<AuthorizationDomainAuthTypeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AuthorizationType/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorizationDomainAuthTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorizationDomainAuthTypeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AuthorizationDomainAuthTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizationDomainAuthTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthorizationDomainAuthTypeDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateAuthorizationTypeDto | null | undefined): Observable<AuthorizationDomainAuthTypeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AuthorizationType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorizationDomainAuthTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorizationDomainAuthTypeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AuthorizationDomainAuthTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizationDomainAuthTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthorizationDomainAuthTypeDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: AuthorizationDomainAuthTypeDto | null | undefined): Observable<AuthorizationDomainAuthTypeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AuthorizationType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorizationDomainAuthTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorizationDomainAuthTypeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AuthorizationDomainAuthTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizationDomainAuthTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthorizationDomainAuthTypeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AuthorizationType/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param categoryType (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, categoryType: CategoryType | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCategoryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Category/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (categoryType !== undefined && categoryType !== null)
            url_ += "CategoryType=" + encodeURIComponent("" + categoryType) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCategoryDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCategoryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<CategoryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Category/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateCategoryDto | null | undefined): Observable<CategoryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Category/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: CategoryDto | null | undefined): Observable<CategoryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Category/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Category/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCityDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/City/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCityDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfCityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCityDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @param authorizationId (optional) 
     * @param exceptTurkey (optional) 
     * @return Success
     */
    getUserUnAssignedCities(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, userId: number | null | undefined, authorizationId: number | null | undefined, exceptTurkey: boolean | null | undefined): Observable<PagedResultDtoOfCityDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/City/GetUserUnAssignedCities?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (authorizationId !== undefined && authorizationId !== null)
            url_ += "authorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        if (exceptTurkey !== undefined && exceptTurkey !== null)
            url_ += "exceptTurkey=" + encodeURIComponent("" + exceptTurkey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedCities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCityDto>;
        }));
    }

    protected processGetUserUnAssignedCities(response: HttpResponseBase): Observable<PagedResultDtoOfCityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCityDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<CityDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/City/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CityDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateCityDto | null | undefined): Observable<CityDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/City/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CityDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: CityDto | null | undefined): Observable<CityDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/City/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CityDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/City/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeUiTheme(input: ChangeUiThemeInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param excludedCustomerIds (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, excludedCustomerIds: number[] | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (excludedCustomerIds !== undefined && excludedCustomerIds !== null)
            excludedCustomerIds && excludedCustomerIds.forEach(item => { url_ += "ExcludedCustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCustomerDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCustomerDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateCustomerDto | null | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: CustomerDto | null | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getProductUsagePurposeTypesByCustomer(customerId: number | null | undefined): Observable<SelectListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetProductUsagePurposeTypesByCustomer?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductUsagePurposeTypesByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductUsagePurposeTypesByCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectListItemDto[]>;
        }));
    }

    protected processGetProductUsagePurposeTypesByCustomer(response: HttpResponseBase): Observable<SelectListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SelectListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectListItemDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param excludedCustomerIds (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForExcel(keyword: string | null | undefined, sorting: string | null | undefined, excludedCustomerIds: number[] | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<ExcelPagedResultDtoOfCustomerExcelDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetAllForExcel?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (excludedCustomerIds !== undefined && excludedCustomerIds !== null)
            excludedCustomerIds && excludedCustomerIds.forEach(item => { url_ += "ExcludedCustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcelPagedResultDtoOfCustomerExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcelPagedResultDtoOfCustomerExcelDto>;
        }));
    }

    protected processGetAllForExcel(response: HttpResponseBase): Observable<ExcelPagedResultDtoOfCustomerExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelPagedResultDtoOfCustomerExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelPagedResultDtoOfCustomerExcelDto>(null as any);
    }

    /**
     * @param selectedItem (optional) 
     * @return Success
     */
    getCustomerComboboxItems(selectedItem: number | null | undefined): Observable<ListResultDtoOfComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetCustomerComboboxItems?";
        if (selectedItem !== undefined && selectedItem !== null)
            url_ += "selectedItem=" + encodeURIComponent("" + selectedItem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfComboboxItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfComboboxItemDto>;
        }));
    }

    protected processGetCustomerComboboxItems(response: HttpResponseBase): Observable<ListResultDtoOfComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfComboboxItemDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param excludedCustomerIds (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getUserUnAssignedCustomer(keyword: string | null | undefined, sorting: string | null | undefined, excludedCustomerIds: number[] | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, userId: number | null | undefined): Observable<PagedResultDtoOfCustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetUserUnAssignedCustomer?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (excludedCustomerIds !== undefined && excludedCustomerIds !== null)
            excludedCustomerIds && excludedCustomerIds.forEach(item => { url_ += "ExcludedCustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCustomerDto>;
        }));
    }

    protected processGetUserUnAssignedCustomer(response: HttpResponseBase): Observable<PagedResultDtoOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCustomerDto>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getWarehousesByCustomer(customerId: number | null | undefined): Observable<CustomerWarehouseListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetWarehousesByCustomer?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehousesByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehousesByCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerWarehouseListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerWarehouseListDto[]>;
        }));
    }

    protected processGetWarehousesByCustomer(response: HttpResponseBase): Observable<CustomerWarehouseListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerWarehouseListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerWarehouseListDto[]>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getPersonInCharges(customerId: number | null | undefined): Observable<CustomerPersonOfChargeDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetPersonInCharges?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonInCharges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonInCharges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerPersonOfChargeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerPersonOfChargeDto[]>;
        }));
    }

    protected processGetPersonInCharges(response: HttpResponseBase): Observable<CustomerPersonOfChargeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerPersonOfChargeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerPersonOfChargeDto[]>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getCustomerUsers(customerId: number | null | undefined): Observable<CustomerUserListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetCustomerUsers?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerUserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerUserListDto[]>;
        }));
    }

    protected processGetCustomerUsers(response: HttpResponseBase): Observable<CustomerUserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerUserListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerUserListDto[]>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getCustomerWarehouseInfo(customerId: number | null | undefined): Observable<CustomerWarehouseInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetCustomerWarehouseInfo?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerWarehouseInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerWarehouseInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerWarehouseInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerWarehouseInfoDto[]>;
        }));
    }

    protected processGetCustomerWarehouseInfo(response: HttpResponseBase): Observable<CustomerWarehouseInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerWarehouseInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerWarehouseInfoDto[]>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param warehouse (optional) 
     * @return Success
     */
    createOrUpdateCustomerWarehouse(customerId: number | null | undefined, warehouse: CustomerWarehouseAssignedDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/CreateOrUpdateCustomerWarehouse?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(warehouse);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCustomerWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCustomerWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateCustomerWarehouse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param customerWarehouseId (optional) 
     * @return Success
     */
    deleteCustomerWarehouse(customerWarehouseId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/DeleteCustomerWarehouse?";
        if (customerWarehouseId !== undefined && customerWarehouseId !== null)
            url_ += "customerWarehouseId=" + encodeURIComponent("" + customerWarehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomerWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomerWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCustomerWarehouse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CustomerMpoiServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @return Success
     */
    getMpoiDatas(): Observable<CustomerMpoiDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/CustomerMpoi/GetMpoiDatas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMpoiDatas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMpoiDatas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerMpoiDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerMpoiDto[]>;
        }));
    }

    protected processGetMpoiDatas(response: HttpResponseBase): Observable<CustomerMpoiDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerMpoiDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerMpoiDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getUserProjects(): Observable<UserProjectsDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/CustomerMpoi/GetUserProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectsDto[]>;
        }));
    }

    protected processGetUserProjects(response: HttpResponseBase): Observable<UserProjectsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserProjectsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProjectsDto[]>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param data (optional) 
     * @return Success
     */
    createExcel(fileName: string | null | undefined, data: CustomerMpoiDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/CustomerMpoi/CreateExcel?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CustomerProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @return Success
     */
    getUserProjects(): Observable<UserProjectsDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/CustomerProduct/GetUserProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectsDto[]>;
        }));
    }

    protected processGetUserProjects(response: HttpResponseBase): Observable<UserProjectsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserProjectsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProjectsDto[]>(null as any);
    }

    /**
     * @param inputProjectId (optional) 
     * @return Success
     */
    getAll(inputProjectId: string | null | undefined): Observable<CustomerProductDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/CustomerProduct/GetAll?";
        if (inputProjectId !== undefined && inputProjectId !== null)
            url_ += "inputProjectId=" + encodeURIComponent("" + inputProjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerProductDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomerProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerProductDto[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateCustomerProductDto | null | undefined): Observable<CustomerProductDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/CustomerProduct/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerProductDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomerProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerProductDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateCustomerProductDto | null | undefined): Observable<CustomerProductDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/CustomerProduct/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerProductDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomerProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerProductDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/CustomerProduct/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getKategoriTypes(): Observable<KategoriTypesDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/CustomerProduct/GetKategoriTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKategoriTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKategoriTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KategoriTypesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KategoriTypesDto[]>;
        }));
    }

    protected processGetKategoriTypes(response: HttpResponseBase): Observable<KategoriTypesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(KategoriTypesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<KategoriTypesDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getUrunTypes(): Observable<UrunTypesDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/CustomerProduct/GetUrunTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUrunTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUrunTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UrunTypesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UrunTypesDto[]>;
        }));
    }

    protected processGetUrunTypes(response: HttpResponseBase): Observable<UrunTypesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UrunTypesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UrunTypesDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getCustomers(): Observable<CustomersDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/CustomerProduct/GetCustomers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomersDto[]>;
        }));
    }

    protected processGetCustomers(response: HttpResponseBase): Observable<CustomersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomersDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomersDto[]>(null as any);
    }
}

@Injectable()
export class CustomerThemeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param customerId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, customerId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCustomerThemeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/CustomerTheme/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCustomerThemeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCustomerThemeDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfCustomerThemeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCustomerThemeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCustomerThemeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<CustomerThemeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/CustomerTheme/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerThemeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerThemeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerThemeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerThemeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerThemeDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateCustomerThemeDto | null | undefined): Observable<CustomerThemeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/CustomerTheme/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerThemeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerThemeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomerThemeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerThemeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerThemeDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateCustomerThemeDto | null | undefined): Observable<CustomerThemeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/CustomerTheme/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerThemeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerThemeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomerThemeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerThemeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerThemeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/CustomerTheme/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getCustomerThemeLogoSizes(): Observable<CustomerThemeSizeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/CustomerTheme/GetCustomerThemeLogoSizes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerThemeLogoSizes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerThemeLogoSizes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerThemeSizeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerThemeSizeDto>;
        }));
    }

    protected processGetCustomerThemeLogoSizes(response: HttpResponseBase): Observable<CustomerThemeSizeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerThemeSizeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerThemeSizeDto>(null as any);
    }
}

@Injectable()
export class DeliveryConfirmServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfDeliveryConfirmDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/DeliveryConfirm/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDeliveryConfirmDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDeliveryConfirmDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfDeliveryConfirmDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDeliveryConfirmDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfDeliveryConfirmDto>(null as any);
    }

    /**
     * @param cariHareketGuid (optional) 
     * @return Success
     */
    getDeliveryConfirmForApprove(cariHareketGuid: string | null | undefined): Observable<DeliveryConfirmDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/DeliveryConfirm/GetDeliveryConfirmForApprove?";
        if (cariHareketGuid !== undefined && cariHareketGuid !== null)
            url_ += "cariHareketGuid=" + encodeURIComponent("" + cariHareketGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryConfirmForApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryConfirmForApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryConfirmDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryConfirmDto[]>;
        }));
    }

    protected processGetDeliveryConfirmForApprove(response: HttpResponseBase): Observable<DeliveryConfirmDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DeliveryConfirmDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryConfirmDto[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateDeliveryConfirmDto | null | undefined): Observable<DeliveryConfirmDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/DeliveryConfirm/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryConfirmDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryConfirmDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DeliveryConfirmDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryConfirmDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryConfirmDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/DeliveryConfirm/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: DeliveryConfirmDto | null | undefined): Observable<DeliveryConfirmDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/DeliveryConfirm/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryConfirmDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryConfirmDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DeliveryConfirmDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryConfirmDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryConfirmDto>(null as any);
    }

    /**
     * @param inputList (optional) 
     * @return Success
     */
    updateApprovedQuantity(inputList: ApprovedQuantityDataInputDto[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/DeliveryConfirm/UpdateApprovedQuantity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateApprovedQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApprovedQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateApprovedQuantity(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<DeliveryConfirmDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/DeliveryConfirm/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryConfirmDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryConfirmDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DeliveryConfirmDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryConfirmDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryConfirmDto>(null as any);
    }
}

@Injectable()
export class DynamicFormManagementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getAllFormsByProject(projectId: string | null | undefined): Observable<DFMFormDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/DynamicFormManagement/GetAllFormsByProject?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFormsByProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFormsByProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DFMFormDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DFMFormDto[]>;
        }));
    }

    protected processGetAllFormsByProject(response: HttpResponseBase): Observable<DFMFormDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DFMFormDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DFMFormDto[]>(null as any);
    }

    /**
     * @param recordId (optional) 
     * @return Success
     */
    getForm(recordId: string | null | undefined): Observable<DFMFormDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/DynamicFormManagement/GetForm?";
        if (recordId !== undefined && recordId !== null)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DFMFormDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DFMFormDto>;
        }));
    }

    protected processGetForm(response: HttpResponseBase): Observable<DFMFormDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DFMFormDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DFMFormDto>(null as any);
    }

    /**
     * @param recordId (optional) 
     * @return Success
     */
    getFormJson(recordId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/platom/portal/DynamicFormManagement/GetFormJson?";
        if (recordId !== undefined && recordId !== null)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFormJson(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getProjectsByUserSession(): Observable<DFMProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/DynamicFormManagement/GetProjectsByUserSession";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsByUserSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsByUserSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DFMProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DFMProjectDto[]>;
        }));
    }

    protected processGetProjectsByUserSession(response: HttpResponseBase): Observable<DFMProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DFMProjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DFMProjectDto[]>(null as any);
    }
}

@Injectable()
export class DynamicFormResultServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param personelGorevId (optional) 
     * @return Success
     */
    getGorevFormSonucByPersonelGorevId(personelGorevId: string | null | undefined): Observable<DynamicFormMainResultDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/DynamicFormResult/GetGorevFormSonucByPersonelGorevId?";
        if (personelGorevId !== undefined && personelGorevId !== null)
            url_ += "personelGorevId=" + encodeURIComponent("" + personelGorevId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGorevFormSonucByPersonelGorevId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGorevFormSonucByPersonelGorevId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicFormMainResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicFormMainResultDto>;
        }));
    }

    protected processGetGorevFormSonucByPersonelGorevId(response: HttpResponseBase): Observable<DynamicFormMainResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicFormMainResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicFormMainResultDto>(null as any);
    }

    /**
     * @param gorevFormSonucId (optional) 
     * @return Success
     */
    getGorevFormSonucBySonucId(gorevFormSonucId: string | null | undefined): Observable<DynamicFormMainResultDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/DynamicFormResult/GetGorevFormSonucBySonucId?";
        if (gorevFormSonucId !== undefined && gorevFormSonucId !== null)
            url_ += "gorevFormSonucId=" + encodeURIComponent("" + gorevFormSonucId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGorevFormSonucBySonucId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGorevFormSonucBySonucId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicFormMainResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicFormMainResultDto>;
        }));
    }

    protected processGetGorevFormSonucBySonucId(response: HttpResponseBase): Observable<DynamicFormMainResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicFormMainResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicFormMainResultDto>(null as any);
    }

    /**
     * @param items (optional) 
     * @return Success
     */
    updateFormSonuclari(items: DynamicFormResultUpdateDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/DynamicFormResult/UpdateFormSonuclari";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFormSonuclari(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFormSonuclari(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFormSonuclari(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class FieldForceDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @return Success
     */
    envanterTest(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/EnvanterTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnvanterTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnvanterTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEnvanterTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getActiveEnvantePhoneAndTabletCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetActiveEnvantePhoneAndTabletCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveEnvantePhoneAndTabletCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveEnvantePhoneAndTabletCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetActiveEnvantePhoneAndTabletCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getActiveEnvanterCarCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetActiveEnvanterCarCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveEnvanterCarCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveEnvanterCarCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetActiveEnvanterCarCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getActivePersonelCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetActivePersonelCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivePersonelCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivePersonelCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetActivePersonelCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getMerchandiserCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetMerchandiserCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMerchandiserCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMerchandiserCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMerchandiserCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getNormCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetNormCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNormCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNormCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNormCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getPersonelSettedNormCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetPersonelSettedNormCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonelSettedNormCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonelSettedNormCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPersonelSettedNormCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getRegionManagerCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetRegionManagerCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionManagerCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionManagerCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetRegionManagerCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getSupervisorCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetSupervisorCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupervisorCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupervisorCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetSupervisorCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getTitlesCount(): Observable<TitleCountDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetTitlesCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitlesCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitlesCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TitleCountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TitleCountDto[]>;
        }));
    }

    protected processGetTitlesCount(response: HttpResponseBase): Observable<TitleCountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TitleCountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TitleCountDto[]>(null as any);
    }

    /**
     * @param projects (optional) 
     * @param startDate (optional) 
     * @param finishDate (optional) 
     * @return Success
     */
    getRoutePlansByProjects(projects: string[] | null | undefined, startDate: Date | null | undefined, finishDate: Date | null | undefined): Observable<RutPlanDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetRoutePlansByProjects?";
        if (projects !== undefined && projects !== null)
            projects && projects.forEach(item => { url_ += "projects=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (finishDate !== undefined && finishDate !== null)
            url_ += "finishDate=" + encodeURIComponent(finishDate ? "" + finishDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoutePlansByProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoutePlansByProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RutPlanDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RutPlanDto[]>;
        }));
    }

    protected processGetRoutePlansByProjects(response: HttpResponseBase): Observable<RutPlanDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RutPlanDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RutPlanDto[]>(null as any);
    }

    /**
     * @param routeId (optional) 
     * @return Success
     */
    getRoutePlan(routeId: string | null | undefined): Observable<RutPlanDetayDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetRoutePlan?";
        if (routeId !== undefined && routeId !== null)
            url_ += "routeId=" + encodeURIComponent("" + routeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoutePlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoutePlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RutPlanDetayDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RutPlanDetayDto[]>;
        }));
    }

    protected processGetRoutePlan(response: HttpResponseBase): Observable<RutPlanDetayDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RutPlanDetayDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RutPlanDetayDto[]>(null as any);
    }

    /**
     * @param projects (optional) 
     * @param startDate (optional) 
     * @param finishDate (optional) 
     * @return Success
     */
    getGorevSonucReport(projects: string[] | null | undefined, startDate: Date | null | undefined, finishDate: Date | null | undefined): Observable<GorevSonucReportDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetGorevSonucReport?";
        if (projects !== undefined && projects !== null)
            projects && projects.forEach(item => { url_ += "projects=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (finishDate !== undefined && finishDate !== null)
            url_ += "finishDate=" + encodeURIComponent(finishDate ? "" + finishDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGorevSonucReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGorevSonucReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GorevSonucReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GorevSonucReportDto[]>;
        }));
    }

    protected processGetGorevSonucReport(response: HttpResponseBase): Observable<GorevSonucReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GorevSonucReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GorevSonucReportDto[]>(null as any);
    }

    /**
     * @param project (optional) 
     * @param startDate (optional) 
     * @param finishDate (optional) 
     * @return Success
     */
    getRutOzet(project: string | null | undefined, startDate: Date | null | undefined, finishDate: Date | null | undefined): Observable<RutOzetDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetRutOzet?";
        if (project !== undefined && project !== null)
            url_ += "project=" + encodeURIComponent("" + project) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (finishDate !== undefined && finishDate !== null)
            url_ += "finishDate=" + encodeURIComponent(finishDate ? "" + finishDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRutOzet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRutOzet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RutOzetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RutOzetDto[]>;
        }));
    }

    protected processGetRutOzet(response: HttpResponseBase): Observable<RutOzetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RutOzetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RutOzetDto[]>(null as any);
    }

    /**
     * @param projects (optional) 
     * @param startDate (optional) 
     * @param finishDate (optional) 
     * @return Success
     */
    getDwhRutOzet(projects: string[] | null | undefined, startDate: Date | null | undefined, finishDate: Date | null | undefined): Observable<RutOzetDwhDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetDwhRutOzet?";
        if (projects !== undefined && projects !== null)
            projects && projects.forEach(item => { url_ += "projects=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (finishDate !== undefined && finishDate !== null)
            url_ += "finishDate=" + encodeURIComponent(finishDate ? "" + finishDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDwhRutOzet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDwhRutOzet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RutOzetDwhDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RutOzetDwhDto[]>;
        }));
    }

    protected processGetDwhRutOzet(response: HttpResponseBase): Observable<RutOzetDwhDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RutOzetDwhDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RutOzetDwhDto[]>(null as any);
    }

    /**
     * @param projects (optional) 
     * @param startDate (optional) 
     * @return Success
     */
    getDwhMerchDailyMapData(projects: string[] | null | undefined, startDate: Date | null | undefined): Observable<RutMerchDwhDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetDwhMerchDailyMapData?";
        if (projects !== undefined && projects !== null)
            projects && projects.forEach(item => { url_ += "projects=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDwhMerchDailyMapData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDwhMerchDailyMapData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RutMerchDwhDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RutMerchDwhDto[]>;
        }));
    }

    protected processGetDwhMerchDailyMapData(response: HttpResponseBase): Observable<RutMerchDwhDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RutMerchDwhDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RutMerchDwhDto[]>(null as any);
    }

    /**
     * @param project (optional) 
     * @param startDate (optional) 
     * @param finishDate (optional) 
     * @return Success
     */
    getRutPlanInfo(project: string | null | undefined, startDate: Date | null | undefined, finishDate: Date | null | undefined): Observable<RutOzetDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetRutPlanInfo?";
        if (project !== undefined && project !== null)
            url_ += "project=" + encodeURIComponent("" + project) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (finishDate !== undefined && finishDate !== null)
            url_ += "finishDate=" + encodeURIComponent(finishDate ? "" + finishDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRutPlanInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRutPlanInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RutOzetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RutOzetDto[]>;
        }));
    }

    protected processGetRutPlanInfo(response: HttpResponseBase): Observable<RutOzetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RutOzetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RutOzetDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getDashboardInfo(): Observable<NormSehirKategoriDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldForceDashboard/GetDashboardInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NormSehirKategoriDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NormSehirKategoriDto>;
        }));
    }

    protected processGetDashboardInfo(response: HttpResponseBase): Observable<NormSehirKategoriDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NormSehirKategoriDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NormSehirKategoriDto>(null as any);
    }
}

@Injectable()
export class FieldPhotoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param projects (optional) 
     * @param dateRange (optional) 
     * @param stores (optional) 
     * @param cities (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFieldPhotoList(keyword: string | null | undefined, sorting: string | null | undefined, projects: string[] | null | undefined, dateRange: string | null | undefined, stores: string[] | null | undefined, cities: string[] | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfFieldPhotoDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldPhoto/GetFieldPhotoList?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (projects !== undefined && projects !== null)
            projects && projects.forEach(item => { url_ += "Projects=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange !== undefined && dateRange !== null)
            url_ += "DateRange=" + encodeURIComponent("" + dateRange) + "&";
        if (stores !== undefined && stores !== null)
            stores && stores.forEach(item => { url_ += "Stores=" + encodeURIComponent("" + item) + "&"; });
        if (cities !== undefined && cities !== null)
            cities && cities.forEach(item => { url_ += "Cities=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldPhotoList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldPhotoList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfFieldPhotoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfFieldPhotoDto>;
        }));
    }

    protected processGetFieldPhotoList(response: HttpResponseBase): Observable<PagedResultDtoOfFieldPhotoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFieldPhotoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFieldPhotoDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param projects (optional) 
     * @param dateRange (optional) 
     * @param stores (optional) 
     * @param cities (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFieldPhotoIdList(keyword: string | null | undefined, sorting: string | null | undefined, projects: string[] | null | undefined, dateRange: string | null | undefined, stores: string[] | null | undefined, cities: string[] | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldPhoto/GetFieldPhotoIdList?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (projects !== undefined && projects !== null)
            projects && projects.forEach(item => { url_ += "Projects=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange !== undefined && dateRange !== null)
            url_ += "DateRange=" + encodeURIComponent("" + dateRange) + "&";
        if (stores !== undefined && stores !== null)
            stores && stores.forEach(item => { url_ += "Stores=" + encodeURIComponent("" + item) + "&"; });
        if (cities !== undefined && cities !== null)
            cities && cities.forEach(item => { url_ += "Cities=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldPhotoIdList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldPhotoIdList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetFieldPhotoIdList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param photoIdList (optional) 
     * @return Success
     */
    sendMailSelectedPhotosWithZipFormat(photoIdList: string[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldPhoto/SendMailSelectedPhotosWithZipFormat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(photoIdList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailSelectedPhotosWithZipFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailSelectedPhotosWithZipFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendMailSelectedPhotosWithZipFormat(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param formResultId (optional) 
     * @return Success
     */
    downloadSinglePhoto(formResultId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldPhoto/DownloadSinglePhoto?";
        if (formResultId !== undefined && formResultId !== null)
            url_ += "formResultId=" + encodeURIComponent("" + formResultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSinglePhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSinglePhoto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadSinglePhoto(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param filterInput (optional) 
     * @return Success
     */
    createZipPackage(filterInput: FieldPhotoFilterInputDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldPhoto/CreateZipPackage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateZipPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateZipPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateZipPackage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    zipTest(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldPhoto/ZipTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processZipTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processZipTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processZipTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    zipTest2(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/FieldPhoto/ZipTest2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processZipTest2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processZipTest2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processZipTest2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class JobScheduleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @return Success
     */
    schedulePortalV2RequestApproveTaskJob(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/JobSchedule/SchedulePortalV2RequestApproveTaskJob";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulePortalV2RequestApproveTaskJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulePortalV2RequestApproveTaskJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSchedulePortalV2RequestApproveTaskJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    scheduleLoadDeliveryConfirmData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/JobSchedule/ScheduleLoadDeliveryConfirmData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleLoadDeliveryConfirmData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleLoadDeliveryConfirmData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScheduleLoadDeliveryConfirmData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class LogisticsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param transpopCariId (optional) 
     * @return Success
     */
    addCariTranspopToPlatom(transpopCariId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Logistics/AddCariTranspopToPlatom?";
        if (transpopCariId !== undefined && transpopCariId !== null)
            url_ += "transpopCariId=" + encodeURIComponent("" + transpopCariId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCariTranspopToPlatom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCariTranspopToPlatom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddCariTranspopToPlatom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param transpopCariId (optional) 
     * @return Success
     */
    updateCariPlatomToTranspop(transpopCariId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Logistics/UpdateCariPlatomToTranspop?";
        if (transpopCariId !== undefined && transpopCariId !== null)
            url_ += "transpopCariId=" + encodeURIComponent("" + transpopCariId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCariPlatomToTranspop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCariPlatomToTranspop(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCariPlatomToTranspop(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    addPersonlMasraf(input: CreateMasrafDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Logistics/AddPersonlMasraf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPersonlMasraf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPersonlMasraf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddPersonlMasraf(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    addSatinalmaTalebi(input: CreateSatinalmaTalepDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Logistics/AddSatinalmaTalebi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSatinalmaTalebi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSatinalmaTalebi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddSatinalmaTalebi(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param satialmaTalepKodu (optional) 
     * @return Success
     */
    getSatinalmaTalepFaturaBilgileri(satialmaTalepKodu: string | null | undefined): Observable<SatinalmaTalepFaturaBilgiDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Logistics/GetSatinalmaTalepFaturaBilgileri?";
        if (satialmaTalepKodu !== undefined && satialmaTalepKodu !== null)
            url_ += "satialmaTalepKodu=" + encodeURIComponent("" + satialmaTalepKodu) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSatinalmaTalepFaturaBilgileri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSatinalmaTalepFaturaBilgileri(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SatinalmaTalepFaturaBilgiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SatinalmaTalepFaturaBilgiDto>;
        }));
    }

    protected processGetSatinalmaTalepFaturaBilgileri(response: HttpResponseBase): Observable<SatinalmaTalepFaturaBilgiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SatinalmaTalepFaturaBilgiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SatinalmaTalepFaturaBilgiDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    addPersonelMasraf(input: CreateMasrafDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Logistics/AddPersonelMasraf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPersonelMasraf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPersonelMasraf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddPersonelMasraf(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class MetabaseDynamicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getReportMetadata(reportId: number | null | undefined): Observable<ReportObjectDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabaseDynamic/GetReportMetadata?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportObjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportObjectDto>;
        }));
    }

    protected processGetReportMetadata(response: HttpResponseBase): Observable<ReportObjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportObjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportObjectDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createPlatomPortalDashboardUrl(input: ReportObjectDto | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabaseDynamic/CreatePlatomPortalDashboardUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlatomPortalDashboardUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlatomPortalDashboardUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutputDto>;
        }));
    }

    protected processCreatePlatomPortalDashboardUrl(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(null as any);
    }

    /**
     * @param targetFilterInput (optional) 
     * @return Success
     */
    loadDrildownFilterData(targetFilterInput: ReportFilterDto | null | undefined): Observable<ReportFilterDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabaseDynamic/LoadDrildownFilterData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(targetFilterInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadDrildownFilterData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadDrildownFilterData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportFilterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportFilterDto>;
        }));
    }

    protected processLoadDrildownFilterData(response: HttpResponseBase): Observable<ReportFilterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportFilterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportFilterDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    photosCreateAsZip(input: ReportObjectDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabaseDynamic/PhotosCreateAsZip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhotosCreateAsZip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhotosCreateAsZip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPhotosCreateAsZip(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param input (optional) 
     * @param title (optional) 
     * @param subtitle (optional) 
     * @return Success
     */
    photosCreateAsPPTX(input: ReportObjectDto | null | undefined, title: string | null | undefined, subtitle: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabaseDynamic/PhotosCreateAsPPTX?";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (subtitle !== undefined && subtitle !== null)
            url_ += "subtitle=" + encodeURIComponent("" + subtitle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhotosCreateAsPPTX(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhotosCreateAsPPTX(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPhotosCreateAsPPTX(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class MetabaseDynamicReportDesignServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param moduleId (optional) 
     * @return Success
     */
    getReports(moduleId: number | null | undefined): Observable<ReportObjectDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseDynamicReportDesign/GetReports?";
        if (moduleId !== undefined && moduleId !== null)
            url_ += "moduleId=" + encodeURIComponent("" + moduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportObjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportObjectDto[]>;
        }));
    }

    protected processGetReports(response: HttpResponseBase): Observable<ReportObjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportObjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportObjectDto[]>(null as any);
    }

    /**
     * @param reportModel (optional) 
     * @return Success
     */
    updateReport(reportModel: ReportObjectDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseDynamicReportDesign/UpdateReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFilterDataSource(id: number | null | undefined): Observable<ReportDataSourceDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseDynamicReportDesign/GetFilterDataSource?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilterDataSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilterDataSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDataSourceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDataSourceDto>;
        }));
    }

    protected processGetFilterDataSource(response: HttpResponseBase): Observable<ReportDataSourceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDataSourceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportDataSourceDto>(null as any);
    }

    /**
     * @param dataSourceModel (optional) 
     * @return Success
     */
    updateFilterDataSource(dataSourceModel: ReportDataSourceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseDynamicReportDesign/UpdateFilterDataSource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataSourceModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFilterDataSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFilterDataSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFilterDataSource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllDataSource(): Observable<ReportDataSourceDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseDynamicReportDesign/GetAllDataSource";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDataSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDataSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDataSourceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDataSourceDto[]>;
        }));
    }

    protected processGetAllDataSource(response: HttpResponseBase): Observable<ReportDataSourceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportDataSourceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportDataSourceDto[]>(null as any);
    }
}

@Injectable()
export class MetabasePlatomPortalFilterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @return Success
     */
    getCostMainCategories(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetCostMainCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostMainCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostMainCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetCostMainCategories(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getCostSubCategories(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetCostSubCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostSubCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostSubCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetCostSubCategories(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getCostTypes(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetCostTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetCostTypes(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getFieldPerformanceKPIs(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetFieldPerformanceKPIs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldPerformanceKPIs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldPerformanceKPIs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetFieldPerformanceKPIs(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getFieldPerformanceRegionManagers(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetFieldPerformanceRegionManagers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldPerformanceRegionManagers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldPerformanceRegionManagers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetFieldPerformanceRegionManagers(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getFieldPerformanceSupervisors(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetFieldPerformanceSupervisors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldPerformanceSupervisors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldPerformanceSupervisors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetFieldPerformanceSupervisors(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getNormTitles(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetNormTitles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNormTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNormTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetNormTitles(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPersonelAgeRanges(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetPersonelAgeRanges";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonelAgeRanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonelAgeRanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetPersonelAgeRanges(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPersonelEducations(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetPersonelEducations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonelEducations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonelEducations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetPersonelEducations(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPersonelGenders(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetPersonelGenders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonelGenders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonelGenders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetPersonelGenders(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPersonelProjectCities(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetPersonelProjectCities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonelProjectCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonelProjectCities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetPersonelProjectCities(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @param projeNames (optional) 
     * @return Success
     */
    getSupervisorList(projeNames: string[] | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetSupervisorList?";
        if (projeNames !== undefined && projeNames !== null)
            projeNames && projeNames.forEach(item => { url_ += "projeNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupervisorList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupervisorList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetSupervisorList(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPersonelProjects(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetPersonelProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonelProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonelProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetPersonelProjects(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPersonelWorkStatus(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetPersonelWorkStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonelWorkStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonelWorkStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetPersonelWorkStatus(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @param textFormat (optional) 
     * @param valueFormat (optional) 
     * @return Success
     */
    getPeriods(textFormat: string | null | undefined, valueFormat: string | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetPeriods?";
        if (textFormat !== undefined && textFormat !== null)
            url_ += "textFormat=" + encodeURIComponent("" + textFormat) + "&";
        if (valueFormat !== undefined && valueFormat !== null)
            url_ += "valueFormat=" + encodeURIComponent("" + valueFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeriods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeriods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetPeriods(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getFieldPerformanceCities(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetFieldPerformanceCities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldPerformanceCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldPerformanceCities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetFieldPerformanceCities(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getStaffTypes(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetStaffTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetStaffTypes(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getStorePerformanceSupervisors(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetStorePerformanceSupervisors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorePerformanceSupervisors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorePerformanceSupervisors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetStorePerformanceSupervisors(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getStorePerformanceCities(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetStorePerformanceCities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorePerformanceCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorePerformanceCities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetStorePerformanceCities(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPersonelInProject(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetPersonelInProject";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonelInProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonelInProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetPersonelInProject(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPersonelListHasRouteTask(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetPersonelListHasRouteTask";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonelListHasRouteTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonelListHasRouteTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetPersonelListHasRouteTask(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @param projects (optional) 
     * @return Success
     */
    getRutGorevFormList(projects: string[] | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetRutGorevFormList?";
        if (projects !== undefined && projects !== null)
            projects && projects.forEach(item => { url_ += "projects=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRutGorevFormList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRutGorevFormList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetRutGorevFormList(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @param forms (optional) 
     * @return Success
     */
    getGorevFormScreenList(forms: string[] | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetGorevFormScreenList?";
        if (forms !== undefined && forms !== null)
            forms && forms.forEach(item => { url_ += "forms=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGorevFormScreenList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGorevFormScreenList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetGorevFormScreenList(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @param forms (optional) 
     * @param screenTitles (optional) 
     * @return Success
     */
    getGorevFormQuestionList(forms: string[] | null | undefined, screenTitles: string[] | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetGorevFormQuestionList?";
        if (forms !== undefined && forms !== null)
            forms && forms.forEach(item => { url_ += "forms=" + encodeURIComponent("" + item) + "&"; });
        if (screenTitles !== undefined && screenTitles !== null)
            screenTitles && screenTitles.forEach(item => { url_ += "screenTitles=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGorevFormQuestionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGorevFormQuestionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetGorevFormQuestionList(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @param projects (optional) 
     * @param cities (optional) 
     * @return Success
     */
    getRutGorevStoreList(projects: string[] | null | undefined, cities: string[] | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetRutGorevStoreList?";
        if (projects !== undefined && projects !== null)
            projects && projects.forEach(item => { url_ += "projects=" + encodeURIComponent("" + item) + "&"; });
        if (cities !== undefined && cities !== null)
            cities && cities.forEach(item => { url_ += "cities=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRutGorevStoreList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRutGorevStoreList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetRutGorevStoreList(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @param projects (optional) 
     * @return Success
     */
    getRutGorevSehirList(projects: string[] | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetRutGorevSehirList?";
        if (projects !== undefined && projects !== null)
            projects && projects.forEach(item => { url_ += "projects=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRutGorevSehirList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRutGorevSehirList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetRutGorevSehirList(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param projectNames (optional) 
     * @return Success
     */
    getMaliyetPersonelList(startDate: string | null | undefined, endDate: string | null | undefined, projectNames: string[] | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalFilter/GetMaliyetPersonelList?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (projectNames !== undefined && projectNames !== null)
            projectNames && projectNames.forEach(item => { url_ += "projectNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaliyetPersonelList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaliyetPersonelList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetMaliyetPersonelList(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }
}

@Injectable()
export class MetabasePlatomPortalModuleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param reportId (optional) 
     * @param dashboardId (optional) 
     * @param cities (optional) 
     * @param periods (optional) 
     * @param staffTypes (optional) 
     * @return Success
     */
    getPlatomPortalDashboardFromMetabaseByFilter1(reportId: number | null | undefined, dashboardId: number | null | undefined, projects: string[], cities: string[] | null | undefined, periods: string[] | null | undefined, staffTypes: string[] | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalModule/GetPlatomPortalDashboardFromMetabaseByFilter1?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (dashboardId !== undefined && dashboardId !== null)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (projects === undefined || projects === null)
            throw new Error("The parameter 'projects' must be defined and cannot be null.");
        else
            projects && projects.forEach(item => { url_ += "Projects=" + encodeURIComponent("" + item) + "&"; });
        if (cities !== undefined && cities !== null)
            cities && cities.forEach(item => { url_ += "Cities=" + encodeURIComponent("" + item) + "&"; });
        if (periods !== undefined && periods !== null)
            periods && periods.forEach(item => { url_ += "Periods=" + encodeURIComponent("" + item) + "&"; });
        if (staffTypes !== undefined && staffTypes !== null)
            staffTypes && staffTypes.forEach(item => { url_ += "StaffTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatomPortalDashboardFromMetabaseByFilter1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatomPortalDashboardFromMetabaseByFilter1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutputDto>;
        }));
    }

    protected processGetPlatomPortalDashboardFromMetabaseByFilter1(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param dashboardId (optional) 
     * @param periods (optional) 
     * @param workStatuses (optional) 
     * @param ageRanges (optional) 
     * @param genders (optional) 
     * @param educations (optional) 
     * @param titles (optional) 
     * @return Success
     */
    getPlatomPortalDashboardFromMetabaseByFilter2(reportId: number | null | undefined, dashboardId: number | null | undefined, projects: string[], periods: string[] | null | undefined, workStatuses: string[] | null | undefined, ageRanges: string[] | null | undefined, genders: string[] | null | undefined, educations: string[] | null | undefined, titles: string[] | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalModule/GetPlatomPortalDashboardFromMetabaseByFilter2?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (dashboardId !== undefined && dashboardId !== null)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (projects === undefined || projects === null)
            throw new Error("The parameter 'projects' must be defined and cannot be null.");
        else
            projects && projects.forEach(item => { url_ += "Projects=" + encodeURIComponent("" + item) + "&"; });
        if (periods !== undefined && periods !== null)
            periods && periods.forEach(item => { url_ += "Periods=" + encodeURIComponent("" + item) + "&"; });
        if (workStatuses !== undefined && workStatuses !== null)
            workStatuses && workStatuses.forEach(item => { url_ += "WorkStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (ageRanges !== undefined && ageRanges !== null)
            ageRanges && ageRanges.forEach(item => { url_ += "AgeRanges=" + encodeURIComponent("" + item) + "&"; });
        if (genders !== undefined && genders !== null)
            genders && genders.forEach(item => { url_ += "Genders=" + encodeURIComponent("" + item) + "&"; });
        if (educations !== undefined && educations !== null)
            educations && educations.forEach(item => { url_ += "Educations=" + encodeURIComponent("" + item) + "&"; });
        if (titles !== undefined && titles !== null)
            titles && titles.forEach(item => { url_ += "Titles=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatomPortalDashboardFromMetabaseByFilter2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatomPortalDashboardFromMetabaseByFilter2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutputDto>;
        }));
    }

    protected processGetPlatomPortalDashboardFromMetabaseByFilter2(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param dashboardId (optional) 
     * @param cities (optional) 
     * @param titles (optional) 
     * @return Success
     */
    getPlatomPortalDashboardFromMetabaseByFilter3(reportId: number | null | undefined, dashboardId: number | null | undefined, periods: string[], projects: string[], cities: string[] | null | undefined, titles: string[] | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalModule/GetPlatomPortalDashboardFromMetabaseByFilter3?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (dashboardId !== undefined && dashboardId !== null)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (periods === undefined || periods === null)
            throw new Error("The parameter 'periods' must be defined and cannot be null.");
        else
            periods && periods.forEach(item => { url_ += "Periods=" + encodeURIComponent("" + item) + "&"; });
        if (projects === undefined || projects === null)
            throw new Error("The parameter 'projects' must be defined and cannot be null.");
        else
            projects && projects.forEach(item => { url_ += "Projects=" + encodeURIComponent("" + item) + "&"; });
        if (cities !== undefined && cities !== null)
            cities && cities.forEach(item => { url_ += "Cities=" + encodeURIComponent("" + item) + "&"; });
        if (titles !== undefined && titles !== null)
            titles && titles.forEach(item => { url_ += "Titles=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatomPortalDashboardFromMetabaseByFilter3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatomPortalDashboardFromMetabaseByFilter3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutputDto>;
        }));
    }

    protected processGetPlatomPortalDashboardFromMetabaseByFilter3(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param dashboardId (optional) 
     * @param cities (optional) 
     * @param titles (optional) 
     * @return Success
     */
    getPlatomPortalDashboardFromMetabaseByFilter4(reportId: number | null | undefined, dashboardId: number | null | undefined, projects: string[], cities: string[] | null | undefined, titles: string[] | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalModule/GetPlatomPortalDashboardFromMetabaseByFilter4?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (dashboardId !== undefined && dashboardId !== null)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (projects === undefined || projects === null)
            throw new Error("The parameter 'projects' must be defined and cannot be null.");
        else
            projects && projects.forEach(item => { url_ += "Projects=" + encodeURIComponent("" + item) + "&"; });
        if (cities !== undefined && cities !== null)
            cities && cities.forEach(item => { url_ += "Cities=" + encodeURIComponent("" + item) + "&"; });
        if (titles !== undefined && titles !== null)
            titles && titles.forEach(item => { url_ += "Titles=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatomPortalDashboardFromMetabaseByFilter4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatomPortalDashboardFromMetabaseByFilter4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutputDto>;
        }));
    }

    protected processGetPlatomPortalDashboardFromMetabaseByFilter4(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param dashboardId (optional) 
     * @param cities (optional) 
     * @param costSubCategory (optional) 
     * @param costCategory (optional) 
     * @param titles (optional) 
     * @return Success
     */
    getPlatomPortalDashboardFromMetabaseByFilter5(reportId: number | null | undefined, dashboardId: number | null | undefined, projects: string[], cities: string[] | null | undefined, costSubCategory: string[] | null | undefined, costCategory: string[] | null | undefined, titles: string[] | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalModule/GetPlatomPortalDashboardFromMetabaseByFilter5?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (dashboardId !== undefined && dashboardId !== null)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (projects === undefined || projects === null)
            throw new Error("The parameter 'projects' must be defined and cannot be null.");
        else
            projects && projects.forEach(item => { url_ += "Projects=" + encodeURIComponent("" + item) + "&"; });
        if (cities !== undefined && cities !== null)
            cities && cities.forEach(item => { url_ += "Cities=" + encodeURIComponent("" + item) + "&"; });
        if (costSubCategory !== undefined && costSubCategory !== null)
            costSubCategory && costSubCategory.forEach(item => { url_ += "CostSubCategory=" + encodeURIComponent("" + item) + "&"; });
        if (costCategory !== undefined && costCategory !== null)
            costCategory && costCategory.forEach(item => { url_ += "CostCategory=" + encodeURIComponent("" + item) + "&"; });
        if (titles !== undefined && titles !== null)
            titles && titles.forEach(item => { url_ += "Titles=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatomPortalDashboardFromMetabaseByFilter5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatomPortalDashboardFromMetabaseByFilter5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutputDto>;
        }));
    }

    protected processGetPlatomPortalDashboardFromMetabaseByFilter5(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param dashboardId (optional) 
     * @param project (optional) 
     * @param period (optional) 
     * @param kpi (optional) 
     * @param cities (optional) 
     * @param regionManagers (optional) 
     * @param supervisors (optional) 
     * @return Success
     */
    getPlatomPortalDashboardFromMetabaseByFilter6(reportId: number | null | undefined, dashboardId: number | null | undefined, project: string[] | null | undefined, period: string[] | null | undefined, kpi: string[] | null | undefined, cities: string[] | null | undefined, regionManagers: string[] | null | undefined, supervisors: string[] | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalModule/GetPlatomPortalDashboardFromMetabaseByFilter6?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (dashboardId !== undefined && dashboardId !== null)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (project !== undefined && project !== null)
            project && project.forEach(item => { url_ += "Project=" + encodeURIComponent("" + item) + "&"; });
        if (period !== undefined && period !== null)
            period && period.forEach(item => { url_ += "Period=" + encodeURIComponent("" + item) + "&"; });
        if (kpi !== undefined && kpi !== null)
            kpi && kpi.forEach(item => { url_ += "Kpi=" + encodeURIComponent("" + item) + "&"; });
        if (cities !== undefined && cities !== null)
            cities && cities.forEach(item => { url_ += "Cities=" + encodeURIComponent("" + item) + "&"; });
        if (regionManagers !== undefined && regionManagers !== null)
            regionManagers && regionManagers.forEach(item => { url_ += "RegionManagers=" + encodeURIComponent("" + item) + "&"; });
        if (supervisors !== undefined && supervisors !== null)
            supervisors && supervisors.forEach(item => { url_ += "Supervisors=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatomPortalDashboardFromMetabaseByFilter6(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatomPortalDashboardFromMetabaseByFilter6(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutputDto>;
        }));
    }

    protected processGetPlatomPortalDashboardFromMetabaseByFilter6(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param dashboardId (optional) 
     * @param periods (optional) 
     * @param genders (optional) 
     * @param educations (optional) 
     * @param managers (optional) 
     * @return Success
     */
    getPlatomPortalDashboardFromMetabaseByFilter7(reportId: number | null | undefined, dashboardId: number | null | undefined, periods: string[] | null | undefined, projects: string[], genders: string[] | null | undefined, educations: string[] | null | undefined, managers: string[] | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalModule/GetPlatomPortalDashboardFromMetabaseByFilter7?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (dashboardId !== undefined && dashboardId !== null)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (periods !== undefined && periods !== null)
            periods && periods.forEach(item => { url_ += "Periods=" + encodeURIComponent("" + item) + "&"; });
        if (projects === undefined || projects === null)
            throw new Error("The parameter 'projects' must be defined and cannot be null.");
        else
            projects && projects.forEach(item => { url_ += "Projects=" + encodeURIComponent("" + item) + "&"; });
        if (genders !== undefined && genders !== null)
            genders && genders.forEach(item => { url_ += "Genders=" + encodeURIComponent("" + item) + "&"; });
        if (educations !== undefined && educations !== null)
            educations && educations.forEach(item => { url_ += "Educations=" + encodeURIComponent("" + item) + "&"; });
        if (managers !== undefined && managers !== null)
            managers && managers.forEach(item => { url_ += "Managers=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatomPortalDashboardFromMetabaseByFilter7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatomPortalDashboardFromMetabaseByFilter7(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutputDto>;
        }));
    }

    protected processGetPlatomPortalDashboardFromMetabaseByFilter7(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param dashboardId (optional) 
     * @param periods (optional) 
     * @param supervisors (optional) 
     * @param cities (optional) 
     * @return Success
     */
    getPlatomPortalDashboardFromMetabaseByFilter8(reportId: number | null | undefined, dashboardId: number | null | undefined, projects: string[], periods: string[] | null | undefined, supervisors: string[] | null | undefined, cities: string[] | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalModule/GetPlatomPortalDashboardFromMetabaseByFilter8?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (dashboardId !== undefined && dashboardId !== null)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (projects === undefined || projects === null)
            throw new Error("The parameter 'projects' must be defined and cannot be null.");
        else
            projects && projects.forEach(item => { url_ += "Projects=" + encodeURIComponent("" + item) + "&"; });
        if (periods !== undefined && periods !== null)
            periods && periods.forEach(item => { url_ += "Periods=" + encodeURIComponent("" + item) + "&"; });
        if (supervisors !== undefined && supervisors !== null)
            supervisors && supervisors.forEach(item => { url_ += "Supervisors=" + encodeURIComponent("" + item) + "&"; });
        if (cities !== undefined && cities !== null)
            cities && cities.forEach(item => { url_ += "Cities=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatomPortalDashboardFromMetabaseByFilter8(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatomPortalDashboardFromMetabaseByFilter8(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutputDto>;
        }));
    }

    protected processGetPlatomPortalDashboardFromMetabaseByFilter8(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param dashboardId (optional) 
     * @param dateRange (optional) 
     * @param personels (optional) 
     * @return Success
     */
    getPlatomPortalDashboardFromMetabaseByFilter9(reportId: number | null | undefined, dashboardId: number | null | undefined, projects: string[], dateRange: string | null | undefined, personels: string[] | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalModule/GetPlatomPortalDashboardFromMetabaseByFilter9?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (dashboardId !== undefined && dashboardId !== null)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (projects === undefined || projects === null)
            throw new Error("The parameter 'projects' must be defined and cannot be null.");
        else
            projects && projects.forEach(item => { url_ += "Projects=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange !== undefined && dateRange !== null)
            url_ += "DateRange=" + encodeURIComponent("" + dateRange) + "&";
        if (personels !== undefined && personels !== null)
            personels && personels.forEach(item => { url_ += "Personels=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatomPortalDashboardFromMetabaseByFilter9(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatomPortalDashboardFromMetabaseByFilter9(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutputDto>;
        }));
    }

    protected processGetPlatomPortalDashboardFromMetabaseByFilter9(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param dashboardId (optional) 
     * @param dateRange (optional) 
     * @param forms (optional) 
     * @param screenTitles (optional) 
     * @param questions (optional) 
     * @param personels (optional) 
     * @param stores (optional) 
     * @return Success
     */
    getPlatomPortalDashboardFromMetabaseByFilter10(reportId: number | null | undefined, dashboardId: number | null | undefined, projects: string[], dateRange: string | null | undefined, forms: string[] | null | undefined, screenTitles: string[] | null | undefined, questions: string[] | null | undefined, personels: string[] | null | undefined, stores: string[] | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalModule/GetPlatomPortalDashboardFromMetabaseByFilter10?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (dashboardId !== undefined && dashboardId !== null)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (projects === undefined || projects === null)
            throw new Error("The parameter 'projects' must be defined and cannot be null.");
        else
            projects && projects.forEach(item => { url_ += "Projects=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange !== undefined && dateRange !== null)
            url_ += "DateRange=" + encodeURIComponent("" + dateRange) + "&";
        if (forms !== undefined && forms !== null)
            forms && forms.forEach(item => { url_ += "Forms=" + encodeURIComponent("" + item) + "&"; });
        if (screenTitles !== undefined && screenTitles !== null)
            screenTitles && screenTitles.forEach(item => { url_ += "ScreenTitles=" + encodeURIComponent("" + item) + "&"; });
        if (questions !== undefined && questions !== null)
            questions && questions.forEach(item => { url_ += "Questions=" + encodeURIComponent("" + item) + "&"; });
        if (personels !== undefined && personels !== null)
            personels && personels.forEach(item => { url_ += "Personels=" + encodeURIComponent("" + item) + "&"; });
        if (stores !== undefined && stores !== null)
            stores && stores.forEach(item => { url_ += "Stores=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatomPortalDashboardFromMetabaseByFilter10(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatomPortalDashboardFromMetabaseByFilter10(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutputDto>;
        }));
    }

    protected processGetPlatomPortalDashboardFromMetabaseByFilter10(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param dashboardId (optional) 
     * @param dateRange (optional) 
     * @param personels (optional) 
     * @param masrafFormNo (optional) 
     * @return Success
     */
    getPlatomPortalDashboardFromMetabaseByFilter11(reportId: number | null | undefined, dashboardId: number | null | undefined, projects: string[], dateRange: string | null | undefined, personels: string[] | null | undefined, masrafFormNo: string | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalModule/GetPlatomPortalDashboardFromMetabaseByFilter11?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (dashboardId !== undefined && dashboardId !== null)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (projects === undefined || projects === null)
            throw new Error("The parameter 'projects' must be defined and cannot be null.");
        else
            projects && projects.forEach(item => { url_ += "Projects=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange !== undefined && dateRange !== null)
            url_ += "DateRange=" + encodeURIComponent("" + dateRange) + "&";
        if (personels !== undefined && personels !== null)
            personels && personels.forEach(item => { url_ += "Personels=" + encodeURIComponent("" + item) + "&"; });
        if (masrafFormNo !== undefined && masrafFormNo !== null)
            url_ += "MasrafFormNo=" + encodeURIComponent("" + masrafFormNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatomPortalDashboardFromMetabaseByFilter11(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatomPortalDashboardFromMetabaseByFilter11(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutputDto>;
        }));
    }

    protected processGetPlatomPortalDashboardFromMetabaseByFilter11(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param dashboardId (optional) 
     * @param workStartDateRange (optional) 
     * @param workEndDateRange (optional) 
     * @return Success
     */
    getPlatomPortalDashboardFromMetabaseByFilter12(reportId: number | null | undefined, dashboardId: number | null | undefined, projects: string[], workStatus: string, workStartDateRange: string | null | undefined, workEndDateRange: string | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/MetabasePlatomPortalModule/GetPlatomPortalDashboardFromMetabaseByFilter12?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (dashboardId !== undefined && dashboardId !== null)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (projects === undefined || projects === null)
            throw new Error("The parameter 'projects' must be defined and cannot be null.");
        else
            projects && projects.forEach(item => { url_ += "Projects=" + encodeURIComponent("" + item) + "&"; });
        if (workStatus === undefined || workStatus === null)
            throw new Error("The parameter 'workStatus' must be defined and cannot be null.");
        else
            url_ += "WorkStatus=" + encodeURIComponent("" + workStatus) + "&";
        if (workStartDateRange !== undefined && workStartDateRange !== null)
            url_ += "WorkStartDateRange=" + encodeURIComponent("" + workStartDateRange) + "&";
        if (workEndDateRange !== undefined && workEndDateRange !== null)
            url_ += "WorkEndDateRange=" + encodeURIComponent("" + workEndDateRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatomPortalDashboardFromMetabaseByFilter12(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatomPortalDashboardFromMetabaseByFilter12(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutputDto>;
        }));
    }

    protected processGetPlatomPortalDashboardFromMetabaseByFilter12(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(null as any);
    }
}

@Injectable()
export class MetabaseTranspopPortalDynamicFilterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getReportMetadata(reportId: number | null | undefined): Observable<ReportObjectDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalDynamicFilter/GetReportMetadata?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportObjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportObjectDto>;
        }));
    }

    protected processGetReportMetadata(response: HttpResponseBase): Observable<ReportObjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportObjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportObjectDto>(null as any);
    }

    /**
     * @param targetFilterInput (optional) 
     * @return Success
     */
    loadDrildownFilterData(targetFilterInput: ReportFilterDto | null | undefined): Observable<ReportFilterDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalDynamicFilter/LoadDrildownFilterData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(targetFilterInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadDrildownFilterData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadDrildownFilterData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportFilterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportFilterDto>;
        }));
    }

    protected processLoadDrildownFilterData(response: HttpResponseBase): Observable<ReportFilterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportFilterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportFilterDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createPlatomPortalDashboardUrl(input: ReportObjectDto | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalDynamicFilter/CreatePlatomPortalDashboardUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlatomPortalDashboardUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlatomPortalDashboardUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutputDto>;
        }));
    }

    protected processCreatePlatomPortalDashboardUrl(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(null as any);
    }
}

@Injectable()
export class MetabaseTranspopPortalFilterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @return Success
     */
    getUserWarehouseFilters(): Observable<WarehouseSelectListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetUserWarehouseFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWarehouseFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWarehouseFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseSelectListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseSelectListDto[]>;
        }));
    }

    protected processGetUserWarehouseFilters(response: HttpResponseBase): Observable<WarehouseSelectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectListDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getDamageStatusFilters(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetDamageStatusFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDamageStatusFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDamageStatusFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetDamageStatusFilters(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getMovementTypeFilters(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetMovementTypeFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMovementTypeFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMovementTypeFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetMovementTypeFilters(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getApprovalStatusFilters(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetApprovalStatusFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalStatusFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalStatusFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetApprovalStatusFilters(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getLastDepartureDateFilters(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetLastDepartureDateFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastDepartureDateFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastDepartureDateFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetLastDepartureDateFilters(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getExpirationDateFilters(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetExpirationDateFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpirationDateFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpirationDateFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetExpirationDateFilters(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @param textFormat (optional) 
     * @param valueFormat (optional) 
     * @return Success
     */
    getPeriods(textFormat: string | null | undefined, valueFormat: string | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetPeriods?";
        if (textFormat !== undefined && textFormat !== null)
            url_ += "textFormat=" + encodeURIComponent("" + textFormat) + "&";
        if (valueFormat !== undefined && valueFormat !== null)
            url_ += "valueFormat=" + encodeURIComponent("" + valueFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeriods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeriods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetPeriods(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getUserBusinessUnitsForMetabaseReports(): Observable<MetabaseTranspopPortalFilterUserBusinessUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetUserBusinessUnitsForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserBusinessUnitsForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserBusinessUnitsForMetabaseReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopPortalFilterUserBusinessUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopPortalFilterUserBusinessUnitDto[]>;
        }));
    }

    protected processGetUserBusinessUnitsForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopPortalFilterUserBusinessUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopPortalFilterUserBusinessUnitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopPortalFilterUserBusinessUnitDto[]>(null as any);
    }

    /**
     * @param businessUnitId (optional) 
     * @return Success
     */
    getBrandsByBusinessUnitForMetabaseReports(businessUnitId: number | null | undefined): Observable<MetabaseTranspopPortalFilterBrandDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetBrandsByBusinessUnitForMetabaseReports?";
        if (businessUnitId !== undefined && businessUnitId !== null)
            url_ += "businessUnitId=" + encodeURIComponent("" + businessUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBrandsByBusinessUnitForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrandsByBusinessUnitForMetabaseReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopPortalFilterBrandDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopPortalFilterBrandDto[]>;
        }));
    }

    protected processGetBrandsByBusinessUnitForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopPortalFilterBrandDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopPortalFilterBrandDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopPortalFilterBrandDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getUserType3AttributesForMetabaseReports(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetUserType3AttributesForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserType3AttributesForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserType3AttributesForMetabaseReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetUserType3AttributesForMetabaseReports(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getUserDistributorsForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetUserDistributorsForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDistributorsForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDistributorsForMetabaseReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopFilterItemDto[]>;
        }));
    }

    protected processGetUserDistributorsForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPmsLaunchesForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetPmsLaunchesForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPmsLaunchesForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPmsLaunchesForMetabaseReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopFilterItemDto[]>;
        }));
    }

    protected processGetPmsLaunchesForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPmsCoordinatorsForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetPmsCoordinatorsForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPmsCoordinatorsForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPmsCoordinatorsForMetabaseReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopFilterItemDto[]>;
        }));
    }

    protected processGetPmsCoordinatorsForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPmsChannelsForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetPmsChannelsForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPmsChannelsForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPmsChannelsForMetabaseReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopFilterItemDto[]>;
        }));
    }

    protected processGetPmsChannelsForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getWmsCheckinTypesForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsCheckinTypesForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsCheckinTypesForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsCheckinTypesForMetabaseReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopFilterItemDto[]>;
        }));
    }

    protected processGetWmsCheckinTypesForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getWmsCheckinCoordinatorsForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsCheckinCoordinatorsForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsCheckinCoordinatorsForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsCheckinCoordinatorsForMetabaseReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopFilterItemDto[]>;
        }));
    }

    protected processGetWmsCheckinCoordinatorsForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getWmsCheckinSupervisorsForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsCheckinSupervisorsForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsCheckinSupervisorsForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsCheckinSupervisorsForMetabaseReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopFilterItemDto[]>;
        }));
    }

    protected processGetWmsCheckinSupervisorsForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getWmsCheckinPopStatusesForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsCheckinPopStatusesForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsCheckinPopStatusesForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsCheckinPopStatusesForMetabaseReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopFilterItemDto[]>;
        }));
    }

    protected processGetWmsCheckinPopStatusesForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPosmAvailabilityInStore(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetPosmAvailabilityInStore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosmAvailabilityInStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosmAvailabilityInStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopFilterItemDto[]>;
        }));
    }

    protected processGetPosmAvailabilityInStore(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getWmsProductList(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsProductList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsProductList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsProductList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopFilterItemDto[]>;
        }));
    }

    protected processGetWmsProductList(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPosmTypeList(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetPosmTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosmTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosmTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopFilterItemDto[]>;
        }));
    }

    protected processGetPosmTypeList(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(null as any);
    }

    /**
     * @param posmTypeName (optional) 
     * @return Success
     */
    getWmsStarbucksProductList(posmTypeName: string[] | null | undefined): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsStarbucksProductList?";
        if (posmTypeName !== undefined && posmTypeName !== null)
            posmTypeName && posmTypeName.forEach(item => { url_ += "posmTypeName=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsStarbucksProductList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsStarbucksProductList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopFilterItemDto[]>;
        }));
    }

    protected processGetWmsStarbucksProductList(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getWmsStarbucksProductTypwList(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsStarbucksProductTypwList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsStarbucksProductTypwList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsStarbucksProductTypwList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopFilterItemDto[]>;
        }));
    }

    protected processGetWmsStarbucksProductTypwList(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(null as any);
    }

    /**
     * @param textFormat (optional) 
     * @param valueFormat (optional) 
     * @return Success
     */
    getLaunchStartMonths(textFormat: string | null | undefined, valueFormat: string | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetLaunchStartMonths?";
        if (textFormat !== undefined && textFormat !== null)
            url_ += "textFormat=" + encodeURIComponent("" + textFormat) + "&";
        if (valueFormat !== undefined && valueFormat !== null)
            url_ += "valueFormat=" + encodeURIComponent("" + valueFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaunchStartMonths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaunchStartMonths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetLaunchStartMonths(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getWmsPgTier(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsPgTier";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsPgTier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsPgTier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetWmsPgTier(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    getWmsPgMonthPeriods(monthYear: string | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsPgMonthPeriods?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsPgMonthPeriods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsPgMonthPeriods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetWmsPgMonthPeriods(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @param startMonthYear (optional) 
     * @return Success
     */
    getWmsPgLaunchList(startMonthYear: string | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsPgLaunchList?";
        if (startMonthYear !== undefined && startMonthYear !== null)
            url_ += "startMonthYear=" + encodeURIComponent("" + startMonthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsPgLaunchList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsPgLaunchList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetWmsPgLaunchList(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getWmsPgSupervisorList(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsPgSupervisorList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsPgSupervisorList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsPgSupervisorList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetWmsPgSupervisorList(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getWmsPgKoordinatorList(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsPgKoordinatorList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsPgKoordinatorList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsPgKoordinatorList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseFilterItemDto[]>;
        }));
    }

    protected processGetWmsPgKoordinatorList(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(null as any);
    }

    /**
     * @param personelType (optional) 
     * @return Success
     */
    getLocationPersonelList(personelType: number | null | undefined): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetLocationPersonelList?";
        if (personelType !== undefined && personelType !== null)
            url_ += "personelType=" + encodeURIComponent("" + personelType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationPersonelList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationPersonelList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseTranspopFilterItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseTranspopFilterItemDto[]>;
        }));
    }

    protected processGetLocationPersonelList(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(null as any);
    }
}

@Injectable()
export class MetabaseTranspopPortalModuleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param reportId (optional) 
     * @param dashboardId (optional) 
     * @param warehouseIds (optional) 
     * @param productIds (optional) 
     * @param distributorNames (optional) 
     * @param damageStatuses (optional) 
     * @param movementType (optional) 
     * @param approvalStatuses (optional) 
     * @param lastDepartureDate (optional) 
     * @param expirationDate (optional) 
     * @param posm (optional) 
     * @param posmType (optional) 
     * @param monthPeriod (optional) 
     * @param posmIsInStore (optional) 
     * @param searchKeyword (optional) 
     * @param dateRange (optional) 
     * @param userId (optional) 
     * @param customerId (optional) 
     * @param customerCode (optional) 
     * @param businessUnitId (optional) 
     * @param businessUnitIds (optional) 
     * @param brandIds (optional) 
     * @param types (optional) 
     * @param launches (optional) 
     * @param coordinators (optional) 
     * @param channels (optional) 
     * @param specificDateRange (optional) 
     * @param supervisors (optional) 
     * @param regionManager (optional) 
     * @param companyManager (optional) 
     * @param popStatuses (optional) 
     * @param processTypes (optional) 
     * @param warehouseCodes (optional) 
     * @return Success
     */
    getDashboardFromMetabaseByFilter(reportId: number | null | undefined, dashboardId: number | null | undefined, warehouseIds: string[] | null | undefined, productIds: string[] | null | undefined, distributorNames: string[] | null | undefined, damageStatuses: string[] | null | undefined, movementType: string[] | null | undefined, approvalStatuses: string[] | null | undefined, lastDepartureDate: string | null | undefined, expirationDate: string | null | undefined, posm: string[] | null | undefined, posmType: string[] | null | undefined, monthPeriod: string | null | undefined, posmIsInStore: string[] | null | undefined, searchKeyword: string | null | undefined, dateRange: string | null | undefined, userId: number | null | undefined, customerId: number | null | undefined, customerCode: string | null | undefined, businessUnitId: number | null | undefined, businessUnitIds: number[] | null | undefined, brandIds: number[] | null | undefined, types: string[] | null | undefined, launches: string[] | null | undefined, coordinators: string[] | null | undefined, channels: string[] | null | undefined, specificDateRange: string | null | undefined, supervisors: string[] | null | undefined, regionManager: string[] | null | undefined, companyManager: string[] | null | undefined, popStatuses: string[] | null | undefined, processTypes: string[] | null | undefined, warehouseCodes: string[] | null | undefined): Observable<TranspopPortalReportResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalModule/GetDashboardFromMetabaseByFilter?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (dashboardId !== undefined && dashboardId !== null)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (warehouseIds !== undefined && warehouseIds !== null)
            warehouseIds && warehouseIds.forEach(item => { url_ += "WarehouseIds=" + encodeURIComponent("" + item) + "&"; });
        if (productIds !== undefined && productIds !== null)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (distributorNames !== undefined && distributorNames !== null)
            distributorNames && distributorNames.forEach(item => { url_ += "DistributorNames=" + encodeURIComponent("" + item) + "&"; });
        if (damageStatuses !== undefined && damageStatuses !== null)
            damageStatuses && damageStatuses.forEach(item => { url_ += "DamageStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (movementType !== undefined && movementType !== null)
            movementType && movementType.forEach(item => { url_ += "MovementType=" + encodeURIComponent("" + item) + "&"; });
        if (approvalStatuses !== undefined && approvalStatuses !== null)
            approvalStatuses && approvalStatuses.forEach(item => { url_ += "ApprovalStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (lastDepartureDate !== undefined && lastDepartureDate !== null)
            url_ += "LastDepartureDate=" + encodeURIComponent("" + lastDepartureDate) + "&";
        if (expirationDate !== undefined && expirationDate !== null)
            url_ += "ExpirationDate=" + encodeURIComponent("" + expirationDate) + "&";
        if (posm !== undefined && posm !== null)
            posm && posm.forEach(item => { url_ += "Posm=" + encodeURIComponent("" + item) + "&"; });
        if (posmType !== undefined && posmType !== null)
            posmType && posmType.forEach(item => { url_ += "PosmType=" + encodeURIComponent("" + item) + "&"; });
        if (monthPeriod !== undefined && monthPeriod !== null)
            url_ += "MonthPeriod=" + encodeURIComponent("" + monthPeriod) + "&";
        if (posmIsInStore !== undefined && posmIsInStore !== null)
            posmIsInStore && posmIsInStore.forEach(item => { url_ += "PosmIsInStore=" + encodeURIComponent("" + item) + "&"; });
        if (searchKeyword !== undefined && searchKeyword !== null)
            url_ += "SearchKeyword=" + encodeURIComponent("" + searchKeyword) + "&";
        if (dateRange !== undefined && dateRange !== null)
            url_ += "DateRange=" + encodeURIComponent("" + dateRange) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (customerCode !== undefined && customerCode !== null)
            url_ += "CustomerCode=" + encodeURIComponent("" + customerCode) + "&";
        if (businessUnitId !== undefined && businessUnitId !== null)
            url_ += "BusinessUnitId=" + encodeURIComponent("" + businessUnitId) + "&";
        if (businessUnitIds !== undefined && businessUnitIds !== null)
            businessUnitIds && businessUnitIds.forEach(item => { url_ += "BusinessUnitIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds !== undefined && brandIds !== null)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "Types=" + encodeURIComponent("" + item) + "&"; });
        if (launches !== undefined && launches !== null)
            launches && launches.forEach(item => { url_ += "Launches=" + encodeURIComponent("" + item) + "&"; });
        if (coordinators !== undefined && coordinators !== null)
            coordinators && coordinators.forEach(item => { url_ += "Coordinators=" + encodeURIComponent("" + item) + "&"; });
        if (channels !== undefined && channels !== null)
            channels && channels.forEach(item => { url_ += "Channels=" + encodeURIComponent("" + item) + "&"; });
        if (specificDateRange !== undefined && specificDateRange !== null)
            url_ += "SpecificDateRange=" + encodeURIComponent("" + specificDateRange) + "&";
        if (supervisors !== undefined && supervisors !== null)
            supervisors && supervisors.forEach(item => { url_ += "Supervisors=" + encodeURIComponent("" + item) + "&"; });
        if (regionManager !== undefined && regionManager !== null)
            regionManager && regionManager.forEach(item => { url_ += "RegionManager=" + encodeURIComponent("" + item) + "&"; });
        if (companyManager !== undefined && companyManager !== null)
            companyManager && companyManager.forEach(item => { url_ += "CompanyManager=" + encodeURIComponent("" + item) + "&"; });
        if (popStatuses !== undefined && popStatuses !== null)
            popStatuses && popStatuses.forEach(item => { url_ += "PopStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (processTypes !== undefined && processTypes !== null)
            processTypes && processTypes.forEach(item => { url_ += "ProcessTypes=" + encodeURIComponent("" + item) + "&"; });
        if (warehouseCodes !== undefined && warehouseCodes !== null)
            warehouseCodes && warehouseCodes.forEach(item => { url_ += "WarehouseCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardFromMetabaseByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardFromMetabaseByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TranspopPortalReportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TranspopPortalReportResultDto>;
        }));
    }

    protected processGetDashboardFromMetabaseByFilter(response: HttpResponseBase): Observable<TranspopPortalReportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TranspopPortalReportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TranspopPortalReportResultDto>(null as any);
    }
}

@Injectable()
export class MetabaseTranspopPortalProcessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param filterInput (optional) 
     * @return Success
     */
    sendMailDownloadPhotosAsZipLink(filterInput: TranspopPortalReportParamsFiltersInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalProcess/SendMailDownloadPhotosAsZipLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailDownloadPhotosAsZipLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailDownloadPhotosAsZipLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMailDownloadPhotosAsZipLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param ekomLocationId (optional) 
     * @param productCode (optional) 
     * @return Success
     */
    getLastCheckinPhoto(ekomLocationId: number | null | undefined, productCode: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalProcess/GetLastCheckinPhoto?";
        if (ekomLocationId !== undefined && ekomLocationId !== null)
            url_ += "ekomLocationId=" + encodeURIComponent("" + ekomLocationId) + "&";
        if (productCode !== undefined && productCode !== null)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastCheckinPhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastCheckinPhoto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLastCheckinPhoto(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class ModuleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<ModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Module/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ModuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ModuleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModuleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Module/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfModuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfModuleDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfModuleDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateModuleDto | null | undefined): Observable<ModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Module/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ModuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ModuleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModuleDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: ModuleDto | null | undefined): Observable<ModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Module/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ModuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ModuleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModuleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Module/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class OrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @return Success
     */
    _CreateTest(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/_CreateTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process_CreateTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process_CreateTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected process_CreateTest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    calculateShipmentPrice(input: CreateOrderDto | null | undefined): Observable<OrderPriceDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/CalculateShipmentPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateShipmentPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateShipmentPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderPriceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderPriceDto[]>;
        }));
    }

    protected processCalculateShipmentPrice(response: HttpResponseBase): Observable<OrderPriceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderPriceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderPriceDto[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createTransferOrder(input: CreateOrderDto | null | undefined): Observable<OrderStockResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/CreateTransferOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTransferOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTransferOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderStockResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderStockResultDto>;
        }));
    }

    protected processCreateTransferOrder(response: HttpResponseBase): Observable<OrderStockResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderStockResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderStockResultDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrderProduct(input: CreateOrderDto | null | undefined): Observable<OrderStockResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/CreateOrderProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrderProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrderProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderStockResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderStockResultDto>;
        }));
    }

    protected processCreateOrderProduct(response: HttpResponseBase): Observable<OrderStockResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderStockResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderStockResultDto>(null as any);
    }

    /**
     * @return Success
     */
    checkUserHasProductLocationOrderHistoryView(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/CheckUserHasProductLocationOrderHistoryView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUserHasProductLocationOrderHistoryView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserHasProductLocationOrderHistoryView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckUserHasProductLocationOrderHistoryView(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param filterDayNumber (optional) 
     * @return Success
     */
    getWaitingForApprovalOrders(filterDayNumber: number | null | undefined): Observable<OrderProductTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/GetWaitingForApprovalOrders?";
        if (filterDayNumber !== undefined && filterDayNumber !== null)
            url_ += "filterDayNumber=" + encodeURIComponent("" + filterDayNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaitingForApprovalOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaitingForApprovalOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderProductTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderProductTaskDto[]>;
        }));
    }

    protected processGetWaitingForApprovalOrders(response: HttpResponseBase): Observable<OrderProductTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderProductTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderProductTaskDto[]>(null as any);
    }

    /**
     * @param withProductPhoto (optional) 
     * @param filterDayNumber (optional) 
     * @return Success
     */
    getWaitingForApprovalOrdersForExcel(withProductPhoto: boolean | null | undefined, filterDayNumber: number | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/GetWaitingForApprovalOrdersForExcel?";
        if (withProductPhoto !== undefined && withProductPhoto !== null)
            url_ += "withProductPhoto=" + encodeURIComponent("" + withProductPhoto) + "&";
        if (filterDayNumber !== undefined && filterDayNumber !== null)
            url_ += "filterDayNumber=" + encodeURIComponent("" + filterDayNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaitingForApprovalOrdersForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaitingForApprovalOrdersForExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcelFileResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcelFileResultDto>;
        }));
    }

    protected processGetWaitingForApprovalOrdersForExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(null as any);
    }

    /**
     * @param filterDayNumber (optional) 
     * @return Success
     */
    getWaitingForMyApprovalOrders(filterDayNumber: number | null | undefined): Observable<OrderProductTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/GetWaitingForMyApprovalOrders?";
        if (filterDayNumber !== undefined && filterDayNumber !== null)
            url_ += "filterDayNumber=" + encodeURIComponent("" + filterDayNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaitingForMyApprovalOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaitingForMyApprovalOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderProductTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderProductTaskDto[]>;
        }));
    }

    protected processGetWaitingForMyApprovalOrders(response: HttpResponseBase): Observable<OrderProductTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderProductTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderProductTaskDto[]>(null as any);
    }

    /**
     * @param filterDayNumber (optional) 
     * @return Success
     */
    getPastOrders(filterDayNumber: number | null | undefined): Observable<OrderProductTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/GetPastOrders?";
        if (filterDayNumber !== undefined && filterDayNumber !== null)
            url_ += "filterDayNumber=" + encodeURIComponent("" + filterDayNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPastOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPastOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderProductTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderProductTaskDto[]>;
        }));
    }

    protected processGetPastOrders(response: HttpResponseBase): Observable<OrderProductTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderProductTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderProductTaskDto[]>(null as any);
    }

    /**
     * @param withProductPhoto (optional) 
     * @param filterDayNumber (optional) 
     * @return Success
     */
    getPastOrdersForExcel(withProductPhoto: boolean | null | undefined, filterDayNumber: number | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/GetPastOrdersForExcel?";
        if (withProductPhoto !== undefined && withProductPhoto !== null)
            url_ += "withProductPhoto=" + encodeURIComponent("" + withProductPhoto) + "&";
        if (filterDayNumber !== undefined && filterDayNumber !== null)
            url_ += "filterDayNumber=" + encodeURIComponent("" + filterDayNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPastOrdersForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPastOrdersForExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcelFileResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcelFileResultDto>;
        }));
    }

    protected processGetPastOrdersForExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(null as any);
    }

    /**
     * @param orderDetailsIds (optional) 
     * @return Success
     */
    removeOrder(orderDetailsIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/RemoveOrder?";
        if (orderDetailsIds !== undefined && orderDetailsIds !== null)
            orderDetailsIds && orderDetailsIds.forEach(item => { url_ += "orderDetailsIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param approvalTaskIds (optional) 
     * @param description (optional) 
     * @return Success
     */
    rejectOrder(approvalTaskIds: number[] | null | undefined, description: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/RejectOrder?";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(approvalTaskIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param approvedOrderList (optional) 
     * @return Success
     */
    approveOrder(approvedOrderList: OrderApprovedDto[] | null | undefined): Observable<OrderApprovedDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/ApproveOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(approvedOrderList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderApprovedDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderApprovedDto[]>;
        }));
    }

    protected processApproveOrder(response: HttpResponseBase): Observable<OrderApprovedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderApprovedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovedDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getOrderApprovalTypes(): Observable<OrderApprovalTypesDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/GetOrderApprovalTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderApprovalTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderApprovalTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderApprovalTypesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderApprovalTypesDto[]>;
        }));
    }

    protected processGetOrderApprovalTypes(response: HttpResponseBase): Observable<OrderApprovalTypesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderApprovalTypesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovalTypesDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param toAddressId (optional) 
     * @return Success
     */
    getProductLocationHistories(productId: number | null | undefined, toAddressId: number | null | undefined): Observable<ProductLocationHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/GetProductLocationHistories?";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (toAddressId !== undefined && toAddressId !== null)
            url_ += "toAddressId=" + encodeURIComponent("" + toAddressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductLocationHistories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductLocationHistories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductLocationHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductLocationHistoryDto[]>;
        }));
    }

    protected processGetProductLocationHistories(response: HttpResponseBase): Observable<ProductLocationHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductLocationHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductLocationHistoryDto[]>(null as any);
    }

    /**
     * @return Success
     */
    _TestMail(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/_TestMail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process_TestMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process_TestMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected process_TestMail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    test123(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/Test123";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest123(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest123(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTest123(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class OrderApprovalRulesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param titleId (optional) 
     * @return Success
     */
    getApprovalRulesByTitleId(titleId: number | null | undefined): Observable<ApprovalRulesGroupedTitlesDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/GetApprovalRulesByTitleId?";
        if (titleId !== undefined && titleId !== null)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalRulesByTitleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalRulesByTitleId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovalRulesGroupedTitlesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovalRulesGroupedTitlesDto[]>;
        }));
    }

    protected processGetApprovalRulesByTitleId(response: HttpResponseBase): Observable<ApprovalRulesGroupedTitlesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ApprovalRulesGroupedTitlesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApprovalRulesGroupedTitlesDto[]>(null as any);
    }

    /**
     * @param titleId (optional) 
     * @param groupId (optional) 
     * @return Success
     */
    getApproversListByGroupId(titleId: number | null | undefined, groupId: number | null | undefined): Observable<ApproverDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/GetApproversListByGroupId?";
        if (titleId !== undefined && titleId !== null)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        if (groupId !== undefined && groupId !== null)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApproversListByGroupId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApproversListByGroupId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApproverDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApproverDto[]>;
        }));
    }

    protected processGetApproversListByGroupId(response: HttpResponseBase): Observable<ApproverDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ApproverDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApproverDto[]>(null as any);
    }

    /**
     * @param approvedTitleId (optional) 
     * @param groupId (optional) 
     * @param addressCategoryId (optional) 
     * @param newApprovers (optional) 
     * @return Success
     */
    addOrUpdateApprovalMechanism(approvedTitleId: number | null | undefined, groupId: number | null | undefined, addressCategoryId: number | null | undefined, newApprovers: ApproverDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/AddOrUpdateApprovalMechanism?";
        if (approvedTitleId !== undefined && approvedTitleId !== null)
            url_ += "approvedTitleId=" + encodeURIComponent("" + approvedTitleId) + "&";
        if (groupId !== undefined && groupId !== null)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        if (addressCategoryId !== undefined && addressCategoryId !== null)
            url_ += "addressCategoryId=" + encodeURIComponent("" + addressCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newApprovers);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateApprovalMechanism(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateApprovalMechanism(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateApprovalMechanism(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param groupId (optional) 
     * @return Success
     */
    deleteApprovalMechanism(groupId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/DeleteApprovalMechanism?";
        if (groupId !== undefined && groupId !== null)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteApprovalMechanism(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteApprovalMechanism(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteApprovalMechanism(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param titleId (optional) 
     * @return Success
     */
    getUnAssignedTitleCategories(titleId: number | null | undefined): Observable<ApprovalRulesCategoryDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/GetUnAssignedTitleCategories?";
        if (titleId !== undefined && titleId !== null)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnAssignedTitleCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnAssignedTitleCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovalRulesCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovalRulesCategoryDto[]>;
        }));
    }

    protected processGetUnAssignedTitleCategories(response: HttpResponseBase): Observable<ApprovalRulesCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ApprovalRulesCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApprovalRulesCategoryDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<OrderApprovalRulesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderApprovalRulesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderApprovalRulesDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderApprovalRulesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderApprovalRulesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovalRulesDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfOrderApprovalRulesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrderApprovalRulesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrderApprovalRulesDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfOrderApprovalRulesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrderApprovalRulesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrderApprovalRulesDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateOrderApprovalRulesDto | null | undefined): Observable<OrderApprovalRulesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderApprovalRulesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderApprovalRulesDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrderApprovalRulesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderApprovalRulesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovalRulesDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: OrderApprovalRulesDto | null | undefined): Observable<OrderApprovalRulesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderApprovalRulesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderApprovalRulesDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrderApprovalRulesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderApprovalRulesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovalRulesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class OrderApprovalTaskRepairServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfOrderApprovalTaskRepairDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalTaskRepair/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrderApprovalTaskRepairDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrderApprovalTaskRepairDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfOrderApprovalTaskRepairDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrderApprovalTaskRepairDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrderApprovalTaskRepairDto>(null as any);
    }

    /**
     * @param taskRepairId (optional) 
     * @param addressId (optional) 
     * @param userId (optional) 
     * @param authorizationId (optional) 
     * @return Success
     */
    setAddressToUser(taskRepairId: number | null | undefined, addressId: number | null | undefined, userId: number | null | undefined, authorizationId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalTaskRepair/SetAddressToUser?";
        if (taskRepairId !== undefined && taskRepairId !== null)
            url_ += "taskRepairId=" + encodeURIComponent("" + taskRepairId) + "&";
        if (addressId !== undefined && addressId !== null)
            url_ += "addressId=" + encodeURIComponent("" + addressId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (authorizationId !== undefined && authorizationId !== null)
            url_ += "authorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAddressToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAddressToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAddressToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<OrderApprovalTaskRepairDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalTaskRepair/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderApprovalTaskRepairDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderApprovalTaskRepairDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderApprovalTaskRepairDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderApprovalTaskRepairDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovalTaskRepairDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateOrderApprovalTaskRepairDto | null | undefined): Observable<OrderApprovalTaskRepairDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalTaskRepair/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderApprovalTaskRepairDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderApprovalTaskRepairDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrderApprovalTaskRepairDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderApprovalTaskRepairDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovalTaskRepairDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: OrderApprovalTaskRepairDto | null | undefined): Observable<OrderApprovalTaskRepairDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalTaskRepair/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderApprovalTaskRepairDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderApprovalTaskRepairDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrderApprovalTaskRepairDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderApprovalTaskRepairDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovalTaskRepairDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalTaskRepair/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class OrderCartServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateOrderCartDto | null | undefined): Observable<OrderCartDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderCartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderCartDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrderCartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCartDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    removeProductInCart(productId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/RemoveProductInCart?";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveProductInCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveProductInCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveProductInCart(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getProductCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/GetProductCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetProductCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getProductsInCart(): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/GetProductsInCart";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductsInCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsInCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto[]>;
        }));
    }

    protected processGetProductsInCart(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[]>(null as any);
    }

    /**
     * @param warehouseCode (optional) 
     * @return Success
     */
    getCalculatedWarehouseStockInCart(warehouseCode: string | null | undefined): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/GetCalculatedWarehouseStockInCart?";
        if (warehouseCode !== undefined && warehouseCode !== null)
            url_ += "warehouseCode=" + encodeURIComponent("" + warehouseCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculatedWarehouseStockInCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculatedWarehouseStockInCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto[]>;
        }));
    }

    protected processGetCalculatedWarehouseStockInCart(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[]>(null as any);
    }

    /**
     * @param warehouseCode (optional) 
     * @param products (optional) 
     * @return Success
     */
    getCalculatedWarehouseStockInOrderList(warehouseCode: string | null | undefined, products: any[] | null | undefined): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/GetCalculatedWarehouseStockInOrderList?";
        if (warehouseCode !== undefined && warehouseCode !== null)
            url_ += "warehouseCode=" + encodeURIComponent("" + warehouseCode) + "&";
        if (products !== undefined && products !== null)
            products && products.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "products[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculatedWarehouseStockInOrderList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculatedWarehouseStockInOrderList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto[]>;
        }));
    }

    protected processGetCalculatedWarehouseStockInOrderList(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrdersByCart(input: CreateOrderDto[] | null | undefined): Observable<CreateOrderCartExceptionDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/CreateOrdersByCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrdersByCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrdersByCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrderCartExceptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrderCartExceptionDto>;
        }));
    }

    protected processCreateOrdersByCart(response: HttpResponseBase): Observable<CreateOrderCartExceptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrderCartExceptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrderCartExceptionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<OrderCartDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderCartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderCartDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderCartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCartDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfOrderCartDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrderCartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrderCartDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfOrderCartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrderCartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrderCartDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: OrderCartDto | null | undefined): Observable<OrderCartDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderCartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderCartDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrderCartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCartDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param isActive (optional) 
     * @param moduleId (optional) 
     * @param isJustParents (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, isActive: boolean | null | undefined, moduleId: number | null | undefined, isJustParents: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfPageDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Page/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (moduleId !== undefined && moduleId !== null)
            url_ += "ModuleId=" + encodeURIComponent("" + moduleId) + "&";
        if (isJustParents !== undefined && isJustParents !== null)
            url_ += "IsJustParents=" + encodeURIComponent("" + isJustParents) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPageDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPageDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreatePageDto | null | undefined): Observable<PageDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Page/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Page/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<PageDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Page/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: PageDto | null | undefined): Observable<PageDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Page/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param isActive (optional) 
     * @param moduleId (optional) 
     * @param isJustParents (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForExcel(keyword: string | null | undefined, sorting: string | null | undefined, isActive: boolean | null | undefined, moduleId: number | null | undefined, isJustParents: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<ExcelPagedResultDtoOfPageExcelDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Page/GetAllForExcel?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (moduleId !== undefined && moduleId !== null)
            url_ += "ModuleId=" + encodeURIComponent("" + moduleId) + "&";
        if (isJustParents !== undefined && isJustParents !== null)
            url_ += "IsJustParents=" + encodeURIComponent("" + isJustParents) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcelPagedResultDtoOfPageExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcelPagedResultDtoOfPageExcelDto>;
        }));
    }

    protected processGetAllForExcel(response: HttpResponseBase): Observable<ExcelPagedResultDtoOfPageExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelPagedResultDtoOfPageExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelPagedResultDtoOfPageExcelDto>(null as any);
    }

    /**
     * @return Success
     */
    test(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Page/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class PlanogramServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @return Success
     */
    getUserProjects(): Observable<UserProjectsDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Planogram/GetUserProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectsDto[]>;
        }));
    }

    protected processGetUserProjects(response: HttpResponseBase): Observable<UserProjectsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserProjectsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProjectsDto[]>(null as any);
    }

    /**
     * @param inputProjectId (optional) 
     * @return Success
     */
    getAll(inputProjectId: string | null | undefined): Observable<PlanogramDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Planogram/GetAll?";
        if (inputProjectId !== undefined && inputProjectId !== null)
            url_ += "inputProjectId=" + encodeURIComponent("" + inputProjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanogramDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanogramDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PlanogramDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PlanogramDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanogramDto[]>(null as any);
    }

    /**
     * @param inputProjectId (optional) 
     * @param filters (optional) 
     * @return Success
     */
    planogramByFilters(inputProjectId: string | null | undefined, filters: GridFilterModal[] | null | undefined): Observable<PlanogramDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Planogram/PlanogramByFilters?";
        if (inputProjectId !== undefined && inputProjectId !== null)
            url_ += "inputProjectId=" + encodeURIComponent("" + inputProjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPlanogramByFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlanogramByFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanogramDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanogramDto[]>;
        }));
    }

    protected processPlanogramByFilters(response: HttpResponseBase): Observable<PlanogramDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PlanogramDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanogramDto[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreatePlanogramDto | null | undefined): Observable<PlanogramDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Planogram/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanogramDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanogramDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PlanogramDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanogramDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanogramDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdatePlanogramDto | null | undefined): Observable<PlanogramDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Planogram/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanogramDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanogramDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PlanogramDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanogramDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanogramDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Planogram/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllPlanogramType(): Observable<PlanogramTypesDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Planogram/GetAllPlanogramType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanogramType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanogramType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanogramTypesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanogramTypesDto[]>;
        }));
    }

    protected processGetAllPlanogramType(response: HttpResponseBase): Observable<PlanogramTypesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PlanogramTypesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanogramTypesDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getUserCustomers(): Observable<PlanogramCustomersDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Planogram/GetUserCustomers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanogramCustomersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanogramCustomersDto[]>;
        }));
    }

    protected processGetUserCustomers(response: HttpResponseBase): Observable<PlanogramCustomersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PlanogramCustomersDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanogramCustomersDto[]>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param data (optional) 
     * @return Success
     */
    createExcel(fileName: string | null | undefined, data: PlanogramDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Planogram/CreateExcel?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PlatomCwfServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    sendSms(input: CwfSmsInput | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/platom/portal/PlatomCwf/SendSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendSms(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param poiId (optional) 
     * @return Success
     */
    updateTranspopIdOnPoi(poiId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/PlatomCwf/UpdateTranspopIdOnPoi?";
        if (poiId !== undefined && poiId !== null)
            url_ += "poiId=" + encodeURIComponent("" + poiId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTranspopIdOnPoi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTranspopIdOnPoi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTranspopIdOnPoi(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PlatomPortalFilterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param kategoriAdi (optional) 
     * @return Success
     */
    getIliskiliModule(kategoriAdi: string | null | undefined): Observable<Kategori> {
        let url_ = this.baseUrl + "/api/services/platom/portal/PlatomPortalFilter/GetIliskiliModule?";
        if (kategoriAdi !== undefined && kategoriAdi !== null)
            url_ += "kategoriAdi=" + encodeURIComponent("" + kategoriAdi) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIliskiliModule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIliskiliModule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Kategori>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Kategori>;
        }));
    }

    protected processGetIliskiliModule(response: HttpResponseBase): Observable<Kategori> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Kategori.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Kategori>(null as any);
    }

    /**
     * @param moduleId (optional) 
     * @param filtreAdi (optional) 
     * @param aciklama (optional) 
     * @param filters (optional) 
     * @return Success
     */
    add(moduleId: string | null | undefined, filtreAdi: string | null | undefined, aciklama: string | null | undefined, filters: GridFilterModal[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/PlatomPortalFilter/Add?";
        if (moduleId !== undefined && moduleId !== null)
            url_ += "moduleId=" + encodeURIComponent("" + moduleId) + "&";
        if (filtreAdi !== undefined && filtreAdi !== null)
            url_ += "filtreAdi=" + encodeURIComponent("" + filtreAdi) + "&";
        if (aciklama !== undefined && aciklama !== null)
            url_ += "aciklama=" + encodeURIComponent("" + aciklama) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param platomFilterId (optional) 
     * @return Success
     */
    delete(platomFilterId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/PlatomPortalFilter/Delete?";
        if (platomFilterId !== undefined && platomFilterId !== null)
            url_ += "platomFilterId=" + encodeURIComponent("" + platomFilterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filterId (optional) 
     * @param moduleId (optional) 
     * @param filtreAdi (optional) 
     * @param aciklama (optional) 
     * @param filters (optional) 
     * @return Success
     */
    edit(filterId: string | null | undefined, moduleId: string | null | undefined, filtreAdi: string | null | undefined, aciklama: string | null | undefined, filters: GridFilterModal[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/PlatomPortalFilter/Edit?";
        if (filterId !== undefined && filterId !== null)
            url_ += "filterId=" + encodeURIComponent("" + filterId) + "&";
        if (moduleId !== undefined && moduleId !== null)
            url_ += "moduleId=" + encodeURIComponent("" + moduleId) + "&";
        if (filtreAdi !== undefined && filtreAdi !== null)
            url_ += "filtreAdi=" + encodeURIComponent("" + filtreAdi) + "&";
        if (aciklama !== undefined && aciklama !== null)
            url_ += "aciklama=" + encodeURIComponent("" + aciklama) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param moduleId (optional) 
     * @return Success
     */
    getAllByModule(moduleId: string | null | undefined): Observable<PlatomPortalFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/PlatomPortalFilter/GetAllByModule?";
        if (moduleId !== undefined && moduleId !== null)
            url_ += "moduleId=" + encodeURIComponent("" + moduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByModule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByModule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlatomPortalFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlatomPortalFilterDto[]>;
        }));
    }

    protected processGetAllByModule(response: HttpResponseBase): Observable<PlatomPortalFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PlatomPortalFilterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlatomPortalFilterDto[]>(null as any);
    }
}

@Injectable()
export class PosmProductionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @return Success
     */
    getBrands(): Observable<ListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetBrands";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBrands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListItemDto[]>;
        }));
    }

    protected processGetBrands(response: HttpResponseBase): Observable<ListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPosmTypes(): Observable<ListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetPosmTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosmTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosmTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListItemDto[]>;
        }));
    }

    protected processGetPosmTypes(response: HttpResponseBase): Observable<ListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getSuppliers(): Observable<ListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetSuppliers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuppliers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuppliers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListItemDto[]>;
        }));
    }

    protected processGetSuppliers(response: HttpResponseBase): Observable<ListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListItemDto[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    addLaunch(input: CreateLaunchDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/AddLaunch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLaunch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLaunch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddLaunch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateLaunch(input: CreateLaunchDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/UpdateLaunch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLaunch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLaunch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLaunch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateLaunchSettings(input: LaunchSettingsDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/UpdateLaunchSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLaunchSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLaunchSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLaunchSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param lansmanId (optional) 
     * @return Success
     */
    sendMailForNewLaunch(lansmanId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/SendMailForNewLaunch?";
        if (lansmanId !== undefined && lansmanId !== null)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailForNewLaunch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailForNewLaunch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendMailForNewLaunch(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param lansmanId (optional) 
     * @return Success
     */
    createUserTitleBudgeForLaunch(lansmanId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/CreateUserTitleBudgeForLaunch?";
        if (lansmanId !== undefined && lansmanId !== null)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserTitleBudgeForLaunch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserTitleBudgeForLaunch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUserTitleBudgeForLaunch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param posmId (optional) 
     * @return Success
     */
    sendMailForNewPosm(posmId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/SendMailForNewPosm?";
        if (posmId !== undefined && posmId !== null)
            url_ += "posmId=" + encodeURIComponent("" + posmId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailForNewPosm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailForNewPosm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendMailForNewPosm(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param noFilter (optional) 
     * @param isSupervisoreChipDagitiminaAcik (optional) 
     * @param isSahaTaleplerineAcik (optional) 
     * @param isAktifLansmanlar (optional) 
     * @param markaId (optional) 
     * @return Success
     */
    getLaunches(noFilter: boolean | null | undefined, isSupervisoreChipDagitiminaAcik: boolean | null | undefined, isSahaTaleplerineAcik: boolean | null | undefined, isAktifLansmanlar: boolean | null | undefined, markaId: string | null | undefined): Observable<PagedResultDtoOfLaunchDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetLaunches?";
        if (noFilter !== undefined && noFilter !== null)
            url_ += "NoFilter=" + encodeURIComponent("" + noFilter) + "&";
        if (isSupervisoreChipDagitiminaAcik !== undefined && isSupervisoreChipDagitiminaAcik !== null)
            url_ += "IsSupervisoreChipDagitiminaAcik=" + encodeURIComponent("" + isSupervisoreChipDagitiminaAcik) + "&";
        if (isSahaTaleplerineAcik !== undefined && isSahaTaleplerineAcik !== null)
            url_ += "IsSahaTaleplerineAcik=" + encodeURIComponent("" + isSahaTaleplerineAcik) + "&";
        if (isAktifLansmanlar !== undefined && isAktifLansmanlar !== null)
            url_ += "IsAktifLansmanlar=" + encodeURIComponent("" + isAktifLansmanlar) + "&";
        if (markaId !== undefined && markaId !== null)
            url_ += "MarkaId=" + encodeURIComponent("" + markaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaunches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaunches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLaunchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLaunchDto>;
        }));
    }

    protected processGetLaunches(response: HttpResponseBase): Observable<PagedResultDtoOfLaunchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLaunchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLaunchDto>(null as any);
    }

    /**
     * @param launchId (optional) 
     * @return Success
     */
    getLaunch(launchId: string | null | undefined): Observable<LaunchDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetLaunch?";
        if (launchId !== undefined && launchId !== null)
            url_ += "launchId=" + encodeURIComponent("" + launchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaunch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaunch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LaunchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LaunchDto>;
        }));
    }

    protected processGetLaunch(response: HttpResponseBase): Observable<LaunchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LaunchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LaunchDto>(null as any);
    }

    /**
     * @param launchId (optional) 
     * @return Success
     */
    getLaunchPosmList(launchId: string | null | undefined): Observable<PosmDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetLaunchPosmList?";
        if (launchId !== undefined && launchId !== null)
            url_ += "launchId=" + encodeURIComponent("" + launchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaunchPosmList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaunchPosmList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosmDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosmDto[]>;
        }));
    }

    protected processGetLaunchPosmList(response: HttpResponseBase): Observable<PosmDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PosmDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmDto[]>(null as any);
    }

    /**
     * @param posmId (optional) 
     * @param taskType (optional) 
     * @return Success
     */
    getPosmProductionTasks(posmId: string | null | undefined, taskType: TaskType | null | undefined): Observable<PosmProductionTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetPosmProductionTasks?";
        if (posmId !== undefined && posmId !== null)
            url_ += "posmId=" + encodeURIComponent("" + posmId) + "&";
        if (taskType !== undefined && taskType !== null)
            url_ += "taskType=" + encodeURIComponent("" + taskType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosmProductionTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosmProductionTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosmProductionTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosmProductionTaskDto[]>;
        }));
    }

    protected processGetPosmProductionTasks(response: HttpResponseBase): Observable<PosmProductionTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PosmProductionTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionTaskDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getUserPosmProductionTasks(): Observable<PosmProductionTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetUserPosmProductionTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPosmProductionTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPosmProductionTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosmProductionTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosmProductionTaskDto[]>;
        }));
    }

    protected processGetUserPosmProductionTasks(response: HttpResponseBase): Observable<PosmProductionTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PosmProductionTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionTaskDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getUserPosmProductionTasksGroup(): Observable<PosmProductionTaskGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetUserPosmProductionTasksGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPosmProductionTasksGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPosmProductionTasksGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosmProductionTaskGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosmProductionTaskGroupDto[]>;
        }));
    }

    protected processGetUserPosmProductionTasksGroup(response: HttpResponseBase): Observable<PosmProductionTaskGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PosmProductionTaskGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionTaskGroupDto[]>(null as any);
    }

    /**
     * @param posmTaskId (optional) 
     * @return Success
     */
    getUserPosmProductionTask(posmTaskId: string | null | undefined): Observable<PosmProductionTaskInput> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetUserPosmProductionTask?";
        if (posmTaskId !== undefined && posmTaskId !== null)
            url_ += "posmTaskId=" + encodeURIComponent("" + posmTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPosmProductionTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPosmProductionTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosmProductionTaskInput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosmProductionTaskInput>;
        }));
    }

    protected processGetUserPosmProductionTask(response: HttpResponseBase): Observable<PosmProductionTaskInput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PosmProductionTaskInput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionTaskInput>(null as any);
    }

    /**
     * @param posmTaskId (optional) 
     * @return Success
     */
    getUserPosmProductionForAllSameTask(posmTaskId: string | null | undefined): Observable<PosmProductionTaskInput[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetUserPosmProductionForAllSameTask?";
        if (posmTaskId !== undefined && posmTaskId !== null)
            url_ += "posmTaskId=" + encodeURIComponent("" + posmTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPosmProductionForAllSameTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPosmProductionForAllSameTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosmProductionTaskInput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosmProductionTaskInput[]>;
        }));
    }

    protected processGetUserPosmProductionForAllSameTask(response: HttpResponseBase): Observable<PosmProductionTaskInput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PosmProductionTaskInput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionTaskInput[]>(null as any);
    }

    /**
     * @param posmId (optional) 
     * @return Success
     */
    createPosmProduceTasks(posmId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/CreatePosmProduceTasks?";
        if (posmId !== undefined && posmId !== null)
            url_ += "posmId=" + encodeURIComponent("" + posmId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePosmProduceTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePosmProduceTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreatePosmProduceTasks(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param posmId (optional) 
     * @return Success
     */
    createPosmProduceTasksV2(posmId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/CreatePosmProduceTasksV2?";
        if (posmId !== undefined && posmId !== null)
            url_ += "posmId=" + encodeURIComponent("" + posmId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePosmProduceTasksV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePosmProduceTasksV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreatePosmProduceTasksV2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeProductionTaskStatus(input: PosmProductionTaskInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/ChangeProductionTaskStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeProductionTaskStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeProductionTaskStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeProductionTaskStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param inputs (optional) 
     * @return Success
     */
    changeProductionTaskStatusMultiple(inputs: PosmProductionTaskInput[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/ChangeProductionTaskStatusMultiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeProductionTaskStatusMultiple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeProductionTaskStatusMultiple(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeProductionTaskStatusMultiple(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param posmTaskId (optional) 
     * @return Success
     */
    sendMailPosmTaskAssigned(posmTaskId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/SendMailPosmTaskAssigned?";
        if (posmTaskId !== undefined && posmTaskId !== null)
            url_ += "posmTaskId=" + encodeURIComponent("" + posmTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailPosmTaskAssigned(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailPosmTaskAssigned(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMailPosmTaskAssigned(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeProductionTaskStatusOLD(input: PosmProductionTaskInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/ChangeProductionTaskStatusOLD";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeProductionTaskStatusOLD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeProductionTaskStatusOLD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeProductionTaskStatusOLD(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    insertOrUpdatePosm(input: CreatePosmDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/InsertOrUpdatePosm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertOrUpdatePosm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertOrUpdatePosm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertOrUpdatePosm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param posmId (optional) 
     * @return Success
     */
    deletePosm(posmId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/DeletePosm?";
        if (posmId !== undefined && posmId !== null)
            url_ += "posmId=" + encodeURIComponent("" + posmId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePosm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePosm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePosm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getCoordinators(): Observable<ListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetCoordinators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoordinators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoordinators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListItemDto[]>;
        }));
    }

    protected processGetCoordinators(response: HttpResponseBase): Observable<ListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListItemDto[]>(null as any);
    }

    /**
     * @param coordinatorId (optional) 
     * @return Success
     */
    getSupervisors(coordinatorId: string | null | undefined): Observable<ListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetSupervisors?";
        if (coordinatorId !== undefined && coordinatorId !== null)
            url_ += "coordinatorId=" + encodeURIComponent("" + coordinatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupervisors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupervisors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListItemDto[]>;
        }));
    }

    protected processGetSupervisors(response: HttpResponseBase): Observable<ListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    testTest(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/TestTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param lansmanId (optional) 
     * @return Success
     */
    test123(lansmanId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/Test123?";
        if (lansmanId !== undefined && lansmanId !== null)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest123(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest123(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTest123(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    sendMailPosmTaskAssignedV2(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/SendMailPosmTaskAssignedV2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailPosmTaskAssignedV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailPosmTaskAssignedV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMailPosmTaskAssignedV2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    testButceBilgiMailiGonder(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/TestButceBilgiMailiGonder";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestButceBilgiMailiGonder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestButceBilgiMailiGonder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestButceBilgiMailiGonder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PosmProductionDemandServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfPosmProductionDemandDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionDemand/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPosmProductionDemandDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPosmProductionDemandDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfPosmProductionDemandDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPosmProductionDemandDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPosmProductionDemandDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreatePosmProductionDemandDto | null | undefined): Observable<PosmProductionDemandDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionDemand/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosmProductionDemandDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosmProductionDemandDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PosmProductionDemandDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PosmProductionDemandDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionDemandDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionDemand/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: PosmProductionDemandDto | null | undefined): Observable<PosmProductionDemandDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionDemand/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosmProductionDemandDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosmProductionDemandDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PosmProductionDemandDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PosmProductionDemandDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionDemandDto>(null as any);
    }

    /**
     * @return Success
     */
    getSuppliers(): Observable<ListResultDtoOfComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionDemand/GetSuppliers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuppliers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuppliers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfComboboxItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfComboboxItemDto>;
        }));
    }

    protected processGetSuppliers(response: HttpResponseBase): Observable<ListResultDtoOfComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfComboboxItemDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<PosmProductionDemandDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionDemand/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosmProductionDemandDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosmProductionDemandDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PosmProductionDemandDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PosmProductionDemandDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionDemandDto>(null as any);
    }
}

@Injectable()
export class PosmProductionRequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param lansmanId (optional) 
     * @param koordinatorId (optional) 
     * @return Success
     */
    downloadPopRequestDraftExcel(lansmanId: string | null | undefined, koordinatorId: string | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/DownloadPopRequestDraftExcel?";
        if (lansmanId !== undefined && lansmanId !== null)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        if (koordinatorId !== undefined && koordinatorId !== null)
            url_ += "koordinatorId=" + encodeURIComponent("" + koordinatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPopRequestDraftExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPopRequestDraftExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcelFileResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcelFileResultDto>;
        }));
    }

    protected processDownloadPopRequestDraftExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(null as any);
    }

    /**
     * @param lansmanId (optional) 
     * @return Success
     */
    downloadPosmOfTheLaunchExcel(lansmanId: string | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/DownloadPosmOfTheLaunchExcel?";
        if (lansmanId !== undefined && lansmanId !== null)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPosmOfTheLaunchExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPosmOfTheLaunchExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcelFileResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcelFileResultDto>;
        }));
    }

    protected processDownloadPosmOfTheLaunchExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(null as any);
    }

    /**
     * @param uploadDto (optional) 
     * @param lansmanId (optional) 
     * @param koordinatorId (optional) 
     * @return Success
     */
    uploadPopRequestExcel(uploadDto: PopRequestExcelUploadDto | null | undefined, lansmanId: string | null | undefined, koordinatorId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/UploadPopRequestExcel?";
        if (lansmanId !== undefined && lansmanId !== null)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        if (koordinatorId !== undefined && koordinatorId !== null)
            url_ += "koordinatorId=" + encodeURIComponent("" + koordinatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(uploadDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPopRequestExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPopRequestExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadPopRequestExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param lansmanId (optional) 
     * @param userUnvanType (optional) 
     * @param koordinatorId (optional) 
     * @return Success
     */
    getUserButceByLansman(lansmanId: string | null | undefined, userUnvanType: UserUnvanType | null | undefined, koordinatorId: string | null | undefined): Observable<UserButceDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/GetUserButceByLansman?";
        if (lansmanId !== undefined && lansmanId !== null)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        if (userUnvanType !== undefined && userUnvanType !== null)
            url_ += "userUnvanType=" + encodeURIComponent("" + userUnvanType) + "&";
        if (koordinatorId !== undefined && koordinatorId !== null)
            url_ += "koordinatorId=" + encodeURIComponent("" + koordinatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserButceByLansman(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserButceByLansman(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserButceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserButceDto>;
        }));
    }

    protected processGetUserButceByLansman(response: HttpResponseBase): Observable<UserButceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserButceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserButceDto>(null as any);
    }

    /**
     * @param lansmanId (optional) 
     * @return Success
     */
    getKoordinatorsButce(lansmanId: string | null | undefined): Observable<UserButceDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/GetKoordinatorsButce?";
        if (lansmanId !== undefined && lansmanId !== null)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKoordinatorsButce(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKoordinatorsButce(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserButceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserButceDto[]>;
        }));
    }

    protected processGetKoordinatorsButce(response: HttpResponseBase): Observable<UserButceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserButceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserButceDto[]>(null as any);
    }

    /**
     * @param lansmanId (optional) 
     * @return Success
     */
    getKoordinatorsSupervisorsButce(lansmanId: string | null | undefined): Observable<UserButceDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/GetKoordinatorsSupervisorsButce?";
        if (lansmanId !== undefined && lansmanId !== null)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKoordinatorsSupervisorsButce(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKoordinatorsSupervisorsButce(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserButceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserButceDto[]>;
        }));
    }

    protected processGetKoordinatorsSupervisorsButce(response: HttpResponseBase): Observable<UserButceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserButceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserButceDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getSupervisorsKoordinators(): Observable<SelectListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/GetSupervisorsKoordinators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupervisorsKoordinators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupervisorsKoordinators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectListItemDto[]>;
        }));
    }

    protected processGetSupervisorsKoordinators(response: HttpResponseBase): Observable<SelectListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SelectListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectListItemDto[]>(null as any);
    }

    /**
     * @param lansmanId (optional) 
     * @param assignedButces (optional) 
     * @return Success
     */
    assignButceToUser(lansmanId: string | null | undefined, assignedButces: UserAssignButceDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/AssignButceToUser?";
        if (lansmanId !== undefined && lansmanId !== null)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignedButces);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignButceToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignButceToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignButceToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param posmId (optional) 
     * @return Success
     */
    updatePosmToplamSahaTalebi(posmId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/UpdatePosmToplamSahaTalebi?";
        if (posmId !== undefined && posmId !== null)
            url_ += "posmId=" + encodeURIComponent("" + posmId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePosmToplamSahaTalebi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePosmToplamSahaTalebi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePosmToplamSahaTalebi(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param posmTalepId (optional) 
     * @return Success
     */
    uptPosmToplamSahaTalebiOnTalep(posmTalepId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/UptPosmToplamSahaTalebiOnTalep?";
        if (posmTalepId !== undefined && posmTalepId !== null)
            url_ += "posmTalepId=" + encodeURIComponent("" + posmTalepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUptPosmToplamSahaTalebiOnTalep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUptPosmToplamSahaTalebiOnTalep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUptPosmToplamSahaTalebiOnTalep(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PredictResultServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param inputForm (optional) 
     * @return Success
     */
    createImagePredictionResult(inputForm: ImagePredictionFormDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/PredictResult/CreateImagePredictionResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputForm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateImagePredictionResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateImagePredictionResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateImagePredictionResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param epochValue (optional) 
     * @return Success
     */
    getGenericFieldToEpochValue(epochValue: string | null | undefined): Observable<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/services/platom/portal/PredictResult/GetGenericFieldToEpochValue?";
        if (epochValue !== undefined && epochValue !== null)
            url_ += "epochValue=" + encodeURIComponent("" + epochValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGenericFieldToEpochValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenericFieldToEpochValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: number; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: number; }>;
        }));
    }

    protected processGetGenericFieldToEpochValue(response: HttpResponseBase): Observable<{ [key: string]: number; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: number; }>(null as any);
    }

    /**
     * @param recordId (optional) 
     * @return Success
     */
    getImagePredictionResult(recordId: string | null | undefined): Observable<PredictionResultDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/PredictResult/GetImagePredictionResult?";
        if (recordId !== undefined && recordId !== null)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImagePredictionResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImagePredictionResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PredictionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PredictionResultDto>;
        }));
    }

    protected processGetImagePredictionResult(response: HttpResponseBase): Observable<PredictionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PredictionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PredictionResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getImgPredictionComboValues(): Observable<PredictionModelParamsDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/PredictResult/GetImgPredictionComboValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImgPredictionComboValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImgPredictionComboValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PredictionModelParamsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PredictionModelParamsDto>;
        }));
    }

    protected processGetImgPredictionComboValues(response: HttpResponseBase): Observable<PredictionModelParamsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PredictionModelParamsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PredictionModelParamsDto>(null as any);
    }

    /**
     * @param inputObject (optional) 
     * @return Success
     */
    updateImagePredictionResult(inputObject: PredictionResultDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/PredictResult/UpdateImagePredictionResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputObject);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateImagePredictionResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateImagePredictionResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateImagePredictionResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param recordId (optional) 
     * @param feedbackMaps (optional) 
     * @param globalFeedback (optional) 
     * @return Success
     */
    setFeedback(recordId: string | null | undefined, feedbackMaps: FeedbackMaps[] | null | undefined, globalFeedback: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/PredictResult/SetFeedback?";
        if (recordId !== undefined && recordId !== null)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        if (globalFeedback !== undefined && globalFeedback !== null)
            url_ += "globalFeedback=" + encodeURIComponent("" + globalFeedback) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedbackMaps);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetFeedback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param withProductPhoto (optional) 
     * @return Success
     */
    test(withProductPhoto: boolean | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/Test?";
        if (withProductPhoto !== undefined && withProductPhoto !== null)
            url_ += "withProductPhoto=" + encodeURIComponent("" + withProductPhoto) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateProductDto | null | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: ProductDto | null | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForExcel(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<ExcelPagedResultDtoOfProductExcelDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetAllForExcel?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcelPagedResultDtoOfProductExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcelPagedResultDtoOfProductExcelDto>;
        }));
    }

    protected processGetAllForExcel(response: HttpResponseBase): Observable<ExcelPagedResultDtoOfProductExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelPagedResultDtoOfProductExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelPagedResultDtoOfProductExcelDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfProductDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfProductDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProductDto>(null as any);
    }

    /**
     * @return Success
     */
    getUserWarehouseListByStockViewAuth(): Observable<ProductDomainWarehouseInput[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetUserWarehouseListByStockViewAuth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWarehouseListByStockViewAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWarehouseListByStockViewAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDomainWarehouseInput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDomainWarehouseInput[]>;
        }));
    }

    protected processGetUserWarehouseListByStockViewAuth(response: HttpResponseBase): Observable<ProductDomainWarehouseInput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDomainWarehouseInput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDomainWarehouseInput[]>(null as any);
    }

    /**
     * @return Success
     */
    getBusinessUnitFiltersWithBrands(): Observable<SelectListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetBusinessUnitFiltersWithBrands";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessUnitFiltersWithBrands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessUnitFiltersWithBrands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectListItemDto[]>;
        }));
    }

    protected processGetBusinessUnitFiltersWithBrands(response: HttpResponseBase): Observable<SelectListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SelectListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectListItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getUserType3Attributes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetUserType3Attributes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserType3Attributes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserType3Attributes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetUserType3Attributes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param brandIds (optional) 
     * @param typeNames (optional) 
     * @param businessUnits (optional) 
     * @param warehouses (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWarehousesProductStockListByUserAuths(brandIds: number[] | null | undefined, typeNames: string[] | null | undefined, businessUnits: number[] | null | undefined, warehouses: any[] | null | undefined, keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfProductDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetWarehousesProductStockListByUserAuths?";
        if (brandIds !== undefined && brandIds !== null)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (typeNames !== undefined && typeNames !== null)
            typeNames && typeNames.forEach(item => { url_ += "TypeNames=" + encodeURIComponent("" + item) + "&"; });
        if (businessUnits !== undefined && businessUnits !== null)
            businessUnits && businessUnits.forEach(item => { url_ += "BusinessUnits=" + encodeURIComponent("" + item) + "&"; });
        if (warehouses !== undefined && warehouses !== null)
            warehouses && warehouses.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Warehouses[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehousesProductStockListByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehousesProductStockListByUserAuths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfProductDto>;
        }));
    }

    protected processGetWarehousesProductStockListByUserAuths(response: HttpResponseBase): Observable<PagedResultDtoOfProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProductDto>(null as any);
    }

    /**
     * @param brandIds (optional) 
     * @param typeNames (optional) 
     * @param businessUnits (optional) 
     * @param warehouses (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param withProductPhoto (optional) 
     * @param isWriteSubWarehouse (optional) 
     * @return Success
     */
    getWarehousesProductStockListByUserAuthsToExcel(brandIds: number[] | null | undefined, typeNames: string[] | null | undefined, businessUnits: number[] | null | undefined, warehouses: any[] | null | undefined, keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, withProductPhoto: boolean | null | undefined, isWriteSubWarehouse: boolean | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetWarehousesProductStockListByUserAuthsToExcel?";
        if (brandIds !== undefined && brandIds !== null)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (typeNames !== undefined && typeNames !== null)
            typeNames && typeNames.forEach(item => { url_ += "TypeNames=" + encodeURIComponent("" + item) + "&"; });
        if (businessUnits !== undefined && businessUnits !== null)
            businessUnits && businessUnits.forEach(item => { url_ += "BusinessUnits=" + encodeURIComponent("" + item) + "&"; });
        if (warehouses !== undefined && warehouses !== null)
            warehouses && warehouses.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Warehouses[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (withProductPhoto !== undefined && withProductPhoto !== null)
            url_ += "withProductPhoto=" + encodeURIComponent("" + withProductPhoto) + "&";
        if (isWriteSubWarehouse !== undefined && isWriteSubWarehouse !== null)
            url_ += "isWriteSubWarehouse=" + encodeURIComponent("" + isWriteSubWarehouse) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehousesProductStockListByUserAuthsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehousesProductStockListByUserAuthsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcelFileResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcelFileResultDto>;
        }));
    }

    protected processGetWarehousesProductStockListByUserAuthsToExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(null as any);
    }

    /**
     * @param forExcelList (optional) 
     * @param rootPath (optional) 
     * @param isWithPhoto (optional) 
     * @param currentUserMail (optional) 
     * @return Success
     */
    createProductExcelFileAndSendMail(forExcelList: ProductStockExcelDto[] | null | undefined, rootPath: string | null | undefined, isWithPhoto: boolean | null | undefined, currentUserMail: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/CreateProductExcelFileAndSendMail?";
        if (rootPath !== undefined && rootPath !== null)
            url_ += "rootPath=" + encodeURIComponent("" + rootPath) + "&";
        if (isWithPhoto !== undefined && isWithPhoto !== null)
            url_ += "isWithPhoto=" + encodeURIComponent("" + isWithPhoto) + "&";
        if (currentUserMail !== undefined && currentUserMail !== null)
            url_ += "currentUserMail=" + encodeURIComponent("" + currentUserMail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forExcelList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductExcelFileAndSendMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductExcelFileAndSendMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProductExcelFileAndSendMail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param warehouseCode (optional) 
     * @param damageStatusType (optional) 
     * @return Success
     */
    getDistinctSpecialCodesFromWarehousesProductList(warehouseId: number | null | undefined, warehouseCode: string | null | undefined, damageStatusType: DamageStatusType | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetDistinctSpecialCodesFromWarehousesProductList?";
        if (warehouseId !== undefined && warehouseId !== null)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (warehouseCode !== undefined && warehouseCode !== null)
            url_ += "WarehouseCode=" + encodeURIComponent("" + warehouseCode) + "&";
        if (damageStatusType !== undefined && damageStatusType !== null)
            url_ += "DamageStatusType=" + encodeURIComponent("" + damageStatusType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistinctSpecialCodesFromWarehousesProductList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistinctSpecialCodesFromWarehousesProductList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetDistinctSpecialCodesFromWarehousesProductList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param warehouseCode (optional) 
     * @param specialCode (optional) 
     * @param brandIds (optional) 
     * @param damageStatusType (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param componentType (optional) 
     * @return Success
     */
    getFormWarehouseProductListByUserAuths(warehouseId: number | null | undefined, warehouseCode: string | null | undefined, specialCode: string | null | undefined, brandIds: number[] | null | undefined, damageStatusType: DamageStatusType2 | null | undefined, keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, componentType: ComponentType | null | undefined): Observable<PagedResultDtoOfProductDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetFormWarehouseProductListByUserAuths?";
        if (warehouseId !== undefined && warehouseId !== null)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (warehouseCode !== undefined && warehouseCode !== null)
            url_ += "WarehouseCode=" + encodeURIComponent("" + warehouseCode) + "&";
        if (specialCode !== undefined && specialCode !== null)
            url_ += "SpecialCode=" + encodeURIComponent("" + specialCode) + "&";
        if (brandIds !== undefined && brandIds !== null)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (damageStatusType !== undefined && damageStatusType !== null)
            url_ += "DamageStatusType=" + encodeURIComponent("" + damageStatusType) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (componentType !== undefined && componentType !== null)
            url_ += "componentType=" + encodeURIComponent("" + componentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormWarehouseProductListByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormWarehouseProductListByUserAuths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfProductDto>;
        }));
    }

    protected processGetFormWarehouseProductListByUserAuths(response: HttpResponseBase): Observable<PagedResultDtoOfProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProductDto>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param warehouseCode (optional) 
     * @param specialCode (optional) 
     * @param brandIds (optional) 
     * @param damageStatusType (optional) 
     * @param productId (optional) 
     * @return Success
     */
    getProductVariationStocks(warehouseId: number | null | undefined, warehouseCode: string | null | undefined, specialCode: string | null | undefined, brandIds: number[] | null | undefined, damageStatusType: DamageStatusType3 | null | undefined, productId: number | null | undefined): Observable<ProductVariationStocksOutputDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetProductVariationStocks?";
        if (warehouseId !== undefined && warehouseId !== null)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (warehouseCode !== undefined && warehouseCode !== null)
            url_ += "WarehouseCode=" + encodeURIComponent("" + warehouseCode) + "&";
        if (specialCode !== undefined && specialCode !== null)
            url_ += "SpecialCode=" + encodeURIComponent("" + specialCode) + "&";
        if (brandIds !== undefined && brandIds !== null)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (damageStatusType !== undefined && damageStatusType !== null)
            url_ += "DamageStatusType=" + encodeURIComponent("" + damageStatusType) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductVariationStocks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductVariationStocks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariationStocksOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariationStocksOutputDto>;
        }));
    }

    protected processGetProductVariationStocks(response: HttpResponseBase): Observable<ProductVariationStocksOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductVariationStocksOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductVariationStocksOutputDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    getProductDetails(productId: number | null | undefined): Observable<ProductDetailsDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetProductDetails?";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDetailsDto>;
        }));
    }

    protected processGetProductDetails(response: HttpResponseBase): Observable<ProductDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDetailsDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    getProductInfo(productId: number | null | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetProductInfo?";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processGetProductInfo(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    getProductStockInWarehouses(productId: number | null | undefined): Observable<ProductDetailsWarehouseStockDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetProductStockInWarehouses?";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductStockInWarehouses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductStockInWarehouses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDetailsWarehouseStockDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDetailsWarehouseStockDto[]>;
        }));
    }

    protected processGetProductStockInWarehouses(response: HttpResponseBase): Observable<ProductDetailsWarehouseStockDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDetailsWarehouseStockDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDetailsWarehouseStockDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param oldestDay (optional) 
     * @return Success
     */
    getDeliveredOrderQtyByUsers(productId: number | null | undefined, oldestDay: number | null | undefined): Observable<ProductDomainUserOrderDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetDeliveredOrderQtyByUsers?";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (oldestDay !== undefined && oldestDay !== null)
            url_ += "oldestDay=" + encodeURIComponent("" + oldestDay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveredOrderQtyByUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveredOrderQtyByUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDomainUserOrderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDomainUserOrderDto[]>;
        }));
    }

    protected processGetDeliveredOrderQtyByUsers(response: HttpResponseBase): Observable<ProductDomainUserOrderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDomainUserOrderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDomainUserOrderDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param oldestDay (optional) 
     * @return Success
     */
    getDeliveredOrderQtyByAddress(productId: number | null | undefined, oldestDay: number | null | undefined): Observable<ProductDomainAddressOrderDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetDeliveredOrderQtyByAddress?";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (oldestDay !== undefined && oldestDay !== null)
            url_ += "oldestDay=" + encodeURIComponent("" + oldestDay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveredOrderQtyByAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveredOrderQtyByAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDomainAddressOrderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDomainAddressOrderDto[]>;
        }));
    }

    protected processGetDeliveredOrderQtyByAddress(response: HttpResponseBase): Observable<ProductDomainAddressOrderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDomainAddressOrderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDomainAddressOrderDto[]>(null as any);
    }
}

@Injectable()
export class ProductAttributeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @param customerId (optional) 
     * @param authorizationId (optional) 
     * @return Success
     */
    getUserUnAssignedProductAttributes(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, userId: number | null | undefined, customerId: number | null | undefined, authorizationId: number | null | undefined): Observable<PagedResultDtoOfProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductAttribute/GetUserUnAssignedProductAttributes?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (authorizationId !== undefined && authorizationId !== null)
            url_ += "authorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedProductAttributes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedProductAttributes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfProductAttributeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfProductAttributeDto>;
        }));
    }

    protected processGetUserUnAssignedProductAttributes(response: HttpResponseBase): Observable<PagedResultDtoOfProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProductAttributeDto>(null as any);
    }

    /**
     * @param businessUnitId (optional) 
     * @return Success
     */
    getBrandsByBusinessUnitId(businessUnitId: number | null | undefined): Observable<ProductAttributeDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductAttribute/GetBrandsByBusinessUnitId?";
        if (businessUnitId !== undefined && businessUnitId !== null)
            url_ += "businessUnitId=" + encodeURIComponent("" + businessUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBrandsByBusinessUnitId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrandsByBusinessUnitId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductAttributeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductAttributeDto[]>;
        }));
    }

    protected processGetBrandsByBusinessUnitId(response: HttpResponseBase): Observable<ProductAttributeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductAttributeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductAttributeDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<ProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductAttribute/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductAttributeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductAttributeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductAttributeDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductAttribute/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfProductAttributeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfProductAttributeDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProductAttributeDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateProductAttributeDto | null | undefined): Observable<ProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductAttribute/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductAttributeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductAttributeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductAttributeDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: ProductAttributeDto | null | undefined): Observable<ProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductAttribute/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductAttributeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductAttributeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductAttributeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductAttribute/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProductDamageStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfProductDamageStatusDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductDamageStatus/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfProductDamageStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfProductDamageStatusDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfProductDamageStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProductDamageStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProductDamageStatusDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<ProductDamageStatusDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductDamageStatus/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDamageStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDamageStatusDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductDamageStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDamageStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDamageStatusDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: ProductDamageStatusDto | null | undefined): Observable<ProductDamageStatusDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductDamageStatus/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDamageStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDamageStatusDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductDamageStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDamageStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDamageStatusDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: ProductDamageStatusDto | null | undefined): Observable<ProductDamageStatusDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductDamageStatus/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDamageStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDamageStatusDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProductDamageStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDamageStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDamageStatusDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductDamageStatus/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReceiptViewerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param recordId (optional) 
     * @return Success
     */
    getReceiptViewerResult(recordId: string | null | undefined): Observable<RvServerResponseDataDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/ReceiptViewer/GetReceiptViewerResult?";
        if (recordId !== undefined && recordId !== null)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiptViewerResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptViewerResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RvServerResponseDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RvServerResponseDataDto>;
        }));
    }

    protected processGetReceiptViewerResult(response: HttpResponseBase): Observable<RvServerResponseDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RvServerResponseDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RvServerResponseDataDto>(null as any);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getUserUnAssignedReports(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, userId: number | null | undefined): Observable<PagedResultDtoOfReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/GetUserUnAssignedReports?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportDto>;
        }));
    }

    protected processGetUserUnAssignedReports(response: HttpResponseBase): Observable<PagedResultDtoOfReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportDto>(null as any);
    }

    /**
     * @param dashboardId (optional) 
     * @return Success
     */
    getDashboardFromMetabase(dashboardId: number | null | undefined): Observable<MetabaseDashboardOutput> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/GetDashboardFromMetabase?";
        if (dashboardId !== undefined && dashboardId !== null)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardFromMetabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardFromMetabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetabaseDashboardOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetabaseDashboardOutput>;
        }));
    }

    protected processGetDashboardFromMetabase(response: HttpResponseBase): Observable<MetabaseDashboardOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutput>(null as any);
    }

    /**
     * @return Success
     */
    mailTest(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/MailTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMailTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMailTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    smsTest(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/SmsTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSmsTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSmsTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSmsTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<ReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateReportDto | null | undefined): Observable<ReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: ReportDto | null | undefined): Observable<ReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateRoleDto | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | null | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRolesAsync?";
        if (permission !== undefined && permission !== null)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfRoleListDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleListDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: RoleDto | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfPermissionDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfPermissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfPermissionDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfPermissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfPermissionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfPermissionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | null | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRoleDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRoleDto>(null as any);
    }
}

@Injectable()
export class RutPlanDetayiServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param newRecord (optional) 
     * @return Success
     */
    create(newRecord: CreateRutPlanDetayiDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlanDetayi/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newRecord);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param recordId (optional) 
     * @return Success
     */
    delete(recordId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlanDetayi/Delete?";
        if (recordId !== undefined && recordId !== null)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param recordId (optional) 
     * @return Success
     */
    get(recordId: string | null | undefined): Observable<RutPlanDetayiDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlanDetayi/Get?";
        if (recordId !== undefined && recordId !== null)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RutPlanDetayiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RutPlanDetayiDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RutPlanDetayiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RutPlanDetayiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RutPlanDetayiDto>(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<RutPlanDetayiDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlanDetayi/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RutPlanDetayiDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RutPlanDetayiDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RutPlanDetayiDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RutPlanDetayiDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RutPlanDetayiDto[]>(null as any);
    }

    /**
     * @param rutPlanRecordId (optional) 
     * @return Success
     */
    getAllByRutPlani(rutPlanRecordId: string | null | undefined): Observable<RutPlanDetayiDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlanDetayi/GetAllByRutPlani?";
        if (rutPlanRecordId !== undefined && rutPlanRecordId !== null)
            url_ += "rutPlanRecordId=" + encodeURIComponent("" + rutPlanRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByRutPlani(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByRutPlani(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RutPlanDetayiDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RutPlanDetayiDto[]>;
        }));
    }

    protected processGetAllByRutPlani(response: HttpResponseBase): Observable<RutPlanDetayiDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RutPlanDetayiDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RutPlanDetayiDto[]>(null as any);
    }

    /**
     * @param updateRecord (optional) 
     * @return Success
     */
    update(updateRecord: UpdateRutPlanDetayiDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlanDetayi/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateRecord);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRutPlanDetayDurumlari(): Observable<Anonymous[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlanDetayi/GetRutPlanDetayDurumlari";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRutPlanDetayDurumlari(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRutPlanDetayDurumlari(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous[]>;
        }));
    }

    protected processGetRutPlanDetayDurumlari(response: HttpResponseBase): Observable<Anonymous[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous[]>(null as any);
    }

    /**
     * @return Success
     */
    getRutPlanDetayCalismaGunleri(): Observable<Anonymous2[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlanDetayi/GetRutPlanDetayCalismaGunleri";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRutPlanDetayCalismaGunleri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRutPlanDetayCalismaGunleri(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous2[]>;
        }));
    }

    protected processGetRutPlanDetayCalismaGunleri(response: HttpResponseBase): Observable<Anonymous2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous2[]>(null as any);
    }
}

@Injectable()
export class RutPlaniServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param newRecord (optional) 
     * @return Success
     */
    create(newRecord: CreateRutPlaniDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlani/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newRecord);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param recordId (optional) 
     * @return Success
     */
    delete(recordId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlani/Delete?";
        if (recordId !== undefined && recordId !== null)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param recordId (optional) 
     * @return Success
     */
    get(recordId: string | null | undefined): Observable<RutPlaniDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlani/Get?";
        if (recordId !== undefined && recordId !== null)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RutPlaniDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RutPlaniDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RutPlaniDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RutPlaniDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RutPlaniDto>(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<RutPlaniDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlani/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RutPlaniDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RutPlaniDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RutPlaniDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RutPlaniDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RutPlaniDto[]>(null as any);
    }

    /**
     * @param updateDto (optional) 
     * @return Success
     */
    update(updateDto: UpdateRutPlaniDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlani/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRutPlanDurumlari(): Observable<Anonymous3[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlani/GetRutPlanDurumlari";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRutPlanDurumlari(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRutPlanDurumlari(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous3[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous3[]>;
        }));
    }

    protected processGetRutPlanDurumlari(response: HttpResponseBase): Observable<Anonymous3[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous3[]>(null as any);
    }

    /**
     * @return Success
     */
    getRutPlanFrekans(): Observable<Anonymous4[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/RutPlani/GetRutPlanFrekans";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRutPlanFrekans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRutPlanFrekans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous4[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous4[]>;
        }));
    }

    protected processGetRutPlanFrekans(response: HttpResponseBase): Observable<Anonymous4[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous4[]>(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(null as any);
    }
}

@Injectable()
export class StaffMapTrackingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param recordId (optional) 
     * @return Success
     */
    getStaffLocationInfo(recordId: string | null | undefined): Observable<StaffLocationInfoResponseDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/StaffMapTracking/GetStaffLocationInfo?";
        if (recordId !== undefined && recordId !== null)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffLocationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffLocationInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffLocationInfoResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffLocationInfoResponseDto>;
        }));
    }

    protected processGetStaffLocationInfo(response: HttpResponseBase): Observable<StaffLocationInfoResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffLocationInfoResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StaffLocationInfoResponseDto>(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateTenantDto | null | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfTenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfTenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTenantDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: TenantDto | null | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }
}

@Injectable()
export class TestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @return Success
     */
    getPersonList(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/GetPersonList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetPersonList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param mesaj (optional) 
     * @return Success
     */
    test1Encryption(mesaj: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/Test1Encryption?";
        if (mesaj !== undefined && mesaj !== null)
            url_ += "mesaj=" + encodeURIComponent("" + mesaj) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest1Encryption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest1Encryption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTest1Encryption(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param mesaj (optional) 
     * @return Success
     */
    test2Decryption(mesaj: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/Test2Decryption?";
        if (mesaj !== undefined && mesaj !== null)
            url_ += "mesaj=" + encodeURIComponent("" + mesaj) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest2Decryption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest2Decryption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTest2Decryption(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    sendTestSms(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/SendTestSms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    test(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    addSmsToPlatom(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/AddSmsToPlatom";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSmsToPlatom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSmsToPlatom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddSmsToPlatom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    addLansmanToTranspopCrm(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/AddLansmanToTranspopCrm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLansmanToTranspopCrm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLansmanToTranspopCrm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddLansmanToTranspopCrm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    nakliyeTalepTest(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/NakliyeTalepTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNakliyeTalepTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNakliyeTalepTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processNakliyeTalepTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    nakliyeTalepTest2(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/NakliyeTalepTest2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNakliyeTalepTest2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNakliyeTalepTest2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processNakliyeTalepTest2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    transpopOrgTest(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/TranspopOrgTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTranspopOrgTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTranspopOrgTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTranspopOrgTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    lansmanTest(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/LansmanTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLansmanTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLansmanTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processLansmanTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    tets123(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/Tets123";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTets123(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTets123(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTets123(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    testLocation(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/TestLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    testSatinAlma(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/TestSatinAlma";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestSatinAlma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestSatinAlma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestSatinAlma(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    test1234(): Observable<{ [key: string]: any; }> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/Test1234";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest1234(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest1234(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: any; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: any; }>;
        }));
    }

    protected processTest1234(response: HttpResponseBase): Observable<{ [key: string]: any; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: any; }>(null as any);
    }

    /**
     * @return Success
     */
    getTiger(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/GetTiger";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetTiger(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    createVakifbankPhotoLink(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/CreateVakifbankPhotoLink";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVakifbankPhotoLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVakifbankPhotoLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateVakifbankPhotoLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    createFerreroPaylasimliMerchPhotoLink(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/CreateFerreroPaylasimliMerchPhotoLink";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFerreroPaylasimliMerchPhotoLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFerreroPaylasimliMerchPhotoLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateFerreroPaylasimliMerchPhotoLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAndSaveDynamicFormPhotos2AsZip(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/GetAndSaveDynamicFormPhotos2AsZip";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAndSaveDynamicFormPhotos2AsZip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAndSaveDynamicFormPhotos2AsZip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAndSaveDynamicFormPhotos2AsZip(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    saveKureselUrunFotolari(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/SaveKureselUrunFotolari";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveKureselUrunFotolari(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveKureselUrunFotolari(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveKureselUrunFotolari(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAndSaveDynamicFormPhotos2AsPowerPoint(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/GetAndSaveDynamicFormPhotos2AsPowerPoint";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAndSaveDynamicFormPhotos2AsPowerPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAndSaveDynamicFormPhotos2AsPowerPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAndSaveDynamicFormPhotos2AsPowerPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getMyName(): Observable<TestDto> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/GetMyName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TestDto>;
        }));
    }

    protected processGetMyName(response: HttpResponseBase): Observable<TestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TestDto>(null as any);
    }

    /**
     * @return Success
     */
    openXmlPresentationTest(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/OpenXmlPresentationTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenXmlPresentationTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenXmlPresentationTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpenXmlPresentationTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    testLogodanCarileriAl(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/Test/TestLogodanCarileriAl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestLogodanCarileriAl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestLogodanCarileriAl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestLogodanCarileriAl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @return Success
     */
    _TestHangfire(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/_TestHangfire";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process_TestHangfire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process_TestHangfire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected process_TestHangfire(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param customerId (optional) 
     * @param excludedTitleIds (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, customerId: number | null | undefined, excludedTitleIds: number[] | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfTitleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (excludedTitleIds !== undefined && excludedTitleIds !== null)
            excludedTitleIds && excludedTitleIds.forEach(item => { url_ += "ExcludedTitleIds=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTitleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTitleDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfTitleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTitleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTitleDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateTitleDto | null | undefined): Observable<TitleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TitleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TitleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TitleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TitleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TitleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: TitleDto | null | undefined): Observable<TitleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TitleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TitleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TitleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TitleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TitleDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param customerId (optional) 
     * @return Success
     */
    getUserUnAssignedTitles(userId: number | null | undefined, customerId: number | null | undefined): Observable<TitleDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/GetUserUnAssignedTitles?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TitleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TitleDto[]>;
        }));
    }

    protected processGetUserUnAssignedTitles(response: HttpResponseBase): Observable<TitleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TitleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TitleDto[]>(null as any);
    }

    /**
     * @return Success
     */
    sendMailTest(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/SendMailTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMailTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    stokManagerTestSchedule(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/StokManagerTestSchedule";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStokManagerTestSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStokManagerTestSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStokManagerTestSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    stokManagerTest(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/StokManagerTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStokManagerTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStokManagerTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStokManagerTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param customerId (optional) 
     * @param customerCode (optional) 
     * @param isWriteSubWarehouse (optional) 
     * @return Success
     */
    generateStockExcel(userId: number | null | undefined, customerId: number | null | undefined, customerCode: string | null | undefined, isWriteSubWarehouse: boolean | null | undefined): Observable<ProductStockPto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/GenerateStockExcel?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (customerCode !== undefined && customerCode !== null)
            url_ += "customerCode=" + encodeURIComponent("" + customerCode) + "&";
        if (isWriteSubWarehouse !== undefined && isWriteSubWarehouse !== null)
            url_ += "isWriteSubWarehouse=" + encodeURIComponent("" + isWriteSubWarehouse) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateStockExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateStockExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductStockPto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductStockPto[]>;
        }));
    }

    protected processGenerateStockExcel(response: HttpResponseBase): Observable<ProductStockPto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductStockPto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductStockPto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<TitleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TitleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TitleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TitleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TitleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TitleDto>(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param model (optional) 
     * @return Success
     */
    authenticate(model: AuthenticateModel | null | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * @param model (optional) 
     * @return Success
     */
    externalAuthenticate(model: ExternalAuthenticateModel | null | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(null as any);
    }
}

@Injectable()
export class TransportBidServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param nakliyeTeklifId (optional) 
     * @return Success
     */
    getBidContent(nakliyeTeklifId: string | null | undefined): Observable<TransportBidInfoDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/TransportBid/GetBidContent?";
        if (nakliyeTeklifId !== undefined && nakliyeTeklifId !== null)
            url_ += "nakliyeTeklifId=" + encodeURIComponent("" + nakliyeTeklifId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBidContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBidContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransportBidInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransportBidInfoDto>;
        }));
    }

    protected processGetBidContent(response: HttpResponseBase): Observable<TransportBidInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransportBidInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransportBidInfoDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateBidPrice(input: UpdateTransportBidDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/TransportBid/UpdateBidPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBidPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBidPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBidPrice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateBidDriverInfo(input: UpdateTransportBidDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/TransportBid/UpdateBidDriverInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBidDriverInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBidDriverInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBidDriverInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param nakliyeTeklifId (optional) 
     * @return Success
     */
    sendSmsForBid(nakliyeTeklifId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/TransportBid/SendSmsForBid?";
        if (nakliyeTeklifId !== undefined && nakliyeTeklifId !== null)
            url_ += "nakliyeTeklifId=" + encodeURIComponent("" + nakliyeTeklifId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSmsForBid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSmsForBid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendSmsForBid(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param nakliyeTeklifId (optional) 
     * @return Success
     */
    sendSmsForBidApprove(nakliyeTeklifId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/TransportBid/SendSmsForBidApprove?";
        if (nakliyeTeklifId !== undefined && nakliyeTeklifId !== null)
            url_ += "nakliyeTeklifId=" + encodeURIComponent("" + nakliyeTeklifId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSmsForBidApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSmsForBidApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendSmsForBidApprove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param isDeleted (optional) 
     * @param customerId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, isDeleted: boolean | null | undefined, customerId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (isDeleted !== undefined && isDeleted !== null)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserDto | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserDto | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<ListResultDtoOfRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfRoleDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeLanguage(input: ChangeUserLanguageDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changePassword(input: ChangePasswordDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resetPassword(input: ResetPasswordDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUsersCustomers(userId: number | null | undefined): Observable<UserCustomerInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersCustomers?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCustomerInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCustomerInfoDto[]>;
        }));
    }

    protected processGetUsersCustomers(response: HttpResponseBase): Observable<UserCustomerInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserCustomerInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCustomerInfoDto[]>(null as any);
    }

    /**
     * @param titleId (optional) 
     * @return Success
     */
    getTitleUsers(titleId: number | null | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetTitleUsers?";
        if (titleId !== undefined && titleId !== null)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitleUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitleUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetTitleUsers(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param password (optional) 
     * @param newUserCustomerId (optional) 
     * @return Success
     */
    changeUserCustomer(userId: number | null | undefined, password: string | null | undefined, newUserCustomerId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeUserCustomer?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (newUserCustomerId !== undefined && newUserCustomerId !== null)
            url_ += "newUserCustomerId=" + encodeURIComponent("" + newUserCustomerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUserCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUserCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUserCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    setActiveToUser(userId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/SetActiveToUser?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetActiveToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetActiveToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetActiveToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    cloneUser(input: CloneUserDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/User/CloneUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloneUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCloneUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    cloneUser2(input: CloneUserDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/User/CloneUser2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloneUser2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneUser2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCloneUser2(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getTestUsers(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetTestUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTestUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTestUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTestUsers(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }
}

@Injectable()
export class UserActionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param minute (optional) 
     * @return Success
     */
    getLastTenMinutesLogins(minute: number | null | undefined): Observable<LastLoggedUsersDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAction/GetLastTenMinutesLogins?";
        if (minute !== undefined && minute !== null)
            url_ += "minute=" + encodeURIComponent("" + minute) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastTenMinutesLogins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastTenMinutesLogins(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LastLoggedUsersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LastLoggedUsersDto[]>;
        }));
    }

    protected processGetLastTenMinutesLogins(response: HttpResponseBase): Observable<LastLoggedUsersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LastLoggedUsersDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LastLoggedUsersDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param durumId (optional) 
     * @return Success
     */
    getUserActions(userId: number | null | undefined, durumId: number | null | undefined): Observable<UserActionDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAction/GetUserActions?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (durumId !== undefined && durumId !== null)
            url_ += "durumId=" + encodeURIComponent("" + durumId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserActionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserActionDto[]>;
        }));
    }

    protected processGetUserActions(response: HttpResponseBase): Observable<UserActionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserActionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserActionDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    getUserLastLoginsDetails(userId: number | null | undefined, startTime: Date | null | undefined, endTime: Date | null | undefined): Observable<UserLastLoginDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAction/GetUserLastLoginsDetails?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLastLoginsDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLastLoginsDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLastLoginDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLastLoginDto[]>;
        }));
    }

    protected processGetUserLastLoginsDetails(response: HttpResponseBase): Observable<UserLastLoginDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserLastLoginDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLastLoginDto[]>(null as any);
    }
}

@Injectable()
export class UserAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param cityId (optional) 
     * @param categoryName (optional) 
     * @param authorizationId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserAssignedAddresses(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, cityId: number | null | undefined, categoryName: string | null | undefined, authorizationId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/GetUserAssignedAddresses?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (cityId !== undefined && cityId !== null)
            url_ += "CityId=" + encodeURIComponent("" + cityId) + "&";
        if (categoryName !== undefined && categoryName !== null)
            url_ += "CategoryName=" + encodeURIComponent("" + categoryName) + "&";
        if (authorizationId !== undefined && authorizationId !== null)
            url_ += "AuthorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedAddresses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserAddressDto>;
        }));
    }

    protected processGetUserAssignedAddresses(response: HttpResponseBase): Observable<PagedResultDtoOfUserAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserAddressDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserAddressesCitiesAndCategories(userId: number | null | undefined): Observable<UserAddressCitiesAndCategoriesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/GetUserAddressesCitiesAndCategories?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAddressesCitiesAndCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAddressesCitiesAndCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAddressCitiesAndCategoriesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAddressCitiesAndCategoriesDto>;
        }));
    }

    protected processGetUserAddressesCitiesAndCategories(response: HttpResponseBase): Observable<UserAddressCitiesAndCategoriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAddressCitiesAndCategoriesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAddressCitiesAndCategoriesDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignAddressToUser(input: CreateUserAddressDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/SetAssignAddressToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignAddressToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignAddressToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssignAddressToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userAddressIds (optional) 
     * @return Success
     */
    setUnAssignAddressToUser(userAddressIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/SetUnAssignAddressToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userAddressIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignAddressToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignAddressToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUnAssignAddressToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAddressDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAddressDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param cityId (optional) 
     * @param categoryName (optional) 
     * @param authorizationId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, cityId: number | null | undefined, categoryName: string | null | undefined, authorizationId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (cityId !== undefined && cityId !== null)
            url_ += "CityId=" + encodeURIComponent("" + cityId) + "&";
        if (categoryName !== undefined && categoryName !== null)
            url_ += "CategoryName=" + encodeURIComponent("" + categoryName) + "&";
        if (authorizationId !== undefined && authorizationId !== null)
            url_ += "AuthorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserAddressDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserAddressDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserAddressDto | null | undefined): Observable<UserAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAddressDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAddressDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserAddressDto | null | undefined): Observable<UserAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAddressDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAddressDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserAuthorizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserAssignedAuthorizations(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/GetUserAssignedAuthorizations?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedAuthorizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedAuthorizations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserAuthorizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserAuthorizationDto>;
        }));
    }

    protected processGetUserAssignedAuthorizations(response: HttpResponseBase): Observable<PagedResultDtoOfUserAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserAuthorizationDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignAuthorizationsToUser(input: CreateUserAuthorizationDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/SetAssignAuthorizationsToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignAuthorizationsToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignAuthorizationsToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssignAuthorizationsToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userAuthorizationIds (optional) 
     * @return Success
     */
    setUnAssignAuthorizationsToUser(userAuthorizationIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/SetUnAssignAuthorizationsToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userAuthorizationIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignAuthorizationsToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignAuthorizationsToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUnAssignAuthorizationsToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAuthorizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAuthorizationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAuthorizationDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserAuthorizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserAuthorizationDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserAuthorizationDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserAuthorizationDto | null | undefined): Observable<UserAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAuthorizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAuthorizationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAuthorizationDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserAuthorizationDto | null | undefined): Observable<UserAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAuthorizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAuthorizationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAuthorizationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserCitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserAssignedCities(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserCitiesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/GetUserAssignedCities?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedCities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserCitiesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserCitiesDto>;
        }));
    }

    protected processGetUserAssignedCities(response: HttpResponseBase): Observable<PagedResultDtoOfUserCitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserCitiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserCitiesDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateUserCities(input: UpdateUserCitiesDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/UpdateUserCities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserCities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserCities(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignCityToUser(input: CreateUserCitiesDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/SetAssignCityToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignCityToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignCityToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssignCityToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userCitiesIds (optional) 
     * @return Success
     */
    setUnAssignUserCitiesToUser(userCitiesIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/SetUnAssignUserCitiesToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userCitiesIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignUserCitiesToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignUserCitiesToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUnAssignUserCitiesToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    setUnAssignAllUserCitiesToUser(userId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/SetUnAssignAllUserCitiesToUser?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignAllUserCitiesToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignAllUserCitiesToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUnAssignAllUserCitiesToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserCitiesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCitiesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCitiesDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserCitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCitiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCitiesDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserCitiesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserCitiesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserCitiesDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserCitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserCitiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserCitiesDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserCitiesDto | null | undefined): Observable<UserCitiesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCitiesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCitiesDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserCitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCitiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCitiesDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateUserCitiesDto | null | undefined): Observable<UserCitiesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCitiesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCitiesDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserCitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCitiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCitiesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserCitiesCategoriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param userCityId (optional) 
     * @return Success
     */
    getUserCityAssignedCategories(userCityId: number | null | undefined): Observable<UserCityCategoryDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCitiesCategories/GetUserCityAssignedCategories?";
        if (userCityId !== undefined && userCityId !== null)
            url_ += "userCityId=" + encodeURIComponent("" + userCityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCityAssignedCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCityAssignedCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCityCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCityCategoryDto[]>;
        }));
    }

    protected processGetUserCityAssignedCategories(response: HttpResponseBase): Observable<UserCityCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserCityCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCityCategoryDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserCitiesCategoriesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCitiesCategories/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCitiesCategoriesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCitiesCategoriesDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserCitiesCategoriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCitiesCategoriesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCitiesCategoriesDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserCitiesCategoriesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCitiesCategories/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserCitiesCategoriesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserCitiesCategoriesDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserCitiesCategoriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserCitiesCategoriesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserCitiesCategoriesDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserCitiesCategoriesDto | null | undefined): Observable<UserCitiesCategoriesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCitiesCategories/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCitiesCategoriesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCitiesCategoriesDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserCitiesCategoriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCitiesCategoriesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCitiesCategoriesDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserCitiesCategoriesDto | null | undefined): Observable<UserCitiesCategoriesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCitiesCategories/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCitiesCategoriesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCitiesCategoriesDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserCitiesCategoriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCitiesCategoriesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCitiesCategoriesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCitiesCategories/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserCustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserAssignedCustomers(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserCustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/GetUserAssignedCustomers?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserCustomerDto>;
        }));
    }

    protected processGetUserAssignedCustomers(response: HttpResponseBase): Observable<PagedResultDtoOfUserCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserCustomerDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignCustomerToUser(input: CreateUserCustomerDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/SetAssignCustomerToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignCustomerToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignCustomerToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssignCustomerToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userCustomerIds (optional) 
     * @return Success
     */
    setUnAssignCustomerToUserOld(userCustomerIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/SetUnAssignCustomerToUserOld";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userCustomerIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignCustomerToUserOld(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignCustomerToUserOld(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUnAssignCustomerToUserOld(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param userCustomerIds (optional) 
     * @return Success
     */
    setUnAssignCustomerToUser(userId: number | null | undefined, userCustomerIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/SetUnAssignCustomerToUser?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userCustomerIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignCustomerToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignCustomerToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUnAssignCustomerToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateUserCustomerDto | null | undefined): Observable<UserCustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCustomerDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCustomerDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserCustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCustomerDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCustomerDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserCustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserCustomerDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserCustomerDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserCustomerDto | null | undefined): Observable<UserCustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCustomerDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCustomerDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserFormsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param userCustomerId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getOrderFormAuthorizationsByUserCustomer(userCustomerId: number | null | undefined, userId: number | null | undefined): Observable<OrderFormAuthorizationDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/GetOrderFormAuthorizationsByUserCustomer?";
        if (userCustomerId !== undefined && userCustomerId !== null)
            url_ += "userCustomerId=" + encodeURIComponent("" + userCustomerId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderFormAuthorizationsByUserCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderFormAuthorizationsByUserCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderFormAuthorizationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderFormAuthorizationDto[]>;
        }));
    }

    protected processGetOrderFormAuthorizationsByUserCustomer(response: HttpResponseBase): Observable<OrderFormAuthorizationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderFormAuthorizationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderFormAuthorizationDto[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignFormsToUser(input: CreateUserFormsDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/SetAssignFormsToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignFormsToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignFormsToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssignFormsToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param componentType (optional) 
     * @return Success
     */
    getUserCustomerShipmentTypeListByForm(componentType: ComponentType2 | null | undefined): Observable<ShipmentTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/GetUserCustomerShipmentTypeListByForm?";
        if (componentType !== undefined && componentType !== null)
            url_ += "componentType=" + encodeURIComponent("" + componentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCustomerShipmentTypeListByForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCustomerShipmentTypeListByForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShipmentTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShipmentTypeDto[]>;
        }));
    }

    protected processGetUserCustomerShipmentTypeListByForm(response: HttpResponseBase): Observable<ShipmentTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShipmentTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShipmentTypeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getMainOrderCardsByUserForms(): Observable<OrderCardDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/GetMainOrderCardsByUserForms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMainOrderCardsByUserForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMainOrderCardsByUserForms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderCardDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderCardDto[]>;
        }));
    }

    protected processGetMainOrderCardsByUserForms(response: HttpResponseBase): Observable<OrderCardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderCardDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCardDto[]>(null as any);
    }

    /**
     * @param orderCardId (optional) 
     * @return Success
     */
    getFormCardsByOrderCardId(orderCardId: number | null | undefined): Observable<UserFormOrderFormTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/GetFormCardsByOrderCardId?";
        if (orderCardId !== undefined && orderCardId !== null)
            url_ += "orderCardId=" + encodeURIComponent("" + orderCardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormCardsByOrderCardId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormCardsByOrderCardId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserFormOrderFormTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserFormOrderFormTypeDto[]>;
        }));
    }

    protected processGetFormCardsByOrderCardId(response: HttpResponseBase): Observable<UserFormOrderFormTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserFormOrderFormTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserFormOrderFormTypeDto[]>(null as any);
    }

    /**
     * @param formId (optional) 
     * @return Success
     */
    getOrderFormTypeByUserFormAuthorization(formId: number | null | undefined): Observable<UserFormOrderFormTypeAuthDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/GetOrderFormTypeByUserFormAuthorization?";
        if (formId !== undefined && formId !== null)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderFormTypeByUserFormAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderFormTypeByUserFormAuthorization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserFormOrderFormTypeAuthDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserFormOrderFormTypeAuthDto>;
        }));
    }

    protected processGetOrderFormTypeByUserFormAuthorization(response: HttpResponseBase): Observable<UserFormOrderFormTypeAuthDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserFormOrderFormTypeAuthDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserFormOrderFormTypeAuthDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserFormsDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserFormsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserFormsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserFormsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserFormsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserFormsDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserFormsDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserFormsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserFormsDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserFormsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserFormsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserFormsDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserFormsDto | null | undefined): Observable<UserFormsDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserFormsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserFormsDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserFormsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserFormsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserFormsDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserFormsDto | null | undefined): Observable<UserFormsDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserFormsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserFormsDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserFormsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserFormsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserFormsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserManagementSummaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserManagementSummaryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserManagementSummary/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserManagementSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserManagementSummaryDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserManagementSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserManagementSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserManagementSummaryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserManagementSummaryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserManagementSummary/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserManagementSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserManagementSummaryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserManagementSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserManagementSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserManagementSummaryDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserManagementSummaryDto | null | undefined): Observable<UserManagementSummaryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserManagementSummary/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserManagementSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserManagementSummaryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserManagementSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserManagementSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserManagementSummaryDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserManagementSummaryDto | null | undefined): Observable<UserManagementSummaryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserManagementSummary/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserManagementSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserManagementSummaryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserManagementSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserManagementSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserManagementSummaryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserManagementSummary/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserModuleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserModule/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserModuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserModuleDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserModuleDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserModulesByAuthorization(userId: number | null | undefined): Observable<UserModuleDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserModule/GetUserModulesByAuthorization?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserModulesByAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserModulesByAuthorization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModuleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModuleDto[]>;
        }));
    }

    protected processGetUserModulesByAuthorization(response: HttpResponseBase): Observable<UserModuleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserModuleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModuleDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserModule/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModuleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModuleDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserModuleDto | null | undefined): Observable<UserModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserModule/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModuleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModuleDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserModuleDto | null | undefined): Observable<UserModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserModule/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModuleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModuleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserModule/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserPagesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserPagesAuthorizationsByUserModule(userId: number | null | undefined): Observable<ModulePageDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/GetUserPagesAuthorizationsByUserModule?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPagesAuthorizationsByUserModule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPagesAuthorizationsByUserModule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ModulePageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ModulePageDto[]>;
        }));
    }

    protected processGetUserPagesAuthorizationsByUserModule(response: HttpResponseBase): Observable<ModulePageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ModulePageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModulePageDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserPagesAuthorizations(userId: number | null | undefined): Observable<PageAuthorizationDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/GetUserPagesAuthorizations?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPagesAuthorizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPagesAuthorizations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageAuthorizationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageAuthorizationDto[]>;
        }));
    }

    protected processGetUserPagesAuthorizations(response: HttpResponseBase): Observable<PageAuthorizationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PageAuthorizationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageAuthorizationDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param defaultUserPageId (optional) 
     * @return Success
     */
    setPageAsDefault(userId: number | null | undefined, defaultUserPageId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/SetPageAsDefault?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (defaultUserPageId !== undefined && defaultUserPageId !== null)
            url_ += "defaultUserPageId=" + encodeURIComponent("" + defaultUserPageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPageAsDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPageAsDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetPageAsDefault(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserPagesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPagesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPagesDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserPagesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPagesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPagesDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserPagesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserPagesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserPagesDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserPagesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserPagesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserPagesDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserPagesDto | null | undefined): Observable<UserPagesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPagesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPagesDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserPagesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPagesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPagesDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserPagesDto | null | undefined): Observable<UserPagesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPagesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPagesDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserPagesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPagesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPagesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserPermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param formId (optional) 
     * @return Success
     */
    getFromRequestWarehouseByUserAuths(formId: number | null | undefined): Observable<WarehouseSelectListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetFromRequestWarehouseByUserAuths?";
        if (formId !== undefined && formId !== null)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFromRequestWarehouseByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFromRequestWarehouseByUserAuths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseSelectListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseSelectListDto[]>;
        }));
    }

    protected processGetFromRequestWarehouseByUserAuths(response: HttpResponseBase): Observable<WarehouseSelectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectListDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getFromReceiveWarehoseByUserAuths(): Observable<WarehouseSelectListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetFromReceiveWarehoseByUserAuths";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFromReceiveWarehoseByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFromReceiveWarehoseByUserAuths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseSelectListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseSelectListDto[]>;
        }));
    }

    protected processGetFromReceiveWarehoseByUserAuths(response: HttpResponseBase): Observable<WarehouseSelectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectListDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param name (optional) 
     * @param code (optional) 
     * @param addressId (optional) 
     * @param isSelected (optional) 
     * @return Success
     */
    getToReceiveWarehoseByUserAuths(id: number | null | undefined, name: string | null | undefined, code: string | null | undefined, addressId: number | null | undefined, isSelected: boolean | null | undefined): Observable<WarehouseSelectListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetToReceiveWarehoseByUserAuths?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (addressId !== undefined && addressId !== null)
            url_ += "AddressId=" + encodeURIComponent("" + addressId) + "&";
        if (isSelected !== undefined && isSelected !== null)
            url_ += "IsSelected=" + encodeURIComponent("" + isSelected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToReceiveWarehoseByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToReceiveWarehoseByUserAuths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseSelectListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseSelectListDto[]>;
        }));
    }

    protected processGetToReceiveWarehoseByUserAuths(response: HttpResponseBase): Observable<WarehouseSelectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectListDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getFromReceiveMobileWarehoseByUserAuths(): Observable<WarehouseSelectListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetFromReceiveMobileWarehoseByUserAuths";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFromReceiveMobileWarehoseByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFromReceiveMobileWarehoseByUserAuths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseSelectListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseSelectListDto[]>;
        }));
    }

    protected processGetFromReceiveMobileWarehoseByUserAuths(response: HttpResponseBase): Observable<WarehouseSelectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectListDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getToRequestWarehouseByUserAuths(): Observable<WarehouseSelectListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetToRequestWarehouseByUserAuths";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToRequestWarehouseByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToRequestWarehouseByUserAuths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseSelectListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseSelectListDto[]>;
        }));
    }

    protected processGetToRequestWarehouseByUserAuths(response: HttpResponseBase): Observable<WarehouseSelectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectListDto[]>(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @return Success
     */
    getToRequestDistributorByUserAuths(searchTerm: string | null | undefined): Observable<PagedUserPermissionAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetToRequestDistributorByUserAuths?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToRequestDistributorByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToRequestDistributorByUserAuths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedUserPermissionAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedUserPermissionAddressDto>;
        }));
    }

    protected processGetToRequestDistributorByUserAuths(response: HttpResponseBase): Observable<PagedUserPermissionAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedUserPermissionAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedUserPermissionAddressDto>(null as any);
    }

    /**
     * @param selectedAddressTypeIds (optional) 
     * @return Success
     */
    getUserAssignedCityList(selectedAddressTypeIds: number[] | null | undefined): Observable<ToRequestCityDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetUserAssignedCityList?";
        if (selectedAddressTypeIds !== undefined && selectedAddressTypeIds !== null)
            selectedAddressTypeIds && selectedAddressTypeIds.forEach(item => { url_ += "selectedAddressTypeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedCityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedCityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ToRequestCityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ToRequestCityDto[]>;
        }));
    }

    protected processGetUserAssignedCityList(response: HttpResponseBase): Observable<ToRequestCityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ToRequestCityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ToRequestCityDto[]>(null as any);
    }

    /**
     * @param selectedAddressTypeIds (optional) 
     * @param cityId (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    getUserCitiesAddressWithUserAssignedAddresses(selectedAddressTypeIds: number[] | null | undefined, cityId: number | null | undefined, searchTerm: string | null | undefined): Observable<PagedUserPermissionAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetUserCitiesAddressWithUserAssignedAddresses?";
        if (selectedAddressTypeIds !== undefined && selectedAddressTypeIds !== null)
            selectedAddressTypeIds && selectedAddressTypeIds.forEach(item => { url_ += "selectedAddressTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (cityId !== undefined && cityId !== null)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCitiesAddressWithUserAssignedAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCitiesAddressWithUserAssignedAddresses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedUserPermissionAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedUserPermissionAddressDto>;
        }));
    }

    protected processGetUserCitiesAddressWithUserAssignedAddresses(response: HttpResponseBase): Observable<PagedUserPermissionAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedUserPermissionAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedUserPermissionAddressDto>(null as any);
    }

    /**
     * @return Success
     */
    getUserAssignedCityAndDistrictListForAddAddress(): Observable<UserPermissionCityDistrictDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetUserAssignedCityAndDistrictListForAddAddress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedCityAndDistrictListForAddAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedCityAndDistrictListForAddAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissionCityDistrictDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissionCityDistrictDto>;
        }));
    }

    protected processGetUserAssignedCityAndDistrictListForAddAddress(response: HttpResponseBase): Observable<UserPermissionCityDistrictDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPermissionCityDistrictDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPermissionCityDistrictDto>(null as any);
    }

    /**
     * @param cityId (optional) 
     * @param districtId (optional) 
     * @return Success
     */
    getUserAddAddressToCityAuthCitiesAddresses(cityId: number | null | undefined, districtId: number | null | undefined): Observable<UserPermissionAddressDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetUserAddAddressToCityAuthCitiesAddresses?";
        if (cityId !== undefined && cityId !== null)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (districtId !== undefined && districtId !== null)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAddAddressToCityAuthCitiesAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAddAddressToCityAuthCitiesAddresses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissionAddressDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissionAddressDto[]>;
        }));
    }

    protected processGetUserAddAddressToCityAuthCitiesAddresses(response: HttpResponseBase): Observable<UserPermissionAddressDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserPermissionAddressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPermissionAddressDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getUserStokViewInformation(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetUserStokViewInformation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserStokViewInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserStokViewInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetUserStokViewInformation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param componentType (optional) 
     * @return Success
     */
    checkUserAuthorizationByForm(componentType: ComponentType3 | null | undefined): Observable<UserPermissionFormAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/CheckUserAuthorizationByForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(componentType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUserAuthorizationByForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserAuthorizationByForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissionFormAuthorizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissionFormAuthorizationDto>;
        }));
    }

    protected processCheckUserAuthorizationByForm(response: HttpResponseBase): Observable<UserPermissionFormAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPermissionFormAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPermissionFormAuthorizationDto>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    checkUserReportAuthorization(reportId: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/CheckUserReportAuthorization?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUserReportAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserReportAuthorization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckUserReportAuthorization(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserCustomerOtherSettings(userId: number | null | undefined): Observable<UserOtherSettingsDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetUserCustomerOtherSettings?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCustomerOtherSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCustomerOtherSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOtherSettingsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOtherSettingsDto[]>;
        }));
    }

    protected processGetUserCustomerOtherSettings(response: HttpResponseBase): Observable<UserOtherSettingsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserOtherSettingsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserOtherSettingsDto[]>(null as any);
    }

    /**
     * @param userCustomerId (optional) 
     * @param data (optional) 
     * @return Success
     */
    updateStockView(userCustomerId: number | null | undefined, data: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/UpdateStockView?";
        if (userCustomerId !== undefined && userCustomerId !== null)
            url_ += "userCustomerId=" + encodeURIComponent("" + userCustomerId) + "&";
        if (data !== undefined && data !== null)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStockView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStockView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStockView(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userCustomerId (optional) 
     * @param data (optional) 
     * @return Success
     */
    updateProductLocationOrderHistoryView(userCustomerId: number | null | undefined, data: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/UpdateProductLocationOrderHistoryView?";
        if (userCustomerId !== undefined && userCustomerId !== null)
            url_ += "userCustomerId=" + encodeURIComponent("" + userCustomerId) + "&";
        if (data !== undefined && data !== null)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductLocationOrderHistoryView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductLocationOrderHistoryView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProductLocationOrderHistoryView(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userCustomerId (optional) 
     * @param data (optional) 
     * @return Success
     */
    updateOnlyWmsProducts(userCustomerId: number | null | undefined, data: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/UpdateOnlyWmsProducts?";
        if (userCustomerId !== undefined && userCustomerId !== null)
            url_ += "userCustomerId=" + encodeURIComponent("" + userCustomerId) + "&";
        if (data !== undefined && data !== null)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOnlyWmsProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOnlyWmsProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOnlyWmsProducts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userCustomerId (optional) 
     * @param data (optional) 
     * @return Success
     */
    updateRequestListStockView(userCustomerId: number | null | undefined, data: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/UpdateRequestListStockView?";
        if (userCustomerId !== undefined && userCustomerId !== null)
            url_ += "userCustomerId=" + encodeURIComponent("" + userCustomerId) + "&";
        if (data !== undefined && data !== null)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRequestListStockView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRequestListStockView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRequestListStockView(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userCustomerId (optional) 
     * @param data (optional) 
     * @return Success
     */
    updateShowPalletQuantity(userCustomerId: number | null | undefined, data: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/UpdateShowPalletQuantity?";
        if (userCustomerId !== undefined && userCustomerId !== null)
            url_ += "userCustomerId=" + encodeURIComponent("" + userCustomerId) + "&";
        if (data !== undefined && data !== null)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShowPalletQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShowPalletQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateShowPalletQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userCustomerId (optional) 
     * @param data (optional) 
     * @return Success
     */
    updateShowTotalShipmentPrice(userCustomerId: number | null | undefined, data: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/UpdateShowTotalShipmentPrice?";
        if (userCustomerId !== undefined && userCustomerId !== null)
            url_ += "userCustomerId=" + encodeURIComponent("" + userCustomerId) + "&";
        if (data !== undefined && data !== null)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShowTotalShipmentPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShowTotalShipmentPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateShowTotalShipmentPrice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserProductAttributeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserAssignedProductAttributes(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/GetUserAssignedProductAttributes?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedProductAttributes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedProductAttributes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserProductAttributeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserProductAttributeDto>;
        }));
    }

    protected processGetUserAssignedProductAttributes(response: HttpResponseBase): Observable<PagedResultDtoOfUserProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserProductAttributeDto>(null as any);
    }

    /**
     * @return Success
     */
    getUserAssignedProductAttributesByGlobalFilters(): Observable<UserProductAttributeDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/GetUserAssignedProductAttributesByGlobalFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedProductAttributesByGlobalFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedProductAttributesByGlobalFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProductAttributeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProductAttributeDto[]>;
        }));
    }

    protected processGetUserAssignedProductAttributesByGlobalFilters(response: HttpResponseBase): Observable<UserProductAttributeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserProductAttributeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProductAttributeDto[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignProductAttributesToUser(input: CreateUserProductAttributeDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/SetAssignProductAttributesToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignProductAttributesToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignProductAttributesToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssignProductAttributesToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userProductAttributeIds (optional) 
     * @return Success
     */
    setUnAssigProductAttributesToUser(userProductAttributeIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/SetUnAssigProductAttributesToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userProductAttributeIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssigProductAttributesToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssigProductAttributesToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUnAssigProductAttributesToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProductAttributeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProductAttributeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProductAttributeDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserProductAttributeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserProductAttributeDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserProductAttributeDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserProductAttributeDto | null | undefined): Observable<UserProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProductAttributeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProductAttributeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProductAttributeDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserProductAttributeDto | null | undefined): Observable<UserProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProductAttributeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProductAttributeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProductAttributeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserAssignedReports(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/GetUserAssignedReports?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserReportDto>;
        }));
    }

    protected processGetUserAssignedReports(response: HttpResponseBase): Observable<PagedResultDtoOfUserReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserReportDto>(null as any);
    }

    /**
     * @param moduleId (optional) 
     * @return Success
     */
    getAssignedReports(moduleId: number | null | undefined): Observable<UserReportDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/GetAssignedReports?";
        if (moduleId !== undefined && moduleId !== null)
            url_ += "moduleId=" + encodeURIComponent("" + moduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserReportDto[]>;
        }));
    }

    protected processGetAssignedReports(response: HttpResponseBase): Observable<UserReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserReportDto[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignReportToUser(input: CreateUserReportDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/SetAssignReportToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignReportToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignReportToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssignReportToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userReportIds (optional) 
     * @return Success
     */
    setUnAssignReportToUser(userReportIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/SetUnAssignReportToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userReportIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignReportToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignReportToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUnAssignReportToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setIsOpenNewScreen(input: UserReportOpenNewScreenDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/SetIsOpenNewScreen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetIsOpenNewScreen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetIsOpenNewScreen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetIsOpenNewScreen(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserReportDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserReportDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserReportDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserReportDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserReportDto | null | undefined): Observable<UserReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserReportDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserReportDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserReportDto | null | undefined): Observable<UserReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserReportDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserReportDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserRoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserRolesByAuthorization(userId: number | null | undefined): Observable<UserRoleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserRole/GetUserRolesByAuthorization?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRolesByAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRolesByAuthorization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDto[]>;
        }));
    }

    protected processGetUserRolesByAuthorization(response: HttpResponseBase): Observable<UserRoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserRoleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRoleDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRole/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRole/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserRoleDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserRoleDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserRoleDto | null | undefined): Observable<UserRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRole/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRoleDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserRoleDto | null | undefined): Observable<UserRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRole/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserRole/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserWarehouseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param warehouseList (optional) 
     * @param userId (optional) 
     * @return Success
     */
    updateWarehousesWithPermission(warehouseList: CustomerWarehouseDto[] | null | undefined, userId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/UpdateWarehousesWithPermission?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(warehouseList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWarehousesWithPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWarehousesWithPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWarehousesWithPermission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getWarehousesWithPermission(userId: number | null | undefined): Observable<CustomerWarehouseDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/GetWarehousesWithPermission?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehousesWithPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehousesWithPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerWarehouseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerWarehouseDto[]>;
        }));
    }

    protected processGetWarehousesWithPermission(response: HttpResponseBase): Observable<CustomerWarehouseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerWarehouseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerWarehouseDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param authorizationId (optional) 
     * @return Success
     */
    getUserAssignedWarehouses(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, authorizationId: number | null | undefined): Observable<PagedResultDtoOfUserWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/GetUserAssignedWarehouses?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (authorizationId !== undefined && authorizationId !== null)
            url_ += "authorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedWarehouses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedWarehouses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserWarehouseDto>;
        }));
    }

    protected processGetUserAssignedWarehouses(response: HttpResponseBase): Observable<PagedResultDtoOfUserWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserWarehouseDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignWarehouseToUser(input: CreateUserWarehouseDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/SetAssignWarehouseToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignWarehouseToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignWarehouseToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSetAssignWarehouseToUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param userWarehouseIds (optional) 
     * @return Success
     */
    setUnAssignWarehouseToUser(userWarehouseIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/SetUnAssignWarehouseToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userWarehouseIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignWarehouseToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignWarehouseToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUnAssignWarehouseToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    setUserWarehouseUnAssignAll(userId: number | null | undefined, warehouseId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/SetUserWarehouseUnAssignAll?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (warehouseId !== undefined && warehouseId !== null)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserWarehouseUnAssignAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserWarehouseUnAssignAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUserWarehouseUnAssignAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWarehouseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserWarehouseDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserWarehouseDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserWarehouseDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserWarehouseDto | null | undefined): Observable<UserWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWarehouseDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserWarehouseDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserWarehouseDto | null | undefined): Observable<UserWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWarehouseDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserWarehouseDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class WarehouseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getMainWarehouses(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/GetMainWarehouses?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMainWarehouses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMainWarehouses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWarehouseDto>;
        }));
    }

    protected processGetMainWarehouses(response: HttpResponseBase): Observable<PagedResultDtoOfWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfWarehouseDto>(null as any);
    }

    /**
     * @param excludedMainWarehouseId (optional) 
     * @return Success
     */
    getUnAssignedDependWarehouses(excludedMainWarehouseId: number | null | undefined): Observable<DependWarehouseDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/GetUnAssignedDependWarehouses?";
        if (excludedMainWarehouseId !== undefined && excludedMainWarehouseId !== null)
            url_ += "excludedMainWarehouseId=" + encodeURIComponent("" + excludedMainWarehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnAssignedDependWarehouses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnAssignedDependWarehouses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DependWarehouseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DependWarehouseDto[]>;
        }));
    }

    protected processGetUnAssignedDependWarehouses(response: HttpResponseBase): Observable<DependWarehouseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DependWarehouseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DependWarehouseDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @param authorizationId (optional) 
     * @return Success
     */
    getUserUnAssignedWarehouses(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, userId: number | null | undefined, authorizationId: number | null | undefined): Observable<PagedResultDtoOfWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/GetUserUnAssignedWarehouses?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (authorizationId !== undefined && authorizationId !== null)
            url_ += "authorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedWarehouses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedWarehouses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWarehouseDto>;
        }));
    }

    protected processGetUserUnAssignedWarehouses(response: HttpResponseBase): Observable<PagedResultDtoOfWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfWarehouseDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateWarehouseDto | null | undefined): Observable<WarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDto>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param customerId (optional) 
     * @param ownerId (optional) 
     * @return Success
     */
    setAssignedOwnerToWarehouse(warehouseId: number | null | undefined, customerId: number | null | undefined, ownerId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/SetAssignedOwnerToWarehouse?";
        if (warehouseId !== undefined && warehouseId !== null)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (ownerId !== undefined && ownerId !== null)
            url_ += "ownerId=" + encodeURIComponent("" + ownerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignedOwnerToWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignedOwnerToWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssignedOwnerToWarehouse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param remoteWarehouseId (optional) 
     * @param mainWarehouseId (optional) 
     * @return Success
     */
    addDependToWarehouse(remoteWarehouseId: number | null | undefined, mainWarehouseId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/AddDependToWarehouse?";
        if (remoteWarehouseId !== undefined && remoteWarehouseId !== null)
            url_ += "remoteWarehouseId=" + encodeURIComponent("" + remoteWarehouseId) + "&";
        if (mainWarehouseId !== undefined && mainWarehouseId !== null)
            url_ += "mainWarehouseId=" + encodeURIComponent("" + mainWarehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDependToWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDependToWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddDependToWarehouse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateWarehouseDto | null | undefined): Observable<WarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<WarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDto>(null as any);
    }

    /**
     * @param selectedItem (optional) 
     * @return Success
     */
    getCustomerComboboxItems(selectedItem: number | null | undefined): Observable<ListResultDtoOfComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/GetCustomerComboboxItems?";
        if (selectedItem !== undefined && selectedItem !== null)
            url_ += "selectedItem=" + encodeURIComponent("" + selectedItem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfComboboxItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfComboboxItemDto>;
        }));
    }

    protected processGetCustomerComboboxItems(response: HttpResponseBase): Observable<ListResultDtoOfComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfComboboxItemDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForExcel(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<ExcelPagedResultDtoOfWarehouseExcelDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/GetAllForExcel?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcelPagedResultDtoOfWarehouseExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcelPagedResultDtoOfWarehouseExcelDto>;
        }));
    }

    protected processGetAllForExcel(response: HttpResponseBase): Observable<ExcelPagedResultDtoOfWarehouseExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelPagedResultDtoOfWarehouseExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelPagedResultDtoOfWarehouseExcelDto>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return Success
     */
    getWarehouseCustomers(warehouseId: number | null | undefined): Observable<WarehouseCustomerDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/GetWarehouseCustomers?";
        if (warehouseId !== undefined && warehouseId !== null)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehouseCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehouseCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseCustomerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseCustomerDto[]>;
        }));
    }

    protected processGetWarehouseCustomers(response: HttpResponseBase): Observable<WarehouseCustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseCustomerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseCustomerDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWarehouseDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfWarehouseDto>(null as any);
    }
}

@Injectable()
export class WarehouseOwnerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @param warehouseId (optional) 
     * @param customerId (optional) 
     * @return Success
     */
    getCustomerWarehouseOwners(warehouseId: number | null | undefined, customerId: number | null | undefined): Observable<WarehouseOwnerUserDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/WarehouseOwner/GetCustomerWarehouseOwners?";
        if (warehouseId !== undefined && warehouseId !== null)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerWarehouseOwners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerWarehouseOwners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseOwnerUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseOwnerUserDto[]>;
        }));
    }

    protected processGetCustomerWarehouseOwners(response: HttpResponseBase): Observable<WarehouseOwnerUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseOwnerUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseOwnerUserDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param ownerId (optional) 
     * @param warehouseId (optional) 
     * @param customerId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, ownerId: number | null | undefined, warehouseId: number | null | undefined, customerId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfWarehouseOwnerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/WarehouseOwner/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (ownerId !== undefined && ownerId !== null)
            url_ += "OwnerId=" + encodeURIComponent("" + ownerId) + "&";
        if (warehouseId !== undefined && warehouseId !== null)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWarehouseOwnerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWarehouseOwnerDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfWarehouseOwnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWarehouseOwnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfWarehouseOwnerDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateWarehouseOwnerDto | null | undefined): Observable<WarehouseOwnerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/WarehouseOwner/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseOwnerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseOwnerDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WarehouseOwnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseOwnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseOwnerDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateWarehouseOwnerDto | null | undefined): Observable<WarehouseOwnerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/WarehouseOwner/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseOwnerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseOwnerDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WarehouseOwnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseOwnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseOwnerDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<WarehouseOwnerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/WarehouseOwner/Get?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseOwnerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseOwnerDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WarehouseOwnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseOwnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseOwnerDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/WarehouseOwner/Delete?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class YazilimDevServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl || "";
    }

    /**
     * @return Success
     */
    personelDeneme(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/YazilimDev/PersonelDeneme";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPersonelDeneme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPersonelDeneme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPersonelDeneme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getTestList(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/YazilimDev/GetTestList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTestList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTestList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetTestList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param mpoiAdi (optional) 
     * @param poiId (optional) 
     * @return Success
     */
    insertNewMPoi(mpoiAdi: string | null | undefined, poiId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/platom/portal/YazilimDev/InsertNewMPoi?";
        if (mpoiAdi !== undefined && mpoiAdi !== null)
            url_ += "mpoiAdi=" + encodeURIComponent("" + mpoiAdi) + "&";
        if (poiId !== undefined && poiId !== null)
            url_ += "poiId=" + encodeURIComponent("" + poiId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertNewMPoi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertNewMPoi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertNewMPoi(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param projectName (optional) 
     * @return Success
     */
    getGorevSonucByProject(projectName: string | null | undefined): Observable<GorevFormSonucuDto[]> {
        let url_ = this.baseUrl + "/api/services/platom/portal/YazilimDev/GetGorevSonucByProject?";
        if (projectName !== undefined && projectName !== null)
            url_ += "projectName=" + encodeURIComponent("" + projectName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGorevSonucByProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGorevSonucByProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GorevFormSonucuDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GorevFormSonucuDto[]>;
        }));
    }

    protected processGetGorevSonucByProject(response: HttpResponseBase): Observable<GorevFormSonucuDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GorevFormSonucuDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GorevFormSonucuDto[]>(null as any);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState | undefined;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState | undefined;
    tenantId: number | undefined;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean | undefined;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean | undefined;
}

export class ResetPasswordRequestInput implements IResetPasswordRequestInput {
    emailAddress: string | undefined;
    returnUrl: string | undefined;
    module: ResetPasswordRequestInputModule | undefined;

    constructor(data?: IResetPasswordRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.returnUrl = _data["returnUrl"];
            this.module = _data["module"];
        }
    }

    static fromJS(data: any): ResetPasswordRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["returnUrl"] = this.returnUrl;
        data["module"] = this.module;
        return data;
    }

    clone(): ResetPasswordRequestInput {
        const json = this.toJSON();
        let result = new ResetPasswordRequestInput();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordRequestInput {
    emailAddress: string | undefined;
    returnUrl: string | undefined;
    module: ResetPasswordRequestInputModule | undefined;
}

export class ResetPasswordInput implements IResetPasswordInput {
    token: string | undefined;
    newPassword: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordInput {
        const json = this.toJSON();
        let result = new ResetPasswordInput();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordInput {
    token: string | undefined;
    newPassword: string | undefined;
}

export class PagedResultDtoOfAddressDto implements IPagedResultDtoOfAddressDto {
    totalCount: number | undefined;
    items: AddressDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAddressDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAddressDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAddressDto {
    totalCount: number | undefined;
    items: AddressDto[] | undefined;
}

export class AddressDto implements IAddressDto {
    poiId: string | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    phone1: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    districtId: number | undefined;
    districtName: string | undefined;
    categoryName: string | undefined;
    id: number | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poiId = _data["poiId"];
            this.name = _data["name"];
            this.fullAddress = _data["fullAddress"];
            this.phone1 = _data["phone1"];
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
            this.districtId = _data["districtId"];
            this.districtName = _data["districtName"];
            this.categoryName = _data["categoryName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poiId"] = this.poiId;
        data["name"] = this.name;
        data["fullAddress"] = this.fullAddress;
        data["phone1"] = this.phone1;
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        data["districtId"] = this.districtId;
        data["districtName"] = this.districtName;
        data["categoryName"] = this.categoryName;
        data["id"] = this.id;
        return data;
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDto {
    poiId: string | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    phone1: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    districtId: number | undefined;
    districtName: string | undefined;
    categoryName: string | undefined;
    id: number | undefined;
}

export class AddressSimilarityDto implements IAddressSimilarityDto {
    id: number | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    readonly searchedAddress: string | undefined;

    constructor(data?: IAddressSimilarityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fullAddress = _data["fullAddress"];
            (<any>this).searchedAddress = _data["searchedAddress"];
        }
    }

    static fromJS(data: any): AddressSimilarityDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSimilarityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fullAddress"] = this.fullAddress;
        data["searchedAddress"] = this.searchedAddress;
        return data;
    }

    clone(): AddressSimilarityDto {
        const json = this.toJSON();
        let result = new AddressSimilarityDto();
        result.init(json);
        return result;
    }
}

export interface IAddressSimilarityDto {
    id: number | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    searchedAddress: string | undefined;
}

export class AddressSimilarityResultDto implements IAddressSimilarityResultDto {
    id: number | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    percent: number | undefined;
    isCriticalSimilarity: boolean | undefined;

    constructor(data?: IAddressSimilarityResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fullAddress = _data["fullAddress"];
            this.percent = _data["percent"];
            this.isCriticalSimilarity = _data["isCriticalSimilarity"];
        }
    }

    static fromJS(data: any): AddressSimilarityResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSimilarityResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fullAddress"] = this.fullAddress;
        data["percent"] = this.percent;
        data["isCriticalSimilarity"] = this.isCriticalSimilarity;
        return data;
    }

    clone(): AddressSimilarityResultDto {
        const json = this.toJSON();
        let result = new AddressSimilarityResultDto();
        result.init(json);
        return result;
    }
}

export interface IAddressSimilarityResultDto {
    id: number | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    percent: number | undefined;
    isCriticalSimilarity: boolean | undefined;
}

export class ExcelFileResultDto implements IExcelFileResultDto {
    base64: string | undefined;
    fileType: string | undefined;
    fileName: string | undefined;

    constructor(data?: IExcelFileResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
            this.fileType = _data["fileType"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): ExcelFileResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelFileResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        data["fileType"] = this.fileType;
        data["fileName"] = this.fileName;
        return data;
    }

    clone(): ExcelFileResultDto {
        const json = this.toJSON();
        let result = new ExcelFileResultDto();
        result.init(json);
        return result;
    }
}

export interface IExcelFileResultDto {
    base64: string | undefined;
    fileType: string | undefined;
    fileName: string | undefined;
}

export class CustomerAddressExcelUploadDto implements ICustomerAddressExcelUploadDto {
    customerId: number;
    base64: string | undefined;

    constructor(data?: ICustomerAddressExcelUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): CustomerAddressExcelUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddressExcelUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["base64"] = this.base64;
        return data;
    }

    clone(): CustomerAddressExcelUploadDto {
        const json = this.toJSON();
        let result = new CustomerAddressExcelUploadDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerAddressExcelUploadDto {
    customerId: number;
    base64: string | undefined;
}

export class CreateAddressDto implements ICreateAddressDto {
    name: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateAddressDto {
        const json = this.toJSON();
        let result = new CreateAddressDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAddressDto {
    name: string | undefined;
    id: number | undefined;
}

export class PlatomAIInputDto implements IPlatomAIInputDto {
    appName: string | undefined;
    system: string | undefined;
    prompt: string | undefined;

    constructor(data?: IPlatomAIInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appName = _data["appName"];
            this.system = _data["system"];
            this.prompt = _data["prompt"];
        }
    }

    static fromJS(data: any): PlatomAIInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlatomAIInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appName"] = this.appName;
        data["system"] = this.system;
        data["prompt"] = this.prompt;
        return data;
    }

    clone(): PlatomAIInputDto {
        const json = this.toJSON();
        let result = new PlatomAIInputDto();
        result.init(json);
        return result;
    }
}

export interface IPlatomAIInputDto {
    appName: string | undefined;
    system: string | undefined;
    prompt: string | undefined;
}

export class PlatomAITrainModelDto implements IPlatomAITrainModelDto {
    konu: string | undefined;
    aciklama: string | undefined;
    ornekSorular: string | undefined;
    readonly ornekSoruList: string[] | undefined;
    id: string | undefined;

    constructor(data?: IPlatomAITrainModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.konu = _data["konu"];
            this.aciklama = _data["aciklama"];
            this.ornekSorular = _data["ornekSorular"];
            if (Array.isArray(_data["ornekSoruList"])) {
                (<any>this).ornekSoruList = [] as any;
                for (let item of _data["ornekSoruList"])
                    (<any>this).ornekSoruList.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PlatomAITrainModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlatomAITrainModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["konu"] = this.konu;
        data["aciklama"] = this.aciklama;
        data["ornekSorular"] = this.ornekSorular;
        if (Array.isArray(this.ornekSoruList)) {
            data["ornekSoruList"] = [];
            for (let item of this.ornekSoruList)
                data["ornekSoruList"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): PlatomAITrainModelDto {
        const json = this.toJSON();
        let result = new PlatomAITrainModelDto();
        result.init(json);
        return result;
    }
}

export interface IPlatomAITrainModelDto {
    konu: string | undefined;
    aciklama: string | undefined;
    ornekSorular: string | undefined;
    ornekSoruList: string[] | undefined;
    id: string | undefined;
}

export class PlatomAIResponseDto implements IPlatomAIResponseDto {
    isScalar: boolean | undefined;
    data: any | undefined;

    constructor(data?: IPlatomAIResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isScalar = _data["isScalar"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): PlatomAIResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlatomAIResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isScalar"] = this.isScalar;
        data["data"] = this.data;
        return data;
    }

    clone(): PlatomAIResponseDto {
        const json = this.toJSON();
        let result = new PlatomAIResponseDto();
        result.init(json);
        return result;
    }
}

export interface IPlatomAIResponseDto {
    isScalar: boolean | undefined;
    data: any | undefined;
}

export class PagedResultDtoOfAuthorizationDomainAuthTypeDto implements IPagedResultDtoOfAuthorizationDomainAuthTypeDto {
    totalCount: number | undefined;
    items: AuthorizationDomainAuthTypeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuthorizationDomainAuthTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuthorizationDomainAuthTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuthorizationDomainAuthTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuthorizationDomainAuthTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAuthorizationDomainAuthTypeDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAuthorizationDomainAuthTypeDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAuthorizationDomainAuthTypeDto {
    totalCount: number | undefined;
    items: AuthorizationDomainAuthTypeDto[] | undefined;
}

export class AuthorizationDomainAuthTypeDto implements IAuthorizationDomainAuthTypeDto {
    name: string | undefined;
    comment: string | undefined;
    databaseName: string | undefined;
    databaseTableName: string | undefined;
    userFriendlyName: string | undefined;
    userFriendlyDescription: string | undefined;
    id: number | undefined;

    constructor(data?: IAuthorizationDomainAuthTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.databaseName = _data["databaseName"];
            this.databaseTableName = _data["databaseTableName"];
            this.userFriendlyName = _data["userFriendlyName"];
            this.userFriendlyDescription = _data["userFriendlyDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuthorizationDomainAuthTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationDomainAuthTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["databaseName"] = this.databaseName;
        data["databaseTableName"] = this.databaseTableName;
        data["userFriendlyName"] = this.userFriendlyName;
        data["userFriendlyDescription"] = this.userFriendlyDescription;
        data["id"] = this.id;
        return data;
    }

    clone(): AuthorizationDomainAuthTypeDto {
        const json = this.toJSON();
        let result = new AuthorizationDomainAuthTypeDto();
        result.init(json);
        return result;
    }
}

export interface IAuthorizationDomainAuthTypeDto {
    name: string | undefined;
    comment: string | undefined;
    databaseName: string | undefined;
    databaseTableName: string | undefined;
    userFriendlyName: string | undefined;
    userFriendlyDescription: string | undefined;
    id: number | undefined;
}

export class CreateAuthorizationTypeDto implements ICreateAuthorizationTypeDto {
    name: string;
    comment: string | undefined;
    databaseName: string | undefined;
    databaseTableName: string | undefined;
    objectRelationTypeId: number | undefined;
    isViewOnClient: boolean;
    userFriendlyName: string | undefined;
    userFriendlyDescription: string | undefined;
    sortIndex: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateAuthorizationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.databaseName = _data["databaseName"];
            this.databaseTableName = _data["databaseTableName"];
            this.objectRelationTypeId = _data["objectRelationTypeId"];
            this.isViewOnClient = _data["isViewOnClient"];
            this.userFriendlyName = _data["userFriendlyName"];
            this.userFriendlyDescription = _data["userFriendlyDescription"];
            this.sortIndex = _data["sortIndex"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateAuthorizationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAuthorizationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["databaseName"] = this.databaseName;
        data["databaseTableName"] = this.databaseTableName;
        data["objectRelationTypeId"] = this.objectRelationTypeId;
        data["isViewOnClient"] = this.isViewOnClient;
        data["userFriendlyName"] = this.userFriendlyName;
        data["userFriendlyDescription"] = this.userFriendlyDescription;
        data["sortIndex"] = this.sortIndex;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateAuthorizationTypeDto {
        const json = this.toJSON();
        let result = new CreateAuthorizationTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAuthorizationTypeDto {
    name: string;
    comment: string | undefined;
    databaseName: string | undefined;
    databaseTableName: string | undefined;
    objectRelationTypeId: number | undefined;
    isViewOnClient: boolean;
    userFriendlyName: string | undefined;
    userFriendlyDescription: string | undefined;
    sortIndex: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfCategoryDto implements IPagedResultDtoOfCategoryDto {
    totalCount: number | undefined;
    items: CategoryDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfCategoryDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCategoryDto {
    totalCount: number | undefined;
    items: CategoryDto[] | undefined;
}

export class CategoryDto implements ICategoryDto {
    name: string | undefined;
    id: number | undefined;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): CategoryDto {
        const json = this.toJSON();
        let result = new CategoryDto();
        result.init(json);
        return result;
    }
}

export interface ICategoryDto {
    name: string | undefined;
    id: number | undefined;
}

export class CreateCategoryDto implements ICreateCategoryDto {
    id: number | undefined;

    constructor(data?: ICreateCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): CreateCategoryDto {
        const json = this.toJSON();
        let result = new CreateCategoryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCategoryDto {
    id: number | undefined;
}

export class PagedResultDtoOfCityDto implements IPagedResultDtoOfCityDto {
    totalCount: number | undefined;
    items: CityDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfCityDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCityDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCityDto {
    totalCount: number | undefined;
    items: CityDto[] | undefined;
}

export class CityDto implements ICityDto {
    name: string | undefined;
    id: number | undefined;

    constructor(data?: ICityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): CityDto {
        const json = this.toJSON();
        let result = new CityDto();
        result.init(json);
        return result;
    }
}

export interface ICityDto {
    name: string | undefined;
    id: number | undefined;
}

export class CreateCityDto implements ICreateCityDto {
    id: number;
    name: string;

    constructor(data?: ICreateCityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateCityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateCityDto {
        const json = this.toJSON();
        let result = new CreateCityDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCityDto {
    id: number;
    name: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class PagedResultDtoOfCustomerDto implements IPagedResultDtoOfCustomerDto {
    totalCount: number | undefined;
    items: CustomerDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfCustomerDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCustomerDto {
    totalCount: number | undefined;
    items: CustomerDto[] | undefined;
}

export class CustomerDto implements ICustomerDto {
    name: string | undefined;
    code: string | undefined;
    comment: string | undefined;
    approvalMinute: number | undefined;
    productSizeApprovalMinute: number | undefined;
    isCheckOrderProductSize: boolean | undefined;
    personInChargeUserId: number | undefined;
    assignedWarehouses: CustomerWarehouseAssignedDto[] | undefined;
    assignedProductUsagePurposes: CustomerProductUsagePurposeAssignedDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.comment = _data["comment"];
            this.approvalMinute = _data["approvalMinute"];
            this.productSizeApprovalMinute = _data["productSizeApprovalMinute"];
            this.isCheckOrderProductSize = _data["isCheckOrderProductSize"];
            this.personInChargeUserId = _data["personInChargeUserId"];
            if (Array.isArray(_data["assignedWarehouses"])) {
                this.assignedWarehouses = [] as any;
                for (let item of _data["assignedWarehouses"])
                    this.assignedWarehouses.push(CustomerWarehouseAssignedDto.fromJS(item));
            }
            if (Array.isArray(_data["assignedProductUsagePurposes"])) {
                this.assignedProductUsagePurposes = [] as any;
                for (let item of _data["assignedProductUsagePurposes"])
                    this.assignedProductUsagePurposes.push(CustomerProductUsagePurposeAssignedDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["comment"] = this.comment;
        data["approvalMinute"] = this.approvalMinute;
        data["productSizeApprovalMinute"] = this.productSizeApprovalMinute;
        data["isCheckOrderProductSize"] = this.isCheckOrderProductSize;
        data["personInChargeUserId"] = this.personInChargeUserId;
        if (Array.isArray(this.assignedWarehouses)) {
            data["assignedWarehouses"] = [];
            for (let item of this.assignedWarehouses)
                data["assignedWarehouses"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedProductUsagePurposes)) {
            data["assignedProductUsagePurposes"] = [];
            for (let item of this.assignedProductUsagePurposes)
                data["assignedProductUsagePurposes"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): CustomerDto {
        const json = this.toJSON();
        let result = new CustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDto {
    name: string | undefined;
    code: string | undefined;
    comment: string | undefined;
    approvalMinute: number | undefined;
    productSizeApprovalMinute: number | undefined;
    isCheckOrderProductSize: boolean | undefined;
    personInChargeUserId: number | undefined;
    assignedWarehouses: CustomerWarehouseAssignedDto[] | undefined;
    assignedProductUsagePurposes: CustomerProductUsagePurposeAssignedDto[] | undefined;
    id: number | undefined;
}

export class CustomerWarehouseAssignedDto implements ICustomerWarehouseAssignedDto {
    warehouseId: number | undefined;
    warehouseOwnerId: number | undefined;

    constructor(data?: ICustomerWarehouseAssignedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.warehouseOwnerId = _data["warehouseOwnerId"];
        }
    }

    static fromJS(data: any): CustomerWarehouseAssignedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerWarehouseAssignedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["warehouseOwnerId"] = this.warehouseOwnerId;
        return data;
    }

    clone(): CustomerWarehouseAssignedDto {
        const json = this.toJSON();
        let result = new CustomerWarehouseAssignedDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerWarehouseAssignedDto {
    warehouseId: number | undefined;
    warehouseOwnerId: number | undefined;
}

export class CustomerProductUsagePurposeAssignedDto implements ICustomerProductUsagePurposeAssignedDto {
    productUsagePurposeTypeId: number | undefined;

    constructor(data?: ICustomerProductUsagePurposeAssignedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productUsagePurposeTypeId = _data["productUsagePurposeTypeId"];
        }
    }

    static fromJS(data: any): CustomerProductUsagePurposeAssignedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerProductUsagePurposeAssignedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productUsagePurposeTypeId"] = this.productUsagePurposeTypeId;
        return data;
    }

    clone(): CustomerProductUsagePurposeAssignedDto {
        const json = this.toJSON();
        let result = new CustomerProductUsagePurposeAssignedDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerProductUsagePurposeAssignedDto {
    productUsagePurposeTypeId: number | undefined;
}

export class CreateCustomerDto implements ICreateCustomerDto {
    name: string;
    code: string;
    approvalMinute: number;
    comment: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.approvalMinute = _data["approvalMinute"];
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["approvalMinute"] = this.approvalMinute;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateCustomerDto {
        const json = this.toJSON();
        let result = new CreateCustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomerDto {
    name: string;
    code: string;
    approvalMinute: number;
    comment: string | undefined;
    id: number | undefined;
}

export class SelectListItemDto implements ISelectListItemDto {
    disabled: boolean | undefined;
    selected: boolean | undefined;
    text: string | undefined;
    value: any | undefined;
    subSelectList: SelectListItemDto[] | undefined;

    constructor(data?: ISelectListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disabled = _data["disabled"];
            this.selected = _data["selected"];
            this.text = _data["text"];
            this.value = _data["value"];
            if (Array.isArray(_data["subSelectList"])) {
                this.subSelectList = [] as any;
                for (let item of _data["subSelectList"])
                    this.subSelectList.push(SelectListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelectListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disabled"] = this.disabled;
        data["selected"] = this.selected;
        data["text"] = this.text;
        data["value"] = this.value;
        if (Array.isArray(this.subSelectList)) {
            data["subSelectList"] = [];
            for (let item of this.subSelectList)
                data["subSelectList"].push(item.toJSON());
        }
        return data;
    }

    clone(): SelectListItemDto {
        const json = this.toJSON();
        let result = new SelectListItemDto();
        result.init(json);
        return result;
    }
}

export interface ISelectListItemDto {
    disabled: boolean | undefined;
    selected: boolean | undefined;
    text: string | undefined;
    value: any | undefined;
    subSelectList: SelectListItemDto[] | undefined;
}

export class ExcelPagedResultDtoOfCustomerExcelDto implements IExcelPagedResultDtoOfCustomerExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: CustomerExcelDto[] | undefined;

    constructor(data?: IExcelPagedResultDtoOfCustomerExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns.push(ExcelColumn.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomerExcelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExcelPagedResultDtoOfCustomerExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelPagedResultDtoOfCustomerExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ExcelPagedResultDtoOfCustomerExcelDto {
        const json = this.toJSON();
        let result = new ExcelPagedResultDtoOfCustomerExcelDto();
        result.init(json);
        return result;
    }
}

export interface IExcelPagedResultDtoOfCustomerExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: CustomerExcelDto[] | undefined;
}

export class ExcelColumn implements IExcelColumn {
    name: string | undefined;
    asName: string | undefined;

    constructor(data?: IExcelColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.asName = _data["asName"];
        }
    }

    static fromJS(data: any): ExcelColumn {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["asName"] = this.asName;
        return data;
    }

    clone(): ExcelColumn {
        const json = this.toJSON();
        let result = new ExcelColumn();
        result.init(json);
        return result;
    }
}

export interface IExcelColumn {
    name: string | undefined;
    asName: string | undefined;
}

export class CustomerExcelDto implements ICustomerExcelDto {
    name: string | undefined;
    code: string | undefined;
    id: number | undefined;

    constructor(data?: ICustomerExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }

    clone(): CustomerExcelDto {
        const json = this.toJSON();
        let result = new CustomerExcelDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerExcelDto {
    name: string | undefined;
    code: string | undefined;
    id: number | undefined;
}

export class ListResultDtoOfComboboxItemDto implements IListResultDtoOfComboboxItemDto {
    items: ComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfComboboxItemDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfComboboxItemDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfComboboxItemDto {
    items: ComboboxItemDto[] | undefined;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean | undefined;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }

    clone(): ComboboxItemDto {
        const json = this.toJSON();
        let result = new ComboboxItemDto();
        result.init(json);
        return result;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean | undefined;
}

export class CustomerWarehouseListDto implements ICustomerWarehouseListDto {
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    isChecked: boolean | undefined;
    isDisable: boolean | undefined;
    assignedCustomerName: string | undefined;
    readonly disabledVirtualWarehouseName: string | undefined;
    warehouseOwnerId: number | undefined;

    constructor(data?: ICustomerWarehouseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.isChecked = _data["isChecked"];
            this.isDisable = _data["isDisable"];
            this.assignedCustomerName = _data["assignedCustomerName"];
            (<any>this).disabledVirtualWarehouseName = _data["disabledVirtualWarehouseName"];
            this.warehouseOwnerId = _data["warehouseOwnerId"];
        }
    }

    static fromJS(data: any): CustomerWarehouseListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerWarehouseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["isChecked"] = this.isChecked;
        data["isDisable"] = this.isDisable;
        data["assignedCustomerName"] = this.assignedCustomerName;
        data["disabledVirtualWarehouseName"] = this.disabledVirtualWarehouseName;
        data["warehouseOwnerId"] = this.warehouseOwnerId;
        return data;
    }

    clone(): CustomerWarehouseListDto {
        const json = this.toJSON();
        let result = new CustomerWarehouseListDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerWarehouseListDto {
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    isChecked: boolean | undefined;
    isDisable: boolean | undefined;
    assignedCustomerName: string | undefined;
    disabledVirtualWarehouseName: string | undefined;
    warehouseOwnerId: number | undefined;
}

export class CustomerPersonOfChargeDto implements ICustomerPersonOfChargeDto {
    userId: number | undefined;
    userName: string | undefined;
    isChecked: boolean | undefined;

    constructor(data?: ICustomerPersonOfChargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.isChecked = _data["isChecked"];
        }
    }

    static fromJS(data: any): CustomerPersonOfChargeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPersonOfChargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["isChecked"] = this.isChecked;
        return data;
    }

    clone(): CustomerPersonOfChargeDto {
        const json = this.toJSON();
        let result = new CustomerPersonOfChargeDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerPersonOfChargeDto {
    userId: number | undefined;
    userName: string | undefined;
    isChecked: boolean | undefined;
}

export class CustomerUserListDto implements ICustomerUserListDto {
    userId: number | undefined;
    userName: string | undefined;

    constructor(data?: ICustomerUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): CustomerUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data;
    }

    clone(): CustomerUserListDto {
        const json = this.toJSON();
        let result = new CustomerUserListDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerUserListDto {
    userId: number | undefined;
    userName: string | undefined;
}

export class CustomerWarehouseInfoDto implements ICustomerWarehouseInfoDto {
    customerWarehouseId: number | undefined;
    customerId: number | undefined;
    customerCode: string | undefined;
    customerName: string | undefined;
    customerIsDeleted: boolean | undefined;
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    warehouseOwner: string | undefined;
    warehouseOwnerId: number | undefined;
    warehouseIsDeleted: boolean | undefined;

    constructor(data?: ICustomerWarehouseInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerWarehouseId = _data["customerWarehouseId"];
            this.customerId = _data["customerId"];
            this.customerCode = _data["customerCode"];
            this.customerName = _data["customerName"];
            this.customerIsDeleted = _data["customerIsDeleted"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.warehouseOwner = _data["warehouseOwner"];
            this.warehouseOwnerId = _data["warehouseOwnerId"];
            this.warehouseIsDeleted = _data["warehouseIsDeleted"];
        }
    }

    static fromJS(data: any): CustomerWarehouseInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerWarehouseInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerWarehouseId"] = this.customerWarehouseId;
        data["customerId"] = this.customerId;
        data["customerCode"] = this.customerCode;
        data["customerName"] = this.customerName;
        data["customerIsDeleted"] = this.customerIsDeleted;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["warehouseOwner"] = this.warehouseOwner;
        data["warehouseOwnerId"] = this.warehouseOwnerId;
        data["warehouseIsDeleted"] = this.warehouseIsDeleted;
        return data;
    }

    clone(): CustomerWarehouseInfoDto {
        const json = this.toJSON();
        let result = new CustomerWarehouseInfoDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerWarehouseInfoDto {
    customerWarehouseId: number | undefined;
    customerId: number | undefined;
    customerCode: string | undefined;
    customerName: string | undefined;
    customerIsDeleted: boolean | undefined;
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    warehouseOwner: string | undefined;
    warehouseOwnerId: number | undefined;
    warehouseIsDeleted: boolean | undefined;
}

export class CustomerMpoiDto implements ICustomerMpoiDto {
    name: string | undefined;
    enlem: string | undefined;
    boylam: string | undefined;

    constructor(data?: ICustomerMpoiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.enlem = _data["enlem"];
            this.boylam = _data["boylam"];
        }
    }

    static fromJS(data: any): CustomerMpoiDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMpoiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["enlem"] = this.enlem;
        data["boylam"] = this.boylam;
        return data;
    }

    clone(): CustomerMpoiDto {
        const json = this.toJSON();
        let result = new CustomerMpoiDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerMpoiDto {
    name: string | undefined;
    enlem: string | undefined;
    boylam: string | undefined;
}

export class UserProjectsDto implements IUserProjectsDto {
    id: string | undefined;
    name: string | undefined;
    personelId: string | undefined;
    personelName: string | undefined;
    projeId: string | undefined;
    projeName: string | undefined;
    firmaId: string | undefined;

    constructor(data?: IUserProjectsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.personelId = _data["personelId"];
            this.personelName = _data["personelName"];
            this.projeId = _data["projeId"];
            this.projeName = _data["projeName"];
            this.firmaId = _data["firmaId"];
        }
    }

    static fromJS(data: any): UserProjectsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProjectsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["personelId"] = this.personelId;
        data["personelName"] = this.personelName;
        data["projeId"] = this.projeId;
        data["projeName"] = this.projeName;
        data["firmaId"] = this.firmaId;
        return data;
    }

    clone(): UserProjectsDto {
        const json = this.toJSON();
        let result = new UserProjectsDto();
        result.init(json);
        return result;
    }
}

export interface IUserProjectsDto {
    id: string | undefined;
    name: string | undefined;
    personelId: string | undefined;
    personelName: string | undefined;
    projeId: string | undefined;
    projeName: string | undefined;
    firmaId: string | undefined;
}

export class CustomerProductDto implements ICustomerProductDto {
    name: string | undefined;
    musteri: string | undefined;
    proje: string | undefined;
    urunKodu: string | undefined;
    ozelKod: string | undefined;
    kritikStok: number | undefined;
    kategoriTipiId: string | undefined;
    kategoriTipi: string | undefined;
    urunTipi: string | undefined;
    urunBarkodu: string | undefined;
    kategori1: string | undefined;
    kategori2: string | undefined;
    kategori3: string | undefined;
    id: string | undefined;

    constructor(data?: ICustomerProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.musteri = _data["musteri"];
            this.proje = _data["proje"];
            this.urunKodu = _data["urunKodu"];
            this.ozelKod = _data["ozelKod"];
            this.kritikStok = _data["kritikStok"];
            this.kategoriTipiId = _data["kategoriTipiId"];
            this.kategoriTipi = _data["kategoriTipi"];
            this.urunTipi = _data["urunTipi"];
            this.urunBarkodu = _data["urunBarkodu"];
            this.kategori1 = _data["kategori1"];
            this.kategori2 = _data["kategori2"];
            this.kategori3 = _data["kategori3"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["musteri"] = this.musteri;
        data["proje"] = this.proje;
        data["urunKodu"] = this.urunKodu;
        data["ozelKod"] = this.ozelKod;
        data["kritikStok"] = this.kritikStok;
        data["kategoriTipiId"] = this.kategoriTipiId;
        data["kategoriTipi"] = this.kategoriTipi;
        data["urunTipi"] = this.urunTipi;
        data["urunBarkodu"] = this.urunBarkodu;
        data["kategori1"] = this.kategori1;
        data["kategori2"] = this.kategori2;
        data["kategori3"] = this.kategori3;
        data["id"] = this.id;
        return data;
    }

    clone(): CustomerProductDto {
        const json = this.toJSON();
        let result = new CustomerProductDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerProductDto {
    name: string | undefined;
    musteri: string | undefined;
    proje: string | undefined;
    urunKodu: string | undefined;
    ozelKod: string | undefined;
    kritikStok: number | undefined;
    kategoriTipiId: string | undefined;
    kategoriTipi: string | undefined;
    urunTipi: string | undefined;
    urunBarkodu: string | undefined;
    kategori1: string | undefined;
    kategori2: string | undefined;
    kategori3: string | undefined;
    id: string | undefined;
}

export class CreateCustomerProductDto implements ICreateCustomerProductDto {
    name: string;
    musteriId: string;
    projeId: string;
    urunKodu: string | undefined;
    ozelKod: string | undefined;
    kritikStok: number | undefined;
    kategoriTipiId: string;
    urunTipiId: string | undefined;
    urunBarkodu: string | undefined;
    kategori1Id: string | undefined;
    kategori2Id: string | undefined;
    kategori3Id: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateCustomerProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.musteriId = _data["musteriId"];
            this.projeId = _data["projeId"];
            this.urunKodu = _data["urunKodu"];
            this.ozelKod = _data["ozelKod"];
            this.kritikStok = _data["kritikStok"];
            this.kategoriTipiId = _data["kategoriTipiId"];
            this.urunTipiId = _data["urunTipiId"];
            this.urunBarkodu = _data["urunBarkodu"];
            this.kategori1Id = _data["kategori1Id"];
            this.kategori2Id = _data["kategori2Id"];
            this.kategori3Id = _data["kategori3Id"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateCustomerProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["musteriId"] = this.musteriId;
        data["projeId"] = this.projeId;
        data["urunKodu"] = this.urunKodu;
        data["ozelKod"] = this.ozelKod;
        data["kritikStok"] = this.kritikStok;
        data["kategoriTipiId"] = this.kategoriTipiId;
        data["urunTipiId"] = this.urunTipiId;
        data["urunBarkodu"] = this.urunBarkodu;
        data["kategori1Id"] = this.kategori1Id;
        data["kategori2Id"] = this.kategori2Id;
        data["kategori3Id"] = this.kategori3Id;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateCustomerProductDto {
        const json = this.toJSON();
        let result = new CreateCustomerProductDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomerProductDto {
    name: string;
    musteriId: string;
    projeId: string;
    urunKodu: string | undefined;
    ozelKod: string | undefined;
    kritikStok: number | undefined;
    kategoriTipiId: string;
    urunTipiId: string | undefined;
    urunBarkodu: string | undefined;
    kategori1Id: string | undefined;
    kategori2Id: string | undefined;
    kategori3Id: string | undefined;
    id: number | undefined;
}

export class UpdateCustomerProductDto implements IUpdateCustomerProductDto {
    id: string;
    name: string;
    musteriId: string;
    projeId: string;
    urunKodu: string | undefined;
    ozelKod: string | undefined;
    kritikStok: number | undefined;
    kategoriTipiId: string;
    urunTipiId: string | undefined;
    urunBarkodu: string | undefined;
    kategori1Id: string | undefined;
    kategori2Id: string | undefined;
    kategori3Id: string | undefined;

    constructor(data?: IUpdateCustomerProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.musteriId = _data["musteriId"];
            this.projeId = _data["projeId"];
            this.urunKodu = _data["urunKodu"];
            this.ozelKod = _data["ozelKod"];
            this.kritikStok = _data["kritikStok"];
            this.kategoriTipiId = _data["kategoriTipiId"];
            this.urunTipiId = _data["urunTipiId"];
            this.urunBarkodu = _data["urunBarkodu"];
            this.kategori1Id = _data["kategori1Id"];
            this.kategori2Id = _data["kategori2Id"];
            this.kategori3Id = _data["kategori3Id"];
        }
    }

    static fromJS(data: any): UpdateCustomerProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["musteriId"] = this.musteriId;
        data["projeId"] = this.projeId;
        data["urunKodu"] = this.urunKodu;
        data["ozelKod"] = this.ozelKod;
        data["kritikStok"] = this.kritikStok;
        data["kategoriTipiId"] = this.kategoriTipiId;
        data["urunTipiId"] = this.urunTipiId;
        data["urunBarkodu"] = this.urunBarkodu;
        data["kategori1Id"] = this.kategori1Id;
        data["kategori2Id"] = this.kategori2Id;
        data["kategori3Id"] = this.kategori3Id;
        return data;
    }

    clone(): UpdateCustomerProductDto {
        const json = this.toJSON();
        let result = new UpdateCustomerProductDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCustomerProductDto {
    id: string;
    name: string;
    musteriId: string;
    projeId: string;
    urunKodu: string | undefined;
    ozelKod: string | undefined;
    kritikStok: number | undefined;
    kategoriTipiId: string;
    urunTipiId: string | undefined;
    urunBarkodu: string | undefined;
    kategori1Id: string | undefined;
    kategori2Id: string | undefined;
    kategori3Id: string | undefined;
}

export class KategoriTypesDto implements IKategoriTypesDto {
    id: string | undefined;
    name: string | undefined;

    constructor(data?: IKategoriTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): KategoriTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new KategoriTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): KategoriTypesDto {
        const json = this.toJSON();
        let result = new KategoriTypesDto();
        result.init(json);
        return result;
    }
}

export interface IKategoriTypesDto {
    id: string | undefined;
    name: string | undefined;
}

export class UrunTypesDto implements IUrunTypesDto {
    id: string | undefined;
    name: string | undefined;

    constructor(data?: IUrunTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UrunTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UrunTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): UrunTypesDto {
        const json = this.toJSON();
        let result = new UrunTypesDto();
        result.init(json);
        return result;
    }
}

export interface IUrunTypesDto {
    id: string | undefined;
    name: string | undefined;
}

export class CustomersDto implements ICustomersDto {
    id: string | undefined;
    name: string | undefined;

    constructor(data?: ICustomersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CustomersDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): CustomersDto {
        const json = this.toJSON();
        let result = new CustomersDto();
        result.init(json);
        return result;
    }
}

export interface ICustomersDto {
    id: string | undefined;
    name: string | undefined;
}

export class PagedResultDtoOfCustomerThemeDto implements IPagedResultDtoOfCustomerThemeDto {
    totalCount: number | undefined;
    items: CustomerThemeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCustomerThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomerThemeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCustomerThemeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCustomerThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfCustomerThemeDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCustomerThemeDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCustomerThemeDto {
    totalCount: number | undefined;
    items: CustomerThemeDto[] | undefined;
}

export class CustomerThemeDto implements ICustomerThemeDto {
    name: string | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    portalLogoPath: string | undefined;
    negativePortalLogoPath: string | undefined;
    customerLogoPath: string | undefined;
    comment: string | undefined;
    id: number | undefined;

    constructor(data?: ICustomerThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.portalLogoPath = _data["portalLogoPath"];
            this.negativePortalLogoPath = _data["negativePortalLogoPath"];
            this.customerLogoPath = _data["customerLogoPath"];
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerThemeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["portalLogoPath"] = this.portalLogoPath;
        data["negativePortalLogoPath"] = this.negativePortalLogoPath;
        data["customerLogoPath"] = this.customerLogoPath;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data;
    }

    clone(): CustomerThemeDto {
        const json = this.toJSON();
        let result = new CustomerThemeDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerThemeDto {
    name: string | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    portalLogoPath: string | undefined;
    negativePortalLogoPath: string | undefined;
    customerLogoPath: string | undefined;
    comment: string | undefined;
    id: number | undefined;
}

export class CreateCustomerThemeDto implements ICreateCustomerThemeDto {
    name: string;
    customerId: number;
    portalLogoBase64: string;
    negativePortalLogoBase64: string;
    customerLogoBase64: string;
    comment: string | undefined;

    constructor(data?: ICreateCustomerThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.portalLogoBase64 = _data["portalLogoBase64"];
            this.negativePortalLogoBase64 = _data["negativePortalLogoBase64"];
            this.customerLogoBase64 = _data["customerLogoBase64"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CreateCustomerThemeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["portalLogoBase64"] = this.portalLogoBase64;
        data["negativePortalLogoBase64"] = this.negativePortalLogoBase64;
        data["customerLogoBase64"] = this.customerLogoBase64;
        data["comment"] = this.comment;
        return data;
    }

    clone(): CreateCustomerThemeDto {
        const json = this.toJSON();
        let result = new CreateCustomerThemeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomerThemeDto {
    name: string;
    customerId: number;
    portalLogoBase64: string;
    negativePortalLogoBase64: string;
    customerLogoBase64: string;
    comment: string | undefined;
}

export class UpdateCustomerThemeDto implements IUpdateCustomerThemeDto {
    name: string;
    customerId: number;
    portalLogoBase64: string | undefined;
    negativePortalLogoBase64: string | undefined;
    customerLogoBase64: string | undefined;
    comment: string | undefined;
    id: number | undefined;

    constructor(data?: IUpdateCustomerThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.portalLogoBase64 = _data["portalLogoBase64"];
            this.negativePortalLogoBase64 = _data["negativePortalLogoBase64"];
            this.customerLogoBase64 = _data["customerLogoBase64"];
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCustomerThemeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["portalLogoBase64"] = this.portalLogoBase64;
        data["negativePortalLogoBase64"] = this.negativePortalLogoBase64;
        data["customerLogoBase64"] = this.customerLogoBase64;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCustomerThemeDto {
        const json = this.toJSON();
        let result = new UpdateCustomerThemeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCustomerThemeDto {
    name: string;
    customerId: number;
    portalLogoBase64: string | undefined;
    negativePortalLogoBase64: string | undefined;
    customerLogoBase64: string | undefined;
    comment: string | undefined;
    id: number | undefined;
}

export class CustomerThemeSizeDto implements ICustomerThemeSizeDto {
    portalHeight: number | undefined;
    portalWidth: number | undefined;
    negativePortalHeight: number | undefined;
    negativePortalWidth: number | undefined;
    customerHeight: number | undefined;
    customerWidth: number | undefined;

    constructor(data?: ICustomerThemeSizeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.portalHeight = _data["portalHeight"];
            this.portalWidth = _data["portalWidth"];
            this.negativePortalHeight = _data["negativePortalHeight"];
            this.negativePortalWidth = _data["negativePortalWidth"];
            this.customerHeight = _data["customerHeight"];
            this.customerWidth = _data["customerWidth"];
        }
    }

    static fromJS(data: any): CustomerThemeSizeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerThemeSizeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalHeight"] = this.portalHeight;
        data["portalWidth"] = this.portalWidth;
        data["negativePortalHeight"] = this.negativePortalHeight;
        data["negativePortalWidth"] = this.negativePortalWidth;
        data["customerHeight"] = this.customerHeight;
        data["customerWidth"] = this.customerWidth;
        return data;
    }

    clone(): CustomerThemeSizeDto {
        const json = this.toJSON();
        let result = new CustomerThemeSizeDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerThemeSizeDto {
    portalHeight: number | undefined;
    portalWidth: number | undefined;
    negativePortalHeight: number | undefined;
    negativePortalWidth: number | undefined;
    customerHeight: number | undefined;
    customerWidth: number | undefined;
}

export class PagedResultDtoOfDeliveryConfirmDto implements IPagedResultDtoOfDeliveryConfirmDto {
    totalCount: number | undefined;
    items: DeliveryConfirmDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDeliveryConfirmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DeliveryConfirmDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDeliveryConfirmDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDeliveryConfirmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfDeliveryConfirmDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfDeliveryConfirmDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfDeliveryConfirmDto {
    totalCount: number | undefined;
    items: DeliveryConfirmDto[] | undefined;
}

export class DeliveryConfirmDto implements IDeliveryConfirmDto {
    id: number | undefined;
    name: string | undefined;
    rowGuid: string | undefined;
    cariHareketId: number | undefined;
    cariHareketGuid: string | undefined;
    productId: number | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    requestOwnerName: string | undefined;
    targetAddressId: number | undefined;
    targetAddressName: string | undefined;
    approverName: string | undefined;
    approverMail: string | undefined;
    approveStatus: string | undefined;
    productQuantity: number | undefined;
    shipmentDate: Date | undefined;
    creationTime: Date | undefined;

    constructor(data?: IDeliveryConfirmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.rowGuid = _data["rowGuid"];
            this.cariHareketId = _data["cariHareketId"];
            this.cariHareketGuid = _data["cariHareketGuid"];
            this.productId = _data["productId"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.requestOwnerName = _data["requestOwnerName"];
            this.targetAddressId = _data["targetAddressId"];
            this.targetAddressName = _data["targetAddressName"];
            this.approverName = _data["approverName"];
            this.approverMail = _data["approverMail"];
            this.approveStatus = _data["approveStatus"];
            this.productQuantity = _data["productQuantity"];
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeliveryConfirmDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryConfirmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["rowGuid"] = this.rowGuid;
        data["cariHareketId"] = this.cariHareketId;
        data["cariHareketGuid"] = this.cariHareketGuid;
        data["productId"] = this.productId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["requestOwnerName"] = this.requestOwnerName;
        data["targetAddressId"] = this.targetAddressId;
        data["targetAddressName"] = this.targetAddressName;
        data["approverName"] = this.approverName;
        data["approverMail"] = this.approverMail;
        data["approveStatus"] = this.approveStatus;
        data["productQuantity"] = this.productQuantity;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): DeliveryConfirmDto {
        const json = this.toJSON();
        let result = new DeliveryConfirmDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryConfirmDto {
    id: number | undefined;
    name: string | undefined;
    rowGuid: string | undefined;
    cariHareketId: number | undefined;
    cariHareketGuid: string | undefined;
    productId: number | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    requestOwnerName: string | undefined;
    targetAddressId: number | undefined;
    targetAddressName: string | undefined;
    approverName: string | undefined;
    approverMail: string | undefined;
    approveStatus: string | undefined;
    productQuantity: number | undefined;
    shipmentDate: Date | undefined;
    creationTime: Date | undefined;
}

export class CreateDeliveryConfirmDto implements ICreateDeliveryConfirmDto {
    name: string | undefined;
    cariHareketId: number | undefined;
    productId: number | undefined;
    requestOwnerName: string | undefined;
    targetAddressId: number | undefined;
    approverName: string | undefined;
    approverMail: string | undefined;
    approveStatus: string | undefined;
    productQuantity: number | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;

    constructor(data?: ICreateDeliveryConfirmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cariHareketId = _data["cariHareketId"];
            this.productId = _data["productId"];
            this.requestOwnerName = _data["requestOwnerName"];
            this.targetAddressId = _data["targetAddressId"];
            this.approverName = _data["approverName"];
            this.approverMail = _data["approverMail"];
            this.approveStatus = _data["approveStatus"];
            this.productQuantity = _data["productQuantity"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): CreateDeliveryConfirmDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDeliveryConfirmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cariHareketId"] = this.cariHareketId;
        data["productId"] = this.productId;
        data["requestOwnerName"] = this.requestOwnerName;
        data["targetAddressId"] = this.targetAddressId;
        data["approverName"] = this.approverName;
        data["approverMail"] = this.approverMail;
        data["approveStatus"] = this.approveStatus;
        data["productQuantity"] = this.productQuantity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data;
    }

    clone(): CreateDeliveryConfirmDto {
        const json = this.toJSON();
        let result = new CreateDeliveryConfirmDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDeliveryConfirmDto {
    name: string | undefined;
    cariHareketId: number | undefined;
    productId: number | undefined;
    requestOwnerName: string | undefined;
    targetAddressId: number | undefined;
    approverName: string | undefined;
    approverMail: string | undefined;
    approveStatus: string | undefined;
    productQuantity: number | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
}

export class ApprovedQuantityDataInputDto implements IApprovedQuantityDataInputDto {
    rowGuid: string | undefined;
    approvedQuantity: number | undefined;

    constructor(data?: IApprovedQuantityDataInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowGuid = _data["rowGuid"];
            this.approvedQuantity = _data["approvedQuantity"];
        }
    }

    static fromJS(data: any): ApprovedQuantityDataInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovedQuantityDataInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowGuid"] = this.rowGuid;
        data["approvedQuantity"] = this.approvedQuantity;
        return data;
    }

    clone(): ApprovedQuantityDataInputDto {
        const json = this.toJSON();
        let result = new ApprovedQuantityDataInputDto();
        result.init(json);
        return result;
    }
}

export interface IApprovedQuantityDataInputDto {
    rowGuid: string | undefined;
    approvedQuantity: number | undefined;
}

export class DFMFormDto implements IDFMFormDto {
    id: string | undefined;
    formAdi: string | undefined;
    formTipi: DFMFormDtoFormTipi | undefined;
    projeAdi: string | undefined;
    formAciklama: string | undefined;
    formTasarimJson: string | undefined;
    olusturulmaTarihi: string | undefined;

    constructor(data?: IDFMFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formAdi = _data["formAdi"];
            this.formTipi = _data["formTipi"];
            this.projeAdi = _data["projeAdi"];
            this.formAciklama = _data["formAciklama"];
            this.formTasarimJson = _data["formTasarimJson"];
            this.olusturulmaTarihi = _data["olusturulmaTarihi"];
        }
    }

    static fromJS(data: any): DFMFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new DFMFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formAdi"] = this.formAdi;
        data["formTipi"] = this.formTipi;
        data["projeAdi"] = this.projeAdi;
        data["formAciklama"] = this.formAciklama;
        data["formTasarimJson"] = this.formTasarimJson;
        data["olusturulmaTarihi"] = this.olusturulmaTarihi;
        return data;
    }

    clone(): DFMFormDto {
        const json = this.toJSON();
        let result = new DFMFormDto();
        result.init(json);
        return result;
    }
}

export interface IDFMFormDto {
    id: string | undefined;
    formAdi: string | undefined;
    formTipi: DFMFormDtoFormTipi | undefined;
    projeAdi: string | undefined;
    formAciklama: string | undefined;
    formTasarimJson: string | undefined;
    olusturulmaTarihi: string | undefined;
}

export class DFMProjectDto implements IDFMProjectDto {
    id: string | undefined;
    name: string | undefined;
    personelId: string | undefined;
    personelAdi: string | undefined;
    projeId: string | undefined;
    projeAdi: string | undefined;

    constructor(data?: IDFMProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.personelId = _data["personelId"];
            this.personelAdi = _data["personelAdi"];
            this.projeId = _data["projeId"];
            this.projeAdi = _data["projeAdi"];
        }
    }

    static fromJS(data: any): DFMProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new DFMProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["personelId"] = this.personelId;
        data["personelAdi"] = this.personelAdi;
        data["projeId"] = this.projeId;
        data["projeAdi"] = this.projeAdi;
        return data;
    }

    clone(): DFMProjectDto {
        const json = this.toJSON();
        let result = new DFMProjectDto();
        result.init(json);
        return result;
    }
}

export interface IDFMProjectDto {
    id: string | undefined;
    name: string | undefined;
    personelId: string | undefined;
    personelAdi: string | undefined;
    projeId: string | undefined;
    projeAdi: string | undefined;
}

export class DynamicFormMainResultDto implements IDynamicFormMainResultDto {
    elements: DynamicFormResultDto[] | undefined;
    datasources: DataSourceDto[] | undefined;
    info: DynamicFormInfoDto | undefined;

    constructor(data?: IDynamicFormMainResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements.push(DynamicFormResultDto.fromJS(item));
            }
            if (Array.isArray(_data["datasources"])) {
                this.datasources = [] as any;
                for (let item of _data["datasources"])
                    this.datasources.push(DataSourceDto.fromJS(item));
            }
            this.info = _data["info"] ? DynamicFormInfoDto.fromJS(_data["info"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DynamicFormMainResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicFormMainResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        if (Array.isArray(this.datasources)) {
            data["datasources"] = [];
            for (let item of this.datasources)
                data["datasources"].push(item.toJSON());
        }
        data["info"] = this.info ? this.info.toJSON() : <any>undefined;
        return data;
    }

    clone(): DynamicFormMainResultDto {
        const json = this.toJSON();
        let result = new DynamicFormMainResultDto();
        result.init(json);
        return result;
    }
}

export interface IDynamicFormMainResultDto {
    elements: DynamicFormResultDto[] | undefined;
    datasources: DataSourceDto[] | undefined;
    info: DynamicFormInfoDto | undefined;
}

export class DynamicFormResultDto implements IDynamicFormResultDto {
    id: string | undefined;
    name: string | undefined;
    type: string | undefined;
    key: string | undefined;
    value: any | undefined;
    soruId: any | undefined;
    datasourcename: string | undefined;

    constructor(data?: IDynamicFormResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.soruId = _data["soruId"];
            this.datasourcename = _data["datasourcename"];
        }
    }

    static fromJS(data: any): DynamicFormResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicFormResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["key"] = this.key;
        data["value"] = this.value;
        data["soruId"] = this.soruId;
        data["datasourcename"] = this.datasourcename;
        return data;
    }

    clone(): DynamicFormResultDto {
        const json = this.toJSON();
        let result = new DynamicFormResultDto();
        result.init(json);
        return result;
    }
}

export interface IDynamicFormResultDto {
    id: string | undefined;
    name: string | undefined;
    type: string | undefined;
    key: string | undefined;
    value: any | undefined;
    soruId: any | undefined;
    datasourcename: string | undefined;
}

export class DataSourceDto implements IDataSourceDto {
    name: string | undefined;
    options: any[] | undefined;

    constructor(data?: IDataSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options.push(item);
            }
        }
    }

    static fromJS(data: any): DataSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        return data;
    }

    clone(): DataSourceDto {
        const json = this.toJSON();
        let result = new DataSourceDto();
        result.init(json);
        return result;
    }
}

export interface IDataSourceDto {
    name: string | undefined;
    options: any[] | undefined;
}

export class DynamicFormInfoDto implements IDynamicFormInfoDto {
    pgsNo: string | undefined;
    noktaAdi: string | undefined;
    gorevAdi: string | undefined;
    ziyaretTarihi: Date | undefined;
    personel: string | undefined;
    supervisor: string | undefined;

    constructor(data?: IDynamicFormInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pgsNo = _data["pgsNo"];
            this.noktaAdi = _data["noktaAdi"];
            this.gorevAdi = _data["gorevAdi"];
            this.ziyaretTarihi = _data["ziyaretTarihi"] ? new Date(_data["ziyaretTarihi"].toString()) : <any>undefined;
            this.personel = _data["personel"];
            this.supervisor = _data["supervisor"];
        }
    }

    static fromJS(data: any): DynamicFormInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicFormInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pgsNo"] = this.pgsNo;
        data["noktaAdi"] = this.noktaAdi;
        data["gorevAdi"] = this.gorevAdi;
        data["ziyaretTarihi"] = this.ziyaretTarihi ? this.ziyaretTarihi.toISOString() : <any>undefined;
        data["personel"] = this.personel;
        data["supervisor"] = this.supervisor;
        return data;
    }

    clone(): DynamicFormInfoDto {
        const json = this.toJSON();
        let result = new DynamicFormInfoDto();
        result.init(json);
        return result;
    }
}

export interface IDynamicFormInfoDto {
    pgsNo: string | undefined;
    noktaAdi: string | undefined;
    gorevAdi: string | undefined;
    ziyaretTarihi: Date | undefined;
    personel: string | undefined;
    supervisor: string | undefined;
}

export class DynamicFormResultUpdateDto implements IDynamicFormResultUpdateDto {
    id: string | undefined;
    key: string | undefined;
    value: any | undefined;
    type: string | undefined;
    updateDesc: string | undefined;

    constructor(data?: IDynamicFormResultUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.type = _data["type"];
            this.updateDesc = _data["updateDesc"];
        }
    }

    static fromJS(data: any): DynamicFormResultUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicFormResultUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["value"] = this.value;
        data["type"] = this.type;
        data["updateDesc"] = this.updateDesc;
        return data;
    }

    clone(): DynamicFormResultUpdateDto {
        const json = this.toJSON();
        let result = new DynamicFormResultUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IDynamicFormResultUpdateDto {
    id: string | undefined;
    key: string | undefined;
    value: any | undefined;
    type: string | undefined;
    updateDesc: string | undefined;
}

export class TitleCountDto implements ITitleCountDto {
    title: string | undefined;
    count: number | undefined;

    constructor(data?: ITitleCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): TitleCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new TitleCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["count"] = this.count;
        return data;
    }

    clone(): TitleCountDto {
        const json = this.toJSON();
        let result = new TitleCountDto();
        result.init(json);
        return result;
    }
}

export interface ITitleCountDto {
    title: string | undefined;
    count: number | undefined;
}

export class RutPlanDto implements IRutPlanDto {
    id: string | undefined;
    projeAdi: string | undefined;
    planAdi: string | undefined;
    rutBaslangicTarihi: Date | undefined;
    rutBitisTarihi: Date | undefined;
    rutFrekansi: string | undefined;
    rutAciklamasi: string | undefined;

    constructor(data?: IRutPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projeAdi = _data["projeAdi"];
            this.planAdi = _data["planAdi"];
            this.rutBaslangicTarihi = _data["rutBaslangicTarihi"] ? new Date(_data["rutBaslangicTarihi"].toString()) : <any>undefined;
            this.rutBitisTarihi = _data["rutBitisTarihi"] ? new Date(_data["rutBitisTarihi"].toString()) : <any>undefined;
            this.rutFrekansi = _data["rutFrekansi"];
            this.rutAciklamasi = _data["rutAciklamasi"];
        }
    }

    static fromJS(data: any): RutPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new RutPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projeAdi"] = this.projeAdi;
        data["planAdi"] = this.planAdi;
        data["rutBaslangicTarihi"] = this.rutBaslangicTarihi ? this.rutBaslangicTarihi.toISOString() : <any>undefined;
        data["rutBitisTarihi"] = this.rutBitisTarihi ? this.rutBitisTarihi.toISOString() : <any>undefined;
        data["rutFrekansi"] = this.rutFrekansi;
        data["rutAciklamasi"] = this.rutAciklamasi;
        return data;
    }

    clone(): RutPlanDto {
        const json = this.toJSON();
        let result = new RutPlanDto();
        result.init(json);
        return result;
    }
}

export interface IRutPlanDto {
    id: string | undefined;
    projeAdi: string | undefined;
    planAdi: string | undefined;
    rutBaslangicTarihi: Date | undefined;
    rutBitisTarihi: Date | undefined;
    rutFrekansi: string | undefined;
    rutAciklamasi: string | undefined;
}

export class RutPlanDetayDto implements IRutPlanDetayDto {
    personel: string | undefined;
    calismaGunu: string | undefined;
    magaza: string | undefined;
    sehir: string | undefined;
    girisSaati: string | undefined;
    cikisSaati: string | undefined;
    calismaSuresi: number | undefined;

    constructor(data?: IRutPlanDetayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personel = _data["personel"];
            this.calismaGunu = _data["calismaGunu"];
            this.magaza = _data["magaza"];
            this.sehir = _data["sehir"];
            this.girisSaati = _data["girisSaati"];
            this.cikisSaati = _data["cikisSaati"];
            this.calismaSuresi = _data["calismaSuresi"];
        }
    }

    static fromJS(data: any): RutPlanDetayDto {
        data = typeof data === 'object' ? data : {};
        let result = new RutPlanDetayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personel"] = this.personel;
        data["calismaGunu"] = this.calismaGunu;
        data["magaza"] = this.magaza;
        data["sehir"] = this.sehir;
        data["girisSaati"] = this.girisSaati;
        data["cikisSaati"] = this.cikisSaati;
        data["calismaSuresi"] = this.calismaSuresi;
        return data;
    }

    clone(): RutPlanDetayDto {
        const json = this.toJSON();
        let result = new RutPlanDetayDto();
        result.init(json);
        return result;
    }
}

export interface IRutPlanDetayDto {
    personel: string | undefined;
    calismaGunu: string | undefined;
    magaza: string | undefined;
    sehir: string | undefined;
    girisSaati: string | undefined;
    cikisSaati: string | undefined;
    calismaSuresi: number | undefined;
}

export class GorevSonucReportDto implements IGorevSonucReportDto {
    tarih: string | undefined;
    magaza: string | undefined;
    sehir: string | undefined;
    merch: string | undefined;
    soru: string | undefined;
    cevap: string | undefined;
    soruTipi: string | undefined;
    raporAlanTipi: string | undefined;
    raporAlanAdi: string | undefined;
    urun: string | undefined;

    constructor(data?: IGorevSonucReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tarih = _data["tarih"];
            this.magaza = _data["magaza"];
            this.sehir = _data["sehir"];
            this.merch = _data["merch"];
            this.soru = _data["soru"];
            this.cevap = _data["cevap"];
            this.soruTipi = _data["soruTipi"];
            this.raporAlanTipi = _data["raporAlanTipi"];
            this.raporAlanAdi = _data["raporAlanAdi"];
            this.urun = _data["urun"];
        }
    }

    static fromJS(data: any): GorevSonucReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GorevSonucReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tarih"] = this.tarih;
        data["magaza"] = this.magaza;
        data["sehir"] = this.sehir;
        data["merch"] = this.merch;
        data["soru"] = this.soru;
        data["cevap"] = this.cevap;
        data["soruTipi"] = this.soruTipi;
        data["raporAlanTipi"] = this.raporAlanTipi;
        data["raporAlanAdi"] = this.raporAlanAdi;
        data["urun"] = this.urun;
        return data;
    }

    clone(): GorevSonucReportDto {
        const json = this.toJSON();
        let result = new GorevSonucReportDto();
        result.init(json);
        return result;
    }
}

export interface IGorevSonucReportDto {
    tarih: string | undefined;
    magaza: string | undefined;
    sehir: string | undefined;
    merch: string | undefined;
    soru: string | undefined;
    cevap: string | undefined;
    soruTipi: string | undefined;
    raporAlanTipi: string | undefined;
    raporAlanAdi: string | undefined;
    urun: string | undefined;
}

export class RutOzetDto implements IRutOzetDto {
    personelAdi: string | undefined;
    gorevTipi: string | undefined;
    gorevDurumu: string | undefined;
    noktaEnlem: number | undefined;
    noktaBoylam: number | undefined;
    nokta: string | undefined;
    gorevTarihi: Date | undefined;
    planlananZiyaretSayisi: number | undefined;
    rutIciZiyaretSayisi: number | undefined;
    gidilmeyenNoktaSayisi: number | undefined;
    rutIciBasariYuzdesi: number | undefined;
    rutDisiZiyaretSayisi: number | undefined;
    toplamZiyaretSayisi: number | undefined;
    toplamBasariYuzdesi: number | undefined;
    gidilenNoktalar: string[] | undefined;
    gidilmeyenNoktalar: string[] | undefined;

    constructor(data?: IRutOzetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personelAdi = _data["personelAdi"];
            this.gorevTipi = _data["gorevTipi"];
            this.gorevDurumu = _data["gorevDurumu"];
            this.noktaEnlem = _data["noktaEnlem"];
            this.noktaBoylam = _data["noktaBoylam"];
            this.nokta = _data["nokta"];
            this.gorevTarihi = _data["gorevTarihi"] ? new Date(_data["gorevTarihi"].toString()) : <any>undefined;
            this.planlananZiyaretSayisi = _data["planlananZiyaretSayisi"];
            this.rutIciZiyaretSayisi = _data["rutIciZiyaretSayisi"];
            this.gidilmeyenNoktaSayisi = _data["gidilmeyenNoktaSayisi"];
            this.rutIciBasariYuzdesi = _data["rutIciBasariYuzdesi"];
            this.rutDisiZiyaretSayisi = _data["rutDisiZiyaretSayisi"];
            this.toplamZiyaretSayisi = _data["toplamZiyaretSayisi"];
            this.toplamBasariYuzdesi = _data["toplamBasariYuzdesi"];
            if (Array.isArray(_data["gidilenNoktalar"])) {
                this.gidilenNoktalar = [] as any;
                for (let item of _data["gidilenNoktalar"])
                    this.gidilenNoktalar.push(item);
            }
            if (Array.isArray(_data["gidilmeyenNoktalar"])) {
                this.gidilmeyenNoktalar = [] as any;
                for (let item of _data["gidilmeyenNoktalar"])
                    this.gidilmeyenNoktalar.push(item);
            }
        }
    }

    static fromJS(data: any): RutOzetDto {
        data = typeof data === 'object' ? data : {};
        let result = new RutOzetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personelAdi"] = this.personelAdi;
        data["gorevTipi"] = this.gorevTipi;
        data["gorevDurumu"] = this.gorevDurumu;
        data["noktaEnlem"] = this.noktaEnlem;
        data["noktaBoylam"] = this.noktaBoylam;
        data["nokta"] = this.nokta;
        data["gorevTarihi"] = this.gorevTarihi ? this.gorevTarihi.toISOString() : <any>undefined;
        data["planlananZiyaretSayisi"] = this.planlananZiyaretSayisi;
        data["rutIciZiyaretSayisi"] = this.rutIciZiyaretSayisi;
        data["gidilmeyenNoktaSayisi"] = this.gidilmeyenNoktaSayisi;
        data["rutIciBasariYuzdesi"] = this.rutIciBasariYuzdesi;
        data["rutDisiZiyaretSayisi"] = this.rutDisiZiyaretSayisi;
        data["toplamZiyaretSayisi"] = this.toplamZiyaretSayisi;
        data["toplamBasariYuzdesi"] = this.toplamBasariYuzdesi;
        if (Array.isArray(this.gidilenNoktalar)) {
            data["gidilenNoktalar"] = [];
            for (let item of this.gidilenNoktalar)
                data["gidilenNoktalar"].push(item);
        }
        if (Array.isArray(this.gidilmeyenNoktalar)) {
            data["gidilmeyenNoktalar"] = [];
            for (let item of this.gidilmeyenNoktalar)
                data["gidilmeyenNoktalar"].push(item);
        }
        return data;
    }

    clone(): RutOzetDto {
        const json = this.toJSON();
        let result = new RutOzetDto();
        result.init(json);
        return result;
    }
}

export interface IRutOzetDto {
    personelAdi: string | undefined;
    gorevTipi: string | undefined;
    gorevDurumu: string | undefined;
    noktaEnlem: number | undefined;
    noktaBoylam: number | undefined;
    nokta: string | undefined;
    gorevTarihi: Date | undefined;
    planlananZiyaretSayisi: number | undefined;
    rutIciZiyaretSayisi: number | undefined;
    gidilmeyenNoktaSayisi: number | undefined;
    rutIciBasariYuzdesi: number | undefined;
    rutDisiZiyaretSayisi: number | undefined;
    toplamZiyaretSayisi: number | undefined;
    toplamBasariYuzdesi: number | undefined;
    gidilenNoktalar: string[] | undefined;
    gidilmeyenNoktalar: string[] | undefined;
}

export class RutOzetDwhDto implements IRutOzetDwhDto {
    amiri: string | undefined;
    personel: string | undefined;
    bolge: string | undefined;
    firma: string | undefined;
    noktaAdi: string | undefined;
    proje: string | undefined;
    sehir: string | undefined;
    rutGorevDurum: string | undefined;
    gorevTarihi: Date | undefined;
    gorevSonDurum: string | undefined;
    planlananHizmetSuresiDk: number | undefined;
    gerceklesenHizmetSuresiDk: number | undefined;
    ziyaretBaslangicEnlem: number | undefined;
    ziyaretBaslangicBoylam: number | undefined;
    ziyaretBaslangicAccuracy: number | undefined;
    ziyaretBitisAccuracy: number | undefined;
    poiKategori: string | undefined;
    gorevSayisi: number | undefined;
    noktaEnlem: number | undefined;
    noktaBoylam: number | undefined;

    constructor(data?: IRutOzetDwhDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amiri = _data["amiri"];
            this.personel = _data["personel"];
            this.bolge = _data["bolge"];
            this.firma = _data["firma"];
            this.noktaAdi = _data["noktaAdi"];
            this.proje = _data["proje"];
            this.sehir = _data["sehir"];
            this.rutGorevDurum = _data["rutGorevDurum"];
            this.gorevTarihi = _data["gorevTarihi"] ? new Date(_data["gorevTarihi"].toString()) : <any>undefined;
            this.gorevSonDurum = _data["gorevSonDurum"];
            this.planlananHizmetSuresiDk = _data["planlananHizmetSuresiDk"];
            this.gerceklesenHizmetSuresiDk = _data["gerceklesenHizmetSuresiDk"];
            this.ziyaretBaslangicEnlem = _data["ziyaretBaslangicEnlem"];
            this.ziyaretBaslangicBoylam = _data["ziyaretBaslangicBoylam"];
            this.ziyaretBaslangicAccuracy = _data["ziyaretBaslangicAccuracy"];
            this.ziyaretBitisAccuracy = _data["ziyaretBitisAccuracy"];
            this.poiKategori = _data["poiKategori"];
            this.gorevSayisi = _data["gorevSayisi"];
            this.noktaEnlem = _data["noktaEnlem"];
            this.noktaBoylam = _data["noktaBoylam"];
        }
    }

    static fromJS(data: any): RutOzetDwhDto {
        data = typeof data === 'object' ? data : {};
        let result = new RutOzetDwhDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amiri"] = this.amiri;
        data["personel"] = this.personel;
        data["bolge"] = this.bolge;
        data["firma"] = this.firma;
        data["noktaAdi"] = this.noktaAdi;
        data["proje"] = this.proje;
        data["sehir"] = this.sehir;
        data["rutGorevDurum"] = this.rutGorevDurum;
        data["gorevTarihi"] = this.gorevTarihi ? this.gorevTarihi.toISOString() : <any>undefined;
        data["gorevSonDurum"] = this.gorevSonDurum;
        data["planlananHizmetSuresiDk"] = this.planlananHizmetSuresiDk;
        data["gerceklesenHizmetSuresiDk"] = this.gerceklesenHizmetSuresiDk;
        data["ziyaretBaslangicEnlem"] = this.ziyaretBaslangicEnlem;
        data["ziyaretBaslangicBoylam"] = this.ziyaretBaslangicBoylam;
        data["ziyaretBaslangicAccuracy"] = this.ziyaretBaslangicAccuracy;
        data["ziyaretBitisAccuracy"] = this.ziyaretBitisAccuracy;
        data["poiKategori"] = this.poiKategori;
        data["gorevSayisi"] = this.gorevSayisi;
        data["noktaEnlem"] = this.noktaEnlem;
        data["noktaBoylam"] = this.noktaBoylam;
        return data;
    }

    clone(): RutOzetDwhDto {
        const json = this.toJSON();
        let result = new RutOzetDwhDto();
        result.init(json);
        return result;
    }
}

export interface IRutOzetDwhDto {
    amiri: string | undefined;
    personel: string | undefined;
    bolge: string | undefined;
    firma: string | undefined;
    noktaAdi: string | undefined;
    proje: string | undefined;
    sehir: string | undefined;
    rutGorevDurum: string | undefined;
    gorevTarihi: Date | undefined;
    gorevSonDurum: string | undefined;
    planlananHizmetSuresiDk: number | undefined;
    gerceklesenHizmetSuresiDk: number | undefined;
    ziyaretBaslangicEnlem: number | undefined;
    ziyaretBaslangicBoylam: number | undefined;
    ziyaretBaslangicAccuracy: number | undefined;
    ziyaretBitisAccuracy: number | undefined;
    poiKategori: string | undefined;
    gorevSayisi: number | undefined;
    noktaEnlem: number | undefined;
    noktaBoylam: number | undefined;
}

export class RutMerchDwhDto implements IRutMerchDwhDto {
    merch: string | undefined;
    noktaAdi: string | undefined;
    sehir: string | undefined;
    gerceklesen: number | undefined;
    planlanan: number | undefined;
    sonTarih: Date | undefined;
    enlem: number | undefined;
    boylam: number | undefined;
    rutlar: RutOzetDwhDto[] | undefined;
    noktaEnlem: string | undefined;
    noktaBoylam: string | undefined;

    constructor(data?: IRutMerchDwhDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merch = _data["merch"];
            this.noktaAdi = _data["noktaAdi"];
            this.sehir = _data["sehir"];
            this.gerceklesen = _data["gerceklesen"];
            this.planlanan = _data["planlanan"];
            this.sonTarih = _data["sonTarih"] ? new Date(_data["sonTarih"].toString()) : <any>undefined;
            this.enlem = _data["enlem"];
            this.boylam = _data["boylam"];
            if (Array.isArray(_data["rutlar"])) {
                this.rutlar = [] as any;
                for (let item of _data["rutlar"])
                    this.rutlar.push(RutOzetDwhDto.fromJS(item));
            }
            this.noktaEnlem = _data["noktaEnlem"];
            this.noktaBoylam = _data["noktaBoylam"];
        }
    }

    static fromJS(data: any): RutMerchDwhDto {
        data = typeof data === 'object' ? data : {};
        let result = new RutMerchDwhDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merch"] = this.merch;
        data["noktaAdi"] = this.noktaAdi;
        data["sehir"] = this.sehir;
        data["gerceklesen"] = this.gerceklesen;
        data["planlanan"] = this.planlanan;
        data["sonTarih"] = this.sonTarih ? this.sonTarih.toISOString() : <any>undefined;
        data["enlem"] = this.enlem;
        data["boylam"] = this.boylam;
        if (Array.isArray(this.rutlar)) {
            data["rutlar"] = [];
            for (let item of this.rutlar)
                data["rutlar"].push(item.toJSON());
        }
        data["noktaEnlem"] = this.noktaEnlem;
        data["noktaBoylam"] = this.noktaBoylam;
        return data;
    }

    clone(): RutMerchDwhDto {
        const json = this.toJSON();
        let result = new RutMerchDwhDto();
        result.init(json);
        return result;
    }
}

export interface IRutMerchDwhDto {
    merch: string | undefined;
    noktaAdi: string | undefined;
    sehir: string | undefined;
    gerceklesen: number | undefined;
    planlanan: number | undefined;
    sonTarih: Date | undefined;
    enlem: number | undefined;
    boylam: number | undefined;
    rutlar: RutOzetDwhDto[] | undefined;
    noktaEnlem: string | undefined;
    noktaBoylam: string | undefined;
}

export class NormSehirKategoriDto implements INormSehirKategoriDto {
    kategoriDagilimi: KategoriDagilimi[] | undefined;
    magazaDetayi: NormKadroMagazaDetayiDto[] | undefined;

    constructor(data?: INormSehirKategoriDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kategoriDagilimi"])) {
                this.kategoriDagilimi = [] as any;
                for (let item of _data["kategoriDagilimi"])
                    this.kategoriDagilimi.push(KategoriDagilimi.fromJS(item));
            }
            if (Array.isArray(_data["magazaDetayi"])) {
                this.magazaDetayi = [] as any;
                for (let item of _data["magazaDetayi"])
                    this.magazaDetayi.push(NormKadroMagazaDetayiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NormSehirKategoriDto {
        data = typeof data === 'object' ? data : {};
        let result = new NormSehirKategoriDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kategoriDagilimi)) {
            data["kategoriDagilimi"] = [];
            for (let item of this.kategoriDagilimi)
                data["kategoriDagilimi"].push(item.toJSON());
        }
        if (Array.isArray(this.magazaDetayi)) {
            data["magazaDetayi"] = [];
            for (let item of this.magazaDetayi)
                data["magazaDetayi"].push(item.toJSON());
        }
        return data;
    }

    clone(): NormSehirKategoriDto {
        const json = this.toJSON();
        let result = new NormSehirKategoriDto();
        result.init(json);
        return result;
    }
}

export interface INormSehirKategoriDto {
    kategoriDagilimi: KategoriDagilimi[] | undefined;
    magazaDetayi: NormKadroMagazaDetayiDto[] | undefined;
}

export class KategoriDagilimi implements IKategoriDagilimi {
    kategori: string | undefined;
    magazaSayisi: number | undefined;

    constructor(data?: IKategoriDagilimi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kategori = _data["kategori"];
            this.magazaSayisi = _data["magazaSayisi"];
        }
    }

    static fromJS(data: any): KategoriDagilimi {
        data = typeof data === 'object' ? data : {};
        let result = new KategoriDagilimi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kategori"] = this.kategori;
        data["magazaSayisi"] = this.magazaSayisi;
        return data;
    }

    clone(): KategoriDagilimi {
        const json = this.toJSON();
        let result = new KategoriDagilimi();
        result.init(json);
        return result;
    }
}

export interface IKategoriDagilimi {
    kategori: string | undefined;
    magazaSayisi: number | undefined;
}

export class NormKadroMagazaDetayiDto implements INormKadroMagazaDetayiDto {
    sehir: string | undefined;
    kategoriListesi: MagazaKategori[] | undefined;
    toplamMagazaSayisi: number | undefined;

    constructor(data?: INormKadroMagazaDetayiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sehir = _data["sehir"];
            if (Array.isArray(_data["kategoriListesi"])) {
                this.kategoriListesi = [] as any;
                for (let item of _data["kategoriListesi"])
                    this.kategoriListesi.push(MagazaKategori.fromJS(item));
            }
            this.toplamMagazaSayisi = _data["toplamMagazaSayisi"];
        }
    }

    static fromJS(data: any): NormKadroMagazaDetayiDto {
        data = typeof data === 'object' ? data : {};
        let result = new NormKadroMagazaDetayiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sehir"] = this.sehir;
        if (Array.isArray(this.kategoriListesi)) {
            data["kategoriListesi"] = [];
            for (let item of this.kategoriListesi)
                data["kategoriListesi"].push(item.toJSON());
        }
        data["toplamMagazaSayisi"] = this.toplamMagazaSayisi;
        return data;
    }

    clone(): NormKadroMagazaDetayiDto {
        const json = this.toJSON();
        let result = new NormKadroMagazaDetayiDto();
        result.init(json);
        return result;
    }
}

export interface INormKadroMagazaDetayiDto {
    sehir: string | undefined;
    kategoriListesi: MagazaKategori[] | undefined;
    toplamMagazaSayisi: number | undefined;
}

export class MagazaKategori implements IMagazaKategori {
    kategori: string | undefined;
    magazaSayisi: number | undefined;

    constructor(data?: IMagazaKategori) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kategori = _data["kategori"];
            this.magazaSayisi = _data["magazaSayisi"];
        }
    }

    static fromJS(data: any): MagazaKategori {
        data = typeof data === 'object' ? data : {};
        let result = new MagazaKategori();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kategori"] = this.kategori;
        data["magazaSayisi"] = this.magazaSayisi;
        return data;
    }

    clone(): MagazaKategori {
        const json = this.toJSON();
        let result = new MagazaKategori();
        result.init(json);
        return result;
    }
}

export interface IMagazaKategori {
    kategori: string | undefined;
    magazaSayisi: number | undefined;
}

export class PagedResultDtoOfFieldPhotoDto implements IPagedResultDtoOfFieldPhotoDto {
    totalCount: number | undefined;
    items: FieldPhotoDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFieldPhotoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FieldPhotoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFieldPhotoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFieldPhotoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfFieldPhotoDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfFieldPhotoDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfFieldPhotoDto {
    totalCount: number | undefined;
    items: FieldPhotoDto[] | undefined;
}

export class FieldPhotoDto implements IFieldPhotoDto {
    formResultId: string | undefined;
    store: string | undefined;
    visitDate: Date | undefined;
    personel: string | undefined;
    photoUrl: string | undefined;
    photoPath: string | undefined;
    sehir: string | undefined;
    comment: string | undefined;

    constructor(data?: IFieldPhotoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formResultId = _data["formResultId"];
            this.store = _data["store"];
            this.visitDate = _data["visitDate"] ? new Date(_data["visitDate"].toString()) : <any>undefined;
            this.personel = _data["personel"];
            this.photoUrl = _data["photoUrl"];
            this.photoPath = _data["photoPath"];
            this.sehir = _data["sehir"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): FieldPhotoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FieldPhotoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formResultId"] = this.formResultId;
        data["store"] = this.store;
        data["visitDate"] = this.visitDate ? this.visitDate.toISOString() : <any>undefined;
        data["personel"] = this.personel;
        data["photoUrl"] = this.photoUrl;
        data["photoPath"] = this.photoPath;
        data["sehir"] = this.sehir;
        data["comment"] = this.comment;
        return data;
    }

    clone(): FieldPhotoDto {
        const json = this.toJSON();
        let result = new FieldPhotoDto();
        result.init(json);
        return result;
    }
}

export interface IFieldPhotoDto {
    formResultId: string | undefined;
    store: string | undefined;
    visitDate: Date | undefined;
    personel: string | undefined;
    photoUrl: string | undefined;
    photoPath: string | undefined;
    sehir: string | undefined;
    comment: string | undefined;
}

export class FieldPhotoFilterInputDto implements IFieldPhotoFilterInputDto {
    keyword: string | undefined;
    sorting: string | undefined;
    projects: string[] | undefined;
    dateRange: string | undefined;
    stores: string[] | undefined;
    cities: string[] | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IFieldPhotoFilterInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.sorting = _data["sorting"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects.push(item);
            }
            this.dateRange = _data["dateRange"];
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores.push(item);
            }
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities.push(item);
            }
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): FieldPhotoFilterInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FieldPhotoFilterInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["sorting"] = this.sorting;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item);
        }
        data["dateRange"] = this.dateRange;
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item);
        }
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item);
        }
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }

    clone(): FieldPhotoFilterInputDto {
        const json = this.toJSON();
        let result = new FieldPhotoFilterInputDto();
        result.init(json);
        return result;
    }
}

export interface IFieldPhotoFilterInputDto {
    keyword: string | undefined;
    sorting: string | undefined;
    projects: string[] | undefined;
    dateRange: string | undefined;
    stores: string[] | undefined;
    cities: string[] | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class CreateMasrafDto implements ICreateMasrafDto {
    personelLogoRefNo: number;
    masrafDonemi: string;
    aciklama: string;
    masrafTipi: CreateMasrafDtoMasrafTipi;
    masrafKalemList: MasrafKalemDto[] | undefined;

    constructor(data?: ICreateMasrafDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personelLogoRefNo = _data["personelLogoRefNo"];
            this.masrafDonemi = _data["masrafDonemi"];
            this.aciklama = _data["aciklama"];
            this.masrafTipi = _data["masrafTipi"];
            if (Array.isArray(_data["masrafKalemList"])) {
                this.masrafKalemList = [] as any;
                for (let item of _data["masrafKalemList"])
                    this.masrafKalemList.push(MasrafKalemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMasrafDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMasrafDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personelLogoRefNo"] = this.personelLogoRefNo;
        data["masrafDonemi"] = this.masrafDonemi;
        data["aciklama"] = this.aciklama;
        data["masrafTipi"] = this.masrafTipi;
        if (Array.isArray(this.masrafKalemList)) {
            data["masrafKalemList"] = [];
            for (let item of this.masrafKalemList)
                data["masrafKalemList"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateMasrafDto {
        const json = this.toJSON();
        let result = new CreateMasrafDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMasrafDto {
    personelLogoRefNo: number;
    masrafDonemi: string;
    aciklama: string;
    masrafTipi: CreateMasrafDtoMasrafTipi;
    masrafKalemList: MasrafKalemDto[] | undefined;
}

export class MasrafKalemDto implements IMasrafKalemDto {
    fisTarihi: Date;
    fisNo: string;
    tutar: number;
    kdvOrani: MasrafKalemDtoKdvOrani;
    masrafAciklama: string;
    masrafKetegoriId: string;
    tutar2: number;

    constructor(data?: IMasrafKalemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fisTarihi = _data["fisTarihi"] ? new Date(_data["fisTarihi"].toString()) : <any>undefined;
            this.fisNo = _data["fisNo"];
            this.tutar = _data["tutar"];
            this.kdvOrani = _data["kdvOrani"];
            this.masrafAciklama = _data["masrafAciklama"];
            this.masrafKetegoriId = _data["masrafKetegoriId"];
            this.tutar2 = _data["tutar2"];
        }
    }

    static fromJS(data: any): MasrafKalemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasrafKalemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fisTarihi"] = this.fisTarihi ? this.fisTarihi.toISOString() : <any>undefined;
        data["fisNo"] = this.fisNo;
        data["tutar"] = this.tutar;
        data["kdvOrani"] = this.kdvOrani;
        data["masrafAciklama"] = this.masrafAciklama;
        data["masrafKetegoriId"] = this.masrafKetegoriId;
        data["tutar2"] = this.tutar2;
        return data;
    }

    clone(): MasrafKalemDto {
        const json = this.toJSON();
        let result = new MasrafKalemDto();
        result.init(json);
        return result;
    }
}

export interface IMasrafKalemDto {
    fisTarihi: Date;
    fisNo: string;
    tutar: number;
    kdvOrani: MasrafKalemDtoKdvOrani;
    masrafAciklama: string;
    masrafKetegoriId: string;
    tutar2: number;
}

export class CreateSatinalmaTalepDto implements ICreateSatinalmaTalepDto {
    satinalmaKonusu: string;
    satinalmaTipi: CreateSatinalmaTalepDtoSatinalmaTipi;
    tutar: number;
    paraBirimi: CreateSatinalmaTalepDtoParaBirimi;
    vade: CreateSatinalmaTalepDtoVade;
    logoCariKod: string;

    constructor(data?: ICreateSatinalmaTalepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.satinalmaKonusu = _data["satinalmaKonusu"];
            this.satinalmaTipi = _data["satinalmaTipi"];
            this.tutar = _data["tutar"];
            this.paraBirimi = _data["paraBirimi"];
            this.vade = _data["vade"];
            this.logoCariKod = _data["logoCariKod"];
        }
    }

    static fromJS(data: any): CreateSatinalmaTalepDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSatinalmaTalepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["satinalmaKonusu"] = this.satinalmaKonusu;
        data["satinalmaTipi"] = this.satinalmaTipi;
        data["tutar"] = this.tutar;
        data["paraBirimi"] = this.paraBirimi;
        data["vade"] = this.vade;
        data["logoCariKod"] = this.logoCariKod;
        return data;
    }

    clone(): CreateSatinalmaTalepDto {
        const json = this.toJSON();
        let result = new CreateSatinalmaTalepDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSatinalmaTalepDto {
    satinalmaKonusu: string;
    satinalmaTipi: CreateSatinalmaTalepDtoSatinalmaTipi;
    tutar: number;
    paraBirimi: CreateSatinalmaTalepDtoParaBirimi;
    vade: CreateSatinalmaTalepDtoVade;
    logoCariKod: string;
}

export class SatinalmaTalepFaturaBilgiDto implements ISatinalmaTalepFaturaBilgiDto {
    talepNo: string | undefined;
    olusturulmaTarihi: Date | undefined;
    talepDurum: SatinalmaTalepFaturaBilgiDtoTalepDurum | undefined;
    faturaDonemi: string | undefined;

    constructor(data?: ISatinalmaTalepFaturaBilgiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.talepNo = _data["talepNo"];
            this.olusturulmaTarihi = _data["olusturulmaTarihi"] ? new Date(_data["olusturulmaTarihi"].toString()) : <any>undefined;
            this.talepDurum = _data["talepDurum"];
            this.faturaDonemi = _data["faturaDonemi"];
        }
    }

    static fromJS(data: any): SatinalmaTalepFaturaBilgiDto {
        data = typeof data === 'object' ? data : {};
        let result = new SatinalmaTalepFaturaBilgiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["talepNo"] = this.talepNo;
        data["olusturulmaTarihi"] = this.olusturulmaTarihi ? this.olusturulmaTarihi.toISOString() : <any>undefined;
        data["talepDurum"] = this.talepDurum;
        data["faturaDonemi"] = this.faturaDonemi;
        return data;
    }

    clone(): SatinalmaTalepFaturaBilgiDto {
        const json = this.toJSON();
        let result = new SatinalmaTalepFaturaBilgiDto();
        result.init(json);
        return result;
    }
}

export interface ISatinalmaTalepFaturaBilgiDto {
    talepNo: string | undefined;
    olusturulmaTarihi: Date | undefined;
    talepDurum: SatinalmaTalepFaturaBilgiDtoTalepDurum | undefined;
    faturaDonemi: string | undefined;
}

export class ReportObjectDto implements IReportObjectDto {
    id: number | undefined;
    moduleId: number | undefined;
    metabaseDashboardId: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    filters: ReportFilterDto[] | undefined;
    isOpenNewScreen: boolean | undefined;
    isShowPhotoDownloadButton: boolean | undefined;
    photoDownloadDataSource: number | undefined;
    isEmbedReport: boolean | undefined;

    constructor(data?: IReportObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moduleId = _data["moduleId"];
            this.metabaseDashboardId = _data["metabaseDashboardId"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters.push(ReportFilterDto.fromJS(item));
            }
            this.isOpenNewScreen = _data["isOpenNewScreen"];
            this.isShowPhotoDownloadButton = _data["isShowPhotoDownloadButton"];
            this.photoDownloadDataSource = _data["photoDownloadDataSource"];
            this.isEmbedReport = _data["isEmbedReport"];
        }
    }

    static fromJS(data: any): ReportObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moduleId"] = this.moduleId;
        data["metabaseDashboardId"] = this.metabaseDashboardId;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["isOpenNewScreen"] = this.isOpenNewScreen;
        data["isShowPhotoDownloadButton"] = this.isShowPhotoDownloadButton;
        data["photoDownloadDataSource"] = this.photoDownloadDataSource;
        data["isEmbedReport"] = this.isEmbedReport;
        return data;
    }

    clone(): ReportObjectDto {
        const json = this.toJSON();
        let result = new ReportObjectDto();
        result.init(json);
        return result;
    }
}

export interface IReportObjectDto {
    id: number | undefined;
    moduleId: number | undefined;
    metabaseDashboardId: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    filters: ReportFilterDto[] | undefined;
    isOpenNewScreen: boolean | undefined;
    isShowPhotoDownloadButton: boolean | undefined;
    photoDownloadDataSource: number | undefined;
    isEmbedReport: boolean | undefined;
}

export class ReportFilterDto implements IReportFilterDto {
    title: string | undefined;
    placeholder: string | undefined;
    type: string | undefined;
    dateRangeControlNames: string[] | undefined;
    isMultiple: boolean | undefined;
    isRequired: boolean | undefined;
    datasource: number | undefined;
    dataSourceConditions: ReportFilterConditionDto[] | undefined;
    paramKey: string | undefined;
    paramValues: string[] | undefined;
    paramValue: string | undefined;
    colSize: number | undefined;
    data: DataItemDto[] | undefined;

    constructor(data?: IReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.placeholder = _data["placeholder"];
            this.type = _data["type"];
            if (Array.isArray(_data["dateRangeControlNames"])) {
                this.dateRangeControlNames = [] as any;
                for (let item of _data["dateRangeControlNames"])
                    this.dateRangeControlNames.push(item);
            }
            this.isMultiple = _data["isMultiple"];
            this.isRequired = _data["isRequired"];
            this.datasource = _data["datasource"];
            if (Array.isArray(_data["dataSourceConditions"])) {
                this.dataSourceConditions = [] as any;
                for (let item of _data["dataSourceConditions"])
                    this.dataSourceConditions.push(ReportFilterConditionDto.fromJS(item));
            }
            this.paramKey = _data["paramKey"];
            if (Array.isArray(_data["paramValues"])) {
                this.paramValues = [] as any;
                for (let item of _data["paramValues"])
                    this.paramValues.push(item);
            }
            this.paramValue = _data["paramValue"];
            this.colSize = _data["colSize"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(DataItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["placeholder"] = this.placeholder;
        data["type"] = this.type;
        if (Array.isArray(this.dateRangeControlNames)) {
            data["dateRangeControlNames"] = [];
            for (let item of this.dateRangeControlNames)
                data["dateRangeControlNames"].push(item);
        }
        data["isMultiple"] = this.isMultiple;
        data["isRequired"] = this.isRequired;
        data["datasource"] = this.datasource;
        if (Array.isArray(this.dataSourceConditions)) {
            data["dataSourceConditions"] = [];
            for (let item of this.dataSourceConditions)
                data["dataSourceConditions"].push(item.toJSON());
        }
        data["paramKey"] = this.paramKey;
        if (Array.isArray(this.paramValues)) {
            data["paramValues"] = [];
            for (let item of this.paramValues)
                data["paramValues"].push(item);
        }
        data["paramValue"] = this.paramValue;
        data["colSize"] = this.colSize;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }

    clone(): ReportFilterDto {
        const json = this.toJSON();
        let result = new ReportFilterDto();
        result.init(json);
        return result;
    }
}

export interface IReportFilterDto {
    title: string | undefined;
    placeholder: string | undefined;
    type: string | undefined;
    dateRangeControlNames: string[] | undefined;
    isMultiple: boolean | undefined;
    isRequired: boolean | undefined;
    datasource: number | undefined;
    dataSourceConditions: ReportFilterConditionDto[] | undefined;
    paramKey: string | undefined;
    paramValues: string[] | undefined;
    paramValue: string | undefined;
    colSize: number | undefined;
    data: DataItemDto[] | undefined;
}

export class ReportFilterConditionDto implements IReportFilterConditionDto {
    conditionParamName: string | undefined;
    values: any[] | undefined;

    constructor(data?: IReportFilterConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conditionParamName = _data["conditionParamName"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values.push(item);
            }
        }
    }

    static fromJS(data: any): ReportFilterConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportFilterConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionParamName"] = this.conditionParamName;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }

    clone(): ReportFilterConditionDto {
        const json = this.toJSON();
        let result = new ReportFilterConditionDto();
        result.init(json);
        return result;
    }
}

export interface IReportFilterConditionDto {
    conditionParamName: string | undefined;
    values: any[] | undefined;
}

export class DataItemDto implements IDataItemDto {
    text: string | undefined;
    value: any | undefined;

    constructor(data?: IDataItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DataItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }

    clone(): DataItemDto {
        const json = this.toJSON();
        let result = new DataItemDto();
        result.init(json);
        return result;
    }
}

export interface IDataItemDto {
    text: string | undefined;
    value: any | undefined;
}

export class MetabaseDashboardOutputDto implements IMetabaseDashboardOutputDto {
    url: string | undefined;
    isOpenNewScreen: boolean | undefined;
    isEmbedReport: boolean | undefined;

    constructor(data?: IMetabaseDashboardOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.isOpenNewScreen = _data["isOpenNewScreen"];
            this.isEmbedReport = _data["isEmbedReport"];
        }
    }

    static fromJS(data: any): MetabaseDashboardOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetabaseDashboardOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["isOpenNewScreen"] = this.isOpenNewScreen;
        data["isEmbedReport"] = this.isEmbedReport;
        return data;
    }

    clone(): MetabaseDashboardOutputDto {
        const json = this.toJSON();
        let result = new MetabaseDashboardOutputDto();
        result.init(json);
        return result;
    }
}

export interface IMetabaseDashboardOutputDto {
    url: string | undefined;
    isOpenNewScreen: boolean | undefined;
    isEmbedReport: boolean | undefined;
}

export class ReportDataSourceDto implements IReportDataSourceDto {
    id: number | undefined;
    sqlQuery: string | undefined;
    isAllItem: boolean | undefined;
    dbModule: ReportDataSourceDtoDbModule | undefined;

    constructor(data?: IReportDataSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sqlQuery = _data["sqlQuery"];
            this.isAllItem = _data["isAllItem"];
            this.dbModule = _data["dbModule"];
        }
    }

    static fromJS(data: any): ReportDataSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDataSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sqlQuery"] = this.sqlQuery;
        data["isAllItem"] = this.isAllItem;
        data["dbModule"] = this.dbModule;
        return data;
    }

    clone(): ReportDataSourceDto {
        const json = this.toJSON();
        let result = new ReportDataSourceDto();
        result.init(json);
        return result;
    }
}

export interface IReportDataSourceDto {
    id: number | undefined;
    sqlQuery: string | undefined;
    isAllItem: boolean | undefined;
    dbModule: ReportDataSourceDtoDbModule | undefined;
}

export class MetabaseFilterItemDto implements IMetabaseFilterItemDto {
    text: string | undefined;
    value: string | undefined;

    constructor(data?: IMetabaseFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MetabaseFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetabaseFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }

    clone(): MetabaseFilterItemDto {
        const json = this.toJSON();
        let result = new MetabaseFilterItemDto();
        result.init(json);
        return result;
    }
}

export interface IMetabaseFilterItemDto {
    text: string | undefined;
    value: string | undefined;
}

export class WarehouseSelectListDto implements IWarehouseSelectListDto {
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
    addressId: number | undefined;
    isSelected: boolean | undefined;

    constructor(data?: IWarehouseSelectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.addressId = _data["addressId"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): WarehouseSelectListDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseSelectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["addressId"] = this.addressId;
        data["isSelected"] = this.isSelected;
        return data;
    }

    clone(): WarehouseSelectListDto {
        const json = this.toJSON();
        let result = new WarehouseSelectListDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseSelectListDto {
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
    addressId: number | undefined;
    isSelected: boolean | undefined;
}

export class MetabaseTranspopPortalFilterUserBusinessUnitDto implements IMetabaseTranspopPortalFilterUserBusinessUnitDto {
    attributeType: string | undefined;
    productAttributeId: number | undefined;

    constructor(data?: IMetabaseTranspopPortalFilterUserBusinessUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data["attributeType"];
            this.productAttributeId = _data["productAttributeId"];
        }
    }

    static fromJS(data: any): MetabaseTranspopPortalFilterUserBusinessUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetabaseTranspopPortalFilterUserBusinessUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType;
        data["productAttributeId"] = this.productAttributeId;
        return data;
    }

    clone(): MetabaseTranspopPortalFilterUserBusinessUnitDto {
        const json = this.toJSON();
        let result = new MetabaseTranspopPortalFilterUserBusinessUnitDto();
        result.init(json);
        return result;
    }
}

export interface IMetabaseTranspopPortalFilterUserBusinessUnitDto {
    attributeType: string | undefined;
    productAttributeId: number | undefined;
}

export class MetabaseTranspopPortalFilterBrandDto implements IMetabaseTranspopPortalFilterBrandDto {
    id: number | undefined;
    name: string | undefined;

    constructor(data?: IMetabaseTranspopPortalFilterBrandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MetabaseTranspopPortalFilterBrandDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetabaseTranspopPortalFilterBrandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): MetabaseTranspopPortalFilterBrandDto {
        const json = this.toJSON();
        let result = new MetabaseTranspopPortalFilterBrandDto();
        result.init(json);
        return result;
    }
}

export interface IMetabaseTranspopPortalFilterBrandDto {
    id: number | undefined;
    name: string | undefined;
}

export class MetabaseTranspopFilterItemDto implements IMetabaseTranspopFilterItemDto {
    text: string | undefined;
    value: string | undefined;

    constructor(data?: IMetabaseTranspopFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MetabaseTranspopFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetabaseTranspopFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }

    clone(): MetabaseTranspopFilterItemDto {
        const json = this.toJSON();
        let result = new MetabaseTranspopFilterItemDto();
        result.init(json);
        return result;
    }
}

export interface IMetabaseTranspopFilterItemDto {
    text: string | undefined;
    value: string | undefined;
}

export class TranspopPortalReportResultDto implements ITranspopPortalReportResultDto {
    hasOverLimit: boolean | undefined;
    overLimitMessage: string | undefined;
    url: string | undefined;
    isOpenNewScreen: boolean | undefined;

    constructor(data?: ITranspopPortalReportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasOverLimit = _data["hasOverLimit"];
            this.overLimitMessage = _data["overLimitMessage"];
            this.url = _data["url"];
            this.isOpenNewScreen = _data["isOpenNewScreen"];
        }
    }

    static fromJS(data: any): TranspopPortalReportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranspopPortalReportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasOverLimit"] = this.hasOverLimit;
        data["overLimitMessage"] = this.overLimitMessage;
        data["url"] = this.url;
        data["isOpenNewScreen"] = this.isOpenNewScreen;
        return data;
    }

    clone(): TranspopPortalReportResultDto {
        const json = this.toJSON();
        let result = new TranspopPortalReportResultDto();
        result.init(json);
        return result;
    }
}

export interface ITranspopPortalReportResultDto {
    hasOverLimit: boolean | undefined;
    overLimitMessage: string | undefined;
    url: string | undefined;
    isOpenNewScreen: boolean | undefined;
}

export class TranspopPortalReportParamsFiltersInput implements ITranspopPortalReportParamsFiltersInput {
    warehouseid: string[] | undefined;
    productid: string[] | undefined;
    distributornames: string[] | undefined;
    hasar_durumu: string[] | undefined;
    hareket_tipi: string[] | undefined;
    onay_durumu: string[] | undefined;
    son_hareket_tarihi: string | undefined;
    skt: string | undefined;
    posm: string[] | undefined;
    posm_tipi: string[] | undefined;
    ay: string | undefined;
    posm_magazada_mi: string[] | undefined;
    searchKeyword: string | undefined;
    daterange: string | undefined;
    userid: number | undefined;
    customerid: number | undefined;
    customercode: string | undefined;
    isbirimiid: number | undefined;
    isbirimiids: number[] | undefined;
    markaid: number[] | undefined;
    malzemetipi: string[] | undefined;
    lansman: string[] | undefined;
    koordinator: string[] | undefined;
    kanal: string[] | undefined;
    tarih: string | undefined;
    supervisor: string[] | undefined;
    bolge_yoneticisi: string[] | undefined;
    firma_sorumlusu: string[] | undefined;
    pop_durumu: string[] | undefined;
    islem_tipi: string[] | undefined;

    constructor(data?: ITranspopPortalReportParamsFiltersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warehouseid"])) {
                this.warehouseid = [] as any;
                for (let item of _data["warehouseid"])
                    this.warehouseid.push(item);
            }
            if (Array.isArray(_data["productid"])) {
                this.productid = [] as any;
                for (let item of _data["productid"])
                    this.productid.push(item);
            }
            if (Array.isArray(_data["distributornames"])) {
                this.distributornames = [] as any;
                for (let item of _data["distributornames"])
                    this.distributornames.push(item);
            }
            if (Array.isArray(_data["hasar_durumu"])) {
                this.hasar_durumu = [] as any;
                for (let item of _data["hasar_durumu"])
                    this.hasar_durumu.push(item);
            }
            if (Array.isArray(_data["hareket_tipi"])) {
                this.hareket_tipi = [] as any;
                for (let item of _data["hareket_tipi"])
                    this.hareket_tipi.push(item);
            }
            if (Array.isArray(_data["onay_durumu"])) {
                this.onay_durumu = [] as any;
                for (let item of _data["onay_durumu"])
                    this.onay_durumu.push(item);
            }
            this.son_hareket_tarihi = _data["son_hareket_tarihi"];
            this.skt = _data["skt"];
            if (Array.isArray(_data["posm"])) {
                this.posm = [] as any;
                for (let item of _data["posm"])
                    this.posm.push(item);
            }
            if (Array.isArray(_data["posm_tipi"])) {
                this.posm_tipi = [] as any;
                for (let item of _data["posm_tipi"])
                    this.posm_tipi.push(item);
            }
            this.ay = _data["ay"];
            if (Array.isArray(_data["posm_magazada_mi"])) {
                this.posm_magazada_mi = [] as any;
                for (let item of _data["posm_magazada_mi"])
                    this.posm_magazada_mi.push(item);
            }
            this.searchKeyword = _data["searchKeyword"];
            this.daterange = _data["daterange"];
            this.userid = _data["userid"];
            this.customerid = _data["customerid"];
            this.customercode = _data["customercode"];
            this.isbirimiid = _data["isbirimiid"];
            if (Array.isArray(_data["isbirimiids"])) {
                this.isbirimiids = [] as any;
                for (let item of _data["isbirimiids"])
                    this.isbirimiids.push(item);
            }
            if (Array.isArray(_data["markaid"])) {
                this.markaid = [] as any;
                for (let item of _data["markaid"])
                    this.markaid.push(item);
            }
            if (Array.isArray(_data["malzemetipi"])) {
                this.malzemetipi = [] as any;
                for (let item of _data["malzemetipi"])
                    this.malzemetipi.push(item);
            }
            if (Array.isArray(_data["lansman"])) {
                this.lansman = [] as any;
                for (let item of _data["lansman"])
                    this.lansman.push(item);
            }
            if (Array.isArray(_data["koordinator"])) {
                this.koordinator = [] as any;
                for (let item of _data["koordinator"])
                    this.koordinator.push(item);
            }
            if (Array.isArray(_data["kanal"])) {
                this.kanal = [] as any;
                for (let item of _data["kanal"])
                    this.kanal.push(item);
            }
            this.tarih = _data["tarih"];
            if (Array.isArray(_data["supervisor"])) {
                this.supervisor = [] as any;
                for (let item of _data["supervisor"])
                    this.supervisor.push(item);
            }
            if (Array.isArray(_data["bolge_yoneticisi"])) {
                this.bolge_yoneticisi = [] as any;
                for (let item of _data["bolge_yoneticisi"])
                    this.bolge_yoneticisi.push(item);
            }
            if (Array.isArray(_data["firma_sorumlusu"])) {
                this.firma_sorumlusu = [] as any;
                for (let item of _data["firma_sorumlusu"])
                    this.firma_sorumlusu.push(item);
            }
            if (Array.isArray(_data["pop_durumu"])) {
                this.pop_durumu = [] as any;
                for (let item of _data["pop_durumu"])
                    this.pop_durumu.push(item);
            }
            if (Array.isArray(_data["islem_tipi"])) {
                this.islem_tipi = [] as any;
                for (let item of _data["islem_tipi"])
                    this.islem_tipi.push(item);
            }
        }
    }

    static fromJS(data: any): TranspopPortalReportParamsFiltersInput {
        data = typeof data === 'object' ? data : {};
        let result = new TranspopPortalReportParamsFiltersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehouseid)) {
            data["warehouseid"] = [];
            for (let item of this.warehouseid)
                data["warehouseid"].push(item);
        }
        if (Array.isArray(this.productid)) {
            data["productid"] = [];
            for (let item of this.productid)
                data["productid"].push(item);
        }
        if (Array.isArray(this.distributornames)) {
            data["distributornames"] = [];
            for (let item of this.distributornames)
                data["distributornames"].push(item);
        }
        if (Array.isArray(this.hasar_durumu)) {
            data["hasar_durumu"] = [];
            for (let item of this.hasar_durumu)
                data["hasar_durumu"].push(item);
        }
        if (Array.isArray(this.hareket_tipi)) {
            data["hareket_tipi"] = [];
            for (let item of this.hareket_tipi)
                data["hareket_tipi"].push(item);
        }
        if (Array.isArray(this.onay_durumu)) {
            data["onay_durumu"] = [];
            for (let item of this.onay_durumu)
                data["onay_durumu"].push(item);
        }
        data["son_hareket_tarihi"] = this.son_hareket_tarihi;
        data["skt"] = this.skt;
        if (Array.isArray(this.posm)) {
            data["posm"] = [];
            for (let item of this.posm)
                data["posm"].push(item);
        }
        if (Array.isArray(this.posm_tipi)) {
            data["posm_tipi"] = [];
            for (let item of this.posm_tipi)
                data["posm_tipi"].push(item);
        }
        data["ay"] = this.ay;
        if (Array.isArray(this.posm_magazada_mi)) {
            data["posm_magazada_mi"] = [];
            for (let item of this.posm_magazada_mi)
                data["posm_magazada_mi"].push(item);
        }
        data["searchKeyword"] = this.searchKeyword;
        data["daterange"] = this.daterange;
        data["userid"] = this.userid;
        data["customerid"] = this.customerid;
        data["customercode"] = this.customercode;
        data["isbirimiid"] = this.isbirimiid;
        if (Array.isArray(this.isbirimiids)) {
            data["isbirimiids"] = [];
            for (let item of this.isbirimiids)
                data["isbirimiids"].push(item);
        }
        if (Array.isArray(this.markaid)) {
            data["markaid"] = [];
            for (let item of this.markaid)
                data["markaid"].push(item);
        }
        if (Array.isArray(this.malzemetipi)) {
            data["malzemetipi"] = [];
            for (let item of this.malzemetipi)
                data["malzemetipi"].push(item);
        }
        if (Array.isArray(this.lansman)) {
            data["lansman"] = [];
            for (let item of this.lansman)
                data["lansman"].push(item);
        }
        if (Array.isArray(this.koordinator)) {
            data["koordinator"] = [];
            for (let item of this.koordinator)
                data["koordinator"].push(item);
        }
        if (Array.isArray(this.kanal)) {
            data["kanal"] = [];
            for (let item of this.kanal)
                data["kanal"].push(item);
        }
        data["tarih"] = this.tarih;
        if (Array.isArray(this.supervisor)) {
            data["supervisor"] = [];
            for (let item of this.supervisor)
                data["supervisor"].push(item);
        }
        if (Array.isArray(this.bolge_yoneticisi)) {
            data["bolge_yoneticisi"] = [];
            for (let item of this.bolge_yoneticisi)
                data["bolge_yoneticisi"].push(item);
        }
        if (Array.isArray(this.firma_sorumlusu)) {
            data["firma_sorumlusu"] = [];
            for (let item of this.firma_sorumlusu)
                data["firma_sorumlusu"].push(item);
        }
        if (Array.isArray(this.pop_durumu)) {
            data["pop_durumu"] = [];
            for (let item of this.pop_durumu)
                data["pop_durumu"].push(item);
        }
        if (Array.isArray(this.islem_tipi)) {
            data["islem_tipi"] = [];
            for (let item of this.islem_tipi)
                data["islem_tipi"].push(item);
        }
        return data;
    }

    clone(): TranspopPortalReportParamsFiltersInput {
        const json = this.toJSON();
        let result = new TranspopPortalReportParamsFiltersInput();
        result.init(json);
        return result;
    }
}

export interface ITranspopPortalReportParamsFiltersInput {
    warehouseid: string[] | undefined;
    productid: string[] | undefined;
    distributornames: string[] | undefined;
    hasar_durumu: string[] | undefined;
    hareket_tipi: string[] | undefined;
    onay_durumu: string[] | undefined;
    son_hareket_tarihi: string | undefined;
    skt: string | undefined;
    posm: string[] | undefined;
    posm_tipi: string[] | undefined;
    ay: string | undefined;
    posm_magazada_mi: string[] | undefined;
    searchKeyword: string | undefined;
    daterange: string | undefined;
    userid: number | undefined;
    customerid: number | undefined;
    customercode: string | undefined;
    isbirimiid: number | undefined;
    isbirimiids: number[] | undefined;
    markaid: number[] | undefined;
    malzemetipi: string[] | undefined;
    lansman: string[] | undefined;
    koordinator: string[] | undefined;
    kanal: string[] | undefined;
    tarih: string | undefined;
    supervisor: string[] | undefined;
    bolge_yoneticisi: string[] | undefined;
    firma_sorumlusu: string[] | undefined;
    pop_durumu: string[] | undefined;
    islem_tipi: string[] | undefined;
}

export class ModuleDto implements IModuleDto {
    name: string | undefined;
    id: number | undefined;

    constructor(data?: IModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): ModuleDto {
        const json = this.toJSON();
        let result = new ModuleDto();
        result.init(json);
        return result;
    }
}

export interface IModuleDto {
    name: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfModuleDto implements IPagedResultDtoOfModuleDto {
    totalCount: number | undefined;
    items: ModuleDto[] | undefined;

    constructor(data?: IPagedResultDtoOfModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ModuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfModuleDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfModuleDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfModuleDto {
    totalCount: number | undefined;
    items: ModuleDto[] | undefined;
}

export class CreateModuleDto implements ICreateModuleDto {
    id: number | undefined;

    constructor(data?: ICreateModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): CreateModuleDto {
        const json = this.toJSON();
        let result = new CreateModuleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateModuleDto {
    id: number | undefined;
}

export class CreateOrderDto implements ICreateOrderDto {
    userId: number | undefined;
    customerId: number | undefined;
    name: string | undefined;
    fromWarehouseId: number;
    fromWarehouseCode: string;
    fromAddressId: number;
    toAddressId: number | undefined;
    products: ProductDto[] | undefined;
    isOrderByVariation: boolean | undefined;
    componentType: CreateOrderDtoComponentType | undefined;
    shipmentType: CreateOrderDtoShipmentType | undefined;
    productDamageStatusType: CreateOrderDtoProductDamageStatusType | undefined;
    newAddressDto: OrderNewAddressDto | undefined;
    receiverName: string | undefined;
    receiverPhone: string | undefined;
    specialCode: string | undefined;
    comment: string | undefined;
    criticalSimilarAddressIdList: number[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.fromWarehouseId = _data["fromWarehouseId"];
            this.fromWarehouseCode = _data["fromWarehouseCode"];
            this.fromAddressId = _data["fromAddressId"];
            this.toAddressId = _data["toAddressId"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(ProductDto.fromJS(item));
            }
            this.isOrderByVariation = _data["isOrderByVariation"];
            this.componentType = _data["componentType"];
            this.shipmentType = _data["shipmentType"];
            this.productDamageStatusType = _data["productDamageStatusType"];
            this.newAddressDto = _data["newAddressDto"] ? OrderNewAddressDto.fromJS(_data["newAddressDto"]) : <any>undefined;
            this.receiverName = _data["receiverName"];
            this.receiverPhone = _data["receiverPhone"];
            this.specialCode = _data["specialCode"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["criticalSimilarAddressIdList"])) {
                this.criticalSimilarAddressIdList = [] as any;
                for (let item of _data["criticalSimilarAddressIdList"])
                    this.criticalSimilarAddressIdList.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["fromWarehouseId"] = this.fromWarehouseId;
        data["fromWarehouseCode"] = this.fromWarehouseCode;
        data["fromAddressId"] = this.fromAddressId;
        data["toAddressId"] = this.toAddressId;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["isOrderByVariation"] = this.isOrderByVariation;
        data["componentType"] = this.componentType;
        data["shipmentType"] = this.shipmentType;
        data["productDamageStatusType"] = this.productDamageStatusType;
        data["newAddressDto"] = this.newAddressDto ? this.newAddressDto.toJSON() : <any>undefined;
        data["receiverName"] = this.receiverName;
        data["receiverPhone"] = this.receiverPhone;
        data["specialCode"] = this.specialCode;
        data["comment"] = this.comment;
        if (Array.isArray(this.criticalSimilarAddressIdList)) {
            data["criticalSimilarAddressIdList"] = [];
            for (let item of this.criticalSimilarAddressIdList)
                data["criticalSimilarAddressIdList"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): CreateOrderDto {
        const json = this.toJSON();
        let result = new CreateOrderDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderDto {
    userId: number | undefined;
    customerId: number | undefined;
    name: string | undefined;
    fromWarehouseId: number;
    fromWarehouseCode: string;
    fromAddressId: number;
    toAddressId: number | undefined;
    products: ProductDto[] | undefined;
    isOrderByVariation: boolean | undefined;
    componentType: CreateOrderDtoComponentType | undefined;
    shipmentType: CreateOrderDtoShipmentType | undefined;
    productDamageStatusType: CreateOrderDtoProductDamageStatusType | undefined;
    newAddressDto: OrderNewAddressDto | undefined;
    receiverName: string | undefined;
    receiverPhone: string | undefined;
    specialCode: string | undefined;
    comment: string | undefined;
    criticalSimilarAddressIdList: number[] | undefined;
    id: number | undefined;
}

export class ProductDto implements IProductDto {
    name: string | undefined;
    kod: string | undefined;
    wmsTip: string | undefined;
    marka: string | undefined;
    stok: number | undefined;
    blokeStok: number | undefined;
    businessUnitName: string | undefined;
    boxQuantity: number | undefined;
    palletQuantity: number | undefined;
    deci: number | undefined;
    type1Name: string | undefined;
    type2Name: string | undefined;
    type3Name: string | undefined;
    type4Name: string | undefined;
    variationId: number | undefined;
    customerProductCode: string | undefined;
    expirationDate: string | undefined;
    barcode: string | undefined;
    lot: string | undefined;
    orderedQty: number | undefined;
    width: number | undefined;
    depth: number | undefined;
    height: number | undefined;
    weight: number | undefined;
    isInCart: boolean | undefined;
    subVariations: ProductSubVariationsDto[] | undefined;
    id: number | undefined;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.kod = _data["kod"];
            this.wmsTip = _data["wmsTip"];
            this.marka = _data["marka"];
            this.stok = _data["stok"];
            this.blokeStok = _data["blokeStok"];
            this.businessUnitName = _data["businessUnitName"];
            this.boxQuantity = _data["boxQuantity"];
            this.palletQuantity = _data["palletQuantity"];
            this.deci = _data["deci"];
            this.type1Name = _data["type1Name"];
            this.type2Name = _data["type2Name"];
            this.type3Name = _data["type3Name"];
            this.type4Name = _data["type4Name"];
            this.variationId = _data["variationId"];
            this.customerProductCode = _data["customerProductCode"];
            this.expirationDate = _data["expirationDate"];
            this.barcode = _data["barcode"];
            this.lot = _data["lot"];
            this.orderedQty = _data["orderedQty"];
            this.width = _data["width"];
            this.depth = _data["depth"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.isInCart = _data["isInCart"];
            if (Array.isArray(_data["subVariations"])) {
                this.subVariations = [] as any;
                for (let item of _data["subVariations"])
                    this.subVariations.push(ProductSubVariationsDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["kod"] = this.kod;
        data["wmsTip"] = this.wmsTip;
        data["marka"] = this.marka;
        data["stok"] = this.stok;
        data["blokeStok"] = this.blokeStok;
        data["businessUnitName"] = this.businessUnitName;
        data["boxQuantity"] = this.boxQuantity;
        data["palletQuantity"] = this.palletQuantity;
        data["deci"] = this.deci;
        data["type1Name"] = this.type1Name;
        data["type2Name"] = this.type2Name;
        data["type3Name"] = this.type3Name;
        data["type4Name"] = this.type4Name;
        data["variationId"] = this.variationId;
        data["customerProductCode"] = this.customerProductCode;
        data["expirationDate"] = this.expirationDate;
        data["barcode"] = this.barcode;
        data["lot"] = this.lot;
        data["orderedQty"] = this.orderedQty;
        data["width"] = this.width;
        data["depth"] = this.depth;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["isInCart"] = this.isInCart;
        if (Array.isArray(this.subVariations)) {
            data["subVariations"] = [];
            for (let item of this.subVariations)
                data["subVariations"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): ProductDto {
        const json = this.toJSON();
        let result = new ProductDto();
        result.init(json);
        return result;
    }
}

export interface IProductDto {
    name: string | undefined;
    kod: string | undefined;
    wmsTip: string | undefined;
    marka: string | undefined;
    stok: number | undefined;
    blokeStok: number | undefined;
    businessUnitName: string | undefined;
    boxQuantity: number | undefined;
    palletQuantity: number | undefined;
    deci: number | undefined;
    type1Name: string | undefined;
    type2Name: string | undefined;
    type3Name: string | undefined;
    type4Name: string | undefined;
    variationId: number | undefined;
    customerProductCode: string | undefined;
    expirationDate: string | undefined;
    barcode: string | undefined;
    lot: string | undefined;
    orderedQty: number | undefined;
    width: number | undefined;
    depth: number | undefined;
    height: number | undefined;
    weight: number | undefined;
    isInCart: boolean | undefined;
    subVariations: ProductSubVariationsDto[] | undefined;
    id: number | undefined;
}

export class OrderNewAddressDto implements IOrderNewAddressDto {
    address: AddressDto | undefined;
    readonly isValidAddress: boolean | undefined;

    constructor(data?: IOrderNewAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            (<any>this).isValidAddress = _data["isValidAddress"];
        }
    }

    static fromJS(data: any): OrderNewAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNewAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["isValidAddress"] = this.isValidAddress;
        return data;
    }

    clone(): OrderNewAddressDto {
        const json = this.toJSON();
        let result = new OrderNewAddressDto();
        result.init(json);
        return result;
    }
}

export interface IOrderNewAddressDto {
    address: AddressDto | undefined;
    isValidAddress: boolean | undefined;
}

export class ProductSubVariationsDto implements IProductSubVariationsDto {
    variationId: number | undefined;
    expirationDate: string | undefined;
    barcode: string | undefined;
    stockQuantity: number | undefined;

    constructor(data?: IProductSubVariationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.variationId = _data["variationId"];
            this.expirationDate = _data["expirationDate"];
            this.barcode = _data["barcode"];
            this.stockQuantity = _data["stockQuantity"];
        }
    }

    static fromJS(data: any): ProductSubVariationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSubVariationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variationId"] = this.variationId;
        data["expirationDate"] = this.expirationDate;
        data["barcode"] = this.barcode;
        data["stockQuantity"] = this.stockQuantity;
        return data;
    }

    clone(): ProductSubVariationsDto {
        const json = this.toJSON();
        let result = new ProductSubVariationsDto();
        result.init(json);
        return result;
    }
}

export interface IProductSubVariationsDto {
    variationId: number | undefined;
    expirationDate: string | undefined;
    barcode: string | undefined;
    stockQuantity: number | undefined;
}

export class OrderPriceDto implements IOrderPriceDto {
    productId: number | undefined;
    productName: string | undefined;
    productCode: string | undefined;
    productDeci: number | undefined;
    orderQty: number | undefined;
    readonly totalDeci: number | undefined;
    deciShipmentPrice: number | undefined;
    readonly totalPrice: number | undefined;

    constructor(data?: IOrderPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
            this.productDeci = _data["productDeci"];
            this.orderQty = _data["orderQty"];
            (<any>this).totalDeci = _data["totalDeci"];
            this.deciShipmentPrice = _data["deciShipmentPrice"];
            (<any>this).totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): OrderPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["productDeci"] = this.productDeci;
        data["orderQty"] = this.orderQty;
        data["totalDeci"] = this.totalDeci;
        data["deciShipmentPrice"] = this.deciShipmentPrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }

    clone(): OrderPriceDto {
        const json = this.toJSON();
        let result = new OrderPriceDto();
        result.init(json);
        return result;
    }
}

export interface IOrderPriceDto {
    productId: number | undefined;
    productName: string | undefined;
    productCode: string | undefined;
    productDeci: number | undefined;
    orderQty: number | undefined;
    totalDeci: number | undefined;
    deciShipmentPrice: number | undefined;
    totalPrice: number | undefined;
}

export class OrderStockResultDto implements IOrderStockResultDto {
    isValid: boolean | undefined;
    userFriendlyMessage: string | undefined;
    unStockProducts: OrderProductStockDto[] | undefined;
    orderedProducts: OrderProductStockDto[] | undefined;

    constructor(data?: IOrderStockResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.userFriendlyMessage = _data["userFriendlyMessage"];
            if (Array.isArray(_data["unStockProducts"])) {
                this.unStockProducts = [] as any;
                for (let item of _data["unStockProducts"])
                    this.unStockProducts.push(OrderProductStockDto.fromJS(item));
            }
            if (Array.isArray(_data["orderedProducts"])) {
                this.orderedProducts = [] as any;
                for (let item of _data["orderedProducts"])
                    this.orderedProducts.push(OrderProductStockDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderStockResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStockResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["userFriendlyMessage"] = this.userFriendlyMessage;
        if (Array.isArray(this.unStockProducts)) {
            data["unStockProducts"] = [];
            for (let item of this.unStockProducts)
                data["unStockProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.orderedProducts)) {
            data["orderedProducts"] = [];
            for (let item of this.orderedProducts)
                data["orderedProducts"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderStockResultDto {
        const json = this.toJSON();
        let result = new OrderStockResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderStockResultDto {
    isValid: boolean | undefined;
    userFriendlyMessage: string | undefined;
    unStockProducts: OrderProductStockDto[] | undefined;
    orderedProducts: OrderProductStockDto[] | undefined;
}

export class OrderProductStockDto implements IOrderProductStockDto {
    productId: number | undefined;
    productName: string | undefined;
    productCode: string | undefined;
    productBusinessUnitName: string | undefined;
    productWmsTypeName: string | undefined;
    productBrandName: string | undefined;
    productBoxQuantity: number | undefined;
    productPalletQuantity: number | undefined;
    warehouseCode: string | undefined;
    warehouseId: number | undefined;
    variationId: number | undefined;
    lot: string | undefined;
    exprirationDate: string | undefined;
    barcode: string | undefined;
    readonly isOrderBySpecialCode: boolean | undefined;
    quantity: number | undefined;
    readonly rawQuantity: number | undefined;
    blockedQuantity: number | undefined;
    dependQuantity: number | undefined;
    centerApprovedQuantity: number | undefined;
    readonly calculatedStockQuantity: number | undefined;
    sortIndex: number | undefined;
    isInstantStockView: boolean | undefined;
    ordererId: number | undefined;
    toAddressId: number | undefined;

    constructor(data?: IOrderProductStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
            this.productBusinessUnitName = _data["productBusinessUnitName"];
            this.productWmsTypeName = _data["productWmsTypeName"];
            this.productBrandName = _data["productBrandName"];
            this.productBoxQuantity = _data["productBoxQuantity"];
            this.productPalletQuantity = _data["productPalletQuantity"];
            this.warehouseCode = _data["warehouseCode"];
            this.warehouseId = _data["warehouseId"];
            this.variationId = _data["variationId"];
            this.lot = _data["lot"];
            this.exprirationDate = _data["exprirationDate"];
            this.barcode = _data["barcode"];
            (<any>this).isOrderBySpecialCode = _data["isOrderBySpecialCode"];
            this.quantity = _data["quantity"];
            (<any>this).rawQuantity = _data["rawQuantity"];
            this.blockedQuantity = _data["blockedQuantity"];
            this.dependQuantity = _data["dependQuantity"];
            this.centerApprovedQuantity = _data["centerApprovedQuantity"];
            (<any>this).calculatedStockQuantity = _data["calculatedStockQuantity"];
            this.sortIndex = _data["sortIndex"];
            this.isInstantStockView = _data["isInstantStockView"];
            this.ordererId = _data["ordererId"];
            this.toAddressId = _data["toAddressId"];
        }
    }

    static fromJS(data: any): OrderProductStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProductStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["productBusinessUnitName"] = this.productBusinessUnitName;
        data["productWmsTypeName"] = this.productWmsTypeName;
        data["productBrandName"] = this.productBrandName;
        data["productBoxQuantity"] = this.productBoxQuantity;
        data["productPalletQuantity"] = this.productPalletQuantity;
        data["warehouseCode"] = this.warehouseCode;
        data["warehouseId"] = this.warehouseId;
        data["variationId"] = this.variationId;
        data["lot"] = this.lot;
        data["exprirationDate"] = this.exprirationDate;
        data["barcode"] = this.barcode;
        data["isOrderBySpecialCode"] = this.isOrderBySpecialCode;
        data["quantity"] = this.quantity;
        data["rawQuantity"] = this.rawQuantity;
        data["blockedQuantity"] = this.blockedQuantity;
        data["dependQuantity"] = this.dependQuantity;
        data["centerApprovedQuantity"] = this.centerApprovedQuantity;
        data["calculatedStockQuantity"] = this.calculatedStockQuantity;
        data["sortIndex"] = this.sortIndex;
        data["isInstantStockView"] = this.isInstantStockView;
        data["ordererId"] = this.ordererId;
        data["toAddressId"] = this.toAddressId;
        return data;
    }

    clone(): OrderProductStockDto {
        const json = this.toJSON();
        let result = new OrderProductStockDto();
        result.init(json);
        return result;
    }
}

export interface IOrderProductStockDto {
    productId: number | undefined;
    productName: string | undefined;
    productCode: string | undefined;
    productBusinessUnitName: string | undefined;
    productWmsTypeName: string | undefined;
    productBrandName: string | undefined;
    productBoxQuantity: number | undefined;
    productPalletQuantity: number | undefined;
    warehouseCode: string | undefined;
    warehouseId: number | undefined;
    variationId: number | undefined;
    lot: string | undefined;
    exprirationDate: string | undefined;
    barcode: string | undefined;
    isOrderBySpecialCode: boolean | undefined;
    quantity: number | undefined;
    rawQuantity: number | undefined;
    blockedQuantity: number | undefined;
    dependQuantity: number | undefined;
    centerApprovedQuantity: number | undefined;
    calculatedStockQuantity: number | undefined;
    sortIndex: number | undefined;
    isInstantStockView: boolean | undefined;
    ordererId: number | undefined;
    toAddressId: number | undefined;
}

export class OrderProductTaskDto implements IOrderProductTaskDto {
    approverId: number | undefined;
    approverName: string | undefined;
    ordererId: number | undefined;
    ordererName: string | undefined;
    productId: number | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    productBrand: string | undefined;
    productDeci: number | undefined;
    productBusinessUnitName: string | undefined;
    productWmsTypeName: string | undefined;
    orderDateTime: Date | undefined;
    readonly orderDate: string | undefined;
    sourceAddressName: string | undefined;
    toAddressId: number | undefined;
    toAddressName: string | undefined;
    qty: number | undefined;
    approvedQty: number | undefined;
    orderDetailsId: number | undefined;
    variationId: number | undefined;
    expirationDate: string | undefined;
    lot: string | undefined;
    barcode: string | undefined;
    orderApprovalTaskId: number | undefined;
    fromWarehouseId: number | undefined;
    fromWarehouseCode: string | undefined;
    approvedStatusType: number | undefined;
    approvedStatus: OrderProductTaskDtoApprovedStatus | undefined;
    approvalStatusText: string | undefined;
    approvalStatusDescText: string | undefined;
    readonly isCanceledOrder: boolean | undefined;
    isChecked: boolean | undefined;
    approvalUsers: OrderApprovalUserDto[] | undefined;
    approvalUsersHasPersonInCharge: boolean | undefined;
    orderedWarehouseCodes: string[] | undefined;
    instantProductStock: number | undefined;
    hasOrderStockViewAuth: boolean | undefined;
    hasOrderSpecialCodeStockViewAuth: boolean | undefined;
    orderComment: string | undefined;

    constructor(data?: IOrderProductTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approverId = _data["approverId"];
            this.approverName = _data["approverName"];
            this.ordererId = _data["ordererId"];
            this.ordererName = _data["ordererName"];
            this.productId = _data["productId"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productBrand = _data["productBrand"];
            this.productDeci = _data["productDeci"];
            this.productBusinessUnitName = _data["productBusinessUnitName"];
            this.productWmsTypeName = _data["productWmsTypeName"];
            this.orderDateTime = _data["orderDateTime"] ? new Date(_data["orderDateTime"].toString()) : <any>undefined;
            (<any>this).orderDate = _data["orderDate"];
            this.sourceAddressName = _data["sourceAddressName"];
            this.toAddressId = _data["toAddressId"];
            this.toAddressName = _data["toAddressName"];
            this.qty = _data["qty"];
            this.approvedQty = _data["approvedQty"];
            this.orderDetailsId = _data["orderDetailsId"];
            this.variationId = _data["variationId"];
            this.expirationDate = _data["expirationDate"];
            this.lot = _data["lot"];
            this.barcode = _data["barcode"];
            this.orderApprovalTaskId = _data["orderApprovalTaskId"];
            this.fromWarehouseId = _data["fromWarehouseId"];
            this.fromWarehouseCode = _data["fromWarehouseCode"];
            this.approvedStatusType = _data["approvedStatusType"];
            this.approvedStatus = _data["approvedStatus"];
            this.approvalStatusText = _data["approvalStatusText"];
            this.approvalStatusDescText = _data["approvalStatusDescText"];
            (<any>this).isCanceledOrder = _data["isCanceledOrder"];
            this.isChecked = _data["isChecked"];
            if (Array.isArray(_data["approvalUsers"])) {
                this.approvalUsers = [] as any;
                for (let item of _data["approvalUsers"])
                    this.approvalUsers.push(OrderApprovalUserDto.fromJS(item));
            }
            this.approvalUsersHasPersonInCharge = _data["approvalUsersHasPersonInCharge"];
            if (Array.isArray(_data["orderedWarehouseCodes"])) {
                this.orderedWarehouseCodes = [] as any;
                for (let item of _data["orderedWarehouseCodes"])
                    this.orderedWarehouseCodes.push(item);
            }
            this.instantProductStock = _data["instantProductStock"];
            this.hasOrderStockViewAuth = _data["hasOrderStockViewAuth"];
            this.hasOrderSpecialCodeStockViewAuth = _data["hasOrderSpecialCodeStockViewAuth"];
            this.orderComment = _data["orderComment"];
        }
    }

    static fromJS(data: any): OrderProductTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProductTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approverId"] = this.approverId;
        data["approverName"] = this.approverName;
        data["ordererId"] = this.ordererId;
        data["ordererName"] = this.ordererName;
        data["productId"] = this.productId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productBrand"] = this.productBrand;
        data["productDeci"] = this.productDeci;
        data["productBusinessUnitName"] = this.productBusinessUnitName;
        data["productWmsTypeName"] = this.productWmsTypeName;
        data["orderDateTime"] = this.orderDateTime ? this.orderDateTime.toISOString() : <any>undefined;
        data["orderDate"] = this.orderDate;
        data["sourceAddressName"] = this.sourceAddressName;
        data["toAddressId"] = this.toAddressId;
        data["toAddressName"] = this.toAddressName;
        data["qty"] = this.qty;
        data["approvedQty"] = this.approvedQty;
        data["orderDetailsId"] = this.orderDetailsId;
        data["variationId"] = this.variationId;
        data["expirationDate"] = this.expirationDate;
        data["lot"] = this.lot;
        data["barcode"] = this.barcode;
        data["orderApprovalTaskId"] = this.orderApprovalTaskId;
        data["fromWarehouseId"] = this.fromWarehouseId;
        data["fromWarehouseCode"] = this.fromWarehouseCode;
        data["approvedStatusType"] = this.approvedStatusType;
        data["approvedStatus"] = this.approvedStatus;
        data["approvalStatusText"] = this.approvalStatusText;
        data["approvalStatusDescText"] = this.approvalStatusDescText;
        data["isCanceledOrder"] = this.isCanceledOrder;
        data["isChecked"] = this.isChecked;
        if (Array.isArray(this.approvalUsers)) {
            data["approvalUsers"] = [];
            for (let item of this.approvalUsers)
                data["approvalUsers"].push(item.toJSON());
        }
        data["approvalUsersHasPersonInCharge"] = this.approvalUsersHasPersonInCharge;
        if (Array.isArray(this.orderedWarehouseCodes)) {
            data["orderedWarehouseCodes"] = [];
            for (let item of this.orderedWarehouseCodes)
                data["orderedWarehouseCodes"].push(item);
        }
        data["instantProductStock"] = this.instantProductStock;
        data["hasOrderStockViewAuth"] = this.hasOrderStockViewAuth;
        data["hasOrderSpecialCodeStockViewAuth"] = this.hasOrderSpecialCodeStockViewAuth;
        data["orderComment"] = this.orderComment;
        return data;
    }

    clone(): OrderProductTaskDto {
        const json = this.toJSON();
        let result = new OrderProductTaskDto();
        result.init(json);
        return result;
    }
}

export interface IOrderProductTaskDto {
    approverId: number | undefined;
    approverName: string | undefined;
    ordererId: number | undefined;
    ordererName: string | undefined;
    productId: number | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    productBrand: string | undefined;
    productDeci: number | undefined;
    productBusinessUnitName: string | undefined;
    productWmsTypeName: string | undefined;
    orderDateTime: Date | undefined;
    orderDate: string | undefined;
    sourceAddressName: string | undefined;
    toAddressId: number | undefined;
    toAddressName: string | undefined;
    qty: number | undefined;
    approvedQty: number | undefined;
    orderDetailsId: number | undefined;
    variationId: number | undefined;
    expirationDate: string | undefined;
    lot: string | undefined;
    barcode: string | undefined;
    orderApprovalTaskId: number | undefined;
    fromWarehouseId: number | undefined;
    fromWarehouseCode: string | undefined;
    approvedStatusType: number | undefined;
    approvedStatus: OrderProductTaskDtoApprovedStatus | undefined;
    approvalStatusText: string | undefined;
    approvalStatusDescText: string | undefined;
    isCanceledOrder: boolean | undefined;
    isChecked: boolean | undefined;
    approvalUsers: OrderApprovalUserDto[] | undefined;
    approvalUsersHasPersonInCharge: boolean | undefined;
    orderedWarehouseCodes: string[] | undefined;
    instantProductStock: number | undefined;
    hasOrderStockViewAuth: boolean | undefined;
    hasOrderSpecialCodeStockViewAuth: boolean | undefined;
    orderComment: string | undefined;
}

export class OrderApprovalUserDto implements IOrderApprovalUserDto {
    userId: number | undefined;
    userName: string | undefined;
    approvalStatusType: OrderApprovalUserDtoApprovalStatusType | undefined;
    approvalStatusText: string | undefined;
    approvalStatusDescText: string | undefined;

    constructor(data?: IOrderApprovalUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.approvalStatusType = _data["approvalStatusType"];
            this.approvalStatusText = _data["approvalStatusText"];
            this.approvalStatusDescText = _data["approvalStatusDescText"];
        }
    }

    static fromJS(data: any): OrderApprovalUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["approvalStatusType"] = this.approvalStatusType;
        data["approvalStatusText"] = this.approvalStatusText;
        data["approvalStatusDescText"] = this.approvalStatusDescText;
        return data;
    }

    clone(): OrderApprovalUserDto {
        const json = this.toJSON();
        let result = new OrderApprovalUserDto();
        result.init(json);
        return result;
    }
}

export interface IOrderApprovalUserDto {
    userId: number | undefined;
    userName: string | undefined;
    approvalStatusType: OrderApprovalUserDtoApprovalStatusType | undefined;
    approvalStatusText: string | undefined;
    approvalStatusDescText: string | undefined;
}

export class OrderApprovedDto implements IOrderApprovedDto {
    toAddressId: number | undefined;
    quantity: number | undefined;
    orderId: number | undefined;
    orderDetailsId: number | undefined;
    approvedQty: number | undefined;
    productId: number | undefined;
    variationId: number | undefined;
    specialCode: string | undefined;
    readonly isOrderBySpecialCode: boolean | undefined;
    warehouseId: number | undefined;
    warehouseCode: string | undefined;
    isUserStockView: boolean | undefined;
    isUserSpecialCodeStockView: boolean | undefined;
    sortIndex: number | undefined;
    orderedDate: Date | undefined;
    statusText: string | undefined;
    statusStyleText: string | undefined;
    status: OrderApprovedDtoStatus | undefined;
    orderableTotalQuantity: number | undefined;
    ordererId: number | undefined;
    productWmsTypeName: string | undefined;
    relatedBigSizeProductIds: number[] | undefined;

    constructor(data?: IOrderApprovedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toAddressId = _data["toAddressId"];
            this.quantity = _data["quantity"];
            this.orderId = _data["orderId"];
            this.orderDetailsId = _data["orderDetailsId"];
            this.approvedQty = _data["approvedQty"];
            this.productId = _data["productId"];
            this.variationId = _data["variationId"];
            this.specialCode = _data["specialCode"];
            (<any>this).isOrderBySpecialCode = _data["isOrderBySpecialCode"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseCode = _data["warehouseCode"];
            this.isUserStockView = _data["isUserStockView"];
            this.isUserSpecialCodeStockView = _data["isUserSpecialCodeStockView"];
            this.sortIndex = _data["sortIndex"];
            this.orderedDate = _data["orderedDate"] ? new Date(_data["orderedDate"].toString()) : <any>undefined;
            this.statusText = _data["statusText"];
            this.statusStyleText = _data["statusStyleText"];
            this.status = _data["status"];
            this.orderableTotalQuantity = _data["orderableTotalQuantity"];
            this.ordererId = _data["ordererId"];
            this.productWmsTypeName = _data["productWmsTypeName"];
            if (Array.isArray(_data["relatedBigSizeProductIds"])) {
                this.relatedBigSizeProductIds = [] as any;
                for (let item of _data["relatedBigSizeProductIds"])
                    this.relatedBigSizeProductIds.push(item);
            }
        }
    }

    static fromJS(data: any): OrderApprovedDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toAddressId"] = this.toAddressId;
        data["quantity"] = this.quantity;
        data["orderId"] = this.orderId;
        data["orderDetailsId"] = this.orderDetailsId;
        data["approvedQty"] = this.approvedQty;
        data["productId"] = this.productId;
        data["variationId"] = this.variationId;
        data["specialCode"] = this.specialCode;
        data["isOrderBySpecialCode"] = this.isOrderBySpecialCode;
        data["warehouseId"] = this.warehouseId;
        data["warehouseCode"] = this.warehouseCode;
        data["isUserStockView"] = this.isUserStockView;
        data["isUserSpecialCodeStockView"] = this.isUserSpecialCodeStockView;
        data["sortIndex"] = this.sortIndex;
        data["orderedDate"] = this.orderedDate ? this.orderedDate.toISOString() : <any>undefined;
        data["statusText"] = this.statusText;
        data["statusStyleText"] = this.statusStyleText;
        data["status"] = this.status;
        data["orderableTotalQuantity"] = this.orderableTotalQuantity;
        data["ordererId"] = this.ordererId;
        data["productWmsTypeName"] = this.productWmsTypeName;
        if (Array.isArray(this.relatedBigSizeProductIds)) {
            data["relatedBigSizeProductIds"] = [];
            for (let item of this.relatedBigSizeProductIds)
                data["relatedBigSizeProductIds"].push(item);
        }
        return data;
    }

    clone(): OrderApprovedDto {
        const json = this.toJSON();
        let result = new OrderApprovedDto();
        result.init(json);
        return result;
    }
}

export interface IOrderApprovedDto {
    toAddressId: number | undefined;
    quantity: number | undefined;
    orderId: number | undefined;
    orderDetailsId: number | undefined;
    approvedQty: number | undefined;
    productId: number | undefined;
    variationId: number | undefined;
    specialCode: string | undefined;
    isOrderBySpecialCode: boolean | undefined;
    warehouseId: number | undefined;
    warehouseCode: string | undefined;
    isUserStockView: boolean | undefined;
    isUserSpecialCodeStockView: boolean | undefined;
    sortIndex: number | undefined;
    orderedDate: Date | undefined;
    statusText: string | undefined;
    statusStyleText: string | undefined;
    status: OrderApprovedDtoStatus | undefined;
    orderableTotalQuantity: number | undefined;
    ordererId: number | undefined;
    productWmsTypeName: string | undefined;
    relatedBigSizeProductIds: number[] | undefined;
}

export class OrderApprovalTypesDto implements IOrderApprovalTypesDto {
    id: number | undefined;
    name: string | undefined;

    constructor(data?: IOrderApprovalTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OrderApprovalTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): OrderApprovalTypesDto {
        const json = this.toJSON();
        let result = new OrderApprovalTypesDto();
        result.init(json);
        return result;
    }
}

export interface IOrderApprovalTypesDto {
    id: number | undefined;
    name: string | undefined;
}

export class ProductLocationHistoryDto implements IProductLocationHistoryDto {
    date: Date | undefined;
    readonly formatedDate: string | undefined;
    quantity: number | undefined;
    kaynakAddress: string | undefined;
    durum: string | undefined;

    constructor(data?: IProductLocationHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            (<any>this).formatedDate = _data["formatedDate"];
            this.quantity = _data["quantity"];
            this.kaynakAddress = _data["kaynakAddress"];
            this.durum = _data["durum"];
        }
    }

    static fromJS(data: any): ProductLocationHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLocationHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["formatedDate"] = this.formatedDate;
        data["quantity"] = this.quantity;
        data["kaynakAddress"] = this.kaynakAddress;
        data["durum"] = this.durum;
        return data;
    }

    clone(): ProductLocationHistoryDto {
        const json = this.toJSON();
        let result = new ProductLocationHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IProductLocationHistoryDto {
    date: Date | undefined;
    formatedDate: string | undefined;
    quantity: number | undefined;
    kaynakAddress: string | undefined;
    durum: string | undefined;
}

export class ApprovalRulesGroupedTitlesDto implements IApprovalRulesGroupedTitlesDto {
    groupId: number | undefined;
    addressCategoryId: number | undefined;
    addressCategoryName: string | undefined;
    readonly approverText: string | undefined;
    approvers: ApproverDto[] | undefined;

    constructor(data?: IApprovalRulesGroupedTitlesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.addressCategoryId = _data["addressCategoryId"];
            this.addressCategoryName = _data["addressCategoryName"];
            (<any>this).approverText = _data["approverText"];
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers.push(ApproverDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprovalRulesGroupedTitlesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalRulesGroupedTitlesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["addressCategoryId"] = this.addressCategoryId;
        data["addressCategoryName"] = this.addressCategoryName;
        data["approverText"] = this.approverText;
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        return data;
    }

    clone(): ApprovalRulesGroupedTitlesDto {
        const json = this.toJSON();
        let result = new ApprovalRulesGroupedTitlesDto();
        result.init(json);
        return result;
    }
}

export interface IApprovalRulesGroupedTitlesDto {
    groupId: number | undefined;
    addressCategoryId: number | undefined;
    addressCategoryName: string | undefined;
    approverText: string | undefined;
    approvers: ApproverDto[] | undefined;
}

export class ApproverDto implements IApproverDto {
    titleId: number | undefined;
    titleName: string | undefined;
    approvalSortOrder: number | undefined;

    constructor(data?: IApproverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.titleName = _data["titleName"];
            this.approvalSortOrder = _data["approvalSortOrder"];
        }
    }

    static fromJS(data: any): ApproverDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["titleName"] = this.titleName;
        data["approvalSortOrder"] = this.approvalSortOrder;
        return data;
    }

    clone(): ApproverDto {
        const json = this.toJSON();
        let result = new ApproverDto();
        result.init(json);
        return result;
    }
}

export interface IApproverDto {
    titleId: number | undefined;
    titleName: string | undefined;
    approvalSortOrder: number | undefined;
}

export class ApprovalRulesCategoryDto implements IApprovalRulesCategoryDto {
    name: string | undefined;
    id: number | undefined;

    constructor(data?: IApprovalRulesCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApprovalRulesCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalRulesCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): ApprovalRulesCategoryDto {
        const json = this.toJSON();
        let result = new ApprovalRulesCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IApprovalRulesCategoryDto {
    name: string | undefined;
    id: number | undefined;
}

export class OrderApprovalRulesDto implements IOrderApprovalRulesDto {
    id: number | undefined;

    constructor(data?: IOrderApprovalRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderApprovalRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): OrderApprovalRulesDto {
        const json = this.toJSON();
        let result = new OrderApprovalRulesDto();
        result.init(json);
        return result;
    }
}

export interface IOrderApprovalRulesDto {
    id: number | undefined;
}

export class PagedResultDtoOfOrderApprovalRulesDto implements IPagedResultDtoOfOrderApprovalRulesDto {
    totalCount: number | undefined;
    items: OrderApprovalRulesDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrderApprovalRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderApprovalRulesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrderApprovalRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrderApprovalRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfOrderApprovalRulesDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfOrderApprovalRulesDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfOrderApprovalRulesDto {
    totalCount: number | undefined;
    items: OrderApprovalRulesDto[] | undefined;
}

export class CreateOrderApprovalRulesDto implements ICreateOrderApprovalRulesDto {
    id: number | undefined;

    constructor(data?: ICreateOrderApprovalRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrderApprovalRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderApprovalRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): CreateOrderApprovalRulesDto {
        const json = this.toJSON();
        let result = new CreateOrderApprovalRulesDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderApprovalRulesDto {
    id: number | undefined;
}

export class PagedResultDtoOfOrderApprovalTaskRepairDto implements IPagedResultDtoOfOrderApprovalTaskRepairDto {
    totalCount: number | undefined;
    items: OrderApprovalTaskRepairDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrderApprovalTaskRepairDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderApprovalTaskRepairDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrderApprovalTaskRepairDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrderApprovalTaskRepairDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfOrderApprovalTaskRepairDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfOrderApprovalTaskRepairDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfOrderApprovalTaskRepairDto {
    totalCount: number | undefined;
    items: OrderApprovalTaskRepairDto[] | undefined;
}

export class OrderApprovalTaskRepairDto implements IOrderApprovalTaskRepairDto {
    addressId: number | undefined;
    addressName: string | undefined;
    fullAddress: string | undefined;
    addressPoiId: string | undefined;
    customerName: string | undefined;
    titleId: number | undefined;
    titleName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    id: number | undefined;

    constructor(data?: IOrderApprovalTaskRepairDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressId = _data["addressId"];
            this.addressName = _data["addressName"];
            this.fullAddress = _data["fullAddress"];
            this.addressPoiId = _data["addressPoiId"];
            this.customerName = _data["customerName"];
            this.titleId = _data["titleId"];
            this.titleName = _data["titleName"];
            this.authorizationId = _data["authorizationId"];
            this.authorizationName = _data["authorizationName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderApprovalTaskRepairDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalTaskRepairDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressId"] = this.addressId;
        data["addressName"] = this.addressName;
        data["fullAddress"] = this.fullAddress;
        data["addressPoiId"] = this.addressPoiId;
        data["customerName"] = this.customerName;
        data["titleId"] = this.titleId;
        data["titleName"] = this.titleName;
        data["authorizationId"] = this.authorizationId;
        data["authorizationName"] = this.authorizationName;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderApprovalTaskRepairDto {
        const json = this.toJSON();
        let result = new OrderApprovalTaskRepairDto();
        result.init(json);
        return result;
    }
}

export interface IOrderApprovalTaskRepairDto {
    addressId: number | undefined;
    addressName: string | undefined;
    fullAddress: string | undefined;
    addressPoiId: string | undefined;
    customerName: string | undefined;
    titleId: number | undefined;
    titleName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    id: number | undefined;
}

export class CreateOrderApprovalTaskRepairDto implements ICreateOrderApprovalTaskRepairDto {
    id: number | undefined;

    constructor(data?: ICreateOrderApprovalTaskRepairDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrderApprovalTaskRepairDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderApprovalTaskRepairDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): CreateOrderApprovalTaskRepairDto {
        const json = this.toJSON();
        let result = new CreateOrderApprovalTaskRepairDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderApprovalTaskRepairDto {
    id: number | undefined;
}

export class CreateOrderCartDto implements ICreateOrderCartDto {
    userId: number | undefined;
    productId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrderCartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.productId = _data["productId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrderCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["productId"] = this.productId;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateOrderCartDto {
        const json = this.toJSON();
        let result = new CreateOrderCartDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderCartDto {
    userId: number | undefined;
    productId: number | undefined;
    id: number | undefined;
}

export class OrderCartDto implements IOrderCartDto {
    userId: number | undefined;
    productId: number | undefined;
    id: number | undefined;

    constructor(data?: IOrderCartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.productId = _data["productId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["productId"] = this.productId;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderCartDto {
        const json = this.toJSON();
        let result = new OrderCartDto();
        result.init(json);
        return result;
    }
}

export interface IOrderCartDto {
    userId: number | undefined;
    productId: number | undefined;
    id: number | undefined;
}

export class CreateOrderCartExceptionDto implements ICreateOrderCartExceptionDto {
    products: ProductDto[] | undefined;
    exceptionMessage: string | undefined;

    constructor(data?: ICreateOrderCartExceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(ProductDto.fromJS(item));
            }
            this.exceptionMessage = _data["exceptionMessage"];
        }
    }

    static fromJS(data: any): CreateOrderCartExceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderCartExceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["exceptionMessage"] = this.exceptionMessage;
        return data;
    }

    clone(): CreateOrderCartExceptionDto {
        const json = this.toJSON();
        let result = new CreateOrderCartExceptionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderCartExceptionDto {
    products: ProductDto[] | undefined;
    exceptionMessage: string | undefined;
}

export class PagedResultDtoOfOrderCartDto implements IPagedResultDtoOfOrderCartDto {
    totalCount: number | undefined;
    items: OrderCartDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrderCartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderCartDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrderCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrderCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfOrderCartDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfOrderCartDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfOrderCartDto {
    totalCount: number | undefined;
    items: OrderCartDto[] | undefined;
}

export class PagedResultDtoOfPageDto implements IPagedResultDtoOfPageDto {
    totalCount: number | undefined;
    items: PageDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfPageDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfPageDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfPageDto {
    totalCount: number | undefined;
    items: PageDto[] | undefined;
}

export class PageDto implements IPageDto {
    name: string | undefined;
    url: string | undefined;
    header: string | undefined;
    subHeader: string | undefined;
    info: string | undefined;
    menuIconUrl: string | undefined;
    sortOrder: number | undefined;
    isDefault: boolean | undefined;
    comment: string | undefined;
    moduleId: number | undefined;
    moduleName: string | undefined;
    parentId: number | undefined;
    parentName: string | undefined;
    id: number | undefined;

    constructor(data?: IPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.header = _data["header"];
            this.subHeader = _data["subHeader"];
            this.info = _data["info"];
            this.menuIconUrl = _data["menuIconUrl"];
            this.sortOrder = _data["sortOrder"];
            this.isDefault = _data["isDefault"];
            this.comment = _data["comment"];
            this.moduleId = _data["moduleId"];
            this.moduleName = _data["moduleName"];
            this.parentId = _data["parentId"];
            this.parentName = _data["parentName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["header"] = this.header;
        data["subHeader"] = this.subHeader;
        data["info"] = this.info;
        data["menuIconUrl"] = this.menuIconUrl;
        data["sortOrder"] = this.sortOrder;
        data["isDefault"] = this.isDefault;
        data["comment"] = this.comment;
        data["moduleId"] = this.moduleId;
        data["moduleName"] = this.moduleName;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["id"] = this.id;
        return data;
    }

    clone(): PageDto {
        const json = this.toJSON();
        let result = new PageDto();
        result.init(json);
        return result;
    }
}

export interface IPageDto {
    name: string | undefined;
    url: string | undefined;
    header: string | undefined;
    subHeader: string | undefined;
    info: string | undefined;
    menuIconUrl: string | undefined;
    sortOrder: number | undefined;
    isDefault: boolean | undefined;
    comment: string | undefined;
    moduleId: number | undefined;
    moduleName: string | undefined;
    parentId: number | undefined;
    parentName: string | undefined;
    id: number | undefined;
}

export class CreatePageDto implements ICreatePageDto {
    name: string;
    url: string | undefined;
    header: string | undefined;
    subHeader: string | undefined;
    info: string | undefined;
    menuIconUrl: string | undefined;
    sortOrder: number | undefined;
    isDefault: boolean | undefined;
    comment: string | undefined;
    moduleId: number | undefined;
    parentId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreatePageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.header = _data["header"];
            this.subHeader = _data["subHeader"];
            this.info = _data["info"];
            this.menuIconUrl = _data["menuIconUrl"];
            this.sortOrder = _data["sortOrder"];
            this.isDefault = _data["isDefault"];
            this.comment = _data["comment"];
            this.moduleId = _data["moduleId"];
            this.parentId = _data["parentId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["header"] = this.header;
        data["subHeader"] = this.subHeader;
        data["info"] = this.info;
        data["menuIconUrl"] = this.menuIconUrl;
        data["sortOrder"] = this.sortOrder;
        data["isDefault"] = this.isDefault;
        data["comment"] = this.comment;
        data["moduleId"] = this.moduleId;
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        return data;
    }

    clone(): CreatePageDto {
        const json = this.toJSON();
        let result = new CreatePageDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePageDto {
    name: string;
    url: string | undefined;
    header: string | undefined;
    subHeader: string | undefined;
    info: string | undefined;
    menuIconUrl: string | undefined;
    sortOrder: number | undefined;
    isDefault: boolean | undefined;
    comment: string | undefined;
    moduleId: number | undefined;
    parentId: number | undefined;
    id: number | undefined;
}

export class ExcelPagedResultDtoOfPageExcelDto implements IExcelPagedResultDtoOfPageExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: PageExcelDto[] | undefined;

    constructor(data?: IExcelPagedResultDtoOfPageExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns.push(ExcelColumn.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PageExcelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExcelPagedResultDtoOfPageExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelPagedResultDtoOfPageExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ExcelPagedResultDtoOfPageExcelDto {
        const json = this.toJSON();
        let result = new ExcelPagedResultDtoOfPageExcelDto();
        result.init(json);
        return result;
    }
}

export interface IExcelPagedResultDtoOfPageExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: PageExcelDto[] | undefined;
}

export class PageExcelDto implements IPageExcelDto {
    url: string | undefined;
    header: string | undefined;
    subHeader: string | undefined;
    info: string | undefined;
    menuIconUrl: string | undefined;
    sortOrder: number | undefined;
    isDefault: boolean | undefined;
    comment: string | undefined;
    id: number | undefined;

    constructor(data?: IPageExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.header = _data["header"];
            this.subHeader = _data["subHeader"];
            this.info = _data["info"];
            this.menuIconUrl = _data["menuIconUrl"];
            this.sortOrder = _data["sortOrder"];
            this.isDefault = _data["isDefault"];
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PageExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["header"] = this.header;
        data["subHeader"] = this.subHeader;
        data["info"] = this.info;
        data["menuIconUrl"] = this.menuIconUrl;
        data["sortOrder"] = this.sortOrder;
        data["isDefault"] = this.isDefault;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data;
    }

    clone(): PageExcelDto {
        const json = this.toJSON();
        let result = new PageExcelDto();
        result.init(json);
        return result;
    }
}

export interface IPageExcelDto {
    url: string | undefined;
    header: string | undefined;
    subHeader: string | undefined;
    info: string | undefined;
    menuIconUrl: string | undefined;
    sortOrder: number | undefined;
    isDefault: boolean | undefined;
    comment: string | undefined;
    id: number | undefined;
}

export class PlanogramDto implements IPlanogramDto {
    planogramId: string | undefined;
    planogramName: string | undefined;
    planogramTypeId: string | undefined;
    planogramType: string | undefined;
    customerName: string | undefined;
    projectName: string | undefined;
    aciklama: string | undefined;
    id: string | undefined;

    constructor(data?: IPlanogramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planogramId = _data["planogramId"];
            this.planogramName = _data["planogramName"];
            this.planogramTypeId = _data["planogramTypeId"];
            this.planogramType = _data["planogramType"];
            this.customerName = _data["customerName"];
            this.projectName = _data["projectName"];
            this.aciklama = _data["aciklama"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PlanogramDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanogramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planogramId"] = this.planogramId;
        data["planogramName"] = this.planogramName;
        data["planogramTypeId"] = this.planogramTypeId;
        data["planogramType"] = this.planogramType;
        data["customerName"] = this.customerName;
        data["projectName"] = this.projectName;
        data["aciklama"] = this.aciklama;
        data["id"] = this.id;
        return data;
    }

    clone(): PlanogramDto {
        const json = this.toJSON();
        let result = new PlanogramDto();
        result.init(json);
        return result;
    }
}

export interface IPlanogramDto {
    planogramId: string | undefined;
    planogramName: string | undefined;
    planogramTypeId: string | undefined;
    planogramType: string | undefined;
    customerName: string | undefined;
    projectName: string | undefined;
    aciklama: string | undefined;
    id: string | undefined;
}

export class GridFilterModal implements IGridFilterModal {
    alan_adi: string | undefined;
    filter_type: GridFilterModalFilter_type | undefined;
    value: string | undefined;
    condition: GridFilterModalCondition | undefined;

    constructor(data?: IGridFilterModal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alan_adi = _data["alan_adi"];
            this.filter_type = _data["filter_type"];
            this.value = _data["value"];
            this.condition = _data["condition"];
        }
    }

    static fromJS(data: any): GridFilterModal {
        data = typeof data === 'object' ? data : {};
        let result = new GridFilterModal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alan_adi"] = this.alan_adi;
        data["filter_type"] = this.filter_type;
        data["value"] = this.value;
        data["condition"] = this.condition;
        return data;
    }

    clone(): GridFilterModal {
        const json = this.toJSON();
        let result = new GridFilterModal();
        result.init(json);
        return result;
    }
}

export interface IGridFilterModal {
    alan_adi: string | undefined;
    filter_type: GridFilterModalFilter_type | undefined;
    value: string | undefined;
    condition: GridFilterModalCondition | undefined;
}

export class CreatePlanogramDto implements ICreatePlanogramDto {
    kategoriTipId: string;
    planogramName: string;
    firmaId: string;
    projeId: string;
    aciklama: string | undefined;
    id: number | undefined;

    constructor(data?: ICreatePlanogramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kategoriTipId = _data["kategoriTipId"];
            this.planogramName = _data["planogramName"];
            this.firmaId = _data["firmaId"];
            this.projeId = _data["projeId"];
            this.aciklama = _data["aciklama"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePlanogramDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlanogramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kategoriTipId"] = this.kategoriTipId;
        data["planogramName"] = this.planogramName;
        data["firmaId"] = this.firmaId;
        data["projeId"] = this.projeId;
        data["aciklama"] = this.aciklama;
        data["id"] = this.id;
        return data;
    }

    clone(): CreatePlanogramDto {
        const json = this.toJSON();
        let result = new CreatePlanogramDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePlanogramDto {
    kategoriTipId: string;
    planogramName: string;
    firmaId: string;
    projeId: string;
    aciklama: string | undefined;
    id: number | undefined;
}

export class UpdatePlanogramDto implements IUpdatePlanogramDto {
    id: string;
    kategoriTipId: string;
    planogramName: string;
    firmaId: string;
    projeId: string;
    aciklama: string | undefined;

    constructor(data?: IUpdatePlanogramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kategoriTipId = _data["kategoriTipId"];
            this.planogramName = _data["planogramName"];
            this.firmaId = _data["firmaId"];
            this.projeId = _data["projeId"];
            this.aciklama = _data["aciklama"];
        }
    }

    static fromJS(data: any): UpdatePlanogramDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlanogramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kategoriTipId"] = this.kategoriTipId;
        data["planogramName"] = this.planogramName;
        data["firmaId"] = this.firmaId;
        data["projeId"] = this.projeId;
        data["aciklama"] = this.aciklama;
        return data;
    }

    clone(): UpdatePlanogramDto {
        const json = this.toJSON();
        let result = new UpdatePlanogramDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePlanogramDto {
    id: string;
    kategoriTipId: string;
    planogramName: string;
    firmaId: string;
    projeId: string;
    aciklama: string | undefined;
}

export class PlanogramTypesDto implements IPlanogramTypesDto {
    id: string | undefined;
    name: string | undefined;

    constructor(data?: IPlanogramTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PlanogramTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanogramTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): PlanogramTypesDto {
        const json = this.toJSON();
        let result = new PlanogramTypesDto();
        result.init(json);
        return result;
    }
}

export interface IPlanogramTypesDto {
    id: string | undefined;
    name: string | undefined;
}

export class PlanogramCustomersDto implements IPlanogramCustomersDto {
    id: string | undefined;
    name: string | undefined;

    constructor(data?: IPlanogramCustomersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PlanogramCustomersDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanogramCustomersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): PlanogramCustomersDto {
        const json = this.toJSON();
        let result = new PlanogramCustomersDto();
        result.init(json);
        return result;
    }
}

export interface IPlanogramCustomersDto {
    id: string | undefined;
    name: string | undefined;
}

export class CwfSmsInput implements ICwfSmsInput {
    smsRecId: string | undefined;
    eType: CwfSmsInputEType | undefined;

    constructor(data?: ICwfSmsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smsRecId = _data["smsRecId"];
            this.eType = _data["eType"];
        }
    }

    static fromJS(data: any): CwfSmsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CwfSmsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsRecId"] = this.smsRecId;
        data["eType"] = this.eType;
        return data;
    }

    clone(): CwfSmsInput {
        const json = this.toJSON();
        let result = new CwfSmsInput();
        result.init(json);
        return result;
    }
}

export interface ICwfSmsInput {
    smsRecId: string | undefined;
    eType: CwfSmsInputEType | undefined;
}

export class Kategori implements IKategori {
    id: string | undefined;
    kategoriTipId: string | undefined;
    kategoriTip: KategoriTip | undefined;
    firmaId: string | undefined;
    firma: Firma | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    aciklama: string | undefined;
    logoImageUrl: string | undefined;
    genericField1: string | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IKategori) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kategoriTipId = _data["kategoriTipId"];
            this.kategoriTip = _data["kategoriTip"] ? KategoriTip.fromJS(_data["kategoriTip"]) : <any>undefined;
            this.firmaId = _data["firmaId"];
            this.firma = _data["firma"] ? Firma.fromJS(_data["firma"]) : <any>undefined;
            this.projeId = _data["projeId"];
            this.proje = _data["proje"] ? Proje.fromJS(_data["proje"]) : <any>undefined;
            this.aciklama = _data["aciklama"];
            this.logoImageUrl = _data["logoImageUrl"];
            this.genericField1 = _data["genericField1"];
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Kategori {
        data = typeof data === 'object' ? data : {};
        let result = new Kategori();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kategoriTipId"] = this.kategoriTipId;
        data["kategoriTip"] = this.kategoriTip ? this.kategoriTip.toJSON() : <any>undefined;
        data["firmaId"] = this.firmaId;
        data["firma"] = this.firma ? this.firma.toJSON() : <any>undefined;
        data["projeId"] = this.projeId;
        data["proje"] = this.proje ? this.proje.toJSON() : <any>undefined;
        data["aciklama"] = this.aciklama;
        data["logoImageUrl"] = this.logoImageUrl;
        data["genericField1"] = this.genericField1;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Kategori {
        const json = this.toJSON();
        let result = new Kategori();
        result.init(json);
        return result;
    }
}

export interface IKategori {
    id: string | undefined;
    kategoriTipId: string | undefined;
    kategoriTip: KategoriTip | undefined;
    firmaId: string | undefined;
    firma: Firma | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    aciklama: string | undefined;
    logoImageUrl: string | undefined;
    genericField1: string | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class KategoriTip implements IKategoriTip {
    id: string | undefined;
    kategoriler: Kategori[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IKategoriTip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["kategoriler"])) {
                this.kategoriler = [] as any;
                for (let item of _data["kategoriler"])
                    this.kategoriler.push(Kategori.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): KategoriTip {
        data = typeof data === 'object' ? data : {};
        let result = new KategoriTip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.kategoriler)) {
            data["kategoriler"] = [];
            for (let item of this.kategoriler)
                data["kategoriler"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): KategoriTip {
        const json = this.toJSON();
        let result = new KategoriTip();
        result.init(json);
        return result;
    }
}

export interface IKategoriTip {
    id: string | undefined;
    kategoriler: Kategori[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class Firma implements IFirma {
    id: string | undefined;
    name: string | undefined;
    vergiDairesi: string | undefined;
    vergiNo: string | undefined;
    sehirId: string | undefined;
    sehir: Sehir | undefined;
    sektorId: string | undefined;
    sektor: Sektor | undefined;
    adres: string | undefined;
    telefon: string | undefined;
    firmaDurumu: FirmaDurumu | undefined;
    musteriOrTedarikci: FirmaMusteriOrTedarikci | undefined;
    aciklama: string | undefined;
    isEkomBireysel: boolean | undefined;
    isTranspop: boolean | undefined;
    transpopMusteriKodu: string | undefined;
    kisaAd: string | undefined;
    tedarikciFirmaEnvanterleri: Envanter[] | undefined;
    aracTakipFirmasiEnvanterleri: Envanter[] | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IFirma) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.vergiDairesi = _data["vergiDairesi"];
            this.vergiNo = _data["vergiNo"];
            this.sehirId = _data["sehirId"];
            this.sehir = _data["sehir"] ? Sehir.fromJS(_data["sehir"]) : <any>undefined;
            this.sektorId = _data["sektorId"];
            this.sektor = _data["sektor"] ? Sektor.fromJS(_data["sektor"]) : <any>undefined;
            this.adres = _data["adres"];
            this.telefon = _data["telefon"];
            this.firmaDurumu = _data["firmaDurumu"];
            this.musteriOrTedarikci = _data["musteriOrTedarikci"];
            this.aciklama = _data["aciklama"];
            this.isEkomBireysel = _data["isEkomBireysel"];
            this.isTranspop = _data["isTranspop"];
            this.transpopMusteriKodu = _data["transpopMusteriKodu"];
            this.kisaAd = _data["kisaAd"];
            if (Array.isArray(_data["tedarikciFirmaEnvanterleri"])) {
                this.tedarikciFirmaEnvanterleri = [] as any;
                for (let item of _data["tedarikciFirmaEnvanterleri"])
                    this.tedarikciFirmaEnvanterleri.push(Envanter.fromJS(item));
            }
            if (Array.isArray(_data["aracTakipFirmasiEnvanterleri"])) {
                this.aracTakipFirmasiEnvanterleri = [] as any;
                for (let item of _data["aracTakipFirmasiEnvanterleri"])
                    this.aracTakipFirmasiEnvanterleri.push(Envanter.fromJS(item));
            }
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Firma {
        data = typeof data === 'object' ? data : {};
        let result = new Firma();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["vergiDairesi"] = this.vergiDairesi;
        data["vergiNo"] = this.vergiNo;
        data["sehirId"] = this.sehirId;
        data["sehir"] = this.sehir ? this.sehir.toJSON() : <any>undefined;
        data["sektorId"] = this.sektorId;
        data["sektor"] = this.sektor ? this.sektor.toJSON() : <any>undefined;
        data["adres"] = this.adres;
        data["telefon"] = this.telefon;
        data["firmaDurumu"] = this.firmaDurumu;
        data["musteriOrTedarikci"] = this.musteriOrTedarikci;
        data["aciklama"] = this.aciklama;
        data["isEkomBireysel"] = this.isEkomBireysel;
        data["isTranspop"] = this.isTranspop;
        data["transpopMusteriKodu"] = this.transpopMusteriKodu;
        data["kisaAd"] = this.kisaAd;
        if (Array.isArray(this.tedarikciFirmaEnvanterleri)) {
            data["tedarikciFirmaEnvanterleri"] = [];
            for (let item of this.tedarikciFirmaEnvanterleri)
                data["tedarikciFirmaEnvanterleri"].push(item.toJSON());
        }
        if (Array.isArray(this.aracTakipFirmasiEnvanterleri)) {
            data["aracTakipFirmasiEnvanterleri"] = [];
            for (let item of this.aracTakipFirmasiEnvanterleri)
                data["aracTakipFirmasiEnvanterleri"].push(item.toJSON());
        }
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Firma {
        const json = this.toJSON();
        let result = new Firma();
        result.init(json);
        return result;
    }
}

export interface IFirma {
    id: string | undefined;
    name: string | undefined;
    vergiDairesi: string | undefined;
    vergiNo: string | undefined;
    sehirId: string | undefined;
    sehir: Sehir | undefined;
    sektorId: string | undefined;
    sektor: Sektor | undefined;
    adres: string | undefined;
    telefon: string | undefined;
    firmaDurumu: FirmaDurumu | undefined;
    musteriOrTedarikci: FirmaMusteriOrTedarikci | undefined;
    aciklama: string | undefined;
    isEkomBireysel: boolean | undefined;
    isTranspop: boolean | undefined;
    transpopMusteriKodu: string | undefined;
    kisaAd: string | undefined;
    tedarikciFirmaEnvanterleri: Envanter[] | undefined;
    aracTakipFirmasiEnvanterleri: Envanter[] | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class Proje implements IProje {
    id: string | undefined;
    sirketId: string | undefined;
    sirket: Sirket | undefined;
    ikSorumlusuId: string | undefined;
    ikSorumlusu: Person | undefined;
    personelTakipSorumlusuId: string | undefined;
    personelTakipSorumlusu: Person | undefined;
    projeYoneticiId: string | undefined;
    projeYoneticisi: Person | undefined;
    projeMuduruId: string | undefined;
    projeMuduru: Person | undefined;
    projeKodu: string | undefined;
    kargoCarpani: number | undefined;
    logoMasrafDonemi: ProjeLogoMasrafDonemi | undefined;
    firmaId: string | undefined;
    firma: Firma | undefined;
    masrafKodAyrimi: ProjeMasrafKodAyrimi | undefined;
    normKadroList: NormKadro[] | undefined;
    kullaniciProjeList: KullaniciProjesi[] | undefined;
    kpIs: Kpi[] | undefined;
    musteriPoiList: PoiMusteri[] | undefined;
    gsmTarifeleri: GsmTarife[] | undefined;
    gorevFormlari: GorevForm[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IProje) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sirketId = _data["sirketId"];
            this.sirket = _data["sirket"] ? Sirket.fromJS(_data["sirket"]) : <any>undefined;
            this.ikSorumlusuId = _data["ikSorumlusuId"];
            this.ikSorumlusu = _data["ikSorumlusu"] ? Person.fromJS(_data["ikSorumlusu"]) : <any>undefined;
            this.personelTakipSorumlusuId = _data["personelTakipSorumlusuId"];
            this.personelTakipSorumlusu = _data["personelTakipSorumlusu"] ? Person.fromJS(_data["personelTakipSorumlusu"]) : <any>undefined;
            this.projeYoneticiId = _data["projeYoneticiId"];
            this.projeYoneticisi = _data["projeYoneticisi"] ? Person.fromJS(_data["projeYoneticisi"]) : <any>undefined;
            this.projeMuduruId = _data["projeMuduruId"];
            this.projeMuduru = _data["projeMuduru"] ? Person.fromJS(_data["projeMuduru"]) : <any>undefined;
            this.projeKodu = _data["projeKodu"];
            this.kargoCarpani = _data["kargoCarpani"];
            this.logoMasrafDonemi = _data["logoMasrafDonemi"];
            this.firmaId = _data["firmaId"];
            this.firma = _data["firma"] ? Firma.fromJS(_data["firma"]) : <any>undefined;
            this.masrafKodAyrimi = _data["masrafKodAyrimi"];
            if (Array.isArray(_data["normKadroList"])) {
                this.normKadroList = [] as any;
                for (let item of _data["normKadroList"])
                    this.normKadroList.push(NormKadro.fromJS(item));
            }
            if (Array.isArray(_data["kullaniciProjeList"])) {
                this.kullaniciProjeList = [] as any;
                for (let item of _data["kullaniciProjeList"])
                    this.kullaniciProjeList.push(KullaniciProjesi.fromJS(item));
            }
            if (Array.isArray(_data["kpIs"])) {
                this.kpIs = [] as any;
                for (let item of _data["kpIs"])
                    this.kpIs.push(Kpi.fromJS(item));
            }
            if (Array.isArray(_data["musteriPoiList"])) {
                this.musteriPoiList = [] as any;
                for (let item of _data["musteriPoiList"])
                    this.musteriPoiList.push(PoiMusteri.fromJS(item));
            }
            if (Array.isArray(_data["gsmTarifeleri"])) {
                this.gsmTarifeleri = [] as any;
                for (let item of _data["gsmTarifeleri"])
                    this.gsmTarifeleri.push(GsmTarife.fromJS(item));
            }
            if (Array.isArray(_data["gorevFormlari"])) {
                this.gorevFormlari = [] as any;
                for (let item of _data["gorevFormlari"])
                    this.gorevFormlari.push(GorevForm.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Proje {
        data = typeof data === 'object' ? data : {};
        let result = new Proje();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sirketId"] = this.sirketId;
        data["sirket"] = this.sirket ? this.sirket.toJSON() : <any>undefined;
        data["ikSorumlusuId"] = this.ikSorumlusuId;
        data["ikSorumlusu"] = this.ikSorumlusu ? this.ikSorumlusu.toJSON() : <any>undefined;
        data["personelTakipSorumlusuId"] = this.personelTakipSorumlusuId;
        data["personelTakipSorumlusu"] = this.personelTakipSorumlusu ? this.personelTakipSorumlusu.toJSON() : <any>undefined;
        data["projeYoneticiId"] = this.projeYoneticiId;
        data["projeYoneticisi"] = this.projeYoneticisi ? this.projeYoneticisi.toJSON() : <any>undefined;
        data["projeMuduruId"] = this.projeMuduruId;
        data["projeMuduru"] = this.projeMuduru ? this.projeMuduru.toJSON() : <any>undefined;
        data["projeKodu"] = this.projeKodu;
        data["kargoCarpani"] = this.kargoCarpani;
        data["logoMasrafDonemi"] = this.logoMasrafDonemi;
        data["firmaId"] = this.firmaId;
        data["firma"] = this.firma ? this.firma.toJSON() : <any>undefined;
        data["masrafKodAyrimi"] = this.masrafKodAyrimi;
        if (Array.isArray(this.normKadroList)) {
            data["normKadroList"] = [];
            for (let item of this.normKadroList)
                data["normKadroList"].push(item.toJSON());
        }
        if (Array.isArray(this.kullaniciProjeList)) {
            data["kullaniciProjeList"] = [];
            for (let item of this.kullaniciProjeList)
                data["kullaniciProjeList"].push(item.toJSON());
        }
        if (Array.isArray(this.kpIs)) {
            data["kpIs"] = [];
            for (let item of this.kpIs)
                data["kpIs"].push(item.toJSON());
        }
        if (Array.isArray(this.musteriPoiList)) {
            data["musteriPoiList"] = [];
            for (let item of this.musteriPoiList)
                data["musteriPoiList"].push(item.toJSON());
        }
        if (Array.isArray(this.gsmTarifeleri)) {
            data["gsmTarifeleri"] = [];
            for (let item of this.gsmTarifeleri)
                data["gsmTarifeleri"].push(item.toJSON());
        }
        if (Array.isArray(this.gorevFormlari)) {
            data["gorevFormlari"] = [];
            for (let item of this.gorevFormlari)
                data["gorevFormlari"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Proje {
        const json = this.toJSON();
        let result = new Proje();
        result.init(json);
        return result;
    }
}

export interface IProje {
    id: string | undefined;
    sirketId: string | undefined;
    sirket: Sirket | undefined;
    ikSorumlusuId: string | undefined;
    ikSorumlusu: Person | undefined;
    personelTakipSorumlusuId: string | undefined;
    personelTakipSorumlusu: Person | undefined;
    projeYoneticiId: string | undefined;
    projeYoneticisi: Person | undefined;
    projeMuduruId: string | undefined;
    projeMuduru: Person | undefined;
    projeKodu: string | undefined;
    kargoCarpani: number | undefined;
    logoMasrafDonemi: ProjeLogoMasrafDonemi | undefined;
    firmaId: string | undefined;
    firma: Firma | undefined;
    masrafKodAyrimi: ProjeMasrafKodAyrimi | undefined;
    normKadroList: NormKadro[] | undefined;
    kullaniciProjeList: KullaniciProjesi[] | undefined;
    kpIs: Kpi[] | undefined;
    musteriPoiList: PoiMusteri[] | undefined;
    gsmTarifeleri: GsmTarife[] | undefined;
    gorevFormlari: GorevForm[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class Sehir implements ISehir {
    id: string | undefined;
    kod: string | undefined;
    ilceler: Ilce[] | undefined;
    normKadroList: NormKadro[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: ISehir) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kod = _data["kod"];
            if (Array.isArray(_data["ilceler"])) {
                this.ilceler = [] as any;
                for (let item of _data["ilceler"])
                    this.ilceler.push(Ilce.fromJS(item));
            }
            if (Array.isArray(_data["normKadroList"])) {
                this.normKadroList = [] as any;
                for (let item of _data["normKadroList"])
                    this.normKadroList.push(NormKadro.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Sehir {
        data = typeof data === 'object' ? data : {};
        let result = new Sehir();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kod"] = this.kod;
        if (Array.isArray(this.ilceler)) {
            data["ilceler"] = [];
            for (let item of this.ilceler)
                data["ilceler"].push(item.toJSON());
        }
        if (Array.isArray(this.normKadroList)) {
            data["normKadroList"] = [];
            for (let item of this.normKadroList)
                data["normKadroList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Sehir {
        const json = this.toJSON();
        let result = new Sehir();
        result.init(json);
        return result;
    }
}

export interface ISehir {
    id: string | undefined;
    kod: string | undefined;
    ilceler: Ilce[] | undefined;
    normKadroList: NormKadro[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class Sektor implements ISektor {
    id: string | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: ISektor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Sektor {
        data = typeof data === 'object' ? data : {};
        let result = new Sektor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Sektor {
        const json = this.toJSON();
        let result = new Sektor();
        result.init(json);
        return result;
    }
}

export interface ISektor {
    id: string | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class Envanter implements IEnvanter {
    id: string | undefined;
    sirketId: string | undefined;
    sirket: Sirket | undefined;
    envanterTipiId: string | undefined;
    envanterTipi: EnvanterTipi | undefined;
    sahiplikDurumu: EnvanterSahiplikDurumu | undefined;
    tedarikciId: string | undefined;
    tedarikci: Firma | undefined;
    faturaTarihi: Date | undefined;
    teslimAlanId: string | undefined;
    teslimAlan: Person | undefined;
    teslimAlmaTarihi: Date | undefined;
    ekomLokasyonId: string | undefined;
    ekomLokasyon: EkomLokasyon | undefined;
    isGarantili: boolean | undefined;
    aciklama: string | undefined;
    garantiBisisTarihi: Date | undefined;
    aracPlaka: string | undefined;
    aracCinsi: EnvanterAracCinsi | undefined;
    aracTipi: string | undefined;
    modelYili: string | undefined;
    teslimKilometresi: number | undefined;
    hasYedekAnahtar: number | undefined;
    yakitFirmasi: EnvanterYakitFirmasi | undefined;
    hgsNo: string | undefined;
    aracTakipFirmaId: string | undefined;
    aracTakipFirmasi: Firma | undefined;
    aracTakipNo: string | undefined;
    aracNetAgirlik: number | undefined;
    aracAzamiYukAgirlik: number | undefined;
    aracIstihapHaddi: number | undefined;
    aracSatinAlmaFiyati: number | undefined;
    aracKiraSozlesmeBaslangicTarihi: Date | undefined;
    aracKiraSozlesmeBitisTarihi: Date | undefined;
    kiralamaSuresiAy: number | undefined;
    kiralamKmSiniri: number | undefined;
    kiralamAylikKira: number | undefined;
    satinAlmaParaBirimi: number | undefined;
    satinAlmaKur: number | undefined;
    hatNo: string | undefined;
    hatTipi: EnvanterHatTipi | undefined;
    cihazUcreti: number | undefined;
    cihazBitisTarihi: Date | undefined;
    hatTarifeBitisTarihi: Date | undefined;
    envanterProjeSehirId: string | undefined;
    envanterProjeSehir: Sehir | undefined;
    cihazMarkaModel: string | undefined;
    cihazSeriNo: string | undefined;
    cihazIMEI: string | undefined;
    cihazRamBellek: EnvanterCihazRamBellek | undefined;
    cihazDiskKapasitesi: string | undefined;
    cihazIslemciTipi: string | undefined;
    atananProjeId: string | undefined;
    atananProje: Proje | undefined;
    envanterSorumlusuId: string | undefined;
    envanterSorumlusu: Person | undefined;
    projeyeAtamaTarihi: Date | undefined;
    hatTarifeId: string | undefined;
    hatTarife: GsmTarife | undefined;
    projeSatisFiyati: number | undefined;
    zimmetlenenPersonelId: string | undefined;
    zimmetlenenPersonel: Person | undefined;
    zimmetTarihi: Date | undefined;
    zimmetDurumu: string | undefined;
    aracZimmetlenenKm: number | undefined;
    zimmetFormu: EnvanterZimmetFormu | undefined;
    serviseVerilisTarihi: Date | undefined;
    serviseVerilisNedeni: string | undefined;
    servisTelefon: string | undefined;
    servisDetay: string | undefined;
    servistenGelisTarihi: Date | undefined;
    zimmetBedeli: number | undefined;
    envanterDurumu: EnvanterDurumu | undefined;
    servisTutari: number | undefined;
    sigortaBitisTarihi: Date | undefined;
    trafikSigortaSirketiId: string | undefined;
    trafikSigortaSirketi: Firma | undefined;
    muayeneBitisTarihi: Date | undefined;
    kaskoBitisTarihi: Date | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IEnvanter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sirketId = _data["sirketId"];
            this.sirket = _data["sirket"] ? Sirket.fromJS(_data["sirket"]) : <any>undefined;
            this.envanterTipiId = _data["envanterTipiId"];
            this.envanterTipi = _data["envanterTipi"] ? EnvanterTipi.fromJS(_data["envanterTipi"]) : <any>undefined;
            this.sahiplikDurumu = _data["sahiplikDurumu"];
            this.tedarikciId = _data["tedarikciId"];
            this.tedarikci = _data["tedarikci"] ? Firma.fromJS(_data["tedarikci"]) : <any>undefined;
            this.faturaTarihi = _data["faturaTarihi"] ? new Date(_data["faturaTarihi"].toString()) : <any>undefined;
            this.teslimAlanId = _data["teslimAlanId"];
            this.teslimAlan = _data["teslimAlan"] ? Person.fromJS(_data["teslimAlan"]) : <any>undefined;
            this.teslimAlmaTarihi = _data["teslimAlmaTarihi"] ? new Date(_data["teslimAlmaTarihi"].toString()) : <any>undefined;
            this.ekomLokasyonId = _data["ekomLokasyonId"];
            this.ekomLokasyon = _data["ekomLokasyon"] ? EkomLokasyon.fromJS(_data["ekomLokasyon"]) : <any>undefined;
            this.isGarantili = _data["isGarantili"];
            this.aciklama = _data["aciklama"];
            this.garantiBisisTarihi = _data["garantiBisisTarihi"] ? new Date(_data["garantiBisisTarihi"].toString()) : <any>undefined;
            this.aracPlaka = _data["aracPlaka"];
            this.aracCinsi = _data["aracCinsi"];
            this.aracTipi = _data["aracTipi"];
            this.modelYili = _data["modelYili"];
            this.teslimKilometresi = _data["teslimKilometresi"];
            this.hasYedekAnahtar = _data["hasYedekAnahtar"];
            this.yakitFirmasi = _data["yakitFirmasi"];
            this.hgsNo = _data["hgsNo"];
            this.aracTakipFirmaId = _data["aracTakipFirmaId"];
            this.aracTakipFirmasi = _data["aracTakipFirmasi"] ? Firma.fromJS(_data["aracTakipFirmasi"]) : <any>undefined;
            this.aracTakipNo = _data["aracTakipNo"];
            this.aracNetAgirlik = _data["aracNetAgirlik"];
            this.aracAzamiYukAgirlik = _data["aracAzamiYukAgirlik"];
            this.aracIstihapHaddi = _data["aracIstihapHaddi"];
            this.aracSatinAlmaFiyati = _data["aracSatinAlmaFiyati"];
            this.aracKiraSozlesmeBaslangicTarihi = _data["aracKiraSozlesmeBaslangicTarihi"] ? new Date(_data["aracKiraSozlesmeBaslangicTarihi"].toString()) : <any>undefined;
            this.aracKiraSozlesmeBitisTarihi = _data["aracKiraSozlesmeBitisTarihi"] ? new Date(_data["aracKiraSozlesmeBitisTarihi"].toString()) : <any>undefined;
            this.kiralamaSuresiAy = _data["kiralamaSuresiAy"];
            this.kiralamKmSiniri = _data["kiralamKmSiniri"];
            this.kiralamAylikKira = _data["kiralamAylikKira"];
            this.satinAlmaParaBirimi = _data["satinAlmaParaBirimi"];
            this.satinAlmaKur = _data["satinAlmaKur"];
            this.hatNo = _data["hatNo"];
            this.hatTipi = _data["hatTipi"];
            this.cihazUcreti = _data["cihazUcreti"];
            this.cihazBitisTarihi = _data["cihazBitisTarihi"] ? new Date(_data["cihazBitisTarihi"].toString()) : <any>undefined;
            this.hatTarifeBitisTarihi = _data["hatTarifeBitisTarihi"] ? new Date(_data["hatTarifeBitisTarihi"].toString()) : <any>undefined;
            this.envanterProjeSehirId = _data["envanterProjeSehirId"];
            this.envanterProjeSehir = _data["envanterProjeSehir"] ? Sehir.fromJS(_data["envanterProjeSehir"]) : <any>undefined;
            this.cihazMarkaModel = _data["cihazMarkaModel"];
            this.cihazSeriNo = _data["cihazSeriNo"];
            this.cihazIMEI = _data["cihazIMEI"];
            this.cihazRamBellek = _data["cihazRamBellek"];
            this.cihazDiskKapasitesi = _data["cihazDiskKapasitesi"];
            this.cihazIslemciTipi = _data["cihazIslemciTipi"];
            this.atananProjeId = _data["atananProjeId"];
            this.atananProje = _data["atananProje"] ? Proje.fromJS(_data["atananProje"]) : <any>undefined;
            this.envanterSorumlusuId = _data["envanterSorumlusuId"];
            this.envanterSorumlusu = _data["envanterSorumlusu"] ? Person.fromJS(_data["envanterSorumlusu"]) : <any>undefined;
            this.projeyeAtamaTarihi = _data["projeyeAtamaTarihi"] ? new Date(_data["projeyeAtamaTarihi"].toString()) : <any>undefined;
            this.hatTarifeId = _data["hatTarifeId"];
            this.hatTarife = _data["hatTarife"] ? GsmTarife.fromJS(_data["hatTarife"]) : <any>undefined;
            this.projeSatisFiyati = _data["projeSatisFiyati"];
            this.zimmetlenenPersonelId = _data["zimmetlenenPersonelId"];
            this.zimmetlenenPersonel = _data["zimmetlenenPersonel"] ? Person.fromJS(_data["zimmetlenenPersonel"]) : <any>undefined;
            this.zimmetTarihi = _data["zimmetTarihi"] ? new Date(_data["zimmetTarihi"].toString()) : <any>undefined;
            this.zimmetDurumu = _data["zimmetDurumu"];
            this.aracZimmetlenenKm = _data["aracZimmetlenenKm"];
            this.zimmetFormu = _data["zimmetFormu"];
            this.serviseVerilisTarihi = _data["serviseVerilisTarihi"] ? new Date(_data["serviseVerilisTarihi"].toString()) : <any>undefined;
            this.serviseVerilisNedeni = _data["serviseVerilisNedeni"];
            this.servisTelefon = _data["servisTelefon"];
            this.servisDetay = _data["servisDetay"];
            this.servistenGelisTarihi = _data["servistenGelisTarihi"] ? new Date(_data["servistenGelisTarihi"].toString()) : <any>undefined;
            this.zimmetBedeli = _data["zimmetBedeli"];
            this.envanterDurumu = _data["envanterDurumu"];
            this.servisTutari = _data["servisTutari"];
            this.sigortaBitisTarihi = _data["sigortaBitisTarihi"] ? new Date(_data["sigortaBitisTarihi"].toString()) : <any>undefined;
            this.trafikSigortaSirketiId = _data["trafikSigortaSirketiId"];
            this.trafikSigortaSirketi = _data["trafikSigortaSirketi"] ? Firma.fromJS(_data["trafikSigortaSirketi"]) : <any>undefined;
            this.muayeneBitisTarihi = _data["muayeneBitisTarihi"] ? new Date(_data["muayeneBitisTarihi"].toString()) : <any>undefined;
            this.kaskoBitisTarihi = _data["kaskoBitisTarihi"] ? new Date(_data["kaskoBitisTarihi"].toString()) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Envanter {
        data = typeof data === 'object' ? data : {};
        let result = new Envanter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sirketId"] = this.sirketId;
        data["sirket"] = this.sirket ? this.sirket.toJSON() : <any>undefined;
        data["envanterTipiId"] = this.envanterTipiId;
        data["envanterTipi"] = this.envanterTipi ? this.envanterTipi.toJSON() : <any>undefined;
        data["sahiplikDurumu"] = this.sahiplikDurumu;
        data["tedarikciId"] = this.tedarikciId;
        data["tedarikci"] = this.tedarikci ? this.tedarikci.toJSON() : <any>undefined;
        data["faturaTarihi"] = this.faturaTarihi ? this.faturaTarihi.toISOString() : <any>undefined;
        data["teslimAlanId"] = this.teslimAlanId;
        data["teslimAlan"] = this.teslimAlan ? this.teslimAlan.toJSON() : <any>undefined;
        data["teslimAlmaTarihi"] = this.teslimAlmaTarihi ? this.teslimAlmaTarihi.toISOString() : <any>undefined;
        data["ekomLokasyonId"] = this.ekomLokasyonId;
        data["ekomLokasyon"] = this.ekomLokasyon ? this.ekomLokasyon.toJSON() : <any>undefined;
        data["isGarantili"] = this.isGarantili;
        data["aciklama"] = this.aciklama;
        data["garantiBisisTarihi"] = this.garantiBisisTarihi ? this.garantiBisisTarihi.toISOString() : <any>undefined;
        data["aracPlaka"] = this.aracPlaka;
        data["aracCinsi"] = this.aracCinsi;
        data["aracTipi"] = this.aracTipi;
        data["modelYili"] = this.modelYili;
        data["teslimKilometresi"] = this.teslimKilometresi;
        data["hasYedekAnahtar"] = this.hasYedekAnahtar;
        data["yakitFirmasi"] = this.yakitFirmasi;
        data["hgsNo"] = this.hgsNo;
        data["aracTakipFirmaId"] = this.aracTakipFirmaId;
        data["aracTakipFirmasi"] = this.aracTakipFirmasi ? this.aracTakipFirmasi.toJSON() : <any>undefined;
        data["aracTakipNo"] = this.aracTakipNo;
        data["aracNetAgirlik"] = this.aracNetAgirlik;
        data["aracAzamiYukAgirlik"] = this.aracAzamiYukAgirlik;
        data["aracIstihapHaddi"] = this.aracIstihapHaddi;
        data["aracSatinAlmaFiyati"] = this.aracSatinAlmaFiyati;
        data["aracKiraSozlesmeBaslangicTarihi"] = this.aracKiraSozlesmeBaslangicTarihi ? this.aracKiraSozlesmeBaslangicTarihi.toISOString() : <any>undefined;
        data["aracKiraSozlesmeBitisTarihi"] = this.aracKiraSozlesmeBitisTarihi ? this.aracKiraSozlesmeBitisTarihi.toISOString() : <any>undefined;
        data["kiralamaSuresiAy"] = this.kiralamaSuresiAy;
        data["kiralamKmSiniri"] = this.kiralamKmSiniri;
        data["kiralamAylikKira"] = this.kiralamAylikKira;
        data["satinAlmaParaBirimi"] = this.satinAlmaParaBirimi;
        data["satinAlmaKur"] = this.satinAlmaKur;
        data["hatNo"] = this.hatNo;
        data["hatTipi"] = this.hatTipi;
        data["cihazUcreti"] = this.cihazUcreti;
        data["cihazBitisTarihi"] = this.cihazBitisTarihi ? this.cihazBitisTarihi.toISOString() : <any>undefined;
        data["hatTarifeBitisTarihi"] = this.hatTarifeBitisTarihi ? this.hatTarifeBitisTarihi.toISOString() : <any>undefined;
        data["envanterProjeSehirId"] = this.envanterProjeSehirId;
        data["envanterProjeSehir"] = this.envanterProjeSehir ? this.envanterProjeSehir.toJSON() : <any>undefined;
        data["cihazMarkaModel"] = this.cihazMarkaModel;
        data["cihazSeriNo"] = this.cihazSeriNo;
        data["cihazIMEI"] = this.cihazIMEI;
        data["cihazRamBellek"] = this.cihazRamBellek;
        data["cihazDiskKapasitesi"] = this.cihazDiskKapasitesi;
        data["cihazIslemciTipi"] = this.cihazIslemciTipi;
        data["atananProjeId"] = this.atananProjeId;
        data["atananProje"] = this.atananProje ? this.atananProje.toJSON() : <any>undefined;
        data["envanterSorumlusuId"] = this.envanterSorumlusuId;
        data["envanterSorumlusu"] = this.envanterSorumlusu ? this.envanterSorumlusu.toJSON() : <any>undefined;
        data["projeyeAtamaTarihi"] = this.projeyeAtamaTarihi ? this.projeyeAtamaTarihi.toISOString() : <any>undefined;
        data["hatTarifeId"] = this.hatTarifeId;
        data["hatTarife"] = this.hatTarife ? this.hatTarife.toJSON() : <any>undefined;
        data["projeSatisFiyati"] = this.projeSatisFiyati;
        data["zimmetlenenPersonelId"] = this.zimmetlenenPersonelId;
        data["zimmetlenenPersonel"] = this.zimmetlenenPersonel ? this.zimmetlenenPersonel.toJSON() : <any>undefined;
        data["zimmetTarihi"] = this.zimmetTarihi ? this.zimmetTarihi.toISOString() : <any>undefined;
        data["zimmetDurumu"] = this.zimmetDurumu;
        data["aracZimmetlenenKm"] = this.aracZimmetlenenKm;
        data["zimmetFormu"] = this.zimmetFormu;
        data["serviseVerilisTarihi"] = this.serviseVerilisTarihi ? this.serviseVerilisTarihi.toISOString() : <any>undefined;
        data["serviseVerilisNedeni"] = this.serviseVerilisNedeni;
        data["servisTelefon"] = this.servisTelefon;
        data["servisDetay"] = this.servisDetay;
        data["servistenGelisTarihi"] = this.servistenGelisTarihi ? this.servistenGelisTarihi.toISOString() : <any>undefined;
        data["zimmetBedeli"] = this.zimmetBedeli;
        data["envanterDurumu"] = this.envanterDurumu;
        data["servisTutari"] = this.servisTutari;
        data["sigortaBitisTarihi"] = this.sigortaBitisTarihi ? this.sigortaBitisTarihi.toISOString() : <any>undefined;
        data["trafikSigortaSirketiId"] = this.trafikSigortaSirketiId;
        data["trafikSigortaSirketi"] = this.trafikSigortaSirketi ? this.trafikSigortaSirketi.toJSON() : <any>undefined;
        data["muayeneBitisTarihi"] = this.muayeneBitisTarihi ? this.muayeneBitisTarihi.toISOString() : <any>undefined;
        data["kaskoBitisTarihi"] = this.kaskoBitisTarihi ? this.kaskoBitisTarihi.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Envanter {
        const json = this.toJSON();
        let result = new Envanter();
        result.init(json);
        return result;
    }
}

export interface IEnvanter {
    id: string | undefined;
    sirketId: string | undefined;
    sirket: Sirket | undefined;
    envanterTipiId: string | undefined;
    envanterTipi: EnvanterTipi | undefined;
    sahiplikDurumu: EnvanterSahiplikDurumu | undefined;
    tedarikciId: string | undefined;
    tedarikci: Firma | undefined;
    faturaTarihi: Date | undefined;
    teslimAlanId: string | undefined;
    teslimAlan: Person | undefined;
    teslimAlmaTarihi: Date | undefined;
    ekomLokasyonId: string | undefined;
    ekomLokasyon: EkomLokasyon | undefined;
    isGarantili: boolean | undefined;
    aciklama: string | undefined;
    garantiBisisTarihi: Date | undefined;
    aracPlaka: string | undefined;
    aracCinsi: EnvanterAracCinsi | undefined;
    aracTipi: string | undefined;
    modelYili: string | undefined;
    teslimKilometresi: number | undefined;
    hasYedekAnahtar: number | undefined;
    yakitFirmasi: EnvanterYakitFirmasi | undefined;
    hgsNo: string | undefined;
    aracTakipFirmaId: string | undefined;
    aracTakipFirmasi: Firma | undefined;
    aracTakipNo: string | undefined;
    aracNetAgirlik: number | undefined;
    aracAzamiYukAgirlik: number | undefined;
    aracIstihapHaddi: number | undefined;
    aracSatinAlmaFiyati: number | undefined;
    aracKiraSozlesmeBaslangicTarihi: Date | undefined;
    aracKiraSozlesmeBitisTarihi: Date | undefined;
    kiralamaSuresiAy: number | undefined;
    kiralamKmSiniri: number | undefined;
    kiralamAylikKira: number | undefined;
    satinAlmaParaBirimi: number | undefined;
    satinAlmaKur: number | undefined;
    hatNo: string | undefined;
    hatTipi: EnvanterHatTipi | undefined;
    cihazUcreti: number | undefined;
    cihazBitisTarihi: Date | undefined;
    hatTarifeBitisTarihi: Date | undefined;
    envanterProjeSehirId: string | undefined;
    envanterProjeSehir: Sehir | undefined;
    cihazMarkaModel: string | undefined;
    cihazSeriNo: string | undefined;
    cihazIMEI: string | undefined;
    cihazRamBellek: EnvanterCihazRamBellek | undefined;
    cihazDiskKapasitesi: string | undefined;
    cihazIslemciTipi: string | undefined;
    atananProjeId: string | undefined;
    atananProje: Proje | undefined;
    envanterSorumlusuId: string | undefined;
    envanterSorumlusu: Person | undefined;
    projeyeAtamaTarihi: Date | undefined;
    hatTarifeId: string | undefined;
    hatTarife: GsmTarife | undefined;
    projeSatisFiyati: number | undefined;
    zimmetlenenPersonelId: string | undefined;
    zimmetlenenPersonel: Person | undefined;
    zimmetTarihi: Date | undefined;
    zimmetDurumu: string | undefined;
    aracZimmetlenenKm: number | undefined;
    zimmetFormu: EnvanterZimmetFormu | undefined;
    serviseVerilisTarihi: Date | undefined;
    serviseVerilisNedeni: string | undefined;
    servisTelefon: string | undefined;
    servisDetay: string | undefined;
    servistenGelisTarihi: Date | undefined;
    zimmetBedeli: number | undefined;
    envanterDurumu: EnvanterDurumu | undefined;
    servisTutari: number | undefined;
    sigortaBitisTarihi: Date | undefined;
    trafikSigortaSirketiId: string | undefined;
    trafikSigortaSirketi: Firma | undefined;
    muayeneBitisTarihi: Date | undefined;
    kaskoBitisTarihi: Date | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class Sirket implements ISirket {
    id: string | undefined;
    adres: string | undefined;
    sgkSicilNo: string | undefined;
    unvan: string | undefined;
    muhasebeEmailAdres: string | undefined;
    logoSirketKodu: string | undefined;
    envanterler: Envanter[] | undefined;
    masrafKalemleri: MasrafKalemi[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: ISirket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.adres = _data["adres"];
            this.sgkSicilNo = _data["sgkSicilNo"];
            this.unvan = _data["unvan"];
            this.muhasebeEmailAdres = _data["muhasebeEmailAdres"];
            this.logoSirketKodu = _data["logoSirketKodu"];
            if (Array.isArray(_data["envanterler"])) {
                this.envanterler = [] as any;
                for (let item of _data["envanterler"])
                    this.envanterler.push(Envanter.fromJS(item));
            }
            if (Array.isArray(_data["masrafKalemleri"])) {
                this.masrafKalemleri = [] as any;
                for (let item of _data["masrafKalemleri"])
                    this.masrafKalemleri.push(MasrafKalemi.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Sirket {
        data = typeof data === 'object' ? data : {};
        let result = new Sirket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["adres"] = this.adres;
        data["sgkSicilNo"] = this.sgkSicilNo;
        data["unvan"] = this.unvan;
        data["muhasebeEmailAdres"] = this.muhasebeEmailAdres;
        data["logoSirketKodu"] = this.logoSirketKodu;
        if (Array.isArray(this.envanterler)) {
            data["envanterler"] = [];
            for (let item of this.envanterler)
                data["envanterler"].push(item.toJSON());
        }
        if (Array.isArray(this.masrafKalemleri)) {
            data["masrafKalemleri"] = [];
            for (let item of this.masrafKalemleri)
                data["masrafKalemleri"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Sirket {
        const json = this.toJSON();
        let result = new Sirket();
        result.init(json);
        return result;
    }
}

export interface ISirket {
    id: string | undefined;
    adres: string | undefined;
    sgkSicilNo: string | undefined;
    unvan: string | undefined;
    muhasebeEmailAdres: string | undefined;
    logoSirketKodu: string | undefined;
    envanterler: Envanter[] | undefined;
    masrafKalemleri: MasrafKalemi[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class Person implements IPerson {
    id: string | undefined;
    tcNo: string | undefined;
    sicilNo: string | undefined;
    cinsiyet: PersonCinsiyet | undefined;
    logoWorkArea: string | undefined;
    ad: string | undefined;
    soyad: string | undefined;
    dogumTarihi: Date | undefined;
    ikPortalUserName: string | undefined;
    ikPortalPassword: string | undefined;
    bugunkiGorevDurumu: PersonBugunkiGorevDurumu | undefined;
    readonly adSoyad: string | undefined;
    readonly adSoyadUniversal: string | undefined;
    sirketId: string | undefined;
    sirket: Sirket | undefined;
    normKadroId: string | undefined;
    normKadro: NormKadro | undefined;
    unvanId: string | undefined;
    unvan: Unvan | undefined;
    birim: string | undefined;
    sgkIsYeriId: string | undefined;
    sgkIsYeri: SgkIsyeri | undefined;
    emailAddress: string | undefined;
    calismaDurumu: PersonCalismaDurumu | undefined;
    isTel: string | undefined;
    iseGirisTarihi: Date | undefined;
    istenCikisTarihi: Date | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    haklarinBaslagicTarihi: Date | undefined;
    masrafMerkezi: MasrafMerkezi | undefined;
    departmanId: string | undefined;
    departman: Departman | undefined;
    mobilTelefon: string | undefined;
    ilkAmirId: string | undefined;
    ilkAmir: Person | undefined;
    yoneticiId: string | undefined;
    yonetici: Person | undefined;
    isPlatomAppKullanir: boolean | undefined;
    ilkAmiriOlduguKadroList: NormKadro[] | undefined;
    projeSorumlusuOlduguKadroList: NormKadro[] | undefined;
    yoneticisiOlduguKadroList: NormKadro[] | undefined;
    ilgiliKisi1OlduguSozlesmeList: Sozlesme[] | undefined;
    ilgiliKisi2OlduguSozlesmeList: Sozlesme[] | undefined;
    ilgiliKisi3OlduguSozlesmeList: Sozlesme[] | undefined;
    ilgiliKisi1OlduguKontratList: Kontrat[] | undefined;
    ilgiliKisi2OlduguKontratList: Kontrat[] | undefined;
    ilgiliKisi3OlduguKontratList: Kontrat[] | undefined;
    istenCikisGorevleri: IstenCikisGorev[] | undefined;
    istenCikisGorevleriBolgeYoneticisi: IstenCikisGorev[] | undefined;
    istenCikisGorevleriProjeYoneticisi: IstenCikisGorev[] | undefined;
    istenCikisGorevleriEkomBolgeSorumlusu: IstenCikisGorev[] | undefined;
    istenCikisGorevleriIKSorumlusu: IstenCikisGorev[] | undefined;
    istenCikisGorevleriTalepEden: IstenCikisGorev[] | undefined;
    iseAlimTalepleri: IseAlimTalep[] | undefined;
    iseAlimTalepPersonelTakipSorumlusu: IseAlimTalep[] | undefined;
    iseAlimTalepPersonelAlimOnaycisi: IseAlimTalep[] | undefined;
    iseAlimTalepPersonelAlimGorevlisi: IseAlimTalep[] | undefined;
    iseAlimTalepEvrakSorumlusu: IseAlimTalep[] | undefined;
    musteriCalisaniPersonelList: MusteriCalisani[] | undefined;
    musteriCalisaniSupevervisorList: MusteriCalisani[] | undefined;
    isGorusmeleri: IsGorusmesi[] | undefined;
    projeIkSorumluList: Proje[] | undefined;
    projePersonelSorumluList: Proje[] | undefined;
    projeProjeMudurList: Proje[] | undefined;
    sahaPerformansPersonel: SahaPerformans[] | undefined;
    sahaPerformansIlkAmir: SahaPerformans[] | undefined;
    sahaPerformansBolgeMuduru: SahaPerformans[] | undefined;
    sahaPerformansDirektor: SahaPerformans[] | undefined;
    magazaPerformansSupervisor: MagazaPerformans[] | undefined;
    magazaPerformansPersonel: MagazaPerformans[] | undefined;
    envanterTeslimAlinanlar: Envanter[] | undefined;
    envanterZimmetlenenler: Envanter[] | undefined;
    ilkAmiriOlduguPersonelList: Person[] | undefined;
    yoneticisiOlduguPersonelList: Person[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tcNo = _data["tcNo"];
            this.sicilNo = _data["sicilNo"];
            this.cinsiyet = _data["cinsiyet"];
            this.logoWorkArea = _data["logoWorkArea"];
            this.ad = _data["ad"];
            this.soyad = _data["soyad"];
            this.dogumTarihi = _data["dogumTarihi"] ? new Date(_data["dogumTarihi"].toString()) : <any>undefined;
            this.ikPortalUserName = _data["ikPortalUserName"];
            this.ikPortalPassword = _data["ikPortalPassword"];
            this.bugunkiGorevDurumu = _data["bugunkiGorevDurumu"];
            (<any>this).adSoyad = _data["adSoyad"];
            (<any>this).adSoyadUniversal = _data["adSoyadUniversal"];
            this.sirketId = _data["sirketId"];
            this.sirket = _data["sirket"] ? Sirket.fromJS(_data["sirket"]) : <any>undefined;
            this.normKadroId = _data["normKadroId"];
            this.normKadro = _data["normKadro"] ? NormKadro.fromJS(_data["normKadro"]) : <any>undefined;
            this.unvanId = _data["unvanId"];
            this.unvan = _data["unvan"] ? Unvan.fromJS(_data["unvan"]) : <any>undefined;
            this.birim = _data["birim"];
            this.sgkIsYeriId = _data["sgkIsYeriId"];
            this.sgkIsYeri = _data["sgkIsYeri"] ? SgkIsyeri.fromJS(_data["sgkIsYeri"]) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.calismaDurumu = _data["calismaDurumu"];
            this.isTel = _data["isTel"];
            this.iseGirisTarihi = _data["iseGirisTarihi"] ? new Date(_data["iseGirisTarihi"].toString()) : <any>undefined;
            this.istenCikisTarihi = _data["istenCikisTarihi"] ? new Date(_data["istenCikisTarihi"].toString()) : <any>undefined;
            this.projeId = _data["projeId"];
            this.proje = _data["proje"] ? Proje.fromJS(_data["proje"]) : <any>undefined;
            this.haklarinBaslagicTarihi = _data["haklarinBaslagicTarihi"] ? new Date(_data["haklarinBaslagicTarihi"].toString()) : <any>undefined;
            this.masrafMerkezi = _data["masrafMerkezi"] ? MasrafMerkezi.fromJS(_data["masrafMerkezi"]) : <any>undefined;
            this.departmanId = _data["departmanId"];
            this.departman = _data["departman"] ? Departman.fromJS(_data["departman"]) : <any>undefined;
            this.mobilTelefon = _data["mobilTelefon"];
            this.ilkAmirId = _data["ilkAmirId"];
            this.ilkAmir = _data["ilkAmir"] ? Person.fromJS(_data["ilkAmir"]) : <any>undefined;
            this.yoneticiId = _data["yoneticiId"];
            this.yonetici = _data["yonetici"] ? Person.fromJS(_data["yonetici"]) : <any>undefined;
            this.isPlatomAppKullanir = _data["isPlatomAppKullanir"];
            if (Array.isArray(_data["ilkAmiriOlduguKadroList"])) {
                this.ilkAmiriOlduguKadroList = [] as any;
                for (let item of _data["ilkAmiriOlduguKadroList"])
                    this.ilkAmiriOlduguKadroList.push(NormKadro.fromJS(item));
            }
            if (Array.isArray(_data["projeSorumlusuOlduguKadroList"])) {
                this.projeSorumlusuOlduguKadroList = [] as any;
                for (let item of _data["projeSorumlusuOlduguKadroList"])
                    this.projeSorumlusuOlduguKadroList.push(NormKadro.fromJS(item));
            }
            if (Array.isArray(_data["yoneticisiOlduguKadroList"])) {
                this.yoneticisiOlduguKadroList = [] as any;
                for (let item of _data["yoneticisiOlduguKadroList"])
                    this.yoneticisiOlduguKadroList.push(NormKadro.fromJS(item));
            }
            if (Array.isArray(_data["ilgiliKisi1OlduguSozlesmeList"])) {
                this.ilgiliKisi1OlduguSozlesmeList = [] as any;
                for (let item of _data["ilgiliKisi1OlduguSozlesmeList"])
                    this.ilgiliKisi1OlduguSozlesmeList.push(Sozlesme.fromJS(item));
            }
            if (Array.isArray(_data["ilgiliKisi2OlduguSozlesmeList"])) {
                this.ilgiliKisi2OlduguSozlesmeList = [] as any;
                for (let item of _data["ilgiliKisi2OlduguSozlesmeList"])
                    this.ilgiliKisi2OlduguSozlesmeList.push(Sozlesme.fromJS(item));
            }
            if (Array.isArray(_data["ilgiliKisi3OlduguSozlesmeList"])) {
                this.ilgiliKisi3OlduguSozlesmeList = [] as any;
                for (let item of _data["ilgiliKisi3OlduguSozlesmeList"])
                    this.ilgiliKisi3OlduguSozlesmeList.push(Sozlesme.fromJS(item));
            }
            if (Array.isArray(_data["ilgiliKisi1OlduguKontratList"])) {
                this.ilgiliKisi1OlduguKontratList = [] as any;
                for (let item of _data["ilgiliKisi1OlduguKontratList"])
                    this.ilgiliKisi1OlduguKontratList.push(Kontrat.fromJS(item));
            }
            if (Array.isArray(_data["ilgiliKisi2OlduguKontratList"])) {
                this.ilgiliKisi2OlduguKontratList = [] as any;
                for (let item of _data["ilgiliKisi2OlduguKontratList"])
                    this.ilgiliKisi2OlduguKontratList.push(Kontrat.fromJS(item));
            }
            if (Array.isArray(_data["ilgiliKisi3OlduguKontratList"])) {
                this.ilgiliKisi3OlduguKontratList = [] as any;
                for (let item of _data["ilgiliKisi3OlduguKontratList"])
                    this.ilgiliKisi3OlduguKontratList.push(Kontrat.fromJS(item));
            }
            if (Array.isArray(_data["istenCikisGorevleri"])) {
                this.istenCikisGorevleri = [] as any;
                for (let item of _data["istenCikisGorevleri"])
                    this.istenCikisGorevleri.push(IstenCikisGorev.fromJS(item));
            }
            if (Array.isArray(_data["istenCikisGorevleriBolgeYoneticisi"])) {
                this.istenCikisGorevleriBolgeYoneticisi = [] as any;
                for (let item of _data["istenCikisGorevleriBolgeYoneticisi"])
                    this.istenCikisGorevleriBolgeYoneticisi.push(IstenCikisGorev.fromJS(item));
            }
            if (Array.isArray(_data["istenCikisGorevleriProjeYoneticisi"])) {
                this.istenCikisGorevleriProjeYoneticisi = [] as any;
                for (let item of _data["istenCikisGorevleriProjeYoneticisi"])
                    this.istenCikisGorevleriProjeYoneticisi.push(IstenCikisGorev.fromJS(item));
            }
            if (Array.isArray(_data["istenCikisGorevleriEkomBolgeSorumlusu"])) {
                this.istenCikisGorevleriEkomBolgeSorumlusu = [] as any;
                for (let item of _data["istenCikisGorevleriEkomBolgeSorumlusu"])
                    this.istenCikisGorevleriEkomBolgeSorumlusu.push(IstenCikisGorev.fromJS(item));
            }
            if (Array.isArray(_data["istenCikisGorevleriIKSorumlusu"])) {
                this.istenCikisGorevleriIKSorumlusu = [] as any;
                for (let item of _data["istenCikisGorevleriIKSorumlusu"])
                    this.istenCikisGorevleriIKSorumlusu.push(IstenCikisGorev.fromJS(item));
            }
            if (Array.isArray(_data["istenCikisGorevleriTalepEden"])) {
                this.istenCikisGorevleriTalepEden = [] as any;
                for (let item of _data["istenCikisGorevleriTalepEden"])
                    this.istenCikisGorevleriTalepEden.push(IstenCikisGorev.fromJS(item));
            }
            if (Array.isArray(_data["iseAlimTalepleri"])) {
                this.iseAlimTalepleri = [] as any;
                for (let item of _data["iseAlimTalepleri"])
                    this.iseAlimTalepleri.push(IseAlimTalep.fromJS(item));
            }
            if (Array.isArray(_data["iseAlimTalepPersonelTakipSorumlusu"])) {
                this.iseAlimTalepPersonelTakipSorumlusu = [] as any;
                for (let item of _data["iseAlimTalepPersonelTakipSorumlusu"])
                    this.iseAlimTalepPersonelTakipSorumlusu.push(IseAlimTalep.fromJS(item));
            }
            if (Array.isArray(_data["iseAlimTalepPersonelAlimOnaycisi"])) {
                this.iseAlimTalepPersonelAlimOnaycisi = [] as any;
                for (let item of _data["iseAlimTalepPersonelAlimOnaycisi"])
                    this.iseAlimTalepPersonelAlimOnaycisi.push(IseAlimTalep.fromJS(item));
            }
            if (Array.isArray(_data["iseAlimTalepPersonelAlimGorevlisi"])) {
                this.iseAlimTalepPersonelAlimGorevlisi = [] as any;
                for (let item of _data["iseAlimTalepPersonelAlimGorevlisi"])
                    this.iseAlimTalepPersonelAlimGorevlisi.push(IseAlimTalep.fromJS(item));
            }
            if (Array.isArray(_data["iseAlimTalepEvrakSorumlusu"])) {
                this.iseAlimTalepEvrakSorumlusu = [] as any;
                for (let item of _data["iseAlimTalepEvrakSorumlusu"])
                    this.iseAlimTalepEvrakSorumlusu.push(IseAlimTalep.fromJS(item));
            }
            if (Array.isArray(_data["musteriCalisaniPersonelList"])) {
                this.musteriCalisaniPersonelList = [] as any;
                for (let item of _data["musteriCalisaniPersonelList"])
                    this.musteriCalisaniPersonelList.push(MusteriCalisani.fromJS(item));
            }
            if (Array.isArray(_data["musteriCalisaniSupevervisorList"])) {
                this.musteriCalisaniSupevervisorList = [] as any;
                for (let item of _data["musteriCalisaniSupevervisorList"])
                    this.musteriCalisaniSupevervisorList.push(MusteriCalisani.fromJS(item));
            }
            if (Array.isArray(_data["isGorusmeleri"])) {
                this.isGorusmeleri = [] as any;
                for (let item of _data["isGorusmeleri"])
                    this.isGorusmeleri.push(IsGorusmesi.fromJS(item));
            }
            if (Array.isArray(_data["projeIkSorumluList"])) {
                this.projeIkSorumluList = [] as any;
                for (let item of _data["projeIkSorumluList"])
                    this.projeIkSorumluList.push(Proje.fromJS(item));
            }
            if (Array.isArray(_data["projePersonelSorumluList"])) {
                this.projePersonelSorumluList = [] as any;
                for (let item of _data["projePersonelSorumluList"])
                    this.projePersonelSorumluList.push(Proje.fromJS(item));
            }
            if (Array.isArray(_data["projeProjeMudurList"])) {
                this.projeProjeMudurList = [] as any;
                for (let item of _data["projeProjeMudurList"])
                    this.projeProjeMudurList.push(Proje.fromJS(item));
            }
            if (Array.isArray(_data["sahaPerformansPersonel"])) {
                this.sahaPerformansPersonel = [] as any;
                for (let item of _data["sahaPerformansPersonel"])
                    this.sahaPerformansPersonel.push(SahaPerformans.fromJS(item));
            }
            if (Array.isArray(_data["sahaPerformansIlkAmir"])) {
                this.sahaPerformansIlkAmir = [] as any;
                for (let item of _data["sahaPerformansIlkAmir"])
                    this.sahaPerformansIlkAmir.push(SahaPerformans.fromJS(item));
            }
            if (Array.isArray(_data["sahaPerformansBolgeMuduru"])) {
                this.sahaPerformansBolgeMuduru = [] as any;
                for (let item of _data["sahaPerformansBolgeMuduru"])
                    this.sahaPerformansBolgeMuduru.push(SahaPerformans.fromJS(item));
            }
            if (Array.isArray(_data["sahaPerformansDirektor"])) {
                this.sahaPerformansDirektor = [] as any;
                for (let item of _data["sahaPerformansDirektor"])
                    this.sahaPerformansDirektor.push(SahaPerformans.fromJS(item));
            }
            if (Array.isArray(_data["magazaPerformansSupervisor"])) {
                this.magazaPerformansSupervisor = [] as any;
                for (let item of _data["magazaPerformansSupervisor"])
                    this.magazaPerformansSupervisor.push(MagazaPerformans.fromJS(item));
            }
            if (Array.isArray(_data["magazaPerformansPersonel"])) {
                this.magazaPerformansPersonel = [] as any;
                for (let item of _data["magazaPerformansPersonel"])
                    this.magazaPerformansPersonel.push(MagazaPerformans.fromJS(item));
            }
            if (Array.isArray(_data["envanterTeslimAlinanlar"])) {
                this.envanterTeslimAlinanlar = [] as any;
                for (let item of _data["envanterTeslimAlinanlar"])
                    this.envanterTeslimAlinanlar.push(Envanter.fromJS(item));
            }
            if (Array.isArray(_data["envanterZimmetlenenler"])) {
                this.envanterZimmetlenenler = [] as any;
                for (let item of _data["envanterZimmetlenenler"])
                    this.envanterZimmetlenenler.push(Envanter.fromJS(item));
            }
            if (Array.isArray(_data["ilkAmiriOlduguPersonelList"])) {
                this.ilkAmiriOlduguPersonelList = [] as any;
                for (let item of _data["ilkAmiriOlduguPersonelList"])
                    this.ilkAmiriOlduguPersonelList.push(Person.fromJS(item));
            }
            if (Array.isArray(_data["yoneticisiOlduguPersonelList"])) {
                this.yoneticisiOlduguPersonelList = [] as any;
                for (let item of _data["yoneticisiOlduguPersonelList"])
                    this.yoneticisiOlduguPersonelList.push(Person.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Person {
        data = typeof data === 'object' ? data : {};
        let result = new Person();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tcNo"] = this.tcNo;
        data["sicilNo"] = this.sicilNo;
        data["cinsiyet"] = this.cinsiyet;
        data["logoWorkArea"] = this.logoWorkArea;
        data["ad"] = this.ad;
        data["soyad"] = this.soyad;
        data["dogumTarihi"] = this.dogumTarihi ? this.dogumTarihi.toISOString() : <any>undefined;
        data["ikPortalUserName"] = this.ikPortalUserName;
        data["ikPortalPassword"] = this.ikPortalPassword;
        data["bugunkiGorevDurumu"] = this.bugunkiGorevDurumu;
        data["adSoyad"] = this.adSoyad;
        data["adSoyadUniversal"] = this.adSoyadUniversal;
        data["sirketId"] = this.sirketId;
        data["sirket"] = this.sirket ? this.sirket.toJSON() : <any>undefined;
        data["normKadroId"] = this.normKadroId;
        data["normKadro"] = this.normKadro ? this.normKadro.toJSON() : <any>undefined;
        data["unvanId"] = this.unvanId;
        data["unvan"] = this.unvan ? this.unvan.toJSON() : <any>undefined;
        data["birim"] = this.birim;
        data["sgkIsYeriId"] = this.sgkIsYeriId;
        data["sgkIsYeri"] = this.sgkIsYeri ? this.sgkIsYeri.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["calismaDurumu"] = this.calismaDurumu;
        data["isTel"] = this.isTel;
        data["iseGirisTarihi"] = this.iseGirisTarihi ? this.iseGirisTarihi.toISOString() : <any>undefined;
        data["istenCikisTarihi"] = this.istenCikisTarihi ? this.istenCikisTarihi.toISOString() : <any>undefined;
        data["projeId"] = this.projeId;
        data["proje"] = this.proje ? this.proje.toJSON() : <any>undefined;
        data["haklarinBaslagicTarihi"] = this.haklarinBaslagicTarihi ? this.haklarinBaslagicTarihi.toISOString() : <any>undefined;
        data["masrafMerkezi"] = this.masrafMerkezi ? this.masrafMerkezi.toJSON() : <any>undefined;
        data["departmanId"] = this.departmanId;
        data["departman"] = this.departman ? this.departman.toJSON() : <any>undefined;
        data["mobilTelefon"] = this.mobilTelefon;
        data["ilkAmirId"] = this.ilkAmirId;
        data["ilkAmir"] = this.ilkAmir ? this.ilkAmir.toJSON() : <any>undefined;
        data["yoneticiId"] = this.yoneticiId;
        data["yonetici"] = this.yonetici ? this.yonetici.toJSON() : <any>undefined;
        data["isPlatomAppKullanir"] = this.isPlatomAppKullanir;
        if (Array.isArray(this.ilkAmiriOlduguKadroList)) {
            data["ilkAmiriOlduguKadroList"] = [];
            for (let item of this.ilkAmiriOlduguKadroList)
                data["ilkAmiriOlduguKadroList"].push(item.toJSON());
        }
        if (Array.isArray(this.projeSorumlusuOlduguKadroList)) {
            data["projeSorumlusuOlduguKadroList"] = [];
            for (let item of this.projeSorumlusuOlduguKadroList)
                data["projeSorumlusuOlduguKadroList"].push(item.toJSON());
        }
        if (Array.isArray(this.yoneticisiOlduguKadroList)) {
            data["yoneticisiOlduguKadroList"] = [];
            for (let item of this.yoneticisiOlduguKadroList)
                data["yoneticisiOlduguKadroList"].push(item.toJSON());
        }
        if (Array.isArray(this.ilgiliKisi1OlduguSozlesmeList)) {
            data["ilgiliKisi1OlduguSozlesmeList"] = [];
            for (let item of this.ilgiliKisi1OlduguSozlesmeList)
                data["ilgiliKisi1OlduguSozlesmeList"].push(item.toJSON());
        }
        if (Array.isArray(this.ilgiliKisi2OlduguSozlesmeList)) {
            data["ilgiliKisi2OlduguSozlesmeList"] = [];
            for (let item of this.ilgiliKisi2OlduguSozlesmeList)
                data["ilgiliKisi2OlduguSozlesmeList"].push(item.toJSON());
        }
        if (Array.isArray(this.ilgiliKisi3OlduguSozlesmeList)) {
            data["ilgiliKisi3OlduguSozlesmeList"] = [];
            for (let item of this.ilgiliKisi3OlduguSozlesmeList)
                data["ilgiliKisi3OlduguSozlesmeList"].push(item.toJSON());
        }
        if (Array.isArray(this.ilgiliKisi1OlduguKontratList)) {
            data["ilgiliKisi1OlduguKontratList"] = [];
            for (let item of this.ilgiliKisi1OlduguKontratList)
                data["ilgiliKisi1OlduguKontratList"].push(item.toJSON());
        }
        if (Array.isArray(this.ilgiliKisi2OlduguKontratList)) {
            data["ilgiliKisi2OlduguKontratList"] = [];
            for (let item of this.ilgiliKisi2OlduguKontratList)
                data["ilgiliKisi2OlduguKontratList"].push(item.toJSON());
        }
        if (Array.isArray(this.ilgiliKisi3OlduguKontratList)) {
            data["ilgiliKisi3OlduguKontratList"] = [];
            for (let item of this.ilgiliKisi3OlduguKontratList)
                data["ilgiliKisi3OlduguKontratList"].push(item.toJSON());
        }
        if (Array.isArray(this.istenCikisGorevleri)) {
            data["istenCikisGorevleri"] = [];
            for (let item of this.istenCikisGorevleri)
                data["istenCikisGorevleri"].push(item.toJSON());
        }
        if (Array.isArray(this.istenCikisGorevleriBolgeYoneticisi)) {
            data["istenCikisGorevleriBolgeYoneticisi"] = [];
            for (let item of this.istenCikisGorevleriBolgeYoneticisi)
                data["istenCikisGorevleriBolgeYoneticisi"].push(item.toJSON());
        }
        if (Array.isArray(this.istenCikisGorevleriProjeYoneticisi)) {
            data["istenCikisGorevleriProjeYoneticisi"] = [];
            for (let item of this.istenCikisGorevleriProjeYoneticisi)
                data["istenCikisGorevleriProjeYoneticisi"].push(item.toJSON());
        }
        if (Array.isArray(this.istenCikisGorevleriEkomBolgeSorumlusu)) {
            data["istenCikisGorevleriEkomBolgeSorumlusu"] = [];
            for (let item of this.istenCikisGorevleriEkomBolgeSorumlusu)
                data["istenCikisGorevleriEkomBolgeSorumlusu"].push(item.toJSON());
        }
        if (Array.isArray(this.istenCikisGorevleriIKSorumlusu)) {
            data["istenCikisGorevleriIKSorumlusu"] = [];
            for (let item of this.istenCikisGorevleriIKSorumlusu)
                data["istenCikisGorevleriIKSorumlusu"].push(item.toJSON());
        }
        if (Array.isArray(this.istenCikisGorevleriTalepEden)) {
            data["istenCikisGorevleriTalepEden"] = [];
            for (let item of this.istenCikisGorevleriTalepEden)
                data["istenCikisGorevleriTalepEden"].push(item.toJSON());
        }
        if (Array.isArray(this.iseAlimTalepleri)) {
            data["iseAlimTalepleri"] = [];
            for (let item of this.iseAlimTalepleri)
                data["iseAlimTalepleri"].push(item.toJSON());
        }
        if (Array.isArray(this.iseAlimTalepPersonelTakipSorumlusu)) {
            data["iseAlimTalepPersonelTakipSorumlusu"] = [];
            for (let item of this.iseAlimTalepPersonelTakipSorumlusu)
                data["iseAlimTalepPersonelTakipSorumlusu"].push(item.toJSON());
        }
        if (Array.isArray(this.iseAlimTalepPersonelAlimOnaycisi)) {
            data["iseAlimTalepPersonelAlimOnaycisi"] = [];
            for (let item of this.iseAlimTalepPersonelAlimOnaycisi)
                data["iseAlimTalepPersonelAlimOnaycisi"].push(item.toJSON());
        }
        if (Array.isArray(this.iseAlimTalepPersonelAlimGorevlisi)) {
            data["iseAlimTalepPersonelAlimGorevlisi"] = [];
            for (let item of this.iseAlimTalepPersonelAlimGorevlisi)
                data["iseAlimTalepPersonelAlimGorevlisi"].push(item.toJSON());
        }
        if (Array.isArray(this.iseAlimTalepEvrakSorumlusu)) {
            data["iseAlimTalepEvrakSorumlusu"] = [];
            for (let item of this.iseAlimTalepEvrakSorumlusu)
                data["iseAlimTalepEvrakSorumlusu"].push(item.toJSON());
        }
        if (Array.isArray(this.musteriCalisaniPersonelList)) {
            data["musteriCalisaniPersonelList"] = [];
            for (let item of this.musteriCalisaniPersonelList)
                data["musteriCalisaniPersonelList"].push(item.toJSON());
        }
        if (Array.isArray(this.musteriCalisaniSupevervisorList)) {
            data["musteriCalisaniSupevervisorList"] = [];
            for (let item of this.musteriCalisaniSupevervisorList)
                data["musteriCalisaniSupevervisorList"].push(item.toJSON());
        }
        if (Array.isArray(this.isGorusmeleri)) {
            data["isGorusmeleri"] = [];
            for (let item of this.isGorusmeleri)
                data["isGorusmeleri"].push(item.toJSON());
        }
        if (Array.isArray(this.projeIkSorumluList)) {
            data["projeIkSorumluList"] = [];
            for (let item of this.projeIkSorumluList)
                data["projeIkSorumluList"].push(item.toJSON());
        }
        if (Array.isArray(this.projePersonelSorumluList)) {
            data["projePersonelSorumluList"] = [];
            for (let item of this.projePersonelSorumluList)
                data["projePersonelSorumluList"].push(item.toJSON());
        }
        if (Array.isArray(this.projeProjeMudurList)) {
            data["projeProjeMudurList"] = [];
            for (let item of this.projeProjeMudurList)
                data["projeProjeMudurList"].push(item.toJSON());
        }
        if (Array.isArray(this.sahaPerformansPersonel)) {
            data["sahaPerformansPersonel"] = [];
            for (let item of this.sahaPerformansPersonel)
                data["sahaPerformansPersonel"].push(item.toJSON());
        }
        if (Array.isArray(this.sahaPerformansIlkAmir)) {
            data["sahaPerformansIlkAmir"] = [];
            for (let item of this.sahaPerformansIlkAmir)
                data["sahaPerformansIlkAmir"].push(item.toJSON());
        }
        if (Array.isArray(this.sahaPerformansBolgeMuduru)) {
            data["sahaPerformansBolgeMuduru"] = [];
            for (let item of this.sahaPerformansBolgeMuduru)
                data["sahaPerformansBolgeMuduru"].push(item.toJSON());
        }
        if (Array.isArray(this.sahaPerformansDirektor)) {
            data["sahaPerformansDirektor"] = [];
            for (let item of this.sahaPerformansDirektor)
                data["sahaPerformansDirektor"].push(item.toJSON());
        }
        if (Array.isArray(this.magazaPerformansSupervisor)) {
            data["magazaPerformansSupervisor"] = [];
            for (let item of this.magazaPerformansSupervisor)
                data["magazaPerformansSupervisor"].push(item.toJSON());
        }
        if (Array.isArray(this.magazaPerformansPersonel)) {
            data["magazaPerformansPersonel"] = [];
            for (let item of this.magazaPerformansPersonel)
                data["magazaPerformansPersonel"].push(item.toJSON());
        }
        if (Array.isArray(this.envanterTeslimAlinanlar)) {
            data["envanterTeslimAlinanlar"] = [];
            for (let item of this.envanterTeslimAlinanlar)
                data["envanterTeslimAlinanlar"].push(item.toJSON());
        }
        if (Array.isArray(this.envanterZimmetlenenler)) {
            data["envanterZimmetlenenler"] = [];
            for (let item of this.envanterZimmetlenenler)
                data["envanterZimmetlenenler"].push(item.toJSON());
        }
        if (Array.isArray(this.ilkAmiriOlduguPersonelList)) {
            data["ilkAmiriOlduguPersonelList"] = [];
            for (let item of this.ilkAmiriOlduguPersonelList)
                data["ilkAmiriOlduguPersonelList"].push(item.toJSON());
        }
        if (Array.isArray(this.yoneticisiOlduguPersonelList)) {
            data["yoneticisiOlduguPersonelList"] = [];
            for (let item of this.yoneticisiOlduguPersonelList)
                data["yoneticisiOlduguPersonelList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Person {
        const json = this.toJSON();
        let result = new Person();
        result.init(json);
        return result;
    }
}

export interface IPerson {
    id: string | undefined;
    tcNo: string | undefined;
    sicilNo: string | undefined;
    cinsiyet: PersonCinsiyet | undefined;
    logoWorkArea: string | undefined;
    ad: string | undefined;
    soyad: string | undefined;
    dogumTarihi: Date | undefined;
    ikPortalUserName: string | undefined;
    ikPortalPassword: string | undefined;
    bugunkiGorevDurumu: PersonBugunkiGorevDurumu | undefined;
    adSoyad: string | undefined;
    adSoyadUniversal: string | undefined;
    sirketId: string | undefined;
    sirket: Sirket | undefined;
    normKadroId: string | undefined;
    normKadro: NormKadro | undefined;
    unvanId: string | undefined;
    unvan: Unvan | undefined;
    birim: string | undefined;
    sgkIsYeriId: string | undefined;
    sgkIsYeri: SgkIsyeri | undefined;
    emailAddress: string | undefined;
    calismaDurumu: PersonCalismaDurumu | undefined;
    isTel: string | undefined;
    iseGirisTarihi: Date | undefined;
    istenCikisTarihi: Date | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    haklarinBaslagicTarihi: Date | undefined;
    masrafMerkezi: MasrafMerkezi | undefined;
    departmanId: string | undefined;
    departman: Departman | undefined;
    mobilTelefon: string | undefined;
    ilkAmirId: string | undefined;
    ilkAmir: Person | undefined;
    yoneticiId: string | undefined;
    yonetici: Person | undefined;
    isPlatomAppKullanir: boolean | undefined;
    ilkAmiriOlduguKadroList: NormKadro[] | undefined;
    projeSorumlusuOlduguKadroList: NormKadro[] | undefined;
    yoneticisiOlduguKadroList: NormKadro[] | undefined;
    ilgiliKisi1OlduguSozlesmeList: Sozlesme[] | undefined;
    ilgiliKisi2OlduguSozlesmeList: Sozlesme[] | undefined;
    ilgiliKisi3OlduguSozlesmeList: Sozlesme[] | undefined;
    ilgiliKisi1OlduguKontratList: Kontrat[] | undefined;
    ilgiliKisi2OlduguKontratList: Kontrat[] | undefined;
    ilgiliKisi3OlduguKontratList: Kontrat[] | undefined;
    istenCikisGorevleri: IstenCikisGorev[] | undefined;
    istenCikisGorevleriBolgeYoneticisi: IstenCikisGorev[] | undefined;
    istenCikisGorevleriProjeYoneticisi: IstenCikisGorev[] | undefined;
    istenCikisGorevleriEkomBolgeSorumlusu: IstenCikisGorev[] | undefined;
    istenCikisGorevleriIKSorumlusu: IstenCikisGorev[] | undefined;
    istenCikisGorevleriTalepEden: IstenCikisGorev[] | undefined;
    iseAlimTalepleri: IseAlimTalep[] | undefined;
    iseAlimTalepPersonelTakipSorumlusu: IseAlimTalep[] | undefined;
    iseAlimTalepPersonelAlimOnaycisi: IseAlimTalep[] | undefined;
    iseAlimTalepPersonelAlimGorevlisi: IseAlimTalep[] | undefined;
    iseAlimTalepEvrakSorumlusu: IseAlimTalep[] | undefined;
    musteriCalisaniPersonelList: MusteriCalisani[] | undefined;
    musteriCalisaniSupevervisorList: MusteriCalisani[] | undefined;
    isGorusmeleri: IsGorusmesi[] | undefined;
    projeIkSorumluList: Proje[] | undefined;
    projePersonelSorumluList: Proje[] | undefined;
    projeProjeMudurList: Proje[] | undefined;
    sahaPerformansPersonel: SahaPerformans[] | undefined;
    sahaPerformansIlkAmir: SahaPerformans[] | undefined;
    sahaPerformansBolgeMuduru: SahaPerformans[] | undefined;
    sahaPerformansDirektor: SahaPerformans[] | undefined;
    magazaPerformansSupervisor: MagazaPerformans[] | undefined;
    magazaPerformansPersonel: MagazaPerformans[] | undefined;
    envanterTeslimAlinanlar: Envanter[] | undefined;
    envanterZimmetlenenler: Envanter[] | undefined;
    ilkAmiriOlduguPersonelList: Person[] | undefined;
    yoneticisiOlduguPersonelList: Person[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class NormKadro implements INormKadro {
    id: string | undefined;
    kadroKodu: string | undefined;
    sozlesmeBitisTarihi: Date | undefined;
    kadroPersoneliId: string | undefined;
    kadroDurumu: NormKadroKadroDurumu | undefined;
    kadroPersoneli: Person | undefined;
    ilkAmirId: string | undefined;
    ilkAmir: Person | undefined;
    projeSorumluId: string | undefined;
    projeSorumlusu: Person | undefined;
    yoneticiId: string | undefined;
    yoneticisi: Person | undefined;
    kadroTipi: NormKadroKadroTipi | undefined;
    calismaSehirId: string | undefined;
    calismaSehri: Sehir | undefined;
    sirketId: string | undefined;
    sirket: Sirket | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    unvanId: string | undefined;
    unvan: Unvan | undefined;
    isGeciciKadro: boolean | undefined;
    personelMerkezDurumu: NormKadroPersonelMerkezDurumu | undefined;
    yanHaklar: YanHak[] | undefined;
    musteriPoiList: PoiMusteri[] | undefined;
    izinOnayGorevleri: IzinOnayGorevi[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: INormKadro) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kadroKodu = _data["kadroKodu"];
            this.sozlesmeBitisTarihi = _data["sozlesmeBitisTarihi"] ? new Date(_data["sozlesmeBitisTarihi"].toString()) : <any>undefined;
            this.kadroPersoneliId = _data["kadroPersoneliId"];
            this.kadroDurumu = _data["kadroDurumu"];
            this.kadroPersoneli = _data["kadroPersoneli"] ? Person.fromJS(_data["kadroPersoneli"]) : <any>undefined;
            this.ilkAmirId = _data["ilkAmirId"];
            this.ilkAmir = _data["ilkAmir"] ? Person.fromJS(_data["ilkAmir"]) : <any>undefined;
            this.projeSorumluId = _data["projeSorumluId"];
            this.projeSorumlusu = _data["projeSorumlusu"] ? Person.fromJS(_data["projeSorumlusu"]) : <any>undefined;
            this.yoneticiId = _data["yoneticiId"];
            this.yoneticisi = _data["yoneticisi"] ? Person.fromJS(_data["yoneticisi"]) : <any>undefined;
            this.kadroTipi = _data["kadroTipi"];
            this.calismaSehirId = _data["calismaSehirId"];
            this.calismaSehri = _data["calismaSehri"] ? Sehir.fromJS(_data["calismaSehri"]) : <any>undefined;
            this.sirketId = _data["sirketId"];
            this.sirket = _data["sirket"] ? Sirket.fromJS(_data["sirket"]) : <any>undefined;
            this.projeId = _data["projeId"];
            this.proje = _data["proje"] ? Proje.fromJS(_data["proje"]) : <any>undefined;
            this.unvanId = _data["unvanId"];
            this.unvan = _data["unvan"] ? Unvan.fromJS(_data["unvan"]) : <any>undefined;
            this.isGeciciKadro = _data["isGeciciKadro"];
            this.personelMerkezDurumu = _data["personelMerkezDurumu"];
            if (Array.isArray(_data["yanHaklar"])) {
                this.yanHaklar = [] as any;
                for (let item of _data["yanHaklar"])
                    this.yanHaklar.push(YanHak.fromJS(item));
            }
            if (Array.isArray(_data["musteriPoiList"])) {
                this.musteriPoiList = [] as any;
                for (let item of _data["musteriPoiList"])
                    this.musteriPoiList.push(PoiMusteri.fromJS(item));
            }
            if (Array.isArray(_data["izinOnayGorevleri"])) {
                this.izinOnayGorevleri = [] as any;
                for (let item of _data["izinOnayGorevleri"])
                    this.izinOnayGorevleri.push(IzinOnayGorevi.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): NormKadro {
        data = typeof data === 'object' ? data : {};
        let result = new NormKadro();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kadroKodu"] = this.kadroKodu;
        data["sozlesmeBitisTarihi"] = this.sozlesmeBitisTarihi ? this.sozlesmeBitisTarihi.toISOString() : <any>undefined;
        data["kadroPersoneliId"] = this.kadroPersoneliId;
        data["kadroDurumu"] = this.kadroDurumu;
        data["kadroPersoneli"] = this.kadroPersoneli ? this.kadroPersoneli.toJSON() : <any>undefined;
        data["ilkAmirId"] = this.ilkAmirId;
        data["ilkAmir"] = this.ilkAmir ? this.ilkAmir.toJSON() : <any>undefined;
        data["projeSorumluId"] = this.projeSorumluId;
        data["projeSorumlusu"] = this.projeSorumlusu ? this.projeSorumlusu.toJSON() : <any>undefined;
        data["yoneticiId"] = this.yoneticiId;
        data["yoneticisi"] = this.yoneticisi ? this.yoneticisi.toJSON() : <any>undefined;
        data["kadroTipi"] = this.kadroTipi;
        data["calismaSehirId"] = this.calismaSehirId;
        data["calismaSehri"] = this.calismaSehri ? this.calismaSehri.toJSON() : <any>undefined;
        data["sirketId"] = this.sirketId;
        data["sirket"] = this.sirket ? this.sirket.toJSON() : <any>undefined;
        data["projeId"] = this.projeId;
        data["proje"] = this.proje ? this.proje.toJSON() : <any>undefined;
        data["unvanId"] = this.unvanId;
        data["unvan"] = this.unvan ? this.unvan.toJSON() : <any>undefined;
        data["isGeciciKadro"] = this.isGeciciKadro;
        data["personelMerkezDurumu"] = this.personelMerkezDurumu;
        if (Array.isArray(this.yanHaklar)) {
            data["yanHaklar"] = [];
            for (let item of this.yanHaklar)
                data["yanHaklar"].push(item.toJSON());
        }
        if (Array.isArray(this.musteriPoiList)) {
            data["musteriPoiList"] = [];
            for (let item of this.musteriPoiList)
                data["musteriPoiList"].push(item.toJSON());
        }
        if (Array.isArray(this.izinOnayGorevleri)) {
            data["izinOnayGorevleri"] = [];
            for (let item of this.izinOnayGorevleri)
                data["izinOnayGorevleri"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): NormKadro {
        const json = this.toJSON();
        let result = new NormKadro();
        result.init(json);
        return result;
    }
}

export interface INormKadro {
    id: string | undefined;
    kadroKodu: string | undefined;
    sozlesmeBitisTarihi: Date | undefined;
    kadroPersoneliId: string | undefined;
    kadroDurumu: NormKadroKadroDurumu | undefined;
    kadroPersoneli: Person | undefined;
    ilkAmirId: string | undefined;
    ilkAmir: Person | undefined;
    projeSorumluId: string | undefined;
    projeSorumlusu: Person | undefined;
    yoneticiId: string | undefined;
    yoneticisi: Person | undefined;
    kadroTipi: NormKadroKadroTipi | undefined;
    calismaSehirId: string | undefined;
    calismaSehri: Sehir | undefined;
    sirketId: string | undefined;
    sirket: Sirket | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    unvanId: string | undefined;
    unvan: Unvan | undefined;
    isGeciciKadro: boolean | undefined;
    personelMerkezDurumu: NormKadroPersonelMerkezDurumu | undefined;
    yanHaklar: YanHak[] | undefined;
    musteriPoiList: PoiMusteri[] | undefined;
    izinOnayGorevleri: IzinOnayGorevi[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class KullaniciProjesi implements IKullaniciProjesi {
    id: string | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IKullaniciProjesi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personelId = _data["personelId"];
            this.personel = _data["personel"] ? Person.fromJS(_data["personel"]) : <any>undefined;
            this.projeId = _data["projeId"];
            this.proje = _data["proje"] ? Proje.fromJS(_data["proje"]) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): KullaniciProjesi {
        data = typeof data === 'object' ? data : {};
        let result = new KullaniciProjesi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personelId"] = this.personelId;
        data["personel"] = this.personel ? this.personel.toJSON() : <any>undefined;
        data["projeId"] = this.projeId;
        data["proje"] = this.proje ? this.proje.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): KullaniciProjesi {
        const json = this.toJSON();
        let result = new KullaniciProjesi();
        result.init(json);
        return result;
    }
}

export interface IKullaniciProjesi {
    id: string | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class Kpi implements IKpi {
    id: string | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    kod: string | undefined;
    sahaPerformansList: SahaPerformans[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IKpi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projeId = _data["projeId"];
            this.proje = _data["proje"] ? Proje.fromJS(_data["proje"]) : <any>undefined;
            this.kod = _data["kod"];
            if (Array.isArray(_data["sahaPerformansList"])) {
                this.sahaPerformansList = [] as any;
                for (let item of _data["sahaPerformansList"])
                    this.sahaPerformansList.push(SahaPerformans.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Kpi {
        data = typeof data === 'object' ? data : {};
        let result = new Kpi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projeId"] = this.projeId;
        data["proje"] = this.proje ? this.proje.toJSON() : <any>undefined;
        data["kod"] = this.kod;
        if (Array.isArray(this.sahaPerformansList)) {
            data["sahaPerformansList"] = [];
            for (let item of this.sahaPerformansList)
                data["sahaPerformansList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Kpi {
        const json = this.toJSON();
        let result = new Kpi();
        result.init(json);
        return result;
    }
}

export interface IKpi {
    id: string | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    kod: string | undefined;
    sahaPerformansList: SahaPerformans[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class PoiMusteri implements IPoiMusteri {
    id: string | undefined;
    genelPoiId: string | undefined;
    poiGenel: PoiGenel | undefined;
    accountId: string | undefined;
    kod: string | undefined;
    musteriNoktaAdi: string | undefined;
    ekomLocationId: number | undefined;
    musteriMagazaKodu: string | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    bolge: string | undefined;
    enlem: number | undefined;
    boylam: number | undefined;
    ziyarettekiAktifPersonelId: string | undefined;
    ziyarettekiAktifPersonel: Person | undefined;
    bugunkiZiyaretDurumu: PoiMusteriBugunkiZiyaretDurumu | undefined;
    acikAdres: string | undefined;
    kanal1: string | undefined;
    kanal2: string | undefined;
    bagliNormKadroId: string | undefined;
    bagliNormKadro: NormKadro | undefined;
    metreKare: PoiMusteriMetreKare | undefined;
    isAvmIci: boolean | undefined;
    hasOtopark: boolean | undefined;
    kasaSayisi: number | undefined;
    teshirAlaniSayisi: number | undefined;
    ziyaretKabulMesafesi: number | undefined;
    konumaUzaklik: number | undefined;
    kapsayanMerchPersonelId: string | undefined;
    kapsayanMerchPersonel: Person | undefined;
    kapsayanSupervisorPersonelId: string | undefined;
    kapsayanSupervisorPersonel: Person | undefined;
    kapsayanKoordinatorPersonelId: string | undefined;
    kapsayanKoordinatorPersonel: Person | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IPoiMusteri) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.genelPoiId = _data["genelPoiId"];
            this.poiGenel = _data["poiGenel"] ? PoiGenel.fromJS(_data["poiGenel"]) : <any>undefined;
            this.accountId = _data["accountId"];
            this.kod = _data["kod"];
            this.musteriNoktaAdi = _data["musteriNoktaAdi"];
            this.ekomLocationId = _data["ekomLocationId"];
            this.musteriMagazaKodu = _data["musteriMagazaKodu"];
            this.projeId = _data["projeId"];
            this.proje = _data["proje"] ? Proje.fromJS(_data["proje"]) : <any>undefined;
            this.bolge = _data["bolge"];
            this.enlem = _data["enlem"];
            this.boylam = _data["boylam"];
            this.ziyarettekiAktifPersonelId = _data["ziyarettekiAktifPersonelId"];
            this.ziyarettekiAktifPersonel = _data["ziyarettekiAktifPersonel"] ? Person.fromJS(_data["ziyarettekiAktifPersonel"]) : <any>undefined;
            this.bugunkiZiyaretDurumu = _data["bugunkiZiyaretDurumu"];
            this.acikAdres = _data["acikAdres"];
            this.kanal1 = _data["kanal1"];
            this.kanal2 = _data["kanal2"];
            this.bagliNormKadroId = _data["bagliNormKadroId"];
            this.bagliNormKadro = _data["bagliNormKadro"] ? NormKadro.fromJS(_data["bagliNormKadro"]) : <any>undefined;
            this.metreKare = _data["metreKare"];
            this.isAvmIci = _data["isAvmIci"];
            this.hasOtopark = _data["hasOtopark"];
            this.kasaSayisi = _data["kasaSayisi"];
            this.teshirAlaniSayisi = _data["teshirAlaniSayisi"];
            this.ziyaretKabulMesafesi = _data["ziyaretKabulMesafesi"];
            this.konumaUzaklik = _data["konumaUzaklik"];
            this.kapsayanMerchPersonelId = _data["kapsayanMerchPersonelId"];
            this.kapsayanMerchPersonel = _data["kapsayanMerchPersonel"] ? Person.fromJS(_data["kapsayanMerchPersonel"]) : <any>undefined;
            this.kapsayanSupervisorPersonelId = _data["kapsayanSupervisorPersonelId"];
            this.kapsayanSupervisorPersonel = _data["kapsayanSupervisorPersonel"] ? Person.fromJS(_data["kapsayanSupervisorPersonel"]) : <any>undefined;
            this.kapsayanKoordinatorPersonelId = _data["kapsayanKoordinatorPersonelId"];
            this.kapsayanKoordinatorPersonel = _data["kapsayanKoordinatorPersonel"] ? Person.fromJS(_data["kapsayanKoordinatorPersonel"]) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): PoiMusteri {
        data = typeof data === 'object' ? data : {};
        let result = new PoiMusteri();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["genelPoiId"] = this.genelPoiId;
        data["poiGenel"] = this.poiGenel ? this.poiGenel.toJSON() : <any>undefined;
        data["accountId"] = this.accountId;
        data["kod"] = this.kod;
        data["musteriNoktaAdi"] = this.musteriNoktaAdi;
        data["ekomLocationId"] = this.ekomLocationId;
        data["musteriMagazaKodu"] = this.musteriMagazaKodu;
        data["projeId"] = this.projeId;
        data["proje"] = this.proje ? this.proje.toJSON() : <any>undefined;
        data["bolge"] = this.bolge;
        data["enlem"] = this.enlem;
        data["boylam"] = this.boylam;
        data["ziyarettekiAktifPersonelId"] = this.ziyarettekiAktifPersonelId;
        data["ziyarettekiAktifPersonel"] = this.ziyarettekiAktifPersonel ? this.ziyarettekiAktifPersonel.toJSON() : <any>undefined;
        data["bugunkiZiyaretDurumu"] = this.bugunkiZiyaretDurumu;
        data["acikAdres"] = this.acikAdres;
        data["kanal1"] = this.kanal1;
        data["kanal2"] = this.kanal2;
        data["bagliNormKadroId"] = this.bagliNormKadroId;
        data["bagliNormKadro"] = this.bagliNormKadro ? this.bagliNormKadro.toJSON() : <any>undefined;
        data["metreKare"] = this.metreKare;
        data["isAvmIci"] = this.isAvmIci;
        data["hasOtopark"] = this.hasOtopark;
        data["kasaSayisi"] = this.kasaSayisi;
        data["teshirAlaniSayisi"] = this.teshirAlaniSayisi;
        data["ziyaretKabulMesafesi"] = this.ziyaretKabulMesafesi;
        data["konumaUzaklik"] = this.konumaUzaklik;
        data["kapsayanMerchPersonelId"] = this.kapsayanMerchPersonelId;
        data["kapsayanMerchPersonel"] = this.kapsayanMerchPersonel ? this.kapsayanMerchPersonel.toJSON() : <any>undefined;
        data["kapsayanSupervisorPersonelId"] = this.kapsayanSupervisorPersonelId;
        data["kapsayanSupervisorPersonel"] = this.kapsayanSupervisorPersonel ? this.kapsayanSupervisorPersonel.toJSON() : <any>undefined;
        data["kapsayanKoordinatorPersonelId"] = this.kapsayanKoordinatorPersonelId;
        data["kapsayanKoordinatorPersonel"] = this.kapsayanKoordinatorPersonel ? this.kapsayanKoordinatorPersonel.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): PoiMusteri {
        const json = this.toJSON();
        let result = new PoiMusteri();
        result.init(json);
        return result;
    }
}

export interface IPoiMusteri {
    id: string | undefined;
    genelPoiId: string | undefined;
    poiGenel: PoiGenel | undefined;
    accountId: string | undefined;
    kod: string | undefined;
    musteriNoktaAdi: string | undefined;
    ekomLocationId: number | undefined;
    musteriMagazaKodu: string | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    bolge: string | undefined;
    enlem: number | undefined;
    boylam: number | undefined;
    ziyarettekiAktifPersonelId: string | undefined;
    ziyarettekiAktifPersonel: Person | undefined;
    bugunkiZiyaretDurumu: PoiMusteriBugunkiZiyaretDurumu | undefined;
    acikAdres: string | undefined;
    kanal1: string | undefined;
    kanal2: string | undefined;
    bagliNormKadroId: string | undefined;
    bagliNormKadro: NormKadro | undefined;
    metreKare: PoiMusteriMetreKare | undefined;
    isAvmIci: boolean | undefined;
    hasOtopark: boolean | undefined;
    kasaSayisi: number | undefined;
    teshirAlaniSayisi: number | undefined;
    ziyaretKabulMesafesi: number | undefined;
    konumaUzaklik: number | undefined;
    kapsayanMerchPersonelId: string | undefined;
    kapsayanMerchPersonel: Person | undefined;
    kapsayanSupervisorPersonelId: string | undefined;
    kapsayanSupervisorPersonel: Person | undefined;
    kapsayanKoordinatorPersonelId: string | undefined;
    kapsayanKoordinatorPersonel: Person | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class GsmTarife implements IGsmTarife {
    id: string | undefined;
    ucret: number | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IGsmTarife) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ucret = _data["ucret"];
            this.projeId = _data["projeId"];
            this.proje = _data["proje"] ? Proje.fromJS(_data["proje"]) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): GsmTarife {
        data = typeof data === 'object' ? data : {};
        let result = new GsmTarife();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ucret"] = this.ucret;
        data["projeId"] = this.projeId;
        data["proje"] = this.proje ? this.proje.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): GsmTarife {
        const json = this.toJSON();
        let result = new GsmTarife();
        result.init(json);
        return result;
    }
}

export interface IGsmTarife {
    id: string | undefined;
    ucret: number | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class GorevForm implements IGorevForm {
    id: string | undefined;
    aciklama: string | undefined;
    tasarimJson: string | undefined;
    isSerbestForm: boolean | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    ekranList: GorevFormEkran[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IGorevForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.aciklama = _data["aciklama"];
            this.tasarimJson = _data["tasarimJson"];
            this.isSerbestForm = _data["isSerbestForm"];
            this.projeId = _data["projeId"];
            this.proje = _data["proje"] ? Proje.fromJS(_data["proje"]) : <any>undefined;
            if (Array.isArray(_data["ekranList"])) {
                this.ekranList = [] as any;
                for (let item of _data["ekranList"])
                    this.ekranList.push(GorevFormEkran.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): GorevForm {
        data = typeof data === 'object' ? data : {};
        let result = new GorevForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["aciklama"] = this.aciklama;
        data["tasarimJson"] = this.tasarimJson;
        data["isSerbestForm"] = this.isSerbestForm;
        data["projeId"] = this.projeId;
        data["proje"] = this.proje ? this.proje.toJSON() : <any>undefined;
        if (Array.isArray(this.ekranList)) {
            data["ekranList"] = [];
            for (let item of this.ekranList)
                data["ekranList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): GorevForm {
        const json = this.toJSON();
        let result = new GorevForm();
        result.init(json);
        return result;
    }
}

export interface IGorevForm {
    id: string | undefined;
    aciklama: string | undefined;
    tasarimJson: string | undefined;
    isSerbestForm: boolean | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    ekranList: GorevFormEkran[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class Ilce implements IIlce {
    id: string | undefined;
    sehirId: string | undefined;
    sehir: Sehir | undefined;
    ilceAdi: string | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IIlce) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sehirId = _data["sehirId"];
            this.sehir = _data["sehir"] ? Sehir.fromJS(_data["sehir"]) : <any>undefined;
            this.ilceAdi = _data["ilceAdi"];
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Ilce {
        data = typeof data === 'object' ? data : {};
        let result = new Ilce();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sehirId"] = this.sehirId;
        data["sehir"] = this.sehir ? this.sehir.toJSON() : <any>undefined;
        data["ilceAdi"] = this.ilceAdi;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Ilce {
        const json = this.toJSON();
        let result = new Ilce();
        result.init(json);
        return result;
    }
}

export interface IIlce {
    id: string | undefined;
    sehirId: string | undefined;
    sehir: Sehir | undefined;
    ilceAdi: string | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class EnvanterTipi implements IEnvanterTipi {
    id: string | undefined;
    kod: string | undefined;
    iconClassName: string | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IEnvanterTipi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kod = _data["kod"];
            this.iconClassName = _data["iconClassName"];
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): EnvanterTipi {
        data = typeof data === 'object' ? data : {};
        let result = new EnvanterTipi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kod"] = this.kod;
        data["iconClassName"] = this.iconClassName;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): EnvanterTipi {
        const json = this.toJSON();
        let result = new EnvanterTipi();
        result.init(json);
        return result;
    }
}

export interface IEnvanterTipi {
    id: string | undefined;
    kod: string | undefined;
    iconClassName: string | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class EkomLokasyon implements IEkomLokasyon {
    id: string | undefined;
    adres: string | undefined;
    konumLink: string | undefined;
    yetkiliId: string | undefined;
    yetkili: Person | undefined;
    telefon: string | undefined;
    sehirId: string | undefined;
    sehir: Sehir | undefined;
    ilceId: string | undefined;
    ilce: Ilce | undefined;
    yurticiKargoGondericiOdemeliApiKullaniciAdi: string | undefined;
    yurticiKargoGondericiOdemeliApiSifre: string | undefined;
    yurticiKargoMusteriNo: string | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IEkomLokasyon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.adres = _data["adres"];
            this.konumLink = _data["konumLink"];
            this.yetkiliId = _data["yetkiliId"];
            this.yetkili = _data["yetkili"] ? Person.fromJS(_data["yetkili"]) : <any>undefined;
            this.telefon = _data["telefon"];
            this.sehirId = _data["sehirId"];
            this.sehir = _data["sehir"] ? Sehir.fromJS(_data["sehir"]) : <any>undefined;
            this.ilceId = _data["ilceId"];
            this.ilce = _data["ilce"] ? Ilce.fromJS(_data["ilce"]) : <any>undefined;
            this.yurticiKargoGondericiOdemeliApiKullaniciAdi = _data["yurticiKargoGondericiOdemeliApiKullaniciAdi"];
            this.yurticiKargoGondericiOdemeliApiSifre = _data["yurticiKargoGondericiOdemeliApiSifre"];
            this.yurticiKargoMusteriNo = _data["yurticiKargoMusteriNo"];
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): EkomLokasyon {
        data = typeof data === 'object' ? data : {};
        let result = new EkomLokasyon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["adres"] = this.adres;
        data["konumLink"] = this.konumLink;
        data["yetkiliId"] = this.yetkiliId;
        data["yetkili"] = this.yetkili ? this.yetkili.toJSON() : <any>undefined;
        data["telefon"] = this.telefon;
        data["sehirId"] = this.sehirId;
        data["sehir"] = this.sehir ? this.sehir.toJSON() : <any>undefined;
        data["ilceId"] = this.ilceId;
        data["ilce"] = this.ilce ? this.ilce.toJSON() : <any>undefined;
        data["yurticiKargoGondericiOdemeliApiKullaniciAdi"] = this.yurticiKargoGondericiOdemeliApiKullaniciAdi;
        data["yurticiKargoGondericiOdemeliApiSifre"] = this.yurticiKargoGondericiOdemeliApiSifre;
        data["yurticiKargoMusteriNo"] = this.yurticiKargoMusteriNo;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): EkomLokasyon {
        const json = this.toJSON();
        let result = new EkomLokasyon();
        result.init(json);
        return result;
    }
}

export interface IEkomLokasyon {
    id: string | undefined;
    adres: string | undefined;
    konumLink: string | undefined;
    yetkiliId: string | undefined;
    yetkili: Person | undefined;
    telefon: string | undefined;
    sehirId: string | undefined;
    sehir: Sehir | undefined;
    ilceId: string | undefined;
    ilce: Ilce | undefined;
    yurticiKargoGondericiOdemeliApiKullaniciAdi: string | undefined;
    yurticiKargoGondericiOdemeliApiSifre: string | undefined;
    yurticiKargoMusteriNo: string | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class MasrafKalemi implements IMasrafKalemi {
    id: string | undefined;
    masrafFormId: string | undefined;
    masrafFormu: MasrafFormu | undefined;
    sirketId: string | undefined;
    sirket: Sirket | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    masrafMerkeziId: string | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    odemeTipi: MasrafKalemiOdemeTipi | undefined;
    tutar: number | undefined;
    tarih: Date | undefined;
    masrafKategoriId: string | undefined;
    masrafKategori: MasrafAnaKategori | undefined;
    kdvOrani: MasrafKalemiKdvOrani | undefined;
    onayDurumu: MasrafKalemiOnayDurumu | undefined;
    aciklama: string | undefined;
    reddedilmeNedeni: string | undefined;
    reddeden: string | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IMasrafKalemi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.masrafFormId = _data["masrafFormId"];
            this.masrafFormu = _data["masrafFormu"] ? MasrafFormu.fromJS(_data["masrafFormu"]) : <any>undefined;
            this.sirketId = _data["sirketId"];
            this.sirket = _data["sirket"] ? Sirket.fromJS(_data["sirket"]) : <any>undefined;
            this.projeId = _data["projeId"];
            this.proje = _data["proje"] ? Proje.fromJS(_data["proje"]) : <any>undefined;
            this.masrafMerkeziId = _data["masrafMerkeziId"];
            this.personelId = _data["personelId"];
            this.personel = _data["personel"] ? Person.fromJS(_data["personel"]) : <any>undefined;
            this.odemeTipi = _data["odemeTipi"];
            this.tutar = _data["tutar"];
            this.tarih = _data["tarih"] ? new Date(_data["tarih"].toString()) : <any>undefined;
            this.masrafKategoriId = _data["masrafKategoriId"];
            this.masrafKategori = _data["masrafKategori"] ? MasrafAnaKategori.fromJS(_data["masrafKategori"]) : <any>undefined;
            this.kdvOrani = _data["kdvOrani"];
            this.onayDurumu = _data["onayDurumu"];
            this.aciklama = _data["aciklama"];
            this.reddedilmeNedeni = _data["reddedilmeNedeni"];
            this.reddeden = _data["reddeden"];
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): MasrafKalemi {
        data = typeof data === 'object' ? data : {};
        let result = new MasrafKalemi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["masrafFormId"] = this.masrafFormId;
        data["masrafFormu"] = this.masrafFormu ? this.masrafFormu.toJSON() : <any>undefined;
        data["sirketId"] = this.sirketId;
        data["sirket"] = this.sirket ? this.sirket.toJSON() : <any>undefined;
        data["projeId"] = this.projeId;
        data["proje"] = this.proje ? this.proje.toJSON() : <any>undefined;
        data["masrafMerkeziId"] = this.masrafMerkeziId;
        data["personelId"] = this.personelId;
        data["personel"] = this.personel ? this.personel.toJSON() : <any>undefined;
        data["odemeTipi"] = this.odemeTipi;
        data["tutar"] = this.tutar;
        data["tarih"] = this.tarih ? this.tarih.toISOString() : <any>undefined;
        data["masrafKategoriId"] = this.masrafKategoriId;
        data["masrafKategori"] = this.masrafKategori ? this.masrafKategori.toJSON() : <any>undefined;
        data["kdvOrani"] = this.kdvOrani;
        data["onayDurumu"] = this.onayDurumu;
        data["aciklama"] = this.aciklama;
        data["reddedilmeNedeni"] = this.reddedilmeNedeni;
        data["reddeden"] = this.reddeden;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): MasrafKalemi {
        const json = this.toJSON();
        let result = new MasrafKalemi();
        result.init(json);
        return result;
    }
}

export interface IMasrafKalemi {
    id: string | undefined;
    masrafFormId: string | undefined;
    masrafFormu: MasrafFormu | undefined;
    sirketId: string | undefined;
    sirket: Sirket | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    masrafMerkeziId: string | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    odemeTipi: MasrafKalemiOdemeTipi | undefined;
    tutar: number | undefined;
    tarih: Date | undefined;
    masrafKategoriId: string | undefined;
    masrafKategori: MasrafAnaKategori | undefined;
    kdvOrani: MasrafKalemiKdvOrani | undefined;
    onayDurumu: MasrafKalemiOnayDurumu | undefined;
    aciklama: string | undefined;
    reddedilmeNedeni: string | undefined;
    reddeden: string | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class Unvan implements IUnvan {
    id: string | undefined;
    kod: string | undefined;
    normKadrolar: NormKadro[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IUnvan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kod = _data["kod"];
            if (Array.isArray(_data["normKadrolar"])) {
                this.normKadrolar = [] as any;
                for (let item of _data["normKadrolar"])
                    this.normKadrolar.push(NormKadro.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Unvan {
        data = typeof data === 'object' ? data : {};
        let result = new Unvan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kod"] = this.kod;
        if (Array.isArray(this.normKadrolar)) {
            data["normKadrolar"] = [];
            for (let item of this.normKadrolar)
                data["normKadrolar"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Unvan {
        const json = this.toJSON();
        let result = new Unvan();
        result.init(json);
        return result;
    }
}

export interface IUnvan {
    id: string | undefined;
    kod: string | undefined;
    normKadrolar: NormKadro[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class SgkIsyeri implements ISgkIsyeri {
    id: string | undefined;
    personelList: Person[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: ISgkIsyeri) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["personelList"])) {
                this.personelList = [] as any;
                for (let item of _data["personelList"])
                    this.personelList.push(Person.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): SgkIsyeri {
        data = typeof data === 'object' ? data : {};
        let result = new SgkIsyeri();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.personelList)) {
            data["personelList"] = [];
            for (let item of this.personelList)
                data["personelList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): SgkIsyeri {
        const json = this.toJSON();
        let result = new SgkIsyeri();
        result.init(json);
        return result;
    }
}

export interface ISgkIsyeri {
    id: string | undefined;
    personelList: Person[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class MasrafMerkezi implements IMasrafMerkezi {
    id: string | undefined;
    kod: string | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IMasrafMerkezi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kod = _data["kod"];
            this.personelId = _data["personelId"];
            this.personel = _data["personel"] ? Person.fromJS(_data["personel"]) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): MasrafMerkezi {
        data = typeof data === 'object' ? data : {};
        let result = new MasrafMerkezi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kod"] = this.kod;
        data["personelId"] = this.personelId;
        data["personel"] = this.personel ? this.personel.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): MasrafMerkezi {
        const json = this.toJSON();
        let result = new MasrafMerkezi();
        result.init(json);
        return result;
    }
}

export interface IMasrafMerkezi {
    id: string | undefined;
    kod: string | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class Departman implements IDepartman {
    id: string | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IDepartman) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Departman {
        data = typeof data === 'object' ? data : {};
        let result = new Departman();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Departman {
        const json = this.toJSON();
        let result = new Departman();
        result.init(json);
        return result;
    }
}

export interface IDepartman {
    id: string | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class Sozlesme implements ISozlesme {
    id: string | undefined;
    konu: string | undefined;
    sozlesmeNo: string | undefined;
    baslangicTarihi: Date | undefined;
    bitisTarihi: Date | undefined;
    hatirlatmaTarihi1: Date | undefined;
    hatirlatmaTarihi2: Date | undefined;
    ilgiliKisi1Id: string | undefined;
    ilgiliKisi1: Person | undefined;
    ilgiliKisi2Id: string | undefined;
    ilgiliKisi2: Person | undefined;
    ilgiliKisi3Id: string | undefined;
    ilgiliKisi3: Person | undefined;
    yenilemeSekli: SozlesmeYenilemeSekli | undefined;
    sozlesmeTipi: SozlesmeTipi | undefined;
    firmaId: string | undefined;
    firma: Firma | undefined;
    sozlesmeDurumu: SozlesmeDurumu | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: ISozlesme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.konu = _data["konu"];
            this.sozlesmeNo = _data["sozlesmeNo"];
            this.baslangicTarihi = _data["baslangicTarihi"] ? new Date(_data["baslangicTarihi"].toString()) : <any>undefined;
            this.bitisTarihi = _data["bitisTarihi"] ? new Date(_data["bitisTarihi"].toString()) : <any>undefined;
            this.hatirlatmaTarihi1 = _data["hatirlatmaTarihi1"] ? new Date(_data["hatirlatmaTarihi1"].toString()) : <any>undefined;
            this.hatirlatmaTarihi2 = _data["hatirlatmaTarihi2"] ? new Date(_data["hatirlatmaTarihi2"].toString()) : <any>undefined;
            this.ilgiliKisi1Id = _data["ilgiliKisi1Id"];
            this.ilgiliKisi1 = _data["ilgiliKisi1"] ? Person.fromJS(_data["ilgiliKisi1"]) : <any>undefined;
            this.ilgiliKisi2Id = _data["ilgiliKisi2Id"];
            this.ilgiliKisi2 = _data["ilgiliKisi2"] ? Person.fromJS(_data["ilgiliKisi2"]) : <any>undefined;
            this.ilgiliKisi3Id = _data["ilgiliKisi3Id"];
            this.ilgiliKisi3 = _data["ilgiliKisi3"] ? Person.fromJS(_data["ilgiliKisi3"]) : <any>undefined;
            this.yenilemeSekli = _data["yenilemeSekli"];
            this.sozlesmeTipi = _data["sozlesmeTipi"];
            this.firmaId = _data["firmaId"];
            this.firma = _data["firma"] ? Firma.fromJS(_data["firma"]) : <any>undefined;
            this.sozlesmeDurumu = _data["sozlesmeDurumu"];
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Sozlesme {
        data = typeof data === 'object' ? data : {};
        let result = new Sozlesme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["konu"] = this.konu;
        data["sozlesmeNo"] = this.sozlesmeNo;
        data["baslangicTarihi"] = this.baslangicTarihi ? this.baslangicTarihi.toISOString() : <any>undefined;
        data["bitisTarihi"] = this.bitisTarihi ? this.bitisTarihi.toISOString() : <any>undefined;
        data["hatirlatmaTarihi1"] = this.hatirlatmaTarihi1 ? this.hatirlatmaTarihi1.toISOString() : <any>undefined;
        data["hatirlatmaTarihi2"] = this.hatirlatmaTarihi2 ? this.hatirlatmaTarihi2.toISOString() : <any>undefined;
        data["ilgiliKisi1Id"] = this.ilgiliKisi1Id;
        data["ilgiliKisi1"] = this.ilgiliKisi1 ? this.ilgiliKisi1.toJSON() : <any>undefined;
        data["ilgiliKisi2Id"] = this.ilgiliKisi2Id;
        data["ilgiliKisi2"] = this.ilgiliKisi2 ? this.ilgiliKisi2.toJSON() : <any>undefined;
        data["ilgiliKisi3Id"] = this.ilgiliKisi3Id;
        data["ilgiliKisi3"] = this.ilgiliKisi3 ? this.ilgiliKisi3.toJSON() : <any>undefined;
        data["yenilemeSekli"] = this.yenilemeSekli;
        data["sozlesmeTipi"] = this.sozlesmeTipi;
        data["firmaId"] = this.firmaId;
        data["firma"] = this.firma ? this.firma.toJSON() : <any>undefined;
        data["sozlesmeDurumu"] = this.sozlesmeDurumu;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Sozlesme {
        const json = this.toJSON();
        let result = new Sozlesme();
        result.init(json);
        return result;
    }
}

export interface ISozlesme {
    id: string | undefined;
    konu: string | undefined;
    sozlesmeNo: string | undefined;
    baslangicTarihi: Date | undefined;
    bitisTarihi: Date | undefined;
    hatirlatmaTarihi1: Date | undefined;
    hatirlatmaTarihi2: Date | undefined;
    ilgiliKisi1Id: string | undefined;
    ilgiliKisi1: Person | undefined;
    ilgiliKisi2Id: string | undefined;
    ilgiliKisi2: Person | undefined;
    ilgiliKisi3Id: string | undefined;
    ilgiliKisi3: Person | undefined;
    yenilemeSekli: SozlesmeYenilemeSekli | undefined;
    sozlesmeTipi: SozlesmeTipi | undefined;
    firmaId: string | undefined;
    firma: Firma | undefined;
    sozlesmeDurumu: SozlesmeDurumu | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class Kontrat implements IKontrat {
    id: string | undefined;
    sozlesmeNo: string | undefined;
    mulkSahibi: string | undefined;
    mulkSahibiTelefon: string | undefined;
    kontratAdi: string | undefined;
    sirketId: string | undefined;
    sirket: Sirket | undefined;
    sehirId: string | undefined;
    sehir: Sehir | undefined;
    baslangicTarihi: Date | undefined;
    bitisTarihi: Date | undefined;
    hatirlatmaTarihi1: Date | undefined;
    hatirlatmaTarihi2: Date | undefined;
    kontratDurumu: KontratDurumu | undefined;
    kontratKullanimAmaci: KontratKullanimAmaci | undefined;
    ilgiliKisi1Id: string | undefined;
    ilgiliKisi1: Person | undefined;
    ilgiliKisi2Id: string | undefined;
    ilgiliKisi2: Person | undefined;
    ilgiliKisi3Id: string | undefined;
    ilgiliKisi3: Person | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IKontrat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sozlesmeNo = _data["sozlesmeNo"];
            this.mulkSahibi = _data["mulkSahibi"];
            this.mulkSahibiTelefon = _data["mulkSahibiTelefon"];
            this.kontratAdi = _data["kontratAdi"];
            this.sirketId = _data["sirketId"];
            this.sirket = _data["sirket"] ? Sirket.fromJS(_data["sirket"]) : <any>undefined;
            this.sehirId = _data["sehirId"];
            this.sehir = _data["sehir"] ? Sehir.fromJS(_data["sehir"]) : <any>undefined;
            this.baslangicTarihi = _data["baslangicTarihi"] ? new Date(_data["baslangicTarihi"].toString()) : <any>undefined;
            this.bitisTarihi = _data["bitisTarihi"] ? new Date(_data["bitisTarihi"].toString()) : <any>undefined;
            this.hatirlatmaTarihi1 = _data["hatirlatmaTarihi1"] ? new Date(_data["hatirlatmaTarihi1"].toString()) : <any>undefined;
            this.hatirlatmaTarihi2 = _data["hatirlatmaTarihi2"] ? new Date(_data["hatirlatmaTarihi2"].toString()) : <any>undefined;
            this.kontratDurumu = _data["kontratDurumu"];
            this.kontratKullanimAmaci = _data["kontratKullanimAmaci"];
            this.ilgiliKisi1Id = _data["ilgiliKisi1Id"];
            this.ilgiliKisi1 = _data["ilgiliKisi1"] ? Person.fromJS(_data["ilgiliKisi1"]) : <any>undefined;
            this.ilgiliKisi2Id = _data["ilgiliKisi2Id"];
            this.ilgiliKisi2 = _data["ilgiliKisi2"] ? Person.fromJS(_data["ilgiliKisi2"]) : <any>undefined;
            this.ilgiliKisi3Id = _data["ilgiliKisi3Id"];
            this.ilgiliKisi3 = _data["ilgiliKisi3"] ? Person.fromJS(_data["ilgiliKisi3"]) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Kontrat {
        data = typeof data === 'object' ? data : {};
        let result = new Kontrat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sozlesmeNo"] = this.sozlesmeNo;
        data["mulkSahibi"] = this.mulkSahibi;
        data["mulkSahibiTelefon"] = this.mulkSahibiTelefon;
        data["kontratAdi"] = this.kontratAdi;
        data["sirketId"] = this.sirketId;
        data["sirket"] = this.sirket ? this.sirket.toJSON() : <any>undefined;
        data["sehirId"] = this.sehirId;
        data["sehir"] = this.sehir ? this.sehir.toJSON() : <any>undefined;
        data["baslangicTarihi"] = this.baslangicTarihi ? this.baslangicTarihi.toISOString() : <any>undefined;
        data["bitisTarihi"] = this.bitisTarihi ? this.bitisTarihi.toISOString() : <any>undefined;
        data["hatirlatmaTarihi1"] = this.hatirlatmaTarihi1 ? this.hatirlatmaTarihi1.toISOString() : <any>undefined;
        data["hatirlatmaTarihi2"] = this.hatirlatmaTarihi2 ? this.hatirlatmaTarihi2.toISOString() : <any>undefined;
        data["kontratDurumu"] = this.kontratDurumu;
        data["kontratKullanimAmaci"] = this.kontratKullanimAmaci;
        data["ilgiliKisi1Id"] = this.ilgiliKisi1Id;
        data["ilgiliKisi1"] = this.ilgiliKisi1 ? this.ilgiliKisi1.toJSON() : <any>undefined;
        data["ilgiliKisi2Id"] = this.ilgiliKisi2Id;
        data["ilgiliKisi2"] = this.ilgiliKisi2 ? this.ilgiliKisi2.toJSON() : <any>undefined;
        data["ilgiliKisi3Id"] = this.ilgiliKisi3Id;
        data["ilgiliKisi3"] = this.ilgiliKisi3 ? this.ilgiliKisi3.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Kontrat {
        const json = this.toJSON();
        let result = new Kontrat();
        result.init(json);
        return result;
    }
}

export interface IKontrat {
    id: string | undefined;
    sozlesmeNo: string | undefined;
    mulkSahibi: string | undefined;
    mulkSahibiTelefon: string | undefined;
    kontratAdi: string | undefined;
    sirketId: string | undefined;
    sirket: Sirket | undefined;
    sehirId: string | undefined;
    sehir: Sehir | undefined;
    baslangicTarihi: Date | undefined;
    bitisTarihi: Date | undefined;
    hatirlatmaTarihi1: Date | undefined;
    hatirlatmaTarihi2: Date | undefined;
    kontratDurumu: KontratDurumu | undefined;
    kontratKullanimAmaci: KontratKullanimAmaci | undefined;
    ilgiliKisi1Id: string | undefined;
    ilgiliKisi1: Person | undefined;
    ilgiliKisi2Id: string | undefined;
    ilgiliKisi2: Person | undefined;
    ilgiliKisi3Id: string | undefined;
    ilgiliKisi3: Person | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class IstenCikisGorev implements IIstenCikisGorev {
    id: string | undefined;
    cikisTuru: IstenCikisGorevCikisTuru | undefined;
    new_istenayrilmasebepid: string | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    planlananCikisTarihi: Date | undefined;
    talepEdenPersonelId: string | undefined;
    talepEdenPersonel: Person | undefined;
    aciklama: string | undefined;
    ikSorumlusuPersonelId: string | undefined;
    ikSorumlusu: Person | undefined;
    gorevDurum: IstenCikisGorevGorevDurum | undefined;
    isEvraklarAlindi: boolean | undefined;
    bolgeYoneticisiPersonelId: string | undefined;
    bolgeYoneticisi: Person | undefined;
    projeYoneticisiPersonelId: string | undefined;
    projeYoneticisi: Person | undefined;
    ekomBolgeSorumlusuPersonelId: string | undefined;
    ekomBolgeSorumlusu: Person | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IIstenCikisGorev) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cikisTuru = _data["cikisTuru"];
            this.new_istenayrilmasebepid = _data["new_istenayrilmasebepid"];
            this.personelId = _data["personelId"];
            this.personel = _data["personel"] ? Person.fromJS(_data["personel"]) : <any>undefined;
            this.planlananCikisTarihi = _data["planlananCikisTarihi"] ? new Date(_data["planlananCikisTarihi"].toString()) : <any>undefined;
            this.talepEdenPersonelId = _data["talepEdenPersonelId"];
            this.talepEdenPersonel = _data["talepEdenPersonel"] ? Person.fromJS(_data["talepEdenPersonel"]) : <any>undefined;
            this.aciklama = _data["aciklama"];
            this.ikSorumlusuPersonelId = _data["ikSorumlusuPersonelId"];
            this.ikSorumlusu = _data["ikSorumlusu"] ? Person.fromJS(_data["ikSorumlusu"]) : <any>undefined;
            this.gorevDurum = _data["gorevDurum"];
            this.isEvraklarAlindi = _data["isEvraklarAlindi"];
            this.bolgeYoneticisiPersonelId = _data["bolgeYoneticisiPersonelId"];
            this.bolgeYoneticisi = _data["bolgeYoneticisi"] ? Person.fromJS(_data["bolgeYoneticisi"]) : <any>undefined;
            this.projeYoneticisiPersonelId = _data["projeYoneticisiPersonelId"];
            this.projeYoneticisi = _data["projeYoneticisi"] ? Person.fromJS(_data["projeYoneticisi"]) : <any>undefined;
            this.ekomBolgeSorumlusuPersonelId = _data["ekomBolgeSorumlusuPersonelId"];
            this.ekomBolgeSorumlusu = _data["ekomBolgeSorumlusu"] ? Person.fromJS(_data["ekomBolgeSorumlusu"]) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): IstenCikisGorev {
        data = typeof data === 'object' ? data : {};
        let result = new IstenCikisGorev();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cikisTuru"] = this.cikisTuru;
        data["new_istenayrilmasebepid"] = this.new_istenayrilmasebepid;
        data["personelId"] = this.personelId;
        data["personel"] = this.personel ? this.personel.toJSON() : <any>undefined;
        data["planlananCikisTarihi"] = this.planlananCikisTarihi ? this.planlananCikisTarihi.toISOString() : <any>undefined;
        data["talepEdenPersonelId"] = this.talepEdenPersonelId;
        data["talepEdenPersonel"] = this.talepEdenPersonel ? this.talepEdenPersonel.toJSON() : <any>undefined;
        data["aciklama"] = this.aciklama;
        data["ikSorumlusuPersonelId"] = this.ikSorumlusuPersonelId;
        data["ikSorumlusu"] = this.ikSorumlusu ? this.ikSorumlusu.toJSON() : <any>undefined;
        data["gorevDurum"] = this.gorevDurum;
        data["isEvraklarAlindi"] = this.isEvraklarAlindi;
        data["bolgeYoneticisiPersonelId"] = this.bolgeYoneticisiPersonelId;
        data["bolgeYoneticisi"] = this.bolgeYoneticisi ? this.bolgeYoneticisi.toJSON() : <any>undefined;
        data["projeYoneticisiPersonelId"] = this.projeYoneticisiPersonelId;
        data["projeYoneticisi"] = this.projeYoneticisi ? this.projeYoneticisi.toJSON() : <any>undefined;
        data["ekomBolgeSorumlusuPersonelId"] = this.ekomBolgeSorumlusuPersonelId;
        data["ekomBolgeSorumlusu"] = this.ekomBolgeSorumlusu ? this.ekomBolgeSorumlusu.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): IstenCikisGorev {
        const json = this.toJSON();
        let result = new IstenCikisGorev();
        result.init(json);
        return result;
    }
}

export interface IIstenCikisGorev {
    id: string | undefined;
    cikisTuru: IstenCikisGorevCikisTuru | undefined;
    new_istenayrilmasebepid: string | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    planlananCikisTarihi: Date | undefined;
    talepEdenPersonelId: string | undefined;
    talepEdenPersonel: Person | undefined;
    aciklama: string | undefined;
    ikSorumlusuPersonelId: string | undefined;
    ikSorumlusu: Person | undefined;
    gorevDurum: IstenCikisGorevGorevDurum | undefined;
    isEvraklarAlindi: boolean | undefined;
    bolgeYoneticisiPersonelId: string | undefined;
    bolgeYoneticisi: Person | undefined;
    projeYoneticisiPersonelId: string | undefined;
    projeYoneticisi: Person | undefined;
    ekomBolgeSorumlusuPersonelId: string | undefined;
    ekomBolgeSorumlusu: Person | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class IseAlimTalep implements IIseAlimTalep {
    id: string | undefined;
    talepEdenPersonelId: string | undefined;
    talepEdenPersonel: Person | undefined;
    aciklama: string | undefined;
    normKadroId: string | undefined;
    normKadro: NormKadro | undefined;
    talepDurum: IseAlimTalepTalepDurum | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    personelTakipSorumlusuId: string | undefined;
    personelTakipSorumlusu: Person | undefined;
    personelAlimOnayciId: string | undefined;
    personelAlimOncaycisi: Person | undefined;
    iseAlimGorevlisiId: string | undefined;
    iseAlimGorevlisi: Person | undefined;
    sehirId: string | undefined;
    sehir: Sehir | undefined;
    evrakSorumlusuId: string | undefined;
    evrakSorumlusu: Person | undefined;
    isGorusmeleri: IsGorusmesi[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IIseAlimTalep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.talepEdenPersonelId = _data["talepEdenPersonelId"];
            this.talepEdenPersonel = _data["talepEdenPersonel"] ? Person.fromJS(_data["talepEdenPersonel"]) : <any>undefined;
            this.aciklama = _data["aciklama"];
            this.normKadroId = _data["normKadroId"];
            this.normKadro = _data["normKadro"] ? NormKadro.fromJS(_data["normKadro"]) : <any>undefined;
            this.talepDurum = _data["talepDurum"];
            this.projeId = _data["projeId"];
            this.proje = _data["proje"] ? Proje.fromJS(_data["proje"]) : <any>undefined;
            this.personelTakipSorumlusuId = _data["personelTakipSorumlusuId"];
            this.personelTakipSorumlusu = _data["personelTakipSorumlusu"] ? Person.fromJS(_data["personelTakipSorumlusu"]) : <any>undefined;
            this.personelAlimOnayciId = _data["personelAlimOnayciId"];
            this.personelAlimOncaycisi = _data["personelAlimOncaycisi"] ? Person.fromJS(_data["personelAlimOncaycisi"]) : <any>undefined;
            this.iseAlimGorevlisiId = _data["iseAlimGorevlisiId"];
            this.iseAlimGorevlisi = _data["iseAlimGorevlisi"] ? Person.fromJS(_data["iseAlimGorevlisi"]) : <any>undefined;
            this.sehirId = _data["sehirId"];
            this.sehir = _data["sehir"] ? Sehir.fromJS(_data["sehir"]) : <any>undefined;
            this.evrakSorumlusuId = _data["evrakSorumlusuId"];
            this.evrakSorumlusu = _data["evrakSorumlusu"] ? Person.fromJS(_data["evrakSorumlusu"]) : <any>undefined;
            if (Array.isArray(_data["isGorusmeleri"])) {
                this.isGorusmeleri = [] as any;
                for (let item of _data["isGorusmeleri"])
                    this.isGorusmeleri.push(IsGorusmesi.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): IseAlimTalep {
        data = typeof data === 'object' ? data : {};
        let result = new IseAlimTalep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["talepEdenPersonelId"] = this.talepEdenPersonelId;
        data["talepEdenPersonel"] = this.talepEdenPersonel ? this.talepEdenPersonel.toJSON() : <any>undefined;
        data["aciklama"] = this.aciklama;
        data["normKadroId"] = this.normKadroId;
        data["normKadro"] = this.normKadro ? this.normKadro.toJSON() : <any>undefined;
        data["talepDurum"] = this.talepDurum;
        data["projeId"] = this.projeId;
        data["proje"] = this.proje ? this.proje.toJSON() : <any>undefined;
        data["personelTakipSorumlusuId"] = this.personelTakipSorumlusuId;
        data["personelTakipSorumlusu"] = this.personelTakipSorumlusu ? this.personelTakipSorumlusu.toJSON() : <any>undefined;
        data["personelAlimOnayciId"] = this.personelAlimOnayciId;
        data["personelAlimOncaycisi"] = this.personelAlimOncaycisi ? this.personelAlimOncaycisi.toJSON() : <any>undefined;
        data["iseAlimGorevlisiId"] = this.iseAlimGorevlisiId;
        data["iseAlimGorevlisi"] = this.iseAlimGorevlisi ? this.iseAlimGorevlisi.toJSON() : <any>undefined;
        data["sehirId"] = this.sehirId;
        data["sehir"] = this.sehir ? this.sehir.toJSON() : <any>undefined;
        data["evrakSorumlusuId"] = this.evrakSorumlusuId;
        data["evrakSorumlusu"] = this.evrakSorumlusu ? this.evrakSorumlusu.toJSON() : <any>undefined;
        if (Array.isArray(this.isGorusmeleri)) {
            data["isGorusmeleri"] = [];
            for (let item of this.isGorusmeleri)
                data["isGorusmeleri"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): IseAlimTalep {
        const json = this.toJSON();
        let result = new IseAlimTalep();
        result.init(json);
        return result;
    }
}

export interface IIseAlimTalep {
    id: string | undefined;
    talepEdenPersonelId: string | undefined;
    talepEdenPersonel: Person | undefined;
    aciklama: string | undefined;
    normKadroId: string | undefined;
    normKadro: NormKadro | undefined;
    talepDurum: IseAlimTalepTalepDurum | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    personelTakipSorumlusuId: string | undefined;
    personelTakipSorumlusu: Person | undefined;
    personelAlimOnayciId: string | undefined;
    personelAlimOncaycisi: Person | undefined;
    iseAlimGorevlisiId: string | undefined;
    iseAlimGorevlisi: Person | undefined;
    sehirId: string | undefined;
    sehir: Sehir | undefined;
    evrakSorumlusuId: string | undefined;
    evrakSorumlusu: Person | undefined;
    isGorusmeleri: IsGorusmesi[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class MusteriCalisani implements IMusteriCalisani {
    id: string | undefined;
    sehirId: string | undefined;
    sehir: Sehir | undefined;
    supervisorId: string | undefined;
    supervisor: Person | undefined;
    musteriCalisaniPersonelId: string | undefined;
    musteriCalisaniPersonel: Person | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IMusteriCalisani) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sehirId = _data["sehirId"];
            this.sehir = _data["sehir"] ? Sehir.fromJS(_data["sehir"]) : <any>undefined;
            this.supervisorId = _data["supervisorId"];
            this.supervisor = _data["supervisor"] ? Person.fromJS(_data["supervisor"]) : <any>undefined;
            this.musteriCalisaniPersonelId = _data["musteriCalisaniPersonelId"];
            this.musteriCalisaniPersonel = _data["musteriCalisaniPersonel"] ? Person.fromJS(_data["musteriCalisaniPersonel"]) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): MusteriCalisani {
        data = typeof data === 'object' ? data : {};
        let result = new MusteriCalisani();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sehirId"] = this.sehirId;
        data["sehir"] = this.sehir ? this.sehir.toJSON() : <any>undefined;
        data["supervisorId"] = this.supervisorId;
        data["supervisor"] = this.supervisor ? this.supervisor.toJSON() : <any>undefined;
        data["musteriCalisaniPersonelId"] = this.musteriCalisaniPersonelId;
        data["musteriCalisaniPersonel"] = this.musteriCalisaniPersonel ? this.musteriCalisaniPersonel.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): MusteriCalisani {
        const json = this.toJSON();
        let result = new MusteriCalisani();
        result.init(json);
        return result;
    }
}

export interface IMusteriCalisani {
    id: string | undefined;
    sehirId: string | undefined;
    sehir: Sehir | undefined;
    supervisorId: string | undefined;
    supervisor: Person | undefined;
    musteriCalisaniPersonelId: string | undefined;
    musteriCalisaniPersonel: Person | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class IsGorusmesi implements IIsGorusmesi {
    id: string | undefined;
    iseAlimTalepId: string | undefined;
    iseAlimTalep: IseAlimTalep | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    ikGorusleri: string | undefined;
    gorusmeDurumu: IsGorusmesiGorusmeDurumu | undefined;
    gorusmeTarihi: Date | undefined;
    iseBaslamaTarihi: Date | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IIsGorusmesi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iseAlimTalepId = _data["iseAlimTalepId"];
            this.iseAlimTalep = _data["iseAlimTalep"] ? IseAlimTalep.fromJS(_data["iseAlimTalep"]) : <any>undefined;
            this.personelId = _data["personelId"];
            this.personel = _data["personel"] ? Person.fromJS(_data["personel"]) : <any>undefined;
            this.ikGorusleri = _data["ikGorusleri"];
            this.gorusmeDurumu = _data["gorusmeDurumu"];
            this.gorusmeTarihi = _data["gorusmeTarihi"] ? new Date(_data["gorusmeTarihi"].toString()) : <any>undefined;
            this.iseBaslamaTarihi = _data["iseBaslamaTarihi"] ? new Date(_data["iseBaslamaTarihi"].toString()) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): IsGorusmesi {
        data = typeof data === 'object' ? data : {};
        let result = new IsGorusmesi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iseAlimTalepId"] = this.iseAlimTalepId;
        data["iseAlimTalep"] = this.iseAlimTalep ? this.iseAlimTalep.toJSON() : <any>undefined;
        data["personelId"] = this.personelId;
        data["personel"] = this.personel ? this.personel.toJSON() : <any>undefined;
        data["ikGorusleri"] = this.ikGorusleri;
        data["gorusmeDurumu"] = this.gorusmeDurumu;
        data["gorusmeTarihi"] = this.gorusmeTarihi ? this.gorusmeTarihi.toISOString() : <any>undefined;
        data["iseBaslamaTarihi"] = this.iseBaslamaTarihi ? this.iseBaslamaTarihi.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): IsGorusmesi {
        const json = this.toJSON();
        let result = new IsGorusmesi();
        result.init(json);
        return result;
    }
}

export interface IIsGorusmesi {
    id: string | undefined;
    iseAlimTalepId: string | undefined;
    iseAlimTalep: IseAlimTalep | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    ikGorusleri: string | undefined;
    gorusmeDurumu: IsGorusmesiGorusmeDurumu | undefined;
    gorusmeTarihi: Date | undefined;
    iseBaslamaTarihi: Date | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class SahaPerformans implements ISahaPerformans {
    id: string | undefined;
    donemId: string | undefined;
    donem: Donem | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    bolge: string | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    kpiId: string | undefined;
    kpi: Kpi | undefined;
    skor: number | undefined;
    ilkAmirId: string | undefined;
    ilkAmir: Person | undefined;
    veriKaynagi: string | undefined;
    hedef: number | undefined;
    magazaId: string | undefined;
    magaza: PoiMusteri | undefined;
    aciklama: string | undefined;
    bolgeMuduruId: string | undefined;
    bolgeMuduru: Person | undefined;
    direktorId: string | undefined;
    direktor: Person | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: ISahaPerformans) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.donemId = _data["donemId"];
            this.donem = _data["donem"] ? Donem.fromJS(_data["donem"]) : <any>undefined;
            this.projeId = _data["projeId"];
            this.proje = _data["proje"] ? Proje.fromJS(_data["proje"]) : <any>undefined;
            this.bolge = _data["bolge"];
            this.personelId = _data["personelId"];
            this.personel = _data["personel"] ? Person.fromJS(_data["personel"]) : <any>undefined;
            this.kpiId = _data["kpiId"];
            this.kpi = _data["kpi"] ? Kpi.fromJS(_data["kpi"]) : <any>undefined;
            this.skor = _data["skor"];
            this.ilkAmirId = _data["ilkAmirId"];
            this.ilkAmir = _data["ilkAmir"] ? Person.fromJS(_data["ilkAmir"]) : <any>undefined;
            this.veriKaynagi = _data["veriKaynagi"];
            this.hedef = _data["hedef"];
            this.magazaId = _data["magazaId"];
            this.magaza = _data["magaza"] ? PoiMusteri.fromJS(_data["magaza"]) : <any>undefined;
            this.aciklama = _data["aciklama"];
            this.bolgeMuduruId = _data["bolgeMuduruId"];
            this.bolgeMuduru = _data["bolgeMuduru"] ? Person.fromJS(_data["bolgeMuduru"]) : <any>undefined;
            this.direktorId = _data["direktorId"];
            this.direktor = _data["direktor"] ? Person.fromJS(_data["direktor"]) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): SahaPerformans {
        data = typeof data === 'object' ? data : {};
        let result = new SahaPerformans();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["donemId"] = this.donemId;
        data["donem"] = this.donem ? this.donem.toJSON() : <any>undefined;
        data["projeId"] = this.projeId;
        data["proje"] = this.proje ? this.proje.toJSON() : <any>undefined;
        data["bolge"] = this.bolge;
        data["personelId"] = this.personelId;
        data["personel"] = this.personel ? this.personel.toJSON() : <any>undefined;
        data["kpiId"] = this.kpiId;
        data["kpi"] = this.kpi ? this.kpi.toJSON() : <any>undefined;
        data["skor"] = this.skor;
        data["ilkAmirId"] = this.ilkAmirId;
        data["ilkAmir"] = this.ilkAmir ? this.ilkAmir.toJSON() : <any>undefined;
        data["veriKaynagi"] = this.veriKaynagi;
        data["hedef"] = this.hedef;
        data["magazaId"] = this.magazaId;
        data["magaza"] = this.magaza ? this.magaza.toJSON() : <any>undefined;
        data["aciklama"] = this.aciklama;
        data["bolgeMuduruId"] = this.bolgeMuduruId;
        data["bolgeMuduru"] = this.bolgeMuduru ? this.bolgeMuduru.toJSON() : <any>undefined;
        data["direktorId"] = this.direktorId;
        data["direktor"] = this.direktor ? this.direktor.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): SahaPerformans {
        const json = this.toJSON();
        let result = new SahaPerformans();
        result.init(json);
        return result;
    }
}

export interface ISahaPerformans {
    id: string | undefined;
    donemId: string | undefined;
    donem: Donem | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    bolge: string | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    kpiId: string | undefined;
    kpi: Kpi | undefined;
    skor: number | undefined;
    ilkAmirId: string | undefined;
    ilkAmir: Person | undefined;
    veriKaynagi: string | undefined;
    hedef: number | undefined;
    magazaId: string | undefined;
    magaza: PoiMusteri | undefined;
    aciklama: string | undefined;
    bolgeMuduruId: string | undefined;
    bolgeMuduru: Person | undefined;
    direktorId: string | undefined;
    direktor: Person | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class MagazaPerformans implements IMagazaPerformans {
    id: string | undefined;
    donemId: string | undefined;
    donem: Donem | undefined;
    sahaSorumlusuId: string | undefined;
    sahaSorumlusu: Person | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    poiId: string | undefined;
    poiGenel: PoiGenel | undefined;
    ciroHedef: number | undefined;
    ciroGerceklesen: number | undefined;
    ciroGirilen: number | undefined;
    ciroFark: number | undefined;
    ziyaretSayisi: number | undefined;
    mPoiId: string | undefined;
    poiMusteri: PoiMusteri | undefined;
    gerceklesmeOrani: number | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IMagazaPerformans) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.donemId = _data["donemId"];
            this.donem = _data["donem"] ? Donem.fromJS(_data["donem"]) : <any>undefined;
            this.sahaSorumlusuId = _data["sahaSorumlusuId"];
            this.sahaSorumlusu = _data["sahaSorumlusu"] ? Person.fromJS(_data["sahaSorumlusu"]) : <any>undefined;
            this.personelId = _data["personelId"];
            this.personel = _data["personel"] ? Person.fromJS(_data["personel"]) : <any>undefined;
            this.poiId = _data["poiId"];
            this.poiGenel = _data["poiGenel"] ? PoiGenel.fromJS(_data["poiGenel"]) : <any>undefined;
            this.ciroHedef = _data["ciroHedef"];
            this.ciroGerceklesen = _data["ciroGerceklesen"];
            this.ciroGirilen = _data["ciroGirilen"];
            this.ciroFark = _data["ciroFark"];
            this.ziyaretSayisi = _data["ziyaretSayisi"];
            this.mPoiId = _data["mPoiId"];
            this.poiMusteri = _data["poiMusteri"] ? PoiMusteri.fromJS(_data["poiMusteri"]) : <any>undefined;
            this.gerceklesmeOrani = _data["gerceklesmeOrani"];
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): MagazaPerformans {
        data = typeof data === 'object' ? data : {};
        let result = new MagazaPerformans();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["donemId"] = this.donemId;
        data["donem"] = this.donem ? this.donem.toJSON() : <any>undefined;
        data["sahaSorumlusuId"] = this.sahaSorumlusuId;
        data["sahaSorumlusu"] = this.sahaSorumlusu ? this.sahaSorumlusu.toJSON() : <any>undefined;
        data["personelId"] = this.personelId;
        data["personel"] = this.personel ? this.personel.toJSON() : <any>undefined;
        data["poiId"] = this.poiId;
        data["poiGenel"] = this.poiGenel ? this.poiGenel.toJSON() : <any>undefined;
        data["ciroHedef"] = this.ciroHedef;
        data["ciroGerceklesen"] = this.ciroGerceklesen;
        data["ciroGirilen"] = this.ciroGirilen;
        data["ciroFark"] = this.ciroFark;
        data["ziyaretSayisi"] = this.ziyaretSayisi;
        data["mPoiId"] = this.mPoiId;
        data["poiMusteri"] = this.poiMusteri ? this.poiMusteri.toJSON() : <any>undefined;
        data["gerceklesmeOrani"] = this.gerceklesmeOrani;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): MagazaPerformans {
        const json = this.toJSON();
        let result = new MagazaPerformans();
        result.init(json);
        return result;
    }
}

export interface IMagazaPerformans {
    id: string | undefined;
    donemId: string | undefined;
    donem: Donem | undefined;
    sahaSorumlusuId: string | undefined;
    sahaSorumlusu: Person | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    poiId: string | undefined;
    poiGenel: PoiGenel | undefined;
    ciroHedef: number | undefined;
    ciroGerceklesen: number | undefined;
    ciroGirilen: number | undefined;
    ciroFark: number | undefined;
    ziyaretSayisi: number | undefined;
    mPoiId: string | undefined;
    poiMusteri: PoiMusteri | undefined;
    gerceklesmeOrani: number | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class YanHak implements IYanHak {
    id: string | undefined;
    normKadroId: string | undefined;
    normKadro: NormKadro | undefined;
    yanHakTanimId: string | undefined;
    yanHakTanim: YanHakTanim | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IYanHak) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.normKadroId = _data["normKadroId"];
            this.normKadro = _data["normKadro"] ? NormKadro.fromJS(_data["normKadro"]) : <any>undefined;
            this.yanHakTanimId = _data["yanHakTanimId"];
            this.yanHakTanim = _data["yanHakTanim"] ? YanHakTanim.fromJS(_data["yanHakTanim"]) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): YanHak {
        data = typeof data === 'object' ? data : {};
        let result = new YanHak();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["normKadroId"] = this.normKadroId;
        data["normKadro"] = this.normKadro ? this.normKadro.toJSON() : <any>undefined;
        data["yanHakTanimId"] = this.yanHakTanimId;
        data["yanHakTanim"] = this.yanHakTanim ? this.yanHakTanim.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): YanHak {
        const json = this.toJSON();
        let result = new YanHak();
        result.init(json);
        return result;
    }
}

export interface IYanHak {
    id: string | undefined;
    normKadroId: string | undefined;
    normKadro: NormKadro | undefined;
    yanHakTanimId: string | undefined;
    yanHakTanim: YanHakTanim | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class IzinOnayGorevi implements IIzinOnayGorevi {
    id: string | undefined;
    onayDurum: IzinOnayGoreviOnayDurum | undefined;
    onaySira: number | undefined;
    toplamOnayAdimi: number | undefined;
    aciklama: string | undefined;
    izinTalepId: string | undefined;
    izinTalep: IzinTalep | undefined;
    izinOnayciId: string | undefined;
    izinOnayci: IzinOnayci | undefined;
    onayciNormKadroId: string | undefined;
    onayciNormKadro: NormKadro | undefined;
    islemTarihi: Date | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IIzinOnayGorevi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.onayDurum = _data["onayDurum"];
            this.onaySira = _data["onaySira"];
            this.toplamOnayAdimi = _data["toplamOnayAdimi"];
            this.aciklama = _data["aciklama"];
            this.izinTalepId = _data["izinTalepId"];
            this.izinTalep = _data["izinTalep"] ? IzinTalep.fromJS(_data["izinTalep"]) : <any>undefined;
            this.izinOnayciId = _data["izinOnayciId"];
            this.izinOnayci = _data["izinOnayci"] ? IzinOnayci.fromJS(_data["izinOnayci"]) : <any>undefined;
            this.onayciNormKadroId = _data["onayciNormKadroId"];
            this.onayciNormKadro = _data["onayciNormKadro"] ? NormKadro.fromJS(_data["onayciNormKadro"]) : <any>undefined;
            this.islemTarihi = _data["islemTarihi"] ? new Date(_data["islemTarihi"].toString()) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): IzinOnayGorevi {
        data = typeof data === 'object' ? data : {};
        let result = new IzinOnayGorevi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["onayDurum"] = this.onayDurum;
        data["onaySira"] = this.onaySira;
        data["toplamOnayAdimi"] = this.toplamOnayAdimi;
        data["aciklama"] = this.aciklama;
        data["izinTalepId"] = this.izinTalepId;
        data["izinTalep"] = this.izinTalep ? this.izinTalep.toJSON() : <any>undefined;
        data["izinOnayciId"] = this.izinOnayciId;
        data["izinOnayci"] = this.izinOnayci ? this.izinOnayci.toJSON() : <any>undefined;
        data["onayciNormKadroId"] = this.onayciNormKadroId;
        data["onayciNormKadro"] = this.onayciNormKadro ? this.onayciNormKadro.toJSON() : <any>undefined;
        data["islemTarihi"] = this.islemTarihi ? this.islemTarihi.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): IzinOnayGorevi {
        const json = this.toJSON();
        let result = new IzinOnayGorevi();
        result.init(json);
        return result;
    }
}

export interface IIzinOnayGorevi {
    id: string | undefined;
    onayDurum: IzinOnayGoreviOnayDurum | undefined;
    onaySira: number | undefined;
    toplamOnayAdimi: number | undefined;
    aciklama: string | undefined;
    izinTalepId: string | undefined;
    izinTalep: IzinTalep | undefined;
    izinOnayciId: string | undefined;
    izinOnayci: IzinOnayci | undefined;
    onayciNormKadroId: string | undefined;
    onayciNormKadro: NormKadro | undefined;
    islemTarihi: Date | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class PoiGenel implements IPoiGenel {
    id: string | undefined;
    sube: string | undefined;
    aciklama: string | undefined;
    islemLog: string | undefined;
    poiTuruId: string | undefined;
    poiTuru: PoiTuru | undefined;
    sehirId: string | undefined;
    sehir: Sehir | undefined;
    ilceId: string | undefined;
    ilce: Ilce | undefined;
    kategoriId: string | undefined;
    kategori: Kategori | undefined;
    metreKare: number | undefined;
    enlem: number | undefined;
    boylam: number | undefined;
    poiKodu: string | undefined;
    hasOtopark: boolean | undefined;
    isAvmIci: boolean | undefined;
    kasaSayisi: number | undefined;
    teshirAlaniSayisi: number | undefined;
    acikAdres: string | undefined;
    yetkiliMail: string | undefined;
    yetkiliAdSoyad: string | undefined;
    yetkiliTelNo: string | undefined;
    ekomPoiNo: string | undefined;
    transpopAdresSiraNo: number | undefined;
    musteriPoiList: PoiMusteri[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IPoiGenel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sube = _data["sube"];
            this.aciklama = _data["aciklama"];
            this.islemLog = _data["islemLog"];
            this.poiTuruId = _data["poiTuruId"];
            this.poiTuru = _data["poiTuru"] ? PoiTuru.fromJS(_data["poiTuru"]) : <any>undefined;
            this.sehirId = _data["sehirId"];
            this.sehir = _data["sehir"] ? Sehir.fromJS(_data["sehir"]) : <any>undefined;
            this.ilceId = _data["ilceId"];
            this.ilce = _data["ilce"] ? Ilce.fromJS(_data["ilce"]) : <any>undefined;
            this.kategoriId = _data["kategoriId"];
            this.kategori = _data["kategori"] ? Kategori.fromJS(_data["kategori"]) : <any>undefined;
            this.metreKare = _data["metreKare"];
            this.enlem = _data["enlem"];
            this.boylam = _data["boylam"];
            this.poiKodu = _data["poiKodu"];
            this.hasOtopark = _data["hasOtopark"];
            this.isAvmIci = _data["isAvmIci"];
            this.kasaSayisi = _data["kasaSayisi"];
            this.teshirAlaniSayisi = _data["teshirAlaniSayisi"];
            this.acikAdres = _data["acikAdres"];
            this.yetkiliMail = _data["yetkiliMail"];
            this.yetkiliAdSoyad = _data["yetkiliAdSoyad"];
            this.yetkiliTelNo = _data["yetkiliTelNo"];
            this.ekomPoiNo = _data["ekomPoiNo"];
            this.transpopAdresSiraNo = _data["transpopAdresSiraNo"];
            if (Array.isArray(_data["musteriPoiList"])) {
                this.musteriPoiList = [] as any;
                for (let item of _data["musteriPoiList"])
                    this.musteriPoiList.push(PoiMusteri.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): PoiGenel {
        data = typeof data === 'object' ? data : {};
        let result = new PoiGenel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sube"] = this.sube;
        data["aciklama"] = this.aciklama;
        data["islemLog"] = this.islemLog;
        data["poiTuruId"] = this.poiTuruId;
        data["poiTuru"] = this.poiTuru ? this.poiTuru.toJSON() : <any>undefined;
        data["sehirId"] = this.sehirId;
        data["sehir"] = this.sehir ? this.sehir.toJSON() : <any>undefined;
        data["ilceId"] = this.ilceId;
        data["ilce"] = this.ilce ? this.ilce.toJSON() : <any>undefined;
        data["kategoriId"] = this.kategoriId;
        data["kategori"] = this.kategori ? this.kategori.toJSON() : <any>undefined;
        data["metreKare"] = this.metreKare;
        data["enlem"] = this.enlem;
        data["boylam"] = this.boylam;
        data["poiKodu"] = this.poiKodu;
        data["hasOtopark"] = this.hasOtopark;
        data["isAvmIci"] = this.isAvmIci;
        data["kasaSayisi"] = this.kasaSayisi;
        data["teshirAlaniSayisi"] = this.teshirAlaniSayisi;
        data["acikAdres"] = this.acikAdres;
        data["yetkiliMail"] = this.yetkiliMail;
        data["yetkiliAdSoyad"] = this.yetkiliAdSoyad;
        data["yetkiliTelNo"] = this.yetkiliTelNo;
        data["ekomPoiNo"] = this.ekomPoiNo;
        data["transpopAdresSiraNo"] = this.transpopAdresSiraNo;
        if (Array.isArray(this.musteriPoiList)) {
            data["musteriPoiList"] = [];
            for (let item of this.musteriPoiList)
                data["musteriPoiList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): PoiGenel {
        const json = this.toJSON();
        let result = new PoiGenel();
        result.init(json);
        return result;
    }
}

export interface IPoiGenel {
    id: string | undefined;
    sube: string | undefined;
    aciklama: string | undefined;
    islemLog: string | undefined;
    poiTuruId: string | undefined;
    poiTuru: PoiTuru | undefined;
    sehirId: string | undefined;
    sehir: Sehir | undefined;
    ilceId: string | undefined;
    ilce: Ilce | undefined;
    kategoriId: string | undefined;
    kategori: Kategori | undefined;
    metreKare: number | undefined;
    enlem: number | undefined;
    boylam: number | undefined;
    poiKodu: string | undefined;
    hasOtopark: boolean | undefined;
    isAvmIci: boolean | undefined;
    kasaSayisi: number | undefined;
    teshirAlaniSayisi: number | undefined;
    acikAdres: string | undefined;
    yetkiliMail: string | undefined;
    yetkiliAdSoyad: string | undefined;
    yetkiliTelNo: string | undefined;
    ekomPoiNo: string | undefined;
    transpopAdresSiraNo: number | undefined;
    musteriPoiList: PoiMusteri[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class GorevFormEkran implements IGorevFormEkran {
    id: string | undefined;
    baslik: string | undefined;
    aciklama: string | undefined;
    sortIndex: number | undefined;
    gorevFormId: string | undefined;
    gorevForm: GorevForm | undefined;
    soruList: GorevFormSoru[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IGorevFormEkran) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.baslik = _data["baslik"];
            this.aciklama = _data["aciklama"];
            this.sortIndex = _data["sortIndex"];
            this.gorevFormId = _data["gorevFormId"];
            this.gorevForm = _data["gorevForm"] ? GorevForm.fromJS(_data["gorevForm"]) : <any>undefined;
            if (Array.isArray(_data["soruList"])) {
                this.soruList = [] as any;
                for (let item of _data["soruList"])
                    this.soruList.push(GorevFormSoru.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): GorevFormEkran {
        data = typeof data === 'object' ? data : {};
        let result = new GorevFormEkran();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["baslik"] = this.baslik;
        data["aciklama"] = this.aciklama;
        data["sortIndex"] = this.sortIndex;
        data["gorevFormId"] = this.gorevFormId;
        data["gorevForm"] = this.gorevForm ? this.gorevForm.toJSON() : <any>undefined;
        if (Array.isArray(this.soruList)) {
            data["soruList"] = [];
            for (let item of this.soruList)
                data["soruList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): GorevFormEkran {
        const json = this.toJSON();
        let result = new GorevFormEkran();
        result.init(json);
        return result;
    }
}

export interface IGorevFormEkran {
    id: string | undefined;
    baslik: string | undefined;
    aciklama: string | undefined;
    sortIndex: number | undefined;
    gorevFormId: string | undefined;
    gorevForm: GorevForm | undefined;
    soruList: GorevFormSoru[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class MasrafFormu implements IMasrafFormu {
    id: string | undefined;
    masrafTip: MasrafFormuMasrafTip | undefined;
    sirketId: string | undefined;
    sirket: Sirket | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    odemeTip: MasrafFormuOdemeTip | undefined;
    tarih: Date | undefined;
    aciklama: string | undefined;
    normKadroId: string | undefined;
    normKadro: NormKadro | undefined;
    onayDurumu: MasrafFormuOnayDurumu | undefined;
    tutar: number | undefined;
    donemId: string | undefined;
    donem: Donem | undefined;
    logoOnayNo: string | undefined;
    masrafKalemiAdedi: number | undefined;
    onaylananTutar: number | undefined;
    onaylananMasrafKalemiAdedi: number | undefined;
    duzenliMasrafGunAdedi: number | undefined;
    duzenliMasrafOnaylananTutar: number | undefined;
    islemTip: MasrafFormuIslemTip | undefined;
    isLogoyaGonderildi: boolean | undefined;
    duzenliMasrafProjeDonemId: string | undefined;
    duzenliMasrafProjeDonemi: ProjeDonemi | undefined;
    masrafKalemleri: MasrafKalemi[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IMasrafFormu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.masrafTip = _data["masrafTip"];
            this.sirketId = _data["sirketId"];
            this.sirket = _data["sirket"] ? Sirket.fromJS(_data["sirket"]) : <any>undefined;
            this.projeId = _data["projeId"];
            this.proje = _data["proje"] ? Proje.fromJS(_data["proje"]) : <any>undefined;
            this.personelId = _data["personelId"];
            this.personel = _data["personel"] ? Person.fromJS(_data["personel"]) : <any>undefined;
            this.odemeTip = _data["odemeTip"];
            this.tarih = _data["tarih"] ? new Date(_data["tarih"].toString()) : <any>undefined;
            this.aciklama = _data["aciklama"];
            this.normKadroId = _data["normKadroId"];
            this.normKadro = _data["normKadro"] ? NormKadro.fromJS(_data["normKadro"]) : <any>undefined;
            this.onayDurumu = _data["onayDurumu"];
            this.tutar = _data["tutar"];
            this.donemId = _data["donemId"];
            this.donem = _data["donem"] ? Donem.fromJS(_data["donem"]) : <any>undefined;
            this.logoOnayNo = _data["logoOnayNo"];
            this.masrafKalemiAdedi = _data["masrafKalemiAdedi"];
            this.onaylananTutar = _data["onaylananTutar"];
            this.onaylananMasrafKalemiAdedi = _data["onaylananMasrafKalemiAdedi"];
            this.duzenliMasrafGunAdedi = _data["duzenliMasrafGunAdedi"];
            this.duzenliMasrafOnaylananTutar = _data["duzenliMasrafOnaylananTutar"];
            this.islemTip = _data["islemTip"];
            this.isLogoyaGonderildi = _data["isLogoyaGonderildi"];
            this.duzenliMasrafProjeDonemId = _data["duzenliMasrafProjeDonemId"];
            this.duzenliMasrafProjeDonemi = _data["duzenliMasrafProjeDonemi"] ? ProjeDonemi.fromJS(_data["duzenliMasrafProjeDonemi"]) : <any>undefined;
            if (Array.isArray(_data["masrafKalemleri"])) {
                this.masrafKalemleri = [] as any;
                for (let item of _data["masrafKalemleri"])
                    this.masrafKalemleri.push(MasrafKalemi.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): MasrafFormu {
        data = typeof data === 'object' ? data : {};
        let result = new MasrafFormu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["masrafTip"] = this.masrafTip;
        data["sirketId"] = this.sirketId;
        data["sirket"] = this.sirket ? this.sirket.toJSON() : <any>undefined;
        data["projeId"] = this.projeId;
        data["proje"] = this.proje ? this.proje.toJSON() : <any>undefined;
        data["personelId"] = this.personelId;
        data["personel"] = this.personel ? this.personel.toJSON() : <any>undefined;
        data["odemeTip"] = this.odemeTip;
        data["tarih"] = this.tarih ? this.tarih.toISOString() : <any>undefined;
        data["aciklama"] = this.aciklama;
        data["normKadroId"] = this.normKadroId;
        data["normKadro"] = this.normKadro ? this.normKadro.toJSON() : <any>undefined;
        data["onayDurumu"] = this.onayDurumu;
        data["tutar"] = this.tutar;
        data["donemId"] = this.donemId;
        data["donem"] = this.donem ? this.donem.toJSON() : <any>undefined;
        data["logoOnayNo"] = this.logoOnayNo;
        data["masrafKalemiAdedi"] = this.masrafKalemiAdedi;
        data["onaylananTutar"] = this.onaylananTutar;
        data["onaylananMasrafKalemiAdedi"] = this.onaylananMasrafKalemiAdedi;
        data["duzenliMasrafGunAdedi"] = this.duzenliMasrafGunAdedi;
        data["duzenliMasrafOnaylananTutar"] = this.duzenliMasrafOnaylananTutar;
        data["islemTip"] = this.islemTip;
        data["isLogoyaGonderildi"] = this.isLogoyaGonderildi;
        data["duzenliMasrafProjeDonemId"] = this.duzenliMasrafProjeDonemId;
        data["duzenliMasrafProjeDonemi"] = this.duzenliMasrafProjeDonemi ? this.duzenliMasrafProjeDonemi.toJSON() : <any>undefined;
        if (Array.isArray(this.masrafKalemleri)) {
            data["masrafKalemleri"] = [];
            for (let item of this.masrafKalemleri)
                data["masrafKalemleri"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): MasrafFormu {
        const json = this.toJSON();
        let result = new MasrafFormu();
        result.init(json);
        return result;
    }
}

export interface IMasrafFormu {
    id: string | undefined;
    masrafTip: MasrafFormuMasrafTip | undefined;
    sirketId: string | undefined;
    sirket: Sirket | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    odemeTip: MasrafFormuOdemeTip | undefined;
    tarih: Date | undefined;
    aciklama: string | undefined;
    normKadroId: string | undefined;
    normKadro: NormKadro | undefined;
    onayDurumu: MasrafFormuOnayDurumu | undefined;
    tutar: number | undefined;
    donemId: string | undefined;
    donem: Donem | undefined;
    logoOnayNo: string | undefined;
    masrafKalemiAdedi: number | undefined;
    onaylananTutar: number | undefined;
    onaylananMasrafKalemiAdedi: number | undefined;
    duzenliMasrafGunAdedi: number | undefined;
    duzenliMasrafOnaylananTutar: number | undefined;
    islemTip: MasrafFormuIslemTip | undefined;
    isLogoyaGonderildi: boolean | undefined;
    duzenliMasrafProjeDonemId: string | undefined;
    duzenliMasrafProjeDonemi: ProjeDonemi | undefined;
    masrafKalemleri: MasrafKalemi[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class MasrafAnaKategori implements IMasrafAnaKategori {
    id: string | undefined;
    kod: string | undefined;
    kod770: string | undefined;
    hesapGrupId: string | undefined;
    hesapGrup: MasrafHesapGrubu | undefined;
    masrafKalemleri: MasrafKalemi[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IMasrafAnaKategori) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kod = _data["kod"];
            this.kod770 = _data["kod770"];
            this.hesapGrupId = _data["hesapGrupId"];
            this.hesapGrup = _data["hesapGrup"] ? MasrafHesapGrubu.fromJS(_data["hesapGrup"]) : <any>undefined;
            if (Array.isArray(_data["masrafKalemleri"])) {
                this.masrafKalemleri = [] as any;
                for (let item of _data["masrafKalemleri"])
                    this.masrafKalemleri.push(MasrafKalemi.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): MasrafAnaKategori {
        data = typeof data === 'object' ? data : {};
        let result = new MasrafAnaKategori();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kod"] = this.kod;
        data["kod770"] = this.kod770;
        data["hesapGrupId"] = this.hesapGrupId;
        data["hesapGrup"] = this.hesapGrup ? this.hesapGrup.toJSON() : <any>undefined;
        if (Array.isArray(this.masrafKalemleri)) {
            data["masrafKalemleri"] = [];
            for (let item of this.masrafKalemleri)
                data["masrafKalemleri"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): MasrafAnaKategori {
        const json = this.toJSON();
        let result = new MasrafAnaKategori();
        result.init(json);
        return result;
    }
}

export interface IMasrafAnaKategori {
    id: string | undefined;
    kod: string | undefined;
    kod770: string | undefined;
    hesapGrupId: string | undefined;
    hesapGrup: MasrafHesapGrubu | undefined;
    masrafKalemleri: MasrafKalemi[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class Donem implements IDonem {
    id: string | undefined;
    yil: number | undefined;
    ay: number | undefined;
    ayKacGun: number | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IDonem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.yil = _data["yil"];
            this.ay = _data["ay"];
            this.ayKacGun = _data["ayKacGun"];
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): Donem {
        data = typeof data === 'object' ? data : {};
        let result = new Donem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["yil"] = this.yil;
        data["ay"] = this.ay;
        data["ayKacGun"] = this.ayKacGun;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): Donem {
        const json = this.toJSON();
        let result = new Donem();
        result.init(json);
        return result;
    }
}

export interface IDonem {
    id: string | undefined;
    yil: number | undefined;
    ay: number | undefined;
    ayKacGun: number | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class YanHakTanim implements IYanHakTanim {
    id: string | undefined;
    isZimmetGerekli: boolean | undefined;
    yanhaklar: YanHak[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IYanHakTanim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isZimmetGerekli = _data["isZimmetGerekli"];
            if (Array.isArray(_data["yanhaklar"])) {
                this.yanhaklar = [] as any;
                for (let item of _data["yanhaklar"])
                    this.yanhaklar.push(YanHak.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): YanHakTanim {
        data = typeof data === 'object' ? data : {};
        let result = new YanHakTanim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isZimmetGerekli"] = this.isZimmetGerekli;
        if (Array.isArray(this.yanhaklar)) {
            data["yanhaklar"] = [];
            for (let item of this.yanhaklar)
                data["yanhaklar"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): YanHakTanim {
        const json = this.toJSON();
        let result = new YanHakTanim();
        result.init(json);
        return result;
    }
}

export interface IYanHakTanim {
    id: string | undefined;
    isZimmetGerekli: boolean | undefined;
    yanhaklar: YanHak[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class IzinTalep implements IIzinTalep {
    id: string | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    izinTipiId: string | undefined;
    izinTipi: IzinTpi | undefined;
    talepDurumu: IzinTalepTalepDurumu | undefined;
    izinBaslangicTarihi: Date | undefined;
    izinBitisTarihi: Date | undefined;
    izinBaslangicAni: IzinTalepIzinBaslangicAni | undefined;
    izinBitisAni: IzinTalepIzinBitisAni | undefined;
    acilDurumdaAranacakKisi: string | undefined;
    acilDurumdaAranacakTelefonNo: string | undefined;
    isOffGun1Pazartesi: boolean | undefined;
    isOffGun2Sali: boolean | undefined;
    isOffGun3Carsamba: boolean | undefined;
    isOffGun4Persembe: boolean | undefined;
    isOffGun5Cuma: boolean | undefined;
    isOffGun6Cumartesi: boolean | undefined;
    isOffGun7Pazar: boolean | undefined;
    aciklama: string | undefined;
    izinliGunSayisi: number | undefined;
    izinTalepNo: string | undefined;
    bulunacagiAdres: string | undefined;
    yerineBakacakPersonel: string | undefined;
    logoNo: string | undefined;
    imzaliForm: IzinTalepImzaliForm | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    izinOnayGorevleri: IzinOnayGorevi[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IIzinTalep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personelId = _data["personelId"];
            this.personel = _data["personel"] ? Person.fromJS(_data["personel"]) : <any>undefined;
            this.izinTipiId = _data["izinTipiId"];
            this.izinTipi = _data["izinTipi"] ? IzinTpi.fromJS(_data["izinTipi"]) : <any>undefined;
            this.talepDurumu = _data["talepDurumu"];
            this.izinBaslangicTarihi = _data["izinBaslangicTarihi"] ? new Date(_data["izinBaslangicTarihi"].toString()) : <any>undefined;
            this.izinBitisTarihi = _data["izinBitisTarihi"] ? new Date(_data["izinBitisTarihi"].toString()) : <any>undefined;
            this.izinBaslangicAni = _data["izinBaslangicAni"];
            this.izinBitisAni = _data["izinBitisAni"];
            this.acilDurumdaAranacakKisi = _data["acilDurumdaAranacakKisi"];
            this.acilDurumdaAranacakTelefonNo = _data["acilDurumdaAranacakTelefonNo"];
            this.isOffGun1Pazartesi = _data["isOffGun1Pazartesi"];
            this.isOffGun2Sali = _data["isOffGun2Sali"];
            this.isOffGun3Carsamba = _data["isOffGun3Carsamba"];
            this.isOffGun4Persembe = _data["isOffGun4Persembe"];
            this.isOffGun5Cuma = _data["isOffGun5Cuma"];
            this.isOffGun6Cumartesi = _data["isOffGun6Cumartesi"];
            this.isOffGun7Pazar = _data["isOffGun7Pazar"];
            this.aciklama = _data["aciklama"];
            this.izinliGunSayisi = _data["izinliGunSayisi"];
            this.izinTalepNo = _data["izinTalepNo"];
            this.bulunacagiAdres = _data["bulunacagiAdres"];
            this.yerineBakacakPersonel = _data["yerineBakacakPersonel"];
            this.logoNo = _data["logoNo"];
            this.imzaliForm = _data["imzaliForm"];
            this.projeId = _data["projeId"];
            this.proje = _data["proje"] ? Proje.fromJS(_data["proje"]) : <any>undefined;
            if (Array.isArray(_data["izinOnayGorevleri"])) {
                this.izinOnayGorevleri = [] as any;
                for (let item of _data["izinOnayGorevleri"])
                    this.izinOnayGorevleri.push(IzinOnayGorevi.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): IzinTalep {
        data = typeof data === 'object' ? data : {};
        let result = new IzinTalep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personelId"] = this.personelId;
        data["personel"] = this.personel ? this.personel.toJSON() : <any>undefined;
        data["izinTipiId"] = this.izinTipiId;
        data["izinTipi"] = this.izinTipi ? this.izinTipi.toJSON() : <any>undefined;
        data["talepDurumu"] = this.talepDurumu;
        data["izinBaslangicTarihi"] = this.izinBaslangicTarihi ? this.izinBaslangicTarihi.toISOString() : <any>undefined;
        data["izinBitisTarihi"] = this.izinBitisTarihi ? this.izinBitisTarihi.toISOString() : <any>undefined;
        data["izinBaslangicAni"] = this.izinBaslangicAni;
        data["izinBitisAni"] = this.izinBitisAni;
        data["acilDurumdaAranacakKisi"] = this.acilDurumdaAranacakKisi;
        data["acilDurumdaAranacakTelefonNo"] = this.acilDurumdaAranacakTelefonNo;
        data["isOffGun1Pazartesi"] = this.isOffGun1Pazartesi;
        data["isOffGun2Sali"] = this.isOffGun2Sali;
        data["isOffGun3Carsamba"] = this.isOffGun3Carsamba;
        data["isOffGun4Persembe"] = this.isOffGun4Persembe;
        data["isOffGun5Cuma"] = this.isOffGun5Cuma;
        data["isOffGun6Cumartesi"] = this.isOffGun6Cumartesi;
        data["isOffGun7Pazar"] = this.isOffGun7Pazar;
        data["aciklama"] = this.aciklama;
        data["izinliGunSayisi"] = this.izinliGunSayisi;
        data["izinTalepNo"] = this.izinTalepNo;
        data["bulunacagiAdres"] = this.bulunacagiAdres;
        data["yerineBakacakPersonel"] = this.yerineBakacakPersonel;
        data["logoNo"] = this.logoNo;
        data["imzaliForm"] = this.imzaliForm;
        data["projeId"] = this.projeId;
        data["proje"] = this.proje ? this.proje.toJSON() : <any>undefined;
        if (Array.isArray(this.izinOnayGorevleri)) {
            data["izinOnayGorevleri"] = [];
            for (let item of this.izinOnayGorevleri)
                data["izinOnayGorevleri"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): IzinTalep {
        const json = this.toJSON();
        let result = new IzinTalep();
        result.init(json);
        return result;
    }
}

export interface IIzinTalep {
    id: string | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    izinTipiId: string | undefined;
    izinTipi: IzinTpi | undefined;
    talepDurumu: IzinTalepTalepDurumu | undefined;
    izinBaslangicTarihi: Date | undefined;
    izinBitisTarihi: Date | undefined;
    izinBaslangicAni: IzinTalepIzinBaslangicAni | undefined;
    izinBitisAni: IzinTalepIzinBitisAni | undefined;
    acilDurumdaAranacakKisi: string | undefined;
    acilDurumdaAranacakTelefonNo: string | undefined;
    isOffGun1Pazartesi: boolean | undefined;
    isOffGun2Sali: boolean | undefined;
    isOffGun3Carsamba: boolean | undefined;
    isOffGun4Persembe: boolean | undefined;
    isOffGun5Cuma: boolean | undefined;
    isOffGun6Cumartesi: boolean | undefined;
    isOffGun7Pazar: boolean | undefined;
    aciklama: string | undefined;
    izinliGunSayisi: number | undefined;
    izinTalepNo: string | undefined;
    bulunacagiAdres: string | undefined;
    yerineBakacakPersonel: string | undefined;
    logoNo: string | undefined;
    imzaliForm: IzinTalepImzaliForm | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    izinOnayGorevleri: IzinOnayGorevi[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class IzinOnayci implements IIzinOnayci {
    id: string | undefined;
    normKadroId: string | undefined;
    normKadro: NormKadro | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    onaySira: number | undefined;
    toplamOnayAdimi: number | undefined;
    onayciNormKadroId: string | undefined;
    onayciNormKadro: NormKadro | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IIzinOnayci) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.normKadroId = _data["normKadroId"];
            this.normKadro = _data["normKadro"] ? NormKadro.fromJS(_data["normKadro"]) : <any>undefined;
            this.personelId = _data["personelId"];
            this.personel = _data["personel"] ? Person.fromJS(_data["personel"]) : <any>undefined;
            this.onaySira = _data["onaySira"];
            this.toplamOnayAdimi = _data["toplamOnayAdimi"];
            this.onayciNormKadroId = _data["onayciNormKadroId"];
            this.onayciNormKadro = _data["onayciNormKadro"] ? NormKadro.fromJS(_data["onayciNormKadro"]) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): IzinOnayci {
        data = typeof data === 'object' ? data : {};
        let result = new IzinOnayci();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["normKadroId"] = this.normKadroId;
        data["normKadro"] = this.normKadro ? this.normKadro.toJSON() : <any>undefined;
        data["personelId"] = this.personelId;
        data["personel"] = this.personel ? this.personel.toJSON() : <any>undefined;
        data["onaySira"] = this.onaySira;
        data["toplamOnayAdimi"] = this.toplamOnayAdimi;
        data["onayciNormKadroId"] = this.onayciNormKadroId;
        data["onayciNormKadro"] = this.onayciNormKadro ? this.onayciNormKadro.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): IzinOnayci {
        const json = this.toJSON();
        let result = new IzinOnayci();
        result.init(json);
        return result;
    }
}

export interface IIzinOnayci {
    id: string | undefined;
    normKadroId: string | undefined;
    normKadro: NormKadro | undefined;
    personelId: string | undefined;
    personel: Person | undefined;
    onaySira: number | undefined;
    toplamOnayAdimi: number | undefined;
    onayciNormKadroId: string | undefined;
    onayciNormKadro: NormKadro | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class PoiTuru implements IPoiTuru {
    id: string | undefined;
    locationTypeId: number | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IPoiTuru) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationTypeId = _data["locationTypeId"];
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): PoiTuru {
        data = typeof data === 'object' ? data : {};
        let result = new PoiTuru();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationTypeId"] = this.locationTypeId;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): PoiTuru {
        const json = this.toJSON();
        let result = new PoiTuru();
        result.init(json);
        return result;
    }
}

export interface IPoiTuru {
    id: string | undefined;
    locationTypeId: number | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class GorevFormSoru implements IGorevFormSoru {
    id: string | undefined;
    soruMetni: string | undefined;
    sortIndex: number | undefined;
    placeHolderText: string | undefined;
    kontrolTipi: number | undefined;
    isInvisible: boolean | undefined;
    isZorunlu: boolean | undefined;
    zorunluAlanMesaji: string | undefined;
    ekranId: string | undefined;
    ekran: GorevFormEkran | undefined;
    soruTextAyar: GorevFormSoruText | undefined;
    soruSecenecekList: GorevFormSoruSecenek[] | undefined;
    soruSecenecekAyarList: GorevFormSoruSecenekAyar[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IGorevFormSoru) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.soruMetni = _data["soruMetni"];
            this.sortIndex = _data["sortIndex"];
            this.placeHolderText = _data["placeHolderText"];
            this.kontrolTipi = _data["kontrolTipi"];
            this.isInvisible = _data["isInvisible"];
            this.isZorunlu = _data["isZorunlu"];
            this.zorunluAlanMesaji = _data["zorunluAlanMesaji"];
            this.ekranId = _data["ekranId"];
            this.ekran = _data["ekran"] ? GorevFormEkran.fromJS(_data["ekran"]) : <any>undefined;
            this.soruTextAyar = _data["soruTextAyar"] ? GorevFormSoruText.fromJS(_data["soruTextAyar"]) : <any>undefined;
            if (Array.isArray(_data["soruSecenecekList"])) {
                this.soruSecenecekList = [] as any;
                for (let item of _data["soruSecenecekList"])
                    this.soruSecenecekList.push(GorevFormSoruSecenek.fromJS(item));
            }
            if (Array.isArray(_data["soruSecenecekAyarList"])) {
                this.soruSecenecekAyarList = [] as any;
                for (let item of _data["soruSecenecekAyarList"])
                    this.soruSecenecekAyarList.push(GorevFormSoruSecenekAyar.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): GorevFormSoru {
        data = typeof data === 'object' ? data : {};
        let result = new GorevFormSoru();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["soruMetni"] = this.soruMetni;
        data["sortIndex"] = this.sortIndex;
        data["placeHolderText"] = this.placeHolderText;
        data["kontrolTipi"] = this.kontrolTipi;
        data["isInvisible"] = this.isInvisible;
        data["isZorunlu"] = this.isZorunlu;
        data["zorunluAlanMesaji"] = this.zorunluAlanMesaji;
        data["ekranId"] = this.ekranId;
        data["ekran"] = this.ekran ? this.ekran.toJSON() : <any>undefined;
        data["soruTextAyar"] = this.soruTextAyar ? this.soruTextAyar.toJSON() : <any>undefined;
        if (Array.isArray(this.soruSecenecekList)) {
            data["soruSecenecekList"] = [];
            for (let item of this.soruSecenecekList)
                data["soruSecenecekList"].push(item.toJSON());
        }
        if (Array.isArray(this.soruSecenecekAyarList)) {
            data["soruSecenecekAyarList"] = [];
            for (let item of this.soruSecenecekAyarList)
                data["soruSecenecekAyarList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): GorevFormSoru {
        const json = this.toJSON();
        let result = new GorevFormSoru();
        result.init(json);
        return result;
    }
}

export interface IGorevFormSoru {
    id: string | undefined;
    soruMetni: string | undefined;
    sortIndex: number | undefined;
    placeHolderText: string | undefined;
    kontrolTipi: number | undefined;
    isInvisible: boolean | undefined;
    isZorunlu: boolean | undefined;
    zorunluAlanMesaji: string | undefined;
    ekranId: string | undefined;
    ekran: GorevFormEkran | undefined;
    soruTextAyar: GorevFormSoruText | undefined;
    soruSecenecekList: GorevFormSoruSecenek[] | undefined;
    soruSecenecekAyarList: GorevFormSoruSecenekAyar[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class ProjeDonemi implements IProjeDonemi {
    id: string | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    donemId: string | undefined;
    donem: Donem | undefined;
    durum: ProjeDonemiDurum | undefined;
    isPuantajOlusturuldu: boolean | undefined;
    puantajOnayTarihi: Date | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IProjeDonemi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projeId = _data["projeId"];
            this.proje = _data["proje"] ? Proje.fromJS(_data["proje"]) : <any>undefined;
            this.donemId = _data["donemId"];
            this.donem = _data["donem"] ? Donem.fromJS(_data["donem"]) : <any>undefined;
            this.durum = _data["durum"];
            this.isPuantajOlusturuldu = _data["isPuantajOlusturuldu"];
            this.puantajOnayTarihi = _data["puantajOnayTarihi"] ? new Date(_data["puantajOnayTarihi"].toString()) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): ProjeDonemi {
        data = typeof data === 'object' ? data : {};
        let result = new ProjeDonemi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projeId"] = this.projeId;
        data["proje"] = this.proje ? this.proje.toJSON() : <any>undefined;
        data["donemId"] = this.donemId;
        data["donem"] = this.donem ? this.donem.toJSON() : <any>undefined;
        data["durum"] = this.durum;
        data["isPuantajOlusturuldu"] = this.isPuantajOlusturuldu;
        data["puantajOnayTarihi"] = this.puantajOnayTarihi ? this.puantajOnayTarihi.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): ProjeDonemi {
        const json = this.toJSON();
        let result = new ProjeDonemi();
        result.init(json);
        return result;
    }
}

export interface IProjeDonemi {
    id: string | undefined;
    projeId: string | undefined;
    proje: Proje | undefined;
    donemId: string | undefined;
    donem: Donem | undefined;
    durum: ProjeDonemiDurum | undefined;
    isPuantajOlusturuldu: boolean | undefined;
    puantajOnayTarihi: Date | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class MasrafHesapGrubu implements IMasrafHesapGrubu {
    id: string | undefined;
    masrafAnaKategorileri: MasrafAnaKategori[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IMasrafHesapGrubu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["masrafAnaKategorileri"])) {
                this.masrafAnaKategorileri = [] as any;
                for (let item of _data["masrafAnaKategorileri"])
                    this.masrafAnaKategorileri.push(MasrafAnaKategori.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): MasrafHesapGrubu {
        data = typeof data === 'object' ? data : {};
        let result = new MasrafHesapGrubu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.masrafAnaKategorileri)) {
            data["masrafAnaKategorileri"] = [];
            for (let item of this.masrafAnaKategorileri)
                data["masrafAnaKategorileri"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): MasrafHesapGrubu {
        const json = this.toJSON();
        let result = new MasrafHesapGrubu();
        result.init(json);
        return result;
    }
}

export interface IMasrafHesapGrubu {
    id: string | undefined;
    masrafAnaKategorileri: MasrafAnaKategori[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class IzinTpi implements IIzinTpi {
    id: string | undefined;
    portalMesaj: string | undefined;
    kisaKod: string | undefined;
    siralama: number | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IIzinTpi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.portalMesaj = _data["portalMesaj"];
            this.kisaKod = _data["kisaKod"];
            this.siralama = _data["siralama"];
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): IzinTpi {
        data = typeof data === 'object' ? data : {};
        let result = new IzinTpi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["portalMesaj"] = this.portalMesaj;
        data["kisaKod"] = this.kisaKod;
        data["siralama"] = this.siralama;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): IzinTpi {
        const json = this.toJSON();
        let result = new IzinTpi();
        result.init(json);
        return result;
    }
}

export interface IIzinTpi {
    id: string | undefined;
    portalMesaj: string | undefined;
    kisaKod: string | undefined;
    siralama: number | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class GorevFormSoruText implements IGorevFormSoruText {
    id: string | undefined;
    textTipi: number | undefined;
    min: number | undefined;
    max: number | undefined;
    minMesaj: string | undefined;
    maxMesaj: string | undefined;
    defaultMesaj: string | undefined;
    soruId: string | undefined;
    soru: GorevFormSoru | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IGorevFormSoruText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.textTipi = _data["textTipi"];
            this.min = _data["min"];
            this.max = _data["max"];
            this.minMesaj = _data["minMesaj"];
            this.maxMesaj = _data["maxMesaj"];
            this.defaultMesaj = _data["defaultMesaj"];
            this.soruId = _data["soruId"];
            this.soru = _data["soru"] ? GorevFormSoru.fromJS(_data["soru"]) : <any>undefined;
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): GorevFormSoruText {
        data = typeof data === 'object' ? data : {};
        let result = new GorevFormSoruText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["textTipi"] = this.textTipi;
        data["min"] = this.min;
        data["max"] = this.max;
        data["minMesaj"] = this.minMesaj;
        data["maxMesaj"] = this.maxMesaj;
        data["defaultMesaj"] = this.defaultMesaj;
        data["soruId"] = this.soruId;
        data["soru"] = this.soru ? this.soru.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): GorevFormSoruText {
        const json = this.toJSON();
        let result = new GorevFormSoruText();
        result.init(json);
        return result;
    }
}

export interface IGorevFormSoruText {
    id: string | undefined;
    textTipi: number | undefined;
    min: number | undefined;
    max: number | undefined;
    minMesaj: string | undefined;
    maxMesaj: string | undefined;
    defaultMesaj: string | undefined;
    soruId: string | undefined;
    soru: GorevFormSoru | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class GorevFormSoruSecenek implements IGorevFormSoruSecenek {
    id: string | undefined;
    value: string | undefined;
    text: string | undefined;
    sortIndex: number | undefined;
    soruId: string | undefined;
    soru: GorevFormSoru | undefined;
    soruSecenekAyarList: GorevFormSoruSecenekAyar[] | undefined;
    secenekSoruIliskisiList: GorevFormSecenekSoruIliskisi[] | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IGorevFormSoruSecenek) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.text = _data["text"];
            this.sortIndex = _data["sortIndex"];
            this.soruId = _data["soruId"];
            this.soru = _data["soru"] ? GorevFormSoru.fromJS(_data["soru"]) : <any>undefined;
            if (Array.isArray(_data["soruSecenekAyarList"])) {
                this.soruSecenekAyarList = [] as any;
                for (let item of _data["soruSecenekAyarList"])
                    this.soruSecenekAyarList.push(GorevFormSoruSecenekAyar.fromJS(item));
            }
            if (Array.isArray(_data["secenekSoruIliskisiList"])) {
                this.secenekSoruIliskisiList = [] as any;
                for (let item of _data["secenekSoruIliskisiList"])
                    this.secenekSoruIliskisiList.push(GorevFormSecenekSoruIliskisi.fromJS(item));
            }
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): GorevFormSoruSecenek {
        data = typeof data === 'object' ? data : {};
        let result = new GorevFormSoruSecenek();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["text"] = this.text;
        data["sortIndex"] = this.sortIndex;
        data["soruId"] = this.soruId;
        data["soru"] = this.soru ? this.soru.toJSON() : <any>undefined;
        if (Array.isArray(this.soruSecenekAyarList)) {
            data["soruSecenekAyarList"] = [];
            for (let item of this.soruSecenekAyarList)
                data["soruSecenekAyarList"].push(item.toJSON());
        }
        if (Array.isArray(this.secenekSoruIliskisiList)) {
            data["secenekSoruIliskisiList"] = [];
            for (let item of this.secenekSoruIliskisiList)
                data["secenekSoruIliskisiList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): GorevFormSoruSecenek {
        const json = this.toJSON();
        let result = new GorevFormSoruSecenek();
        result.init(json);
        return result;
    }
}

export interface IGorevFormSoruSecenek {
    id: string | undefined;
    value: string | undefined;
    text: string | undefined;
    sortIndex: number | undefined;
    soruId: string | undefined;
    soru: GorevFormSoru | undefined;
    soruSecenekAyarList: GorevFormSoruSecenekAyar[] | undefined;
    secenekSoruIliskisiList: GorevFormSecenekSoruIliskisi[] | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class GorevFormSoruSecenekAyar implements IGorevFormSoruSecenekAyar {
    id: string | undefined;
    secenekId: string | undefined;
    secenek: GorevFormSoruSecenek | undefined;
    soruId: string | undefined;
    soru: GorevFormSoru | undefined;
    varsayilanDeger: string | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IGorevFormSoruSecenekAyar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.secenekId = _data["secenekId"];
            this.secenek = _data["secenek"] ? GorevFormSoruSecenek.fromJS(_data["secenek"]) : <any>undefined;
            this.soruId = _data["soruId"];
            this.soru = _data["soru"] ? GorevFormSoru.fromJS(_data["soru"]) : <any>undefined;
            this.varsayilanDeger = _data["varsayilanDeger"];
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): GorevFormSoruSecenekAyar {
        data = typeof data === 'object' ? data : {};
        let result = new GorevFormSoruSecenekAyar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["secenekId"] = this.secenekId;
        data["secenek"] = this.secenek ? this.secenek.toJSON() : <any>undefined;
        data["soruId"] = this.soruId;
        data["soru"] = this.soru ? this.soru.toJSON() : <any>undefined;
        data["varsayilanDeger"] = this.varsayilanDeger;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): GorevFormSoruSecenekAyar {
        const json = this.toJSON();
        let result = new GorevFormSoruSecenekAyar();
        result.init(json);
        return result;
    }
}

export interface IGorevFormSoruSecenekAyar {
    id: string | undefined;
    secenekId: string | undefined;
    secenek: GorevFormSoruSecenek | undefined;
    soruId: string | undefined;
    soru: GorevFormSoru | undefined;
    varsayilanDeger: string | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class GorevFormSecenekSoruIliskisi implements IGorevFormSecenekSoruIliskisi {
    id: string | undefined;
    secenekId: string | undefined;
    secenek: GorevFormSoruSecenek | undefined;
    soruId: string | undefined;
    soru: GorevFormSoru | undefined;
    aciklama: string | undefined;
    name: string | undefined;
    readonly nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;

    constructor(data?: IGorevFormSecenekSoruIliskisi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.secenekId = _data["secenekId"];
            this.secenek = _data["secenek"] ? GorevFormSoruSecenek.fromJS(_data["secenek"]) : <any>undefined;
            this.soruId = _data["soruId"];
            this.soru = _data["soru"] ? GorevFormSoru.fromJS(_data["soru"]) : <any>undefined;
            this.aciklama = _data["aciklama"];
            this.name = _data["name"];
            (<any>this).nameUniversal = _data["nameUniversal"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): GorevFormSecenekSoruIliskisi {
        data = typeof data === 'object' ? data : {};
        let result = new GorevFormSecenekSoruIliskisi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["secenekId"] = this.secenekId;
        data["secenek"] = this.secenek ? this.secenek.toJSON() : <any>undefined;
        data["soruId"] = this.soruId;
        data["soru"] = this.soru ? this.soru.toJSON() : <any>undefined;
        data["aciklama"] = this.aciklama;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): GorevFormSecenekSoruIliskisi {
        const json = this.toJSON();
        let result = new GorevFormSecenekSoruIliskisi();
        result.init(json);
        return result;
    }
}

export interface IGorevFormSecenekSoruIliskisi {
    id: string | undefined;
    secenekId: string | undefined;
    secenek: GorevFormSoruSecenek | undefined;
    soruId: string | undefined;
    soru: GorevFormSoru | undefined;
    aciklama: string | undefined;
    name: string | undefined;
    nameUniversal: string | undefined;
    createdBy: string | undefined;
    createdOn: Date | undefined;
    modifiedBy: string | undefined;
    modifiedOn: Date | undefined;
    stateCode: number | undefined;
}

export class PlatomPortalFilterDto implements IPlatomPortalFilterDto {
    platomPortalFilterId: string | undefined;
    personelId: string | undefined;
    iliskiliModul: string | undefined;
    filtreAdi: string | undefined;
    aciklama: string | undefined;
    filtreParametreleri: string | undefined;
    filtreParametreleriModals: GridFilterModal[] | undefined;

    constructor(data?: IPlatomPortalFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platomPortalFilterId = _data["platomPortalFilterId"];
            this.personelId = _data["personelId"];
            this.iliskiliModul = _data["iliskiliModul"];
            this.filtreAdi = _data["filtreAdi"];
            this.aciklama = _data["aciklama"];
            this.filtreParametreleri = _data["filtreParametreleri"];
            if (Array.isArray(_data["filtreParametreleriModals"])) {
                this.filtreParametreleriModals = [] as any;
                for (let item of _data["filtreParametreleriModals"])
                    this.filtreParametreleriModals.push(GridFilterModal.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlatomPortalFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlatomPortalFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platomPortalFilterId"] = this.platomPortalFilterId;
        data["personelId"] = this.personelId;
        data["iliskiliModul"] = this.iliskiliModul;
        data["filtreAdi"] = this.filtreAdi;
        data["aciklama"] = this.aciklama;
        data["filtreParametreleri"] = this.filtreParametreleri;
        if (Array.isArray(this.filtreParametreleriModals)) {
            data["filtreParametreleriModals"] = [];
            for (let item of this.filtreParametreleriModals)
                data["filtreParametreleriModals"].push(item.toJSON());
        }
        return data;
    }

    clone(): PlatomPortalFilterDto {
        const json = this.toJSON();
        let result = new PlatomPortalFilterDto();
        result.init(json);
        return result;
    }
}

export interface IPlatomPortalFilterDto {
    platomPortalFilterId: string | undefined;
    personelId: string | undefined;
    iliskiliModul: string | undefined;
    filtreAdi: string | undefined;
    aciklama: string | undefined;
    filtreParametreleri: string | undefined;
    filtreParametreleriModals: GridFilterModal[] | undefined;
}

export class ListItemDto implements IListItemDto {
    id: any | undefined;
    text: any | undefined;

    constructor(data?: IListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): ListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }

    clone(): ListItemDto {
        const json = this.toJSON();
        let result = new ListItemDto();
        result.init(json);
        return result;
    }
}

export interface IListItemDto {
    id: any | undefined;
    text: any | undefined;
}

export class CreateLaunchDto implements ICreateLaunchDto {
    name: string;
    firmaId: string | undefined;
    markaId: string;
    baslangicTarihi: Date;
    butce: number | undefined;
    aciklama: string | undefined;
    id: string | undefined;

    constructor(data?: ICreateLaunchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.firmaId = _data["firmaId"];
            this.markaId = _data["markaId"];
            this.baslangicTarihi = _data["baslangicTarihi"] ? new Date(_data["baslangicTarihi"].toString()) : <any>undefined;
            this.butce = _data["butce"];
            this.aciklama = _data["aciklama"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateLaunchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLaunchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["firmaId"] = this.firmaId;
        data["markaId"] = this.markaId;
        data["baslangicTarihi"] = this.baslangicTarihi ? this.baslangicTarihi.toISOString() : <any>undefined;
        data["butce"] = this.butce;
        data["aciklama"] = this.aciklama;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateLaunchDto {
        const json = this.toJSON();
        let result = new CreateLaunchDto();
        result.init(json);
        return result;
    }
}

export interface ICreateLaunchDto {
    name: string;
    firmaId: string | undefined;
    markaId: string;
    baslangicTarihi: Date;
    butce: number | undefined;
    aciklama: string | undefined;
    id: string | undefined;
}

export class LaunchSettingsDto implements ILaunchSettingsDto {
    launchId: string | undefined;
    isSahaPosmTaleplerineAcik: boolean | undefined;
    isSpvChipDagitiminaAcik: boolean | undefined;

    constructor(data?: ILaunchSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.launchId = _data["launchId"];
            this.isSahaPosmTaleplerineAcik = _data["isSahaPosmTaleplerineAcik"];
            this.isSpvChipDagitiminaAcik = _data["isSpvChipDagitiminaAcik"];
        }
    }

    static fromJS(data: any): LaunchSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaunchSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["launchId"] = this.launchId;
        data["isSahaPosmTaleplerineAcik"] = this.isSahaPosmTaleplerineAcik;
        data["isSpvChipDagitiminaAcik"] = this.isSpvChipDagitiminaAcik;
        return data;
    }

    clone(): LaunchSettingsDto {
        const json = this.toJSON();
        let result = new LaunchSettingsDto();
        result.init(json);
        return result;
    }
}

export interface ILaunchSettingsDto {
    launchId: string | undefined;
    isSahaPosmTaleplerineAcik: boolean | undefined;
    isSpvChipDagitiminaAcik: boolean | undefined;
}

export class PagedResultDtoOfLaunchDto implements IPagedResultDtoOfLaunchDto {
    totalCount: number | undefined;
    items: LaunchDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLaunchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LaunchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLaunchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLaunchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfLaunchDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfLaunchDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfLaunchDto {
    totalCount: number | undefined;
    items: LaunchDto[] | undefined;
}

export class LaunchDto implements ILaunchDto {
    name: string | undefined;
    sistemKodu: string | undefined;
    firmaId: string | undefined;
    firmaAdi: string | undefined;
    markaId: string | undefined;
    marka: string | undefined;
    baslangicTarihi: Date | undefined;
    butce: number | undefined;
    aciklama: string | undefined;
    posmAdet: number | undefined;
    isSupervisoreChipDagitiminaAcik: boolean | undefined;
    isSahaTaleplerineAcik: boolean | undefined;
    id: string | undefined;

    constructor(data?: ILaunchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sistemKodu = _data["sistemKodu"];
            this.firmaId = _data["firmaId"];
            this.firmaAdi = _data["firmaAdi"];
            this.markaId = _data["markaId"];
            this.marka = _data["marka"];
            this.baslangicTarihi = _data["baslangicTarihi"] ? new Date(_data["baslangicTarihi"].toString()) : <any>undefined;
            this.butce = _data["butce"];
            this.aciklama = _data["aciklama"];
            this.posmAdet = _data["posmAdet"];
            this.isSupervisoreChipDagitiminaAcik = _data["isSupervisoreChipDagitiminaAcik"];
            this.isSahaTaleplerineAcik = _data["isSahaTaleplerineAcik"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LaunchDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaunchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sistemKodu"] = this.sistemKodu;
        data["firmaId"] = this.firmaId;
        data["firmaAdi"] = this.firmaAdi;
        data["markaId"] = this.markaId;
        data["marka"] = this.marka;
        data["baslangicTarihi"] = this.baslangicTarihi ? this.baslangicTarihi.toISOString() : <any>undefined;
        data["butce"] = this.butce;
        data["aciklama"] = this.aciklama;
        data["posmAdet"] = this.posmAdet;
        data["isSupervisoreChipDagitiminaAcik"] = this.isSupervisoreChipDagitiminaAcik;
        data["isSahaTaleplerineAcik"] = this.isSahaTaleplerineAcik;
        data["id"] = this.id;
        return data;
    }

    clone(): LaunchDto {
        const json = this.toJSON();
        let result = new LaunchDto();
        result.init(json);
        return result;
    }
}

export interface ILaunchDto {
    name: string | undefined;
    sistemKodu: string | undefined;
    firmaId: string | undefined;
    firmaAdi: string | undefined;
    markaId: string | undefined;
    marka: string | undefined;
    baslangicTarihi: Date | undefined;
    butce: number | undefined;
    aciklama: string | undefined;
    posmAdet: number | undefined;
    isSupervisoreChipDagitiminaAcik: boolean | undefined;
    isSahaTaleplerineAcik: boolean | undefined;
    id: string | undefined;
}

export class PosmDto implements IPosmDto {
    name: string | undefined;
    posmKodu: string | undefined;
    markalar: string[] | undefined;
    durum: string | undefined;
    uretimToplamIslemAdimi: number | undefined;
    uretimGuncelIslemAdimNo: number | undefined;
    tasarimToplamIslemAdimi: number | undefined;
    tasarimGuncelIslemAdimNo: number | undefined;
    uretimGuncelFirma: string | undefined;
    uretimGuncelYetkili: string | undefined;
    tasarimGuncelFirma: string | undefined;
    tasarimGuncelYetkili: string | undefined;
    butcePuani: number | undefined;
    isNumuneKullanimi: boolean | undefined;
    readonly uretimGoreviTamamlanmaDurumu: number | undefined;
    readonly tasarimGoreviTamamlanmaDurumu: number | undefined;
    id: string | undefined;

    constructor(data?: IPosmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.posmKodu = _data["posmKodu"];
            if (Array.isArray(_data["markalar"])) {
                this.markalar = [] as any;
                for (let item of _data["markalar"])
                    this.markalar.push(item);
            }
            this.durum = _data["durum"];
            this.uretimToplamIslemAdimi = _data["uretimToplamIslemAdimi"];
            this.uretimGuncelIslemAdimNo = _data["uretimGuncelIslemAdimNo"];
            this.tasarimToplamIslemAdimi = _data["tasarimToplamIslemAdimi"];
            this.tasarimGuncelIslemAdimNo = _data["tasarimGuncelIslemAdimNo"];
            this.uretimGuncelFirma = _data["uretimGuncelFirma"];
            this.uretimGuncelYetkili = _data["uretimGuncelYetkili"];
            this.tasarimGuncelFirma = _data["tasarimGuncelFirma"];
            this.tasarimGuncelYetkili = _data["tasarimGuncelYetkili"];
            this.butcePuani = _data["butcePuani"];
            this.isNumuneKullanimi = _data["isNumuneKullanimi"];
            (<any>this).uretimGoreviTamamlanmaDurumu = _data["uretimGoreviTamamlanmaDurumu"];
            (<any>this).tasarimGoreviTamamlanmaDurumu = _data["tasarimGoreviTamamlanmaDurumu"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PosmDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["posmKodu"] = this.posmKodu;
        if (Array.isArray(this.markalar)) {
            data["markalar"] = [];
            for (let item of this.markalar)
                data["markalar"].push(item);
        }
        data["durum"] = this.durum;
        data["uretimToplamIslemAdimi"] = this.uretimToplamIslemAdimi;
        data["uretimGuncelIslemAdimNo"] = this.uretimGuncelIslemAdimNo;
        data["tasarimToplamIslemAdimi"] = this.tasarimToplamIslemAdimi;
        data["tasarimGuncelIslemAdimNo"] = this.tasarimGuncelIslemAdimNo;
        data["uretimGuncelFirma"] = this.uretimGuncelFirma;
        data["uretimGuncelYetkili"] = this.uretimGuncelYetkili;
        data["tasarimGuncelFirma"] = this.tasarimGuncelFirma;
        data["tasarimGuncelYetkili"] = this.tasarimGuncelYetkili;
        data["butcePuani"] = this.butcePuani;
        data["isNumuneKullanimi"] = this.isNumuneKullanimi;
        data["uretimGoreviTamamlanmaDurumu"] = this.uretimGoreviTamamlanmaDurumu;
        data["tasarimGoreviTamamlanmaDurumu"] = this.tasarimGoreviTamamlanmaDurumu;
        data["id"] = this.id;
        return data;
    }

    clone(): PosmDto {
        const json = this.toJSON();
        let result = new PosmDto();
        result.init(json);
        return result;
    }
}

export interface IPosmDto {
    name: string | undefined;
    posmKodu: string | undefined;
    markalar: string[] | undefined;
    durum: string | undefined;
    uretimToplamIslemAdimi: number | undefined;
    uretimGuncelIslemAdimNo: number | undefined;
    tasarimToplamIslemAdimi: number | undefined;
    tasarimGuncelIslemAdimNo: number | undefined;
    uretimGuncelFirma: string | undefined;
    uretimGuncelYetkili: string | undefined;
    tasarimGuncelFirma: string | undefined;
    tasarimGuncelYetkili: string | undefined;
    butcePuani: number | undefined;
    isNumuneKullanimi: boolean | undefined;
    uretimGoreviTamamlanmaDurumu: number | undefined;
    tasarimGoreviTamamlanmaDurumu: number | undefined;
    id: string | undefined;
}

export class PosmProductionTaskDto implements IPosmProductionTaskDto {
    name: string | undefined;
    posmAdi: string | undefined;
    gorevTipi: PosmProductionTaskDtoGorevTipi | undefined;
    toplamOnayAdimi: number | undefined;
    onayAdimNo: number | undefined;
    gorevAciklama: string | undefined;
    gorevDetayAciklama: string | undefined;
    durum: PosmProductionTaskDtoDurum | undefined;
    gorevBitisTarihi: Date | undefined;
    tamamlanmaTarihi: Date | undefined;
    ilgiliFirma: string | undefined;
    sorumluAdSoyad: string | undefined;
    id: string | undefined;

    constructor(data?: IPosmProductionTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.posmAdi = _data["posmAdi"];
            this.gorevTipi = _data["gorevTipi"];
            this.toplamOnayAdimi = _data["toplamOnayAdimi"];
            this.onayAdimNo = _data["onayAdimNo"];
            this.gorevAciklama = _data["gorevAciklama"];
            this.gorevDetayAciklama = _data["gorevDetayAciklama"];
            this.durum = _data["durum"];
            this.gorevBitisTarihi = _data["gorevBitisTarihi"] ? new Date(_data["gorevBitisTarihi"].toString()) : <any>undefined;
            this.tamamlanmaTarihi = _data["tamamlanmaTarihi"] ? new Date(_data["tamamlanmaTarihi"].toString()) : <any>undefined;
            this.ilgiliFirma = _data["ilgiliFirma"];
            this.sorumluAdSoyad = _data["sorumluAdSoyad"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PosmProductionTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosmProductionTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["posmAdi"] = this.posmAdi;
        data["gorevTipi"] = this.gorevTipi;
        data["toplamOnayAdimi"] = this.toplamOnayAdimi;
        data["onayAdimNo"] = this.onayAdimNo;
        data["gorevAciklama"] = this.gorevAciklama;
        data["gorevDetayAciklama"] = this.gorevDetayAciklama;
        data["durum"] = this.durum;
        data["gorevBitisTarihi"] = this.gorevBitisTarihi ? this.gorevBitisTarihi.toISOString() : <any>undefined;
        data["tamamlanmaTarihi"] = this.tamamlanmaTarihi ? this.tamamlanmaTarihi.toISOString() : <any>undefined;
        data["ilgiliFirma"] = this.ilgiliFirma;
        data["sorumluAdSoyad"] = this.sorumluAdSoyad;
        data["id"] = this.id;
        return data;
    }

    clone(): PosmProductionTaskDto {
        const json = this.toJSON();
        let result = new PosmProductionTaskDto();
        result.init(json);
        return result;
    }
}

export interface IPosmProductionTaskDto {
    name: string | undefined;
    posmAdi: string | undefined;
    gorevTipi: PosmProductionTaskDtoGorevTipi | undefined;
    toplamOnayAdimi: number | undefined;
    onayAdimNo: number | undefined;
    gorevAciklama: string | undefined;
    gorevDetayAciklama: string | undefined;
    durum: PosmProductionTaskDtoDurum | undefined;
    gorevBitisTarihi: Date | undefined;
    tamamlanmaTarihi: Date | undefined;
    ilgiliFirma: string | undefined;
    sorumluAdSoyad: string | undefined;
    id: string | undefined;
}

export class PosmProductionTaskGroupDto implements IPosmProductionTaskGroupDto {
    name: string | undefined;
    lansmanAdi: string | undefined;
    gorevAciklama: string | undefined;
    gorevDetayAciklama: string | undefined;
    sorumluPersonel: string | undefined;
    sorumluFirma: string | undefined;
    gorevSonTarihi: Date | undefined;
    readonly isSureDoldu: boolean | undefined;
    id: string | undefined;

    constructor(data?: IPosmProductionTaskGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.lansmanAdi = _data["lansmanAdi"];
            this.gorevAciklama = _data["gorevAciklama"];
            this.gorevDetayAciklama = _data["gorevDetayAciklama"];
            this.sorumluPersonel = _data["sorumluPersonel"];
            this.sorumluFirma = _data["sorumluFirma"];
            this.gorevSonTarihi = _data["gorevSonTarihi"] ? new Date(_data["gorevSonTarihi"].toString()) : <any>undefined;
            (<any>this).isSureDoldu = _data["isSureDoldu"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PosmProductionTaskGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosmProductionTaskGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lansmanAdi"] = this.lansmanAdi;
        data["gorevAciklama"] = this.gorevAciklama;
        data["gorevDetayAciklama"] = this.gorevDetayAciklama;
        data["sorumluPersonel"] = this.sorumluPersonel;
        data["sorumluFirma"] = this.sorumluFirma;
        data["gorevSonTarihi"] = this.gorevSonTarihi ? this.gorevSonTarihi.toISOString() : <any>undefined;
        data["isSureDoldu"] = this.isSureDoldu;
        data["id"] = this.id;
        return data;
    }

    clone(): PosmProductionTaskGroupDto {
        const json = this.toJSON();
        let result = new PosmProductionTaskGroupDto();
        result.init(json);
        return result;
    }
}

export interface IPosmProductionTaskGroupDto {
    name: string | undefined;
    lansmanAdi: string | undefined;
    gorevAciklama: string | undefined;
    gorevDetayAciklama: string | undefined;
    sorumluPersonel: string | undefined;
    sorumluFirma: string | undefined;
    gorevSonTarihi: Date | undefined;
    isSureDoldu: boolean | undefined;
    id: string | undefined;
}

export class PosmProductionTaskInput implements IPosmProductionTaskInput {
    id: string | undefined;
    ilgiliFirma: string | undefined;
    sorumluPersonel: string | undefined;
    lansmanAdi: string | undefined;
    marka: string | undefined;
    posmAdi: string | undefined;
    posmTakipKodu: string | undefined;
    akisFormKodu: string | undefined;
    gorevTakipKodu: string | undefined;
    gorevAtanmaTarihi: Date | undefined;
    gorevBitisTarihi: Date | undefined;
    gorevinTamamlanmaTarihi: Date | undefined;
    durum: number | undefined;
    gorevDetayAciklama: string | undefined;
    gorevAciklama: string | undefined;
    revizeAciklamasi: string | undefined;
    revizeTalebiAciklamalari: RevizeTalebiAciklama[] | undefined;
    userData: UserData | undefined;

    constructor(data?: IPosmProductionTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ilgiliFirma = _data["ilgiliFirma"];
            this.sorumluPersonel = _data["sorumluPersonel"];
            this.lansmanAdi = _data["lansmanAdi"];
            this.marka = _data["marka"];
            this.posmAdi = _data["posmAdi"];
            this.posmTakipKodu = _data["posmTakipKodu"];
            this.akisFormKodu = _data["akisFormKodu"];
            this.gorevTakipKodu = _data["gorevTakipKodu"];
            this.gorevAtanmaTarihi = _data["gorevAtanmaTarihi"] ? new Date(_data["gorevAtanmaTarihi"].toString()) : <any>undefined;
            this.gorevBitisTarihi = _data["gorevBitisTarihi"] ? new Date(_data["gorevBitisTarihi"].toString()) : <any>undefined;
            this.gorevinTamamlanmaTarihi = _data["gorevinTamamlanmaTarihi"] ? new Date(_data["gorevinTamamlanmaTarihi"].toString()) : <any>undefined;
            this.durum = _data["durum"];
            this.gorevDetayAciklama = _data["gorevDetayAciklama"];
            this.gorevAciklama = _data["gorevAciklama"];
            this.revizeAciklamasi = _data["revizeAciklamasi"];
            if (Array.isArray(_data["revizeTalebiAciklamalari"])) {
                this.revizeTalebiAciklamalari = [] as any;
                for (let item of _data["revizeTalebiAciklamalari"])
                    this.revizeTalebiAciklamalari.push(RevizeTalebiAciklama.fromJS(item));
            }
            this.userData = _data["userData"] ? UserData.fromJS(_data["userData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PosmProductionTaskInput {
        data = typeof data === 'object' ? data : {};
        let result = new PosmProductionTaskInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ilgiliFirma"] = this.ilgiliFirma;
        data["sorumluPersonel"] = this.sorumluPersonel;
        data["lansmanAdi"] = this.lansmanAdi;
        data["marka"] = this.marka;
        data["posmAdi"] = this.posmAdi;
        data["posmTakipKodu"] = this.posmTakipKodu;
        data["akisFormKodu"] = this.akisFormKodu;
        data["gorevTakipKodu"] = this.gorevTakipKodu;
        data["gorevAtanmaTarihi"] = this.gorevAtanmaTarihi ? this.gorevAtanmaTarihi.toISOString() : <any>undefined;
        data["gorevBitisTarihi"] = this.gorevBitisTarihi ? this.gorevBitisTarihi.toISOString() : <any>undefined;
        data["gorevinTamamlanmaTarihi"] = this.gorevinTamamlanmaTarihi ? this.gorevinTamamlanmaTarihi.toISOString() : <any>undefined;
        data["durum"] = this.durum;
        data["gorevDetayAciklama"] = this.gorevDetayAciklama;
        data["gorevAciklama"] = this.gorevAciklama;
        data["revizeAciklamasi"] = this.revizeAciklamasi;
        if (Array.isArray(this.revizeTalebiAciklamalari)) {
            data["revizeTalebiAciklamalari"] = [];
            for (let item of this.revizeTalebiAciklamalari)
                data["revizeTalebiAciklamalari"].push(item.toJSON());
        }
        data["userData"] = this.userData ? this.userData.toJSON() : <any>undefined;
        return data;
    }

    clone(): PosmProductionTaskInput {
        const json = this.toJSON();
        let result = new PosmProductionTaskInput();
        result.init(json);
        return result;
    }
}

export interface IPosmProductionTaskInput {
    id: string | undefined;
    ilgiliFirma: string | undefined;
    sorumluPersonel: string | undefined;
    lansmanAdi: string | undefined;
    marka: string | undefined;
    posmAdi: string | undefined;
    posmTakipKodu: string | undefined;
    akisFormKodu: string | undefined;
    gorevTakipKodu: string | undefined;
    gorevAtanmaTarihi: Date | undefined;
    gorevBitisTarihi: Date | undefined;
    gorevinTamamlanmaTarihi: Date | undefined;
    durum: number | undefined;
    gorevDetayAciklama: string | undefined;
    gorevAciklama: string | undefined;
    revizeAciklamasi: string | undefined;
    revizeTalebiAciklamalari: RevizeTalebiAciklama[] | undefined;
    userData: UserData | undefined;
}

export class RevizeTalebiAciklama implements IRevizeTalebiAciklama {
    talebiYapanAdSoyad: string | undefined;
    aciklma: string | undefined;

    constructor(data?: IRevizeTalebiAciklama) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.talebiYapanAdSoyad = _data["talebiYapanAdSoyad"];
            this.aciklma = _data["aciklma"];
        }
    }

    static fromJS(data: any): RevizeTalebiAciklama {
        data = typeof data === 'object' ? data : {};
        let result = new RevizeTalebiAciklama();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["talebiYapanAdSoyad"] = this.talebiYapanAdSoyad;
        data["aciklma"] = this.aciklma;
        return data;
    }

    clone(): RevizeTalebiAciklama {
        const json = this.toJSON();
        let result = new RevizeTalebiAciklama();
        result.init(json);
        return result;
    }
}

export interface IRevizeTalebiAciklama {
    talebiYapanAdSoyad: string | undefined;
    aciklma: string | undefined;
}

export class UserData implements IUserData {
    girilenAciklama: string | undefined;
    uretimMiktari: number | undefined;
    gorselTasarimUrl: string | undefined;
    uretimButcesi: UretimButcesi[] | undefined;
    ureticiPlanlanaTeslim: UreticiTeslimTarih | undefined;
    depoTeslimBilgisi: DepoTeslimBilgi | undefined;
    sahaDagilimPlani: SahaDagilimPlani[] | undefined;

    constructor(data?: IUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.girilenAciklama = _data["girilenAciklama"];
            this.uretimMiktari = _data["uretimMiktari"];
            this.gorselTasarimUrl = _data["gorselTasarimUrl"];
            if (Array.isArray(_data["uretimButcesi"])) {
                this.uretimButcesi = [] as any;
                for (let item of _data["uretimButcesi"])
                    this.uretimButcesi.push(UretimButcesi.fromJS(item));
            }
            this.ureticiPlanlanaTeslim = _data["ureticiPlanlanaTeslim"] ? UreticiTeslimTarih.fromJS(_data["ureticiPlanlanaTeslim"]) : <any>undefined;
            this.depoTeslimBilgisi = _data["depoTeslimBilgisi"] ? DepoTeslimBilgi.fromJS(_data["depoTeslimBilgisi"]) : <any>undefined;
            if (Array.isArray(_data["sahaDagilimPlani"])) {
                this.sahaDagilimPlani = [] as any;
                for (let item of _data["sahaDagilimPlani"])
                    this.sahaDagilimPlani.push(SahaDagilimPlani.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserData {
        data = typeof data === 'object' ? data : {};
        let result = new UserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["girilenAciklama"] = this.girilenAciklama;
        data["uretimMiktari"] = this.uretimMiktari;
        data["gorselTasarimUrl"] = this.gorselTasarimUrl;
        if (Array.isArray(this.uretimButcesi)) {
            data["uretimButcesi"] = [];
            for (let item of this.uretimButcesi)
                data["uretimButcesi"].push(item.toJSON());
        }
        data["ureticiPlanlanaTeslim"] = this.ureticiPlanlanaTeslim ? this.ureticiPlanlanaTeslim.toJSON() : <any>undefined;
        data["depoTeslimBilgisi"] = this.depoTeslimBilgisi ? this.depoTeslimBilgisi.toJSON() : <any>undefined;
        if (Array.isArray(this.sahaDagilimPlani)) {
            data["sahaDagilimPlani"] = [];
            for (let item of this.sahaDagilimPlani)
                data["sahaDagilimPlani"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserData {
        const json = this.toJSON();
        let result = new UserData();
        result.init(json);
        return result;
    }
}

export interface IUserData {
    girilenAciklama: string | undefined;
    uretimMiktari: number | undefined;
    gorselTasarimUrl: string | undefined;
    uretimButcesi: UretimButcesi[] | undefined;
    ureticiPlanlanaTeslim: UreticiTeslimTarih | undefined;
    depoTeslimBilgisi: DepoTeslimBilgi | undefined;
    sahaDagilimPlani: SahaDagilimPlani[] | undefined;
}

export class UretimButcesi implements IUretimButcesi {
    butceAdi: string | undefined;
    tutar: number | undefined;

    constructor(data?: IUretimButcesi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.butceAdi = _data["butceAdi"];
            this.tutar = _data["tutar"];
        }
    }

    static fromJS(data: any): UretimButcesi {
        data = typeof data === 'object' ? data : {};
        let result = new UretimButcesi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["butceAdi"] = this.butceAdi;
        data["tutar"] = this.tutar;
        return data;
    }

    clone(): UretimButcesi {
        const json = this.toJSON();
        let result = new UretimButcesi();
        result.init(json);
        return result;
    }
}

export interface IUretimButcesi {
    butceAdi: string | undefined;
    tutar: number | undefined;
}

export class UreticiTeslimTarih implements IUreticiTeslimTarih {
    depoTeslim: Date | undefined;
    numuneTeslim: Date | undefined;

    constructor(data?: IUreticiTeslimTarih) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.depoTeslim = _data["depoTeslim"] ? new Date(_data["depoTeslim"].toString()) : <any>undefined;
            this.numuneTeslim = _data["numuneTeslim"] ? new Date(_data["numuneTeslim"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UreticiTeslimTarih {
        data = typeof data === 'object' ? data : {};
        let result = new UreticiTeslimTarih();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["depoTeslim"] = this.depoTeslim ? this.depoTeslim.toISOString() : <any>undefined;
        data["numuneTeslim"] = this.numuneTeslim ? this.numuneTeslim.toISOString() : <any>undefined;
        return data;
    }

    clone(): UreticiTeslimTarih {
        const json = this.toJSON();
        let result = new UreticiTeslimTarih();
        result.init(json);
        return result;
    }
}

export interface IUreticiTeslimTarih {
    depoTeslim: Date | undefined;
    numuneTeslim: Date | undefined;
}

export class DepoTeslimBilgi implements IDepoTeslimBilgi {
    irsaliyeNo: string | undefined;
    adet: number | undefined;
    teslimTarihi: Date | undefined;

    constructor(data?: IDepoTeslimBilgi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.irsaliyeNo = _data["irsaliyeNo"];
            this.adet = _data["adet"];
            this.teslimTarihi = _data["teslimTarihi"] ? new Date(_data["teslimTarihi"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DepoTeslimBilgi {
        data = typeof data === 'object' ? data : {};
        let result = new DepoTeslimBilgi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["irsaliyeNo"] = this.irsaliyeNo;
        data["adet"] = this.adet;
        data["teslimTarihi"] = this.teslimTarihi ? this.teslimTarihi.toISOString() : <any>undefined;
        return data;
    }

    clone(): DepoTeslimBilgi {
        const json = this.toJSON();
        let result = new DepoTeslimBilgi();
        result.init(json);
        return result;
    }
}

export interface IDepoTeslimBilgi {
    irsaliyeNo: string | undefined;
    adet: number | undefined;
    teslimTarihi: Date | undefined;
}

export class SahaDagilimPlani implements ISahaDagilimPlani {
    kanal: string | undefined;
    planlananTeslimTarihi: Date | undefined;

    constructor(data?: ISahaDagilimPlani) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kanal = _data["kanal"];
            this.planlananTeslimTarihi = _data["planlananTeslimTarihi"] ? new Date(_data["planlananTeslimTarihi"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SahaDagilimPlani {
        data = typeof data === 'object' ? data : {};
        let result = new SahaDagilimPlani();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kanal"] = this.kanal;
        data["planlananTeslimTarihi"] = this.planlananTeslimTarihi ? this.planlananTeslimTarihi.toISOString() : <any>undefined;
        return data;
    }

    clone(): SahaDagilimPlani {
        const json = this.toJSON();
        let result = new SahaDagilimPlani();
        result.init(json);
        return result;
    }
}

export interface ISahaDagilimPlani {
    kanal: string | undefined;
    planlananTeslimTarihi: Date | undefined;
}

export class CreatePosmDto implements ICreatePosmDto {
    name: string | undefined;
    lansmanId: string | undefined;
    markaId: string | undefined;
    markaDiger1Id: string | undefined;
    markaDiger2Id: string | undefined;
    posmTipId: string | undefined;
    butcePuani: number | undefined;
    isNumuneKullanimi: boolean | undefined;
    tasarimciFirmaId: string | undefined;
    ureticiFirmaId: string | undefined;
    sahaEkibiFirmaId: string | undefined;
    lojistikFirmaId: string | undefined;
    id: string | undefined;

    constructor(data?: ICreatePosmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.lansmanId = _data["lansmanId"];
            this.markaId = _data["markaId"];
            this.markaDiger1Id = _data["markaDiger1Id"];
            this.markaDiger2Id = _data["markaDiger2Id"];
            this.posmTipId = _data["posmTipId"];
            this.butcePuani = _data["butcePuani"];
            this.isNumuneKullanimi = _data["isNumuneKullanimi"];
            this.tasarimciFirmaId = _data["tasarimciFirmaId"];
            this.ureticiFirmaId = _data["ureticiFirmaId"];
            this.sahaEkibiFirmaId = _data["sahaEkibiFirmaId"];
            this.lojistikFirmaId = _data["lojistikFirmaId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePosmDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePosmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lansmanId"] = this.lansmanId;
        data["markaId"] = this.markaId;
        data["markaDiger1Id"] = this.markaDiger1Id;
        data["markaDiger2Id"] = this.markaDiger2Id;
        data["posmTipId"] = this.posmTipId;
        data["butcePuani"] = this.butcePuani;
        data["isNumuneKullanimi"] = this.isNumuneKullanimi;
        data["tasarimciFirmaId"] = this.tasarimciFirmaId;
        data["ureticiFirmaId"] = this.ureticiFirmaId;
        data["sahaEkibiFirmaId"] = this.sahaEkibiFirmaId;
        data["lojistikFirmaId"] = this.lojistikFirmaId;
        data["id"] = this.id;
        return data;
    }

    clone(): CreatePosmDto {
        const json = this.toJSON();
        let result = new CreatePosmDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePosmDto {
    name: string | undefined;
    lansmanId: string | undefined;
    markaId: string | undefined;
    markaDiger1Id: string | undefined;
    markaDiger2Id: string | undefined;
    posmTipId: string | undefined;
    butcePuani: number | undefined;
    isNumuneKullanimi: boolean | undefined;
    tasarimciFirmaId: string | undefined;
    ureticiFirmaId: string | undefined;
    sahaEkibiFirmaId: string | undefined;
    lojistikFirmaId: string | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfPosmProductionDemandDto implements IPagedResultDtoOfPosmProductionDemandDto {
    totalCount: number | undefined;
    items: PosmProductionDemandDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPosmProductionDemandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PosmProductionDemandDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPosmProductionDemandDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPosmProductionDemandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfPosmProductionDemandDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfPosmProductionDemandDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfPosmProductionDemandDto {
    totalCount: number | undefined;
    items: PosmProductionDemandDto[] | undefined;
}

export class PosmProductionDemandDto implements IPosmProductionDemandDto {
    productId: number | undefined;
    productName: string | undefined;
    productCode: string | undefined;
    customerId: number | undefined;
    estimatedProductionDate: Date | undefined;
    amount: number | undefined;
    supplierAddressId: number | undefined;
    supplierName: string | undefined;
    supplierAddress: string | undefined;
    id: number | undefined;

    constructor(data?: IPosmProductionDemandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
            this.customerId = _data["customerId"];
            this.estimatedProductionDate = _data["estimatedProductionDate"] ? new Date(_data["estimatedProductionDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.supplierAddressId = _data["supplierAddressId"];
            this.supplierName = _data["supplierName"];
            this.supplierAddress = _data["supplierAddress"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PosmProductionDemandDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosmProductionDemandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["customerId"] = this.customerId;
        data["estimatedProductionDate"] = this.estimatedProductionDate ? this.estimatedProductionDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["supplierAddressId"] = this.supplierAddressId;
        data["supplierName"] = this.supplierName;
        data["supplierAddress"] = this.supplierAddress;
        data["id"] = this.id;
        return data;
    }

    clone(): PosmProductionDemandDto {
        const json = this.toJSON();
        let result = new PosmProductionDemandDto();
        result.init(json);
        return result;
    }
}

export interface IPosmProductionDemandDto {
    productId: number | undefined;
    productName: string | undefined;
    productCode: string | undefined;
    customerId: number | undefined;
    estimatedProductionDate: Date | undefined;
    amount: number | undefined;
    supplierAddressId: number | undefined;
    supplierName: string | undefined;
    supplierAddress: string | undefined;
    id: number | undefined;
}

export class CreatePosmProductionDemandDto implements ICreatePosmProductionDemandDto {
    name: string | undefined;
    productId: number;
    customerId: number | undefined;
    estimatedProductionDate: Date;
    amount: number;
    supplierAddressId: number;
    comment: string | undefined;

    constructor(data?: ICreatePosmProductionDemandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.productId = _data["productId"];
            this.customerId = _data["customerId"];
            this.estimatedProductionDate = _data["estimatedProductionDate"] ? new Date(_data["estimatedProductionDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.supplierAddressId = _data["supplierAddressId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CreatePosmProductionDemandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePosmProductionDemandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["productId"] = this.productId;
        data["customerId"] = this.customerId;
        data["estimatedProductionDate"] = this.estimatedProductionDate ? this.estimatedProductionDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["supplierAddressId"] = this.supplierAddressId;
        data["comment"] = this.comment;
        return data;
    }

    clone(): CreatePosmProductionDemandDto {
        const json = this.toJSON();
        let result = new CreatePosmProductionDemandDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePosmProductionDemandDto {
    name: string | undefined;
    productId: number;
    customerId: number | undefined;
    estimatedProductionDate: Date;
    amount: number;
    supplierAddressId: number;
    comment: string | undefined;
}

export class PopRequestExcelUploadDto implements IPopRequestExcelUploadDto {
    base64: string | undefined;

    constructor(data?: IPopRequestExcelUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): PopRequestExcelUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new PopRequestExcelUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        return data;
    }

    clone(): PopRequestExcelUploadDto {
        const json = this.toJSON();
        let result = new PopRequestExcelUploadDto();
        result.init(json);
        return result;
    }
}

export interface IPopRequestExcelUploadDto {
    base64: string | undefined;
}

export class UserButceDto implements IUserButceDto {
    userId: string | undefined;
    userButceId: string | undefined;
    userUnvanId: string | undefined;
    name: string | undefined;
    butce: number | undefined;
    kalanButce: number | undefined;
    kullanilanButce: number | undefined;

    constructor(data?: IUserButceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userButceId = _data["userButceId"];
            this.userUnvanId = _data["userUnvanId"];
            this.name = _data["name"];
            this.butce = _data["butce"];
            this.kalanButce = _data["kalanButce"];
            this.kullanilanButce = _data["kullanilanButce"];
        }
    }

    static fromJS(data: any): UserButceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserButceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userButceId"] = this.userButceId;
        data["userUnvanId"] = this.userUnvanId;
        data["name"] = this.name;
        data["butce"] = this.butce;
        data["kalanButce"] = this.kalanButce;
        data["kullanilanButce"] = this.kullanilanButce;
        return data;
    }

    clone(): UserButceDto {
        const json = this.toJSON();
        let result = new UserButceDto();
        result.init(json);
        return result;
    }
}

export interface IUserButceDto {
    userId: string | undefined;
    userButceId: string | undefined;
    userUnvanId: string | undefined;
    name: string | undefined;
    butce: number | undefined;
    kalanButce: number | undefined;
    kullanilanButce: number | undefined;
}

export class UserAssignButceDto implements IUserAssignButceDto {
    userId: string | undefined;
    userUnvanId: string | undefined;
    userButceId: string | undefined;
    butce: number | undefined;

    constructor(data?: IUserAssignButceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userUnvanId = _data["userUnvanId"];
            this.userButceId = _data["userButceId"];
            this.butce = _data["butce"];
        }
    }

    static fromJS(data: any): UserAssignButceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAssignButceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userUnvanId"] = this.userUnvanId;
        data["userButceId"] = this.userButceId;
        data["butce"] = this.butce;
        return data;
    }

    clone(): UserAssignButceDto {
        const json = this.toJSON();
        let result = new UserAssignButceDto();
        result.init(json);
        return result;
    }
}

export interface IUserAssignButceDto {
    userId: string | undefined;
    userUnvanId: string | undefined;
    userButceId: string | undefined;
    butce: number | undefined;
}

export class ImagePredictionFormDto implements IImagePredictionFormDto {
    imageUrl: string | undefined;
    filePath: string | undefined;
    confidenceValue: number | undefined;
    gorevFormSonucKodu: string | undefined;
    projeTag: string | undefined;
    iteration: string | undefined;
    brand: string | undefined;
    epochValue: string | undefined;
    isStackClear: boolean | undefined;

    constructor(data?: IImagePredictionFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data["imageUrl"];
            this.filePath = _data["filePath"];
            this.confidenceValue = _data["confidenceValue"];
            this.gorevFormSonucKodu = _data["gorevFormSonucKodu"];
            this.projeTag = _data["projeTag"];
            this.iteration = _data["iteration"];
            this.brand = _data["brand"];
            this.epochValue = _data["epochValue"];
            this.isStackClear = _data["isStackClear"];
        }
    }

    static fromJS(data: any): ImagePredictionFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImagePredictionFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl;
        data["filePath"] = this.filePath;
        data["confidenceValue"] = this.confidenceValue;
        data["gorevFormSonucKodu"] = this.gorevFormSonucKodu;
        data["projeTag"] = this.projeTag;
        data["iteration"] = this.iteration;
        data["brand"] = this.brand;
        data["epochValue"] = this.epochValue;
        data["isStackClear"] = this.isStackClear;
        return data;
    }

    clone(): ImagePredictionFormDto {
        const json = this.toJSON();
        let result = new ImagePredictionFormDto();
        result.init(json);
        return result;
    }
}

export interface IImagePredictionFormDto {
    imageUrl: string | undefined;
    filePath: string | undefined;
    confidenceValue: number | undefined;
    gorevFormSonucKodu: string | undefined;
    projeTag: string | undefined;
    iteration: string | undefined;
    brand: string | undefined;
    epochValue: string | undefined;
    isStackClear: boolean | undefined;
}

export class PredictionResultDto implements IPredictionResultDto {
    id: string | undefined;
    gorevFormSonucId: string | undefined;
    fotoUrl: string | undefined;
    sonucFotoUrl: string | undefined;
    koordinatTextUrl: string | undefined;
    projeTag: string | undefined;
    predictJson: string | undefined;

    constructor(data?: IPredictionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gorevFormSonucId = _data["gorevFormSonucId"];
            this.fotoUrl = _data["fotoUrl"];
            this.sonucFotoUrl = _data["sonucFotoUrl"];
            this.koordinatTextUrl = _data["koordinatTextUrl"];
            this.projeTag = _data["projeTag"];
            this.predictJson = _data["predictJson"];
        }
    }

    static fromJS(data: any): PredictionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredictionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gorevFormSonucId"] = this.gorevFormSonucId;
        data["fotoUrl"] = this.fotoUrl;
        data["sonucFotoUrl"] = this.sonucFotoUrl;
        data["koordinatTextUrl"] = this.koordinatTextUrl;
        data["projeTag"] = this.projeTag;
        data["predictJson"] = this.predictJson;
        return data;
    }

    clone(): PredictionResultDto {
        const json = this.toJSON();
        let result = new PredictionResultDto();
        result.init(json);
        return result;
    }
}

export interface IPredictionResultDto {
    id: string | undefined;
    gorevFormSonucId: string | undefined;
    fotoUrl: string | undefined;
    sonucFotoUrl: string | undefined;
    koordinatTextUrl: string | undefined;
    projeTag: string | undefined;
    predictJson: string | undefined;
}

export class PredictionModelParamsDto implements IPredictionModelParamsDto {
    name: string | undefined;
    imageIterations: string[] | undefined;
    imageBrands: string[] | undefined;
    imageEpoches: string[] | undefined;

    constructor(data?: IPredictionModelParamsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["imageIterations"])) {
                this.imageIterations = [] as any;
                for (let item of _data["imageIterations"])
                    this.imageIterations.push(item);
            }
            if (Array.isArray(_data["imageBrands"])) {
                this.imageBrands = [] as any;
                for (let item of _data["imageBrands"])
                    this.imageBrands.push(item);
            }
            if (Array.isArray(_data["imageEpoches"])) {
                this.imageEpoches = [] as any;
                for (let item of _data["imageEpoches"])
                    this.imageEpoches.push(item);
            }
        }
    }

    static fromJS(data: any): PredictionModelParamsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredictionModelParamsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.imageIterations)) {
            data["imageIterations"] = [];
            for (let item of this.imageIterations)
                data["imageIterations"].push(item);
        }
        if (Array.isArray(this.imageBrands)) {
            data["imageBrands"] = [];
            for (let item of this.imageBrands)
                data["imageBrands"].push(item);
        }
        if (Array.isArray(this.imageEpoches)) {
            data["imageEpoches"] = [];
            for (let item of this.imageEpoches)
                data["imageEpoches"].push(item);
        }
        return data;
    }

    clone(): PredictionModelParamsDto {
        const json = this.toJSON();
        let result = new PredictionModelParamsDto();
        result.init(json);
        return result;
    }
}

export interface IPredictionModelParamsDto {
    name: string | undefined;
    imageIterations: string[] | undefined;
    imageBrands: string[] | undefined;
    imageEpoches: string[] | undefined;
}

export class FeedbackMaps implements IFeedbackMaps {
    label: string | undefined;
    comment: string | undefined;

    constructor(data?: IFeedbackMaps) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): FeedbackMaps {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackMaps();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["comment"] = this.comment;
        return data;
    }

    clone(): FeedbackMaps {
        const json = this.toJSON();
        let result = new FeedbackMaps();
        result.init(json);
        return result;
    }
}

export interface IFeedbackMaps {
    label: string | undefined;
    comment: string | undefined;
}

export class CreateProductDto implements ICreateProductDto {
    name: string | undefined;
    kod: string | undefined;
    wmsTip: string | undefined;
    stok: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.kod = _data["kod"];
            this.wmsTip = _data["wmsTip"];
            this.stok = _data["stok"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["kod"] = this.kod;
        data["wmsTip"] = this.wmsTip;
        data["stok"] = this.stok;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateProductDto {
        const json = this.toJSON();
        let result = new CreateProductDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProductDto {
    name: string | undefined;
    kod: string | undefined;
    wmsTip: string | undefined;
    stok: number | undefined;
    id: number | undefined;
}

export class ExcelPagedResultDtoOfProductExcelDto implements IExcelPagedResultDtoOfProductExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: ProductExcelDto[] | undefined;

    constructor(data?: IExcelPagedResultDtoOfProductExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns.push(ExcelColumn.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductExcelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExcelPagedResultDtoOfProductExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelPagedResultDtoOfProductExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ExcelPagedResultDtoOfProductExcelDto {
        const json = this.toJSON();
        let result = new ExcelPagedResultDtoOfProductExcelDto();
        result.init(json);
        return result;
    }
}

export interface IExcelPagedResultDtoOfProductExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: ProductExcelDto[] | undefined;
}

export class ProductExcelDto implements IProductExcelDto {
    name: string | undefined;
    kod: string | undefined;
    wmsTip: string | undefined;
    marka: string | undefined;
    stok: number | undefined;
    id: number | undefined;

    constructor(data?: IProductExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.kod = _data["kod"];
            this.wmsTip = _data["wmsTip"];
            this.marka = _data["marka"];
            this.stok = _data["stok"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["kod"] = this.kod;
        data["wmsTip"] = this.wmsTip;
        data["marka"] = this.marka;
        data["stok"] = this.stok;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductExcelDto {
        const json = this.toJSON();
        let result = new ProductExcelDto();
        result.init(json);
        return result;
    }
}

export interface IProductExcelDto {
    name: string | undefined;
    kod: string | undefined;
    wmsTip: string | undefined;
    marka: string | undefined;
    stok: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfProductDto implements IPagedResultDtoOfProductDto {
    totalCount: number | undefined;
    items: ProductDto[] | undefined;

    constructor(data?: IPagedResultDtoOfProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfProductDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfProductDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfProductDto {
    totalCount: number | undefined;
    items: ProductDto[] | undefined;
}

export class ProductDomainWarehouseInput implements IProductDomainWarehouseInput {
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;

    constructor(data?: IProductDomainWarehouseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ProductDomainWarehouseInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDomainWarehouseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }

    clone(): ProductDomainWarehouseInput {
        const json = this.toJSON();
        let result = new ProductDomainWarehouseInput();
        result.init(json);
        return result;
    }
}

export interface IProductDomainWarehouseInput {
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
}

export class ProductStockExcelDto implements IProductStockExcelDto {
    readonly photoPath: string | undefined;
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
    businessUnitName: string | undefined;
    brandName: string | undefined;
    campaignName: string | undefined;
    warehouseName: string | undefined;
    stock: number | undefined;
    blockedStock: number | undefined;
    type: string | undefined;
    type1Name: string | undefined;
    type2Name: string | undefined;
    type3Name: string | undefined;
    type4Name: string | undefined;
    group1Name: string | undefined;
    group2Name: string | undefined;
    merkezOnayliStok: number | undefined;
    onaySureciDevamEdenStok: number | undefined;

    constructor(data?: IProductStockExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).photoPath = _data["photoPath"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.businessUnitName = _data["businessUnitName"];
            this.brandName = _data["brandName"];
            this.campaignName = _data["campaignName"];
            this.warehouseName = _data["warehouseName"];
            this.stock = _data["stock"];
            this.blockedStock = _data["blockedStock"];
            this.type = _data["type"];
            this.type1Name = _data["type1Name"];
            this.type2Name = _data["type2Name"];
            this.type3Name = _data["type3Name"];
            this.type4Name = _data["type4Name"];
            this.group1Name = _data["group1Name"];
            this.group2Name = _data["group2Name"];
            this.merkezOnayliStok = _data["merkezOnayliStok"];
            this.onaySureciDevamEdenStok = _data["onaySureciDevamEdenStok"];
        }
    }

    static fromJS(data: any): ProductStockExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStockExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["photoPath"] = this.photoPath;
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["businessUnitName"] = this.businessUnitName;
        data["brandName"] = this.brandName;
        data["campaignName"] = this.campaignName;
        data["warehouseName"] = this.warehouseName;
        data["stock"] = this.stock;
        data["blockedStock"] = this.blockedStock;
        data["type"] = this.type;
        data["type1Name"] = this.type1Name;
        data["type2Name"] = this.type2Name;
        data["type3Name"] = this.type3Name;
        data["type4Name"] = this.type4Name;
        data["group1Name"] = this.group1Name;
        data["group2Name"] = this.group2Name;
        data["merkezOnayliStok"] = this.merkezOnayliStok;
        data["onaySureciDevamEdenStok"] = this.onaySureciDevamEdenStok;
        return data;
    }

    clone(): ProductStockExcelDto {
        const json = this.toJSON();
        let result = new ProductStockExcelDto();
        result.init(json);
        return result;
    }
}

export interface IProductStockExcelDto {
    photoPath: string | undefined;
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
    businessUnitName: string | undefined;
    brandName: string | undefined;
    campaignName: string | undefined;
    warehouseName: string | undefined;
    stock: number | undefined;
    blockedStock: number | undefined;
    type: string | undefined;
    type1Name: string | undefined;
    type2Name: string | undefined;
    type3Name: string | undefined;
    type4Name: string | undefined;
    group1Name: string | undefined;
    group2Name: string | undefined;
    merkezOnayliStok: number | undefined;
    onaySureciDevamEdenStok: number | undefined;
}

export class ProductVariationStocksOutputDto implements IProductVariationStocksOutputDto {
    noVariationTotalStock: number | undefined;
    products: ProductDto[] | undefined;

    constructor(data?: IProductVariationStocksOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noVariationTotalStock = _data["noVariationTotalStock"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(ProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductVariationStocksOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductVariationStocksOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noVariationTotalStock"] = this.noVariationTotalStock;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductVariationStocksOutputDto {
        const json = this.toJSON();
        let result = new ProductVariationStocksOutputDto();
        result.init(json);
        return result;
    }
}

export interface IProductVariationStocksOutputDto {
    noVariationTotalStock: number | undefined;
    products: ProductDto[] | undefined;
}

export class ProductDetailsDto implements IProductDetailsDto {
    product: ProductDto | undefined;
    warehouseStocks: ProductDetailsWarehouseStockDto[] | undefined;

    constructor(data?: IProductDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            if (Array.isArray(_data["warehouseStocks"])) {
                this.warehouseStocks = [] as any;
                for (let item of _data["warehouseStocks"])
                    this.warehouseStocks.push(ProductDetailsWarehouseStockDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        if (Array.isArray(this.warehouseStocks)) {
            data["warehouseStocks"] = [];
            for (let item of this.warehouseStocks)
                data["warehouseStocks"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductDetailsDto {
        const json = this.toJSON();
        let result = new ProductDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IProductDetailsDto {
    product: ProductDto | undefined;
    warehouseStocks: ProductDetailsWarehouseStockDto[] | undefined;
}

export class ProductDetailsWarehouseStockDto implements IProductDetailsWarehouseStockDto {
    warehouseCode: string | undefined;
    warehouseName: string | undefined;
    totalStock: number | undefined;

    constructor(data?: IProductDetailsWarehouseStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseCode = _data["warehouseCode"];
            this.warehouseName = _data["warehouseName"];
            this.totalStock = _data["totalStock"];
        }
    }

    static fromJS(data: any): ProductDetailsWarehouseStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDetailsWarehouseStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseCode"] = this.warehouseCode;
        data["warehouseName"] = this.warehouseName;
        data["totalStock"] = this.totalStock;
        return data;
    }

    clone(): ProductDetailsWarehouseStockDto {
        const json = this.toJSON();
        let result = new ProductDetailsWarehouseStockDto();
        result.init(json);
        return result;
    }
}

export interface IProductDetailsWarehouseStockDto {
    warehouseCode: string | undefined;
    warehouseName: string | undefined;
    totalStock: number | undefined;
}

export class ProductDomainUserOrderDto implements IProductDomainUserOrderDto {
    qty: number | undefined;
    userId: number | undefined;
    userName: string | undefined;
    productId: number | undefined;

    constructor(data?: IProductDomainUserOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qty = _data["qty"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): ProductDomainUserOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDomainUserOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qty"] = this.qty;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["productId"] = this.productId;
        return data;
    }

    clone(): ProductDomainUserOrderDto {
        const json = this.toJSON();
        let result = new ProductDomainUserOrderDto();
        result.init(json);
        return result;
    }
}

export interface IProductDomainUserOrderDto {
    qty: number | undefined;
    userId: number | undefined;
    userName: string | undefined;
    productId: number | undefined;
}

export class ProductDomainAddressOrderDto implements IProductDomainAddressOrderDto {
    qty: number | undefined;
    addressId: number | undefined;
    addressName: string | undefined;
    productId: number | undefined;

    constructor(data?: IProductDomainAddressOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qty = _data["qty"];
            this.addressId = _data["addressId"];
            this.addressName = _data["addressName"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): ProductDomainAddressOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDomainAddressOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qty"] = this.qty;
        data["addressId"] = this.addressId;
        data["addressName"] = this.addressName;
        data["productId"] = this.productId;
        return data;
    }

    clone(): ProductDomainAddressOrderDto {
        const json = this.toJSON();
        let result = new ProductDomainAddressOrderDto();
        result.init(json);
        return result;
    }
}

export interface IProductDomainAddressOrderDto {
    qty: number | undefined;
    addressId: number | undefined;
    addressName: string | undefined;
    productId: number | undefined;
}

export class PagedResultDtoOfProductAttributeDto implements IPagedResultDtoOfProductAttributeDto {
    totalCount: number | undefined;
    items: ProductAttributeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfProductAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductAttributeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProductAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProductAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfProductAttributeDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfProductAttributeDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfProductAttributeDto {
    totalCount: number | undefined;
    items: ProductAttributeDto[] | undefined;
}

export class ProductAttributeDto implements IProductAttributeDto {
    name: string | undefined;
    attributeType: string | undefined;
    id: number | undefined;

    constructor(data?: IProductAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.attributeType = _data["attributeType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["attributeType"] = this.attributeType;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductAttributeDto {
        const json = this.toJSON();
        let result = new ProductAttributeDto();
        result.init(json);
        return result;
    }
}

export interface IProductAttributeDto {
    name: string | undefined;
    attributeType: string | undefined;
    id: number | undefined;
}

export class CreateProductAttributeDto implements ICreateProductAttributeDto {
    name: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateProductAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateProductAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateProductAttributeDto {
        const json = this.toJSON();
        let result = new CreateProductAttributeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProductAttributeDto {
    name: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfProductDamageStatusDto implements IPagedResultDtoOfProductDamageStatusDto {
    totalCount: number | undefined;
    items: ProductDamageStatusDto[] | undefined;

    constructor(data?: IPagedResultDtoOfProductDamageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductDamageStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProductDamageStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProductDamageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfProductDamageStatusDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfProductDamageStatusDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfProductDamageStatusDto {
    totalCount: number | undefined;
    items: ProductDamageStatusDto[] | undefined;
}

export class ProductDamageStatusDto implements IProductDamageStatusDto {
    name: string | undefined;
    localizationKey: string | undefined;
    id: number | undefined;

    constructor(data?: IProductDamageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.localizationKey = _data["localizationKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductDamageStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDamageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["localizationKey"] = this.localizationKey;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductDamageStatusDto {
        const json = this.toJSON();
        let result = new ProductDamageStatusDto();
        result.init(json);
        return result;
    }
}

export interface IProductDamageStatusDto {
    name: string | undefined;
    localizationKey: string | undefined;
    id: number | undefined;
}

export class RvServerResponseDataDto implements IRvServerResponseDataDto {
    cityCountry: RvServerResponseContentDto | undefined;
    licencePlate: RvServerResponseContentDto | undefined;
    merchantAddress: RvServerResponseContentDto | undefined;
    merchantName: RvServerResponseContentDto | undefined;
    paymentType: RvServerResponseContentDto | undefined;
    taxNo: RvServerResponseContentDto | undefined;
    total: RvServerResponseContentDto | undefined;
    totalTax: RvServerResponseContentDto | undefined;
    transactionDate: RvServerResponseContentDto | undefined;
    transactionId: RvServerResponseContentDto | undefined;
    transactionTime: RvServerResponseContentDto | undefined;
    items: RvServerResponseItemsDto[] | undefined;

    constructor(data?: IRvServerResponseDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityCountry = _data["CityCountry"] ? RvServerResponseContentDto.fromJS(_data["CityCountry"]) : <any>undefined;
            this.licencePlate = _data["LicencePlate"] ? RvServerResponseContentDto.fromJS(_data["LicencePlate"]) : <any>undefined;
            this.merchantAddress = _data["MerchantAddress"] ? RvServerResponseContentDto.fromJS(_data["MerchantAddress"]) : <any>undefined;
            this.merchantName = _data["MerchantName"] ? RvServerResponseContentDto.fromJS(_data["MerchantName"]) : <any>undefined;
            this.paymentType = _data["PaymentType"] ? RvServerResponseContentDto.fromJS(_data["PaymentType"]) : <any>undefined;
            this.taxNo = _data["TaxNo"] ? RvServerResponseContentDto.fromJS(_data["TaxNo"]) : <any>undefined;
            this.total = _data["Total"] ? RvServerResponseContentDto.fromJS(_data["Total"]) : <any>undefined;
            this.totalTax = _data["TotalTax"] ? RvServerResponseContentDto.fromJS(_data["TotalTax"]) : <any>undefined;
            this.transactionDate = _data["TransactionDate"] ? RvServerResponseContentDto.fromJS(_data["TransactionDate"]) : <any>undefined;
            this.transactionId = _data["TransactionId"] ? RvServerResponseContentDto.fromJS(_data["TransactionId"]) : <any>undefined;
            this.transactionTime = _data["TransactionTime"] ? RvServerResponseContentDto.fromJS(_data["TransactionTime"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RvServerResponseItemsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RvServerResponseDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new RvServerResponseDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CityCountry"] = this.cityCountry ? this.cityCountry.toJSON() : <any>undefined;
        data["LicencePlate"] = this.licencePlate ? this.licencePlate.toJSON() : <any>undefined;
        data["MerchantAddress"] = this.merchantAddress ? this.merchantAddress.toJSON() : <any>undefined;
        data["MerchantName"] = this.merchantName ? this.merchantName.toJSON() : <any>undefined;
        data["PaymentType"] = this.paymentType ? this.paymentType.toJSON() : <any>undefined;
        data["TaxNo"] = this.taxNo ? this.taxNo.toJSON() : <any>undefined;
        data["Total"] = this.total ? this.total.toJSON() : <any>undefined;
        data["TotalTax"] = this.totalTax ? this.totalTax.toJSON() : <any>undefined;
        data["TransactionDate"] = this.transactionDate ? this.transactionDate.toJSON() : <any>undefined;
        data["TransactionId"] = this.transactionId ? this.transactionId.toJSON() : <any>undefined;
        data["TransactionTime"] = this.transactionTime ? this.transactionTime.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RvServerResponseDataDto {
        const json = this.toJSON();
        let result = new RvServerResponseDataDto();
        result.init(json);
        return result;
    }
}

export interface IRvServerResponseDataDto {
    cityCountry: RvServerResponseContentDto | undefined;
    licencePlate: RvServerResponseContentDto | undefined;
    merchantAddress: RvServerResponseContentDto | undefined;
    merchantName: RvServerResponseContentDto | undefined;
    paymentType: RvServerResponseContentDto | undefined;
    taxNo: RvServerResponseContentDto | undefined;
    total: RvServerResponseContentDto | undefined;
    totalTax: RvServerResponseContentDto | undefined;
    transactionDate: RvServerResponseContentDto | undefined;
    transactionId: RvServerResponseContentDto | undefined;
    transactionTime: RvServerResponseContentDto | undefined;
    items: RvServerResponseItemsDto[] | undefined;
}

export class RvServerResponseContentDto implements IRvServerResponseContentDto {
    conf: string | undefined;
    value: string | undefined;

    constructor(data?: IRvServerResponseContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conf = _data["conf"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RvServerResponseContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RvServerResponseContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conf"] = this.conf;
        data["value"] = this.value;
        return data;
    }

    clone(): RvServerResponseContentDto {
        const json = this.toJSON();
        let result = new RvServerResponseContentDto();
        result.init(json);
        return result;
    }
}

export interface IRvServerResponseContentDto {
    conf: string | undefined;
    value: string | undefined;
}

export class RvServerResponseItemsDto implements IRvServerResponseItemsDto {
    content: RvServerResponseContentDto | undefined;
    description: RvServerResponseContentDto | undefined;
    price: RvServerResponseContentDto | undefined;
    quantity: RvServerResponseContentDto | undefined;
    quantityUnit: RvServerResponseContentDto | undefined;
    tax: RvServerResponseContentDto | undefined;
    totalPrice: RvServerResponseContentDto | undefined;

    constructor(data?: IRvServerResponseItemsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"] ? RvServerResponseContentDto.fromJS(_data["content"]) : <any>undefined;
            this.description = _data["description"] ? RvServerResponseContentDto.fromJS(_data["description"]) : <any>undefined;
            this.price = _data["price"] ? RvServerResponseContentDto.fromJS(_data["price"]) : <any>undefined;
            this.quantity = _data["quantity"] ? RvServerResponseContentDto.fromJS(_data["quantity"]) : <any>undefined;
            this.quantityUnit = _data["quantityUnit"] ? RvServerResponseContentDto.fromJS(_data["quantityUnit"]) : <any>undefined;
            this.tax = _data["tax"] ? RvServerResponseContentDto.fromJS(_data["tax"]) : <any>undefined;
            this.totalPrice = _data["totalPrice"] ? RvServerResponseContentDto.fromJS(_data["totalPrice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RvServerResponseItemsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RvServerResponseItemsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["quantity"] = this.quantity ? this.quantity.toJSON() : <any>undefined;
        data["quantityUnit"] = this.quantityUnit ? this.quantityUnit.toJSON() : <any>undefined;
        data["tax"] = this.tax ? this.tax.toJSON() : <any>undefined;
        data["totalPrice"] = this.totalPrice ? this.totalPrice.toJSON() : <any>undefined;
        return data;
    }

    clone(): RvServerResponseItemsDto {
        const json = this.toJSON();
        let result = new RvServerResponseItemsDto();
        result.init(json);
        return result;
    }
}

export interface IRvServerResponseItemsDto {
    content: RvServerResponseContentDto | undefined;
    description: RvServerResponseContentDto | undefined;
    price: RvServerResponseContentDto | undefined;
    quantity: RvServerResponseContentDto | undefined;
    quantityUnit: RvServerResponseContentDto | undefined;
    tax: RvServerResponseContentDto | undefined;
    totalPrice: RvServerResponseContentDto | undefined;
}

export class PagedResultDtoOfReportDto implements IPagedResultDtoOfReportDto {
    totalCount: number | undefined;
    items: ReportDto[] | undefined;

    constructor(data?: IPagedResultDtoOfReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfReportDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfReportDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfReportDto {
    totalCount: number | undefined;
    items: ReportDto[] | undefined;
}

export class ReportDto implements IReportDto {
    name: string | undefined;
    moduleId: number | undefined;
    moduleName: string | undefined;
    reportSourcesId: number | undefined;
    reportSourcesName: number | undefined;
    dashbordNumber: number | undefined;
    dashbordNumberEN: number | undefined;
    dashbordName: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    buttonTitle: string | undefined;
    buttonColor: string | undefined;
    iconURL: string | undefined;
    viewName: string | undefined;
    id: number | undefined;

    constructor(data?: IReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.moduleId = _data["moduleId"];
            this.moduleName = _data["moduleName"];
            this.reportSourcesId = _data["reportSourcesId"];
            this.reportSourcesName = _data["reportSourcesName"];
            this.dashbordNumber = _data["dashbordNumber"];
            this.dashbordNumberEN = _data["dashbordNumberEN"];
            this.dashbordName = _data["dashbordName"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.buttonTitle = _data["buttonTitle"];
            this.buttonColor = _data["buttonColor"];
            this.iconURL = _data["iconURL"];
            this.viewName = _data["viewName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["moduleId"] = this.moduleId;
        data["moduleName"] = this.moduleName;
        data["reportSourcesId"] = this.reportSourcesId;
        data["reportSourcesName"] = this.reportSourcesName;
        data["dashbordNumber"] = this.dashbordNumber;
        data["dashbordNumberEN"] = this.dashbordNumberEN;
        data["dashbordName"] = this.dashbordName;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["buttonTitle"] = this.buttonTitle;
        data["buttonColor"] = this.buttonColor;
        data["iconURL"] = this.iconURL;
        data["viewName"] = this.viewName;
        data["id"] = this.id;
        return data;
    }

    clone(): ReportDto {
        const json = this.toJSON();
        let result = new ReportDto();
        result.init(json);
        return result;
    }
}

export interface IReportDto {
    name: string | undefined;
    moduleId: number | undefined;
    moduleName: string | undefined;
    reportSourcesId: number | undefined;
    reportSourcesName: number | undefined;
    dashbordNumber: number | undefined;
    dashbordNumberEN: number | undefined;
    dashbordName: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    buttonTitle: string | undefined;
    buttonColor: string | undefined;
    iconURL: string | undefined;
    viewName: string | undefined;
    id: number | undefined;
}

export class MetabaseDashboardOutput implements IMetabaseDashboardOutput {
    url: string | undefined;

    constructor(data?: IMetabaseDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): MetabaseDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new MetabaseDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }

    clone(): MetabaseDashboardOutput {
        const json = this.toJSON();
        let result = new MetabaseDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface IMetabaseDashboardOutput {
    url: string | undefined;
}

export class CreateReportDto implements ICreateReportDto {
    name: string | undefined;
    moduleId: number | undefined;
    reportSourcesId: number | undefined;
    dashbordNumber: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    buttonTitle: string | undefined;
    buttonColor: string | undefined;
    iconURL: string | undefined;
    viewName: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.moduleId = _data["moduleId"];
            this.reportSourcesId = _data["reportSourcesId"];
            this.dashbordNumber = _data["dashbordNumber"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.buttonTitle = _data["buttonTitle"];
            this.buttonColor = _data["buttonColor"];
            this.iconURL = _data["iconURL"];
            this.viewName = _data["viewName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["moduleId"] = this.moduleId;
        data["reportSourcesId"] = this.reportSourcesId;
        data["dashbordNumber"] = this.dashbordNumber;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["buttonTitle"] = this.buttonTitle;
        data["buttonColor"] = this.buttonColor;
        data["iconURL"] = this.iconURL;
        data["viewName"] = this.viewName;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateReportDto {
        const json = this.toJSON();
        let result = new CreateReportDto();
        result.init(json);
        return result;
    }
}

export interface ICreateReportDto {
    name: string | undefined;
    moduleId: number | undefined;
    reportSourcesId: number | undefined;
    dashbordNumber: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    buttonTitle: string | undefined;
    buttonColor: string | undefined;
    iconURL: string | undefined;
    viewName: string | undefined;
    id: number | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDto implements IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfRoleListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfRoleListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class RoleListDto implements IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean | undefined;
    isDefault: boolean | undefined;
    creationTime: Date | undefined;
    id: number | undefined;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean | undefined;
    isDefault: boolean | undefined;
    creationTime: Date | undefined;
    id: number | undefined;
}

export class ListResultDtoOfPermissionDto implements IListResultDtoOfPermissionDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IListResultDtoOfPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfPermissionDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfPermissionDto {
    items: PermissionDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto | undefined;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto | undefined;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean | undefined;
    id: number | undefined;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        data["id"] = this.id;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean | undefined;
    id: number | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PagedResultDtoOfRoleDto implements IPagedResultDtoOfRoleDto {
    totalCount: number | undefined;
    items: RoleDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfRoleDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfRoleDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfRoleDto {
    totalCount: number | undefined;
    items: RoleDto[] | undefined;
}

export class CreateRutPlanDetayiDto implements ICreateRutPlanDetayiDto {
    rutPlanId: string | undefined;
    projeId: string | undefined;
    normKadroId: string | undefined;
    mpoiId: string | undefined;
    rutDetayDurumu: CreateRutPlanDetayiDtoRutDetayDurumu | undefined;
    calismaGunu: CreateRutPlanDetayiDtoCalismaGunu | undefined;
    aciklama: string | undefined;
    girisSaati: string | undefined;
    cikisSaati: string | undefined;

    constructor(data?: ICreateRutPlanDetayiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rutPlanId = _data["rutPlanId"];
            this.projeId = _data["projeId"];
            this.normKadroId = _data["normKadroId"];
            this.mpoiId = _data["mpoiId"];
            this.rutDetayDurumu = _data["rutDetayDurumu"];
            this.calismaGunu = _data["calismaGunu"];
            this.aciklama = _data["aciklama"];
            this.girisSaati = _data["girisSaati"];
            this.cikisSaati = _data["cikisSaati"];
        }
    }

    static fromJS(data: any): CreateRutPlanDetayiDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRutPlanDetayiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rutPlanId"] = this.rutPlanId;
        data["projeId"] = this.projeId;
        data["normKadroId"] = this.normKadroId;
        data["mpoiId"] = this.mpoiId;
        data["rutDetayDurumu"] = this.rutDetayDurumu;
        data["calismaGunu"] = this.calismaGunu;
        data["aciklama"] = this.aciklama;
        data["girisSaati"] = this.girisSaati;
        data["cikisSaati"] = this.cikisSaati;
        return data;
    }

    clone(): CreateRutPlanDetayiDto {
        const json = this.toJSON();
        let result = new CreateRutPlanDetayiDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRutPlanDetayiDto {
    rutPlanId: string | undefined;
    projeId: string | undefined;
    normKadroId: string | undefined;
    mpoiId: string | undefined;
    rutDetayDurumu: CreateRutPlanDetayiDtoRutDetayDurumu | undefined;
    calismaGunu: CreateRutPlanDetayiDtoCalismaGunu | undefined;
    aciklama: string | undefined;
    girisSaati: string | undefined;
    cikisSaati: string | undefined;
}

export class RutPlanDetayiDto implements IRutPlanDetayiDto {
    rutPlanDetayiId: string | undefined;
    rutPlanId: string | undefined;
    rutPlanDetayNo: string | undefined;
    projeAdi: string | undefined;
    normKadroAdi: string | undefined;
    rutDetayDurum: RutPlanDetayiDtoRutDetayDurum | undefined;
    calismaGunu: RutPlanDetayiDtoCalismaGunu | undefined;
    mpoiAdi: string | undefined;
    aciklama: string | undefined;
    girisSaati: string | undefined;
    cikisSaati: string | undefined;
    gorevSuresi: number | undefined;

    constructor(data?: IRutPlanDetayiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rutPlanDetayiId = _data["rutPlanDetayiId"];
            this.rutPlanId = _data["rutPlanId"];
            this.rutPlanDetayNo = _data["rutPlanDetayNo"];
            this.projeAdi = _data["projeAdi"];
            this.normKadroAdi = _data["normKadroAdi"];
            this.rutDetayDurum = _data["rutDetayDurum"];
            this.calismaGunu = _data["calismaGunu"];
            this.mpoiAdi = _data["mpoiAdi"];
            this.aciklama = _data["aciklama"];
            this.girisSaati = _data["girisSaati"];
            this.cikisSaati = _data["cikisSaati"];
            this.gorevSuresi = _data["gorevSuresi"];
        }
    }

    static fromJS(data: any): RutPlanDetayiDto {
        data = typeof data === 'object' ? data : {};
        let result = new RutPlanDetayiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rutPlanDetayiId"] = this.rutPlanDetayiId;
        data["rutPlanId"] = this.rutPlanId;
        data["rutPlanDetayNo"] = this.rutPlanDetayNo;
        data["projeAdi"] = this.projeAdi;
        data["normKadroAdi"] = this.normKadroAdi;
        data["rutDetayDurum"] = this.rutDetayDurum;
        data["calismaGunu"] = this.calismaGunu;
        data["mpoiAdi"] = this.mpoiAdi;
        data["aciklama"] = this.aciklama;
        data["girisSaati"] = this.girisSaati;
        data["cikisSaati"] = this.cikisSaati;
        data["gorevSuresi"] = this.gorevSuresi;
        return data;
    }

    clone(): RutPlanDetayiDto {
        const json = this.toJSON();
        let result = new RutPlanDetayiDto();
        result.init(json);
        return result;
    }
}

export interface IRutPlanDetayiDto {
    rutPlanDetayiId: string | undefined;
    rutPlanId: string | undefined;
    rutPlanDetayNo: string | undefined;
    projeAdi: string | undefined;
    normKadroAdi: string | undefined;
    rutDetayDurum: RutPlanDetayiDtoRutDetayDurum | undefined;
    calismaGunu: RutPlanDetayiDtoCalismaGunu | undefined;
    mpoiAdi: string | undefined;
    aciklama: string | undefined;
    girisSaati: string | undefined;
    cikisSaati: string | undefined;
    gorevSuresi: number | undefined;
}

export class UpdateRutPlanDetayiDto implements IUpdateRutPlanDetayiDto {
    rutPlanDetayId: string | undefined;
    rutPlanId: string | undefined;
    projeId: string | undefined;
    normKadroId: string | undefined;
    mpoiId: string | undefined;
    rutDetayDurumu: UpdateRutPlanDetayiDtoRutDetayDurumu | undefined;
    calismaGunu: UpdateRutPlanDetayiDtoCalismaGunu | undefined;
    aciklama: string | undefined;
    girisSaati: string | undefined;
    cikisSaati: string | undefined;

    constructor(data?: IUpdateRutPlanDetayiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rutPlanDetayId = _data["rutPlanDetayId"];
            this.rutPlanId = _data["rutPlanId"];
            this.projeId = _data["projeId"];
            this.normKadroId = _data["normKadroId"];
            this.mpoiId = _data["mpoiId"];
            this.rutDetayDurumu = _data["rutDetayDurumu"];
            this.calismaGunu = _data["calismaGunu"];
            this.aciklama = _data["aciklama"];
            this.girisSaati = _data["girisSaati"];
            this.cikisSaati = _data["cikisSaati"];
        }
    }

    static fromJS(data: any): UpdateRutPlanDetayiDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRutPlanDetayiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rutPlanDetayId"] = this.rutPlanDetayId;
        data["rutPlanId"] = this.rutPlanId;
        data["projeId"] = this.projeId;
        data["normKadroId"] = this.normKadroId;
        data["mpoiId"] = this.mpoiId;
        data["rutDetayDurumu"] = this.rutDetayDurumu;
        data["calismaGunu"] = this.calismaGunu;
        data["aciklama"] = this.aciklama;
        data["girisSaati"] = this.girisSaati;
        data["cikisSaati"] = this.cikisSaati;
        return data;
    }

    clone(): UpdateRutPlanDetayiDto {
        const json = this.toJSON();
        let result = new UpdateRutPlanDetayiDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRutPlanDetayiDto {
    rutPlanDetayId: string | undefined;
    rutPlanId: string | undefined;
    projeId: string | undefined;
    normKadroId: string | undefined;
    mpoiId: string | undefined;
    rutDetayDurumu: UpdateRutPlanDetayiDtoRutDetayDurumu | undefined;
    calismaGunu: UpdateRutPlanDetayiDtoCalismaGunu | undefined;
    aciklama: string | undefined;
    girisSaati: string | undefined;
    cikisSaati: string | undefined;
}

export class CreateRutPlaniDto implements ICreateRutPlaniDto {
    projeId: string | undefined;
    planOlusturmaTarihi: Date | undefined;
    planBitisTarihi: Date | undefined;
    rutPlanAdi: string | undefined;
    rutPlanDurumu: CreateRutPlaniDtoRutPlanDurumu | undefined;
    rutBaslangicTarihi: Date | undefined;
    rutBitisTarihi: Date | undefined;
    rutFrekansi: CreateRutPlaniDtoRutFrekansi | undefined;
    isRutSaatiGorunsun: boolean | undefined;
    isGorevSuresiGorunsun: boolean | undefined;
    aciklama: string | undefined;

    constructor(data?: ICreateRutPlaniDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projeId = _data["projeId"];
            this.planOlusturmaTarihi = _data["planOlusturmaTarihi"] ? new Date(_data["planOlusturmaTarihi"].toString()) : <any>undefined;
            this.planBitisTarihi = _data["planBitisTarihi"] ? new Date(_data["planBitisTarihi"].toString()) : <any>undefined;
            this.rutPlanAdi = _data["rutPlanAdi"];
            this.rutPlanDurumu = _data["rutPlanDurumu"];
            this.rutBaslangicTarihi = _data["rutBaslangicTarihi"] ? new Date(_data["rutBaslangicTarihi"].toString()) : <any>undefined;
            this.rutBitisTarihi = _data["rutBitisTarihi"] ? new Date(_data["rutBitisTarihi"].toString()) : <any>undefined;
            this.rutFrekansi = _data["rutFrekansi"];
            this.isRutSaatiGorunsun = _data["isRutSaatiGorunsun"];
            this.isGorevSuresiGorunsun = _data["isGorevSuresiGorunsun"];
            this.aciklama = _data["aciklama"];
        }
    }

    static fromJS(data: any): CreateRutPlaniDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRutPlaniDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projeId"] = this.projeId;
        data["planOlusturmaTarihi"] = this.planOlusturmaTarihi ? this.planOlusturmaTarihi.toISOString() : <any>undefined;
        data["planBitisTarihi"] = this.planBitisTarihi ? this.planBitisTarihi.toISOString() : <any>undefined;
        data["rutPlanAdi"] = this.rutPlanAdi;
        data["rutPlanDurumu"] = this.rutPlanDurumu;
        data["rutBaslangicTarihi"] = this.rutBaslangicTarihi ? this.rutBaslangicTarihi.toISOString() : <any>undefined;
        data["rutBitisTarihi"] = this.rutBitisTarihi ? this.rutBitisTarihi.toISOString() : <any>undefined;
        data["rutFrekansi"] = this.rutFrekansi;
        data["isRutSaatiGorunsun"] = this.isRutSaatiGorunsun;
        data["isGorevSuresiGorunsun"] = this.isGorevSuresiGorunsun;
        data["aciklama"] = this.aciklama;
        return data;
    }

    clone(): CreateRutPlaniDto {
        const json = this.toJSON();
        let result = new CreateRutPlaniDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRutPlaniDto {
    projeId: string | undefined;
    planOlusturmaTarihi: Date | undefined;
    planBitisTarihi: Date | undefined;
    rutPlanAdi: string | undefined;
    rutPlanDurumu: CreateRutPlaniDtoRutPlanDurumu | undefined;
    rutBaslangicTarihi: Date | undefined;
    rutBitisTarihi: Date | undefined;
    rutFrekansi: CreateRutPlaniDtoRutFrekansi | undefined;
    isRutSaatiGorunsun: boolean | undefined;
    isGorevSuresiGorunsun: boolean | undefined;
    aciklama: string | undefined;
}

export class RutPlaniDto implements IRutPlaniDto {
    id: string | undefined;
    rutPlanNo: string | undefined;
    projeAdi: string | undefined;
    planOlusturmaTarihi: Date | undefined;
    planBitisTarihi: Date | undefined;
    rutPlanAdi: string | undefined;
    rutPlanDurumu: RutPlaniDtoRutPlanDurumu | undefined;
    isRutDisi: boolean | undefined;
    rutBaslangicTarihi: Date | undefined;
    rutBitisTarihi: Date | undefined;
    rutFrekansi: RutPlaniDtoRutFrekansi | undefined;
    isRutSaatiGorunsun: boolean | undefined;
    isGorevSuresiGorunsun: boolean | undefined;
    aciklama: string | undefined;

    constructor(data?: IRutPlaniDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rutPlanNo = _data["rutPlanNo"];
            this.projeAdi = _data["projeAdi"];
            this.planOlusturmaTarihi = _data["planOlusturmaTarihi"] ? new Date(_data["planOlusturmaTarihi"].toString()) : <any>undefined;
            this.planBitisTarihi = _data["planBitisTarihi"] ? new Date(_data["planBitisTarihi"].toString()) : <any>undefined;
            this.rutPlanAdi = _data["rutPlanAdi"];
            this.rutPlanDurumu = _data["rutPlanDurumu"];
            this.isRutDisi = _data["isRutDisi"];
            this.rutBaslangicTarihi = _data["rutBaslangicTarihi"] ? new Date(_data["rutBaslangicTarihi"].toString()) : <any>undefined;
            this.rutBitisTarihi = _data["rutBitisTarihi"] ? new Date(_data["rutBitisTarihi"].toString()) : <any>undefined;
            this.rutFrekansi = _data["rutFrekansi"];
            this.isRutSaatiGorunsun = _data["isRutSaatiGorunsun"];
            this.isGorevSuresiGorunsun = _data["isGorevSuresiGorunsun"];
            this.aciklama = _data["aciklama"];
        }
    }

    static fromJS(data: any): RutPlaniDto {
        data = typeof data === 'object' ? data : {};
        let result = new RutPlaniDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rutPlanNo"] = this.rutPlanNo;
        data["projeAdi"] = this.projeAdi;
        data["planOlusturmaTarihi"] = this.planOlusturmaTarihi ? this.planOlusturmaTarihi.toISOString() : <any>undefined;
        data["planBitisTarihi"] = this.planBitisTarihi ? this.planBitisTarihi.toISOString() : <any>undefined;
        data["rutPlanAdi"] = this.rutPlanAdi;
        data["rutPlanDurumu"] = this.rutPlanDurumu;
        data["isRutDisi"] = this.isRutDisi;
        data["rutBaslangicTarihi"] = this.rutBaslangicTarihi ? this.rutBaslangicTarihi.toISOString() : <any>undefined;
        data["rutBitisTarihi"] = this.rutBitisTarihi ? this.rutBitisTarihi.toISOString() : <any>undefined;
        data["rutFrekansi"] = this.rutFrekansi;
        data["isRutSaatiGorunsun"] = this.isRutSaatiGorunsun;
        data["isGorevSuresiGorunsun"] = this.isGorevSuresiGorunsun;
        data["aciklama"] = this.aciklama;
        return data;
    }

    clone(): RutPlaniDto {
        const json = this.toJSON();
        let result = new RutPlaniDto();
        result.init(json);
        return result;
    }
}

export interface IRutPlaniDto {
    id: string | undefined;
    rutPlanNo: string | undefined;
    projeAdi: string | undefined;
    planOlusturmaTarihi: Date | undefined;
    planBitisTarihi: Date | undefined;
    rutPlanAdi: string | undefined;
    rutPlanDurumu: RutPlaniDtoRutPlanDurumu | undefined;
    isRutDisi: boolean | undefined;
    rutBaslangicTarihi: Date | undefined;
    rutBitisTarihi: Date | undefined;
    rutFrekansi: RutPlaniDtoRutFrekansi | undefined;
    isRutSaatiGorunsun: boolean | undefined;
    isGorevSuresiGorunsun: boolean | undefined;
    aciklama: string | undefined;
}

export class UpdateRutPlaniDto implements IUpdateRutPlaniDto {
    id: string | undefined;
    projeId: string | undefined;
    planOlusturmaTarihi: Date | undefined;
    planBitisTarihi: Date | undefined;
    rutPlanAdi: string | undefined;
    rutPlanDurumu: UpdateRutPlaniDtoRutPlanDurumu | undefined;
    isRutDisi: boolean | undefined;
    rutBaslangicTarihi: Date | undefined;
    rutBitisTarihi: Date | undefined;
    rutFrekansi: UpdateRutPlaniDtoRutFrekansi | undefined;
    isRutSaatiGorunsun: boolean | undefined;
    isGorevSuresiGorunsun: boolean | undefined;
    aciklama: string | undefined;

    constructor(data?: IUpdateRutPlaniDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projeId = _data["projeId"];
            this.planOlusturmaTarihi = _data["planOlusturmaTarihi"] ? new Date(_data["planOlusturmaTarihi"].toString()) : <any>undefined;
            this.planBitisTarihi = _data["planBitisTarihi"] ? new Date(_data["planBitisTarihi"].toString()) : <any>undefined;
            this.rutPlanAdi = _data["rutPlanAdi"];
            this.rutPlanDurumu = _data["rutPlanDurumu"];
            this.isRutDisi = _data["isRutDisi"];
            this.rutBaslangicTarihi = _data["rutBaslangicTarihi"] ? new Date(_data["rutBaslangicTarihi"].toString()) : <any>undefined;
            this.rutBitisTarihi = _data["rutBitisTarihi"] ? new Date(_data["rutBitisTarihi"].toString()) : <any>undefined;
            this.rutFrekansi = _data["rutFrekansi"];
            this.isRutSaatiGorunsun = _data["isRutSaatiGorunsun"];
            this.isGorevSuresiGorunsun = _data["isGorevSuresiGorunsun"];
            this.aciklama = _data["aciklama"];
        }
    }

    static fromJS(data: any): UpdateRutPlaniDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRutPlaniDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projeId"] = this.projeId;
        data["planOlusturmaTarihi"] = this.planOlusturmaTarihi ? this.planOlusturmaTarihi.toISOString() : <any>undefined;
        data["planBitisTarihi"] = this.planBitisTarihi ? this.planBitisTarihi.toISOString() : <any>undefined;
        data["rutPlanAdi"] = this.rutPlanAdi;
        data["rutPlanDurumu"] = this.rutPlanDurumu;
        data["isRutDisi"] = this.isRutDisi;
        data["rutBaslangicTarihi"] = this.rutBaslangicTarihi ? this.rutBaslangicTarihi.toISOString() : <any>undefined;
        data["rutBitisTarihi"] = this.rutBitisTarihi ? this.rutBitisTarihi.toISOString() : <any>undefined;
        data["rutFrekansi"] = this.rutFrekansi;
        data["isRutSaatiGorunsun"] = this.isRutSaatiGorunsun;
        data["isGorevSuresiGorunsun"] = this.isGorevSuresiGorunsun;
        data["aciklama"] = this.aciklama;
        return data;
    }

    clone(): UpdateRutPlaniDto {
        const json = this.toJSON();
        let result = new UpdateRutPlaniDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRutPlaniDto {
    id: string | undefined;
    projeId: string | undefined;
    planOlusturmaTarihi: Date | undefined;
    planBitisTarihi: Date | undefined;
    rutPlanAdi: string | undefined;
    rutPlanDurumu: UpdateRutPlaniDtoRutPlanDurumu | undefined;
    isRutDisi: boolean | undefined;
    rutBaslangicTarihi: Date | undefined;
    rutBitisTarihi: Date | undefined;
    rutFrekansi: UpdateRutPlaniDtoRutFrekansi | undefined;
    isRutSaatiGorunsun: boolean | undefined;
    isGorevSuresiGorunsun: boolean | undefined;
    aciklama: string | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto | undefined;
    user: UserLoginInfoDto | undefined;
    tenant: TenantLoginInfoDto | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto | undefined;
    user: UserLoginInfoDto | undefined;
    tenant: TenantLoginInfoDto | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: Date | undefined;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: Date | undefined;
    features: { [key: string]: boolean; } | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    musteriKodu: string | undefined;
    defaultCustomerName: string | undefined;
    defaultCustomerRowGuid: string | undefined;
    isUserApprover: boolean | undefined;
    isUserOrderer: boolean | undefined;
    isUserCanUseCart: boolean | undefined;
    isUserCanViewTotalShipmentPrice: boolean | undefined;
    isUserStockView: boolean | undefined;
    userDefaultPageUrl: string | undefined;
    platomUserId: string | undefined;
    platomProjectId: string | undefined;
    platomIsMerkezPersonel: boolean | undefined;
    appCustomerThemeInfo: ApplicationThemeDto | undefined;
    platomAppInfo: PlatomAppInfoDto | undefined;
    id: number | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.musteriKodu = _data["musteriKodu"];
            this.defaultCustomerName = _data["defaultCustomerName"];
            this.defaultCustomerRowGuid = _data["defaultCustomerRowGuid"];
            this.isUserApprover = _data["isUserApprover"];
            this.isUserOrderer = _data["isUserOrderer"];
            this.isUserCanUseCart = _data["isUserCanUseCart"];
            this.isUserCanViewTotalShipmentPrice = _data["isUserCanViewTotalShipmentPrice"];
            this.isUserStockView = _data["isUserStockView"];
            this.userDefaultPageUrl = _data["userDefaultPageUrl"];
            this.platomUserId = _data["platomUserId"];
            this.platomProjectId = _data["platomProjectId"];
            this.platomIsMerkezPersonel = _data["platomIsMerkezPersonel"];
            this.appCustomerThemeInfo = _data["appCustomerThemeInfo"] ? ApplicationThemeDto.fromJS(_data["appCustomerThemeInfo"]) : <any>undefined;
            this.platomAppInfo = _data["platomAppInfo"] ? PlatomAppInfoDto.fromJS(_data["platomAppInfo"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["musteriKodu"] = this.musteriKodu;
        data["defaultCustomerName"] = this.defaultCustomerName;
        data["defaultCustomerRowGuid"] = this.defaultCustomerRowGuid;
        data["isUserApprover"] = this.isUserApprover;
        data["isUserOrderer"] = this.isUserOrderer;
        data["isUserCanUseCart"] = this.isUserCanUseCart;
        data["isUserCanViewTotalShipmentPrice"] = this.isUserCanViewTotalShipmentPrice;
        data["isUserStockView"] = this.isUserStockView;
        data["userDefaultPageUrl"] = this.userDefaultPageUrl;
        data["platomUserId"] = this.platomUserId;
        data["platomProjectId"] = this.platomProjectId;
        data["platomIsMerkezPersonel"] = this.platomIsMerkezPersonel;
        data["appCustomerThemeInfo"] = this.appCustomerThemeInfo ? this.appCustomerThemeInfo.toJSON() : <any>undefined;
        data["platomAppInfo"] = this.platomAppInfo ? this.platomAppInfo.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    musteriKodu: string | undefined;
    defaultCustomerName: string | undefined;
    defaultCustomerRowGuid: string | undefined;
    isUserApprover: boolean | undefined;
    isUserOrderer: boolean | undefined;
    isUserCanUseCart: boolean | undefined;
    isUserCanViewTotalShipmentPrice: boolean | undefined;
    isUserStockView: boolean | undefined;
    userDefaultPageUrl: string | undefined;
    platomUserId: string | undefined;
    platomProjectId: string | undefined;
    platomIsMerkezPersonel: boolean | undefined;
    appCustomerThemeInfo: ApplicationThemeDto | undefined;
    platomAppInfo: PlatomAppInfoDto | undefined;
    id: number | undefined;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number | undefined;
}

export class ApplicationThemeDto implements IApplicationThemeDto {
    portalLogoPath: string | undefined;
    customerLogoPath: string | undefined;

    constructor(data?: IApplicationThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.portalLogoPath = _data["portalLogoPath"];
            this.customerLogoPath = _data["customerLogoPath"];
        }
    }

    static fromJS(data: any): ApplicationThemeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalLogoPath"] = this.portalLogoPath;
        data["customerLogoPath"] = this.customerLogoPath;
        return data;
    }

    clone(): ApplicationThemeDto {
        const json = this.toJSON();
        let result = new ApplicationThemeDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationThemeDto {
    portalLogoPath: string | undefined;
    customerLogoPath: string | undefined;
}

export class PlatomAppInfoDto implements IPlatomAppInfoDto {
    moduleAccess: PlatomAppModuleAccessDto | undefined;

    constructor(data?: IPlatomAppInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleAccess = _data["moduleAccess"] ? PlatomAppModuleAccessDto.fromJS(_data["moduleAccess"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlatomAppInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlatomAppInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleAccess"] = this.moduleAccess ? this.moduleAccess.toJSON() : <any>undefined;
        return data;
    }

    clone(): PlatomAppInfoDto {
        const json = this.toJSON();
        let result = new PlatomAppInfoDto();
        result.init(json);
        return result;
    }
}

export interface IPlatomAppInfoDto {
    moduleAccess: PlatomAppModuleAccessDto | undefined;
}

export class PlatomAppModuleAccessDto implements IPlatomAppModuleAccessDto {
    izin: boolean | undefined;
    masraf: boolean | undefined;
    rutGorev: boolean | undefined;
    personelGorev: boolean | undefined;
    serbestForm: boolean | undefined;
    video: boolean | undefined;
    duyuru: boolean | undefined;
    bringMyStand: boolean | undefined;
    ekibim: boolean | undefined;
    magazalarim: boolean | undefined;
    zimmet: boolean | undefined;
    crmModulu: boolean | undefined;
    hizliGorevOlustur: boolean | undefined;
    sahaGorselleriGoruntuleme: boolean | undefined;
    sahaGorselleriDuzenleme: boolean | undefined;

    constructor(data?: IPlatomAppModuleAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.izin = _data["izin"];
            this.masraf = _data["masraf"];
            this.rutGorev = _data["rutGorev"];
            this.personelGorev = _data["personelGorev"];
            this.serbestForm = _data["serbestForm"];
            this.video = _data["video"];
            this.duyuru = _data["duyuru"];
            this.bringMyStand = _data["bringMyStand"];
            this.ekibim = _data["ekibim"];
            this.magazalarim = _data["magazalarim"];
            this.zimmet = _data["zimmet"];
            this.crmModulu = _data["crmModulu"];
            this.hizliGorevOlustur = _data["hizliGorevOlustur"];
            this.sahaGorselleriGoruntuleme = _data["sahaGorselleriGoruntuleme"];
            this.sahaGorselleriDuzenleme = _data["sahaGorselleriDuzenleme"];
        }
    }

    static fromJS(data: any): PlatomAppModuleAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlatomAppModuleAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["izin"] = this.izin;
        data["masraf"] = this.masraf;
        data["rutGorev"] = this.rutGorev;
        data["personelGorev"] = this.personelGorev;
        data["serbestForm"] = this.serbestForm;
        data["video"] = this.video;
        data["duyuru"] = this.duyuru;
        data["bringMyStand"] = this.bringMyStand;
        data["ekibim"] = this.ekibim;
        data["magazalarim"] = this.magazalarim;
        data["zimmet"] = this.zimmet;
        data["crmModulu"] = this.crmModulu;
        data["hizliGorevOlustur"] = this.hizliGorevOlustur;
        data["sahaGorselleriGoruntuleme"] = this.sahaGorselleriGoruntuleme;
        data["sahaGorselleriDuzenleme"] = this.sahaGorselleriDuzenleme;
        return data;
    }

    clone(): PlatomAppModuleAccessDto {
        const json = this.toJSON();
        let result = new PlatomAppModuleAccessDto();
        result.init(json);
        return result;
    }
}

export interface IPlatomAppModuleAccessDto {
    izin: boolean | undefined;
    masraf: boolean | undefined;
    rutGorev: boolean | undefined;
    personelGorev: boolean | undefined;
    serbestForm: boolean | undefined;
    video: boolean | undefined;
    duyuru: boolean | undefined;
    bringMyStand: boolean | undefined;
    ekibim: boolean | undefined;
    magazalarim: boolean | undefined;
    zimmet: boolean | undefined;
    crmModulu: boolean | undefined;
    hizliGorevOlustur: boolean | undefined;
    sahaGorselleriGoruntuleme: boolean | undefined;
    sahaGorselleriDuzenleme: boolean | undefined;
}

export class StaffLocationInfoResponseDto implements IStaffLocationInfoResponseDto {
    personelAdi: string | undefined;
    calismaGunu: string | undefined;
    magazaAdi: string | undefined;
    magazaAdres: string | undefined;
    poiEnlem: number | undefined;
    poiBoylam: number | undefined;
    planlananGirisTarihi: string | undefined;
    planlananCikisTarihi: string | undefined;
    ziyaretKabulMesafesi: number | undefined;
    gorevSuresiDk: string | undefined;
    gerceklesenGirisTarihi: string | undefined;
    gerceklesenCikisTarihi: string | undefined;
    gorevTipi: string | undefined;
    gorevDurumu: string | undefined;
    girisEnlem: number | undefined;
    girisBoylam: number | undefined;
    cikisEnlem: number | undefined;
    cikisBoylam: number | undefined;
    girisSapmaDegeri: number | undefined;
    cikisSapmaDegeri: number | undefined;
    anaNoktayaUzaklikGirisMt: number | undefined;
    anaNoktayaUzaklikCikisMt: number | undefined;

    constructor(data?: IStaffLocationInfoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personelAdi = _data["personelAdi"];
            this.calismaGunu = _data["calismaGunu"];
            this.magazaAdi = _data["magazaAdi"];
            this.magazaAdres = _data["magazaAdres"];
            this.poiEnlem = _data["poiEnlem"];
            this.poiBoylam = _data["poiBoylam"];
            this.planlananGirisTarihi = _data["planlananGirisTarihi"];
            this.planlananCikisTarihi = _data["planlananCikisTarihi"];
            this.ziyaretKabulMesafesi = _data["ziyaretKabulMesafesi"];
            this.gorevSuresiDk = _data["gorevSuresiDk"];
            this.gerceklesenGirisTarihi = _data["gerceklesenGirisTarihi"];
            this.gerceklesenCikisTarihi = _data["gerceklesenCikisTarihi"];
            this.gorevTipi = _data["gorevTipi"];
            this.gorevDurumu = _data["gorevDurumu"];
            this.girisEnlem = _data["girisEnlem"];
            this.girisBoylam = _data["girisBoylam"];
            this.cikisEnlem = _data["cikisEnlem"];
            this.cikisBoylam = _data["cikisBoylam"];
            this.girisSapmaDegeri = _data["girisSapmaDegeri"];
            this.cikisSapmaDegeri = _data["cikisSapmaDegeri"];
            this.anaNoktayaUzaklikGirisMt = _data["anaNoktayaUzaklikGirisMt"];
            this.anaNoktayaUzaklikCikisMt = _data["anaNoktayaUzaklikCikisMt"];
        }
    }

    static fromJS(data: any): StaffLocationInfoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffLocationInfoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personelAdi"] = this.personelAdi;
        data["calismaGunu"] = this.calismaGunu;
        data["magazaAdi"] = this.magazaAdi;
        data["magazaAdres"] = this.magazaAdres;
        data["poiEnlem"] = this.poiEnlem;
        data["poiBoylam"] = this.poiBoylam;
        data["planlananGirisTarihi"] = this.planlananGirisTarihi;
        data["planlananCikisTarihi"] = this.planlananCikisTarihi;
        data["ziyaretKabulMesafesi"] = this.ziyaretKabulMesafesi;
        data["gorevSuresiDk"] = this.gorevSuresiDk;
        data["gerceklesenGirisTarihi"] = this.gerceklesenGirisTarihi;
        data["gerceklesenCikisTarihi"] = this.gerceklesenCikisTarihi;
        data["gorevTipi"] = this.gorevTipi;
        data["gorevDurumu"] = this.gorevDurumu;
        data["girisEnlem"] = this.girisEnlem;
        data["girisBoylam"] = this.girisBoylam;
        data["cikisEnlem"] = this.cikisEnlem;
        data["cikisBoylam"] = this.cikisBoylam;
        data["girisSapmaDegeri"] = this.girisSapmaDegeri;
        data["cikisSapmaDegeri"] = this.cikisSapmaDegeri;
        data["anaNoktayaUzaklikGirisMt"] = this.anaNoktayaUzaklikGirisMt;
        data["anaNoktayaUzaklikCikisMt"] = this.anaNoktayaUzaklikCikisMt;
        return data;
    }

    clone(): StaffLocationInfoResponseDto {
        const json = this.toJSON();
        let result = new StaffLocationInfoResponseDto();
        result.init(json);
        return result;
    }
}

export interface IStaffLocationInfoResponseDto {
    personelAdi: string | undefined;
    calismaGunu: string | undefined;
    magazaAdi: string | undefined;
    magazaAdres: string | undefined;
    poiEnlem: number | undefined;
    poiBoylam: number | undefined;
    planlananGirisTarihi: string | undefined;
    planlananCikisTarihi: string | undefined;
    ziyaretKabulMesafesi: number | undefined;
    gorevSuresiDk: string | undefined;
    gerceklesenGirisTarihi: string | undefined;
    gerceklesenCikisTarihi: string | undefined;
    gorevTipi: string | undefined;
    gorevDurumu: string | undefined;
    girisEnlem: number | undefined;
    girisBoylam: number | undefined;
    cikisEnlem: number | undefined;
    cikisBoylam: number | undefined;
    girisSapmaDegeri: number | undefined;
    cikisSapmaDegeri: number | undefined;
    anaNoktayaUzaklikGirisMt: number | undefined;
    anaNoktayaUzaklikCikisMt: number | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean | undefined;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean | undefined;
}

export class TenantDto implements ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfTenantDto implements IPagedResultDtoOfTenantDto {
    totalCount: number | undefined;
    items: TenantDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfTenantDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTenantDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTenantDto {
    totalCount: number | undefined;
    items: TenantDto[] | undefined;
}

export class TestDto implements ITestDto {
    myName: string | undefined;

    constructor(data?: ITestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.myName = _data["myName"];
        }
    }

    static fromJS(data: any): TestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["myName"] = this.myName;
        return data;
    }

    clone(): TestDto {
        const json = this.toJSON();
        let result = new TestDto();
        result.init(json);
        return result;
    }
}

export interface ITestDto {
    myName: string | undefined;
}

export class PagedResultDtoOfTitleDto implements IPagedResultDtoOfTitleDto {
    totalCount: number | undefined;
    items: TitleDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfTitleDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTitleDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTitleDto {
    totalCount: number | undefined;
    items: TitleDto[] | undefined;
}

export class TitleDto implements ITitleDto {
    name: string | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    comment: string | undefined;
    isDeleted: boolean | undefined;
    id: number | undefined;

    constructor(data?: ITitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.comment = _data["comment"];
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new TitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["comment"] = this.comment;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): TitleDto {
        const json = this.toJSON();
        let result = new TitleDto();
        result.init(json);
        return result;
    }
}

export interface ITitleDto {
    name: string | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    comment: string | undefined;
    isDeleted: boolean | undefined;
    id: number | undefined;
}

export class CreateTitleDto implements ICreateTitleDto {
    name: string;
    customerId: number;
    comment: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateTitleDto {
        const json = this.toJSON();
        let result = new CreateTitleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTitleDto {
    name: string;
    customerId: number;
    comment: string | undefined;
    id: number | undefined;
}

export class ProductStockPto implements IProductStockPto {
    readonly photoPathSmall: string | undefined;
    readonly photoPathLarge: string | undefined;
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
    businessUnitName: string | undefined;
    brandName: string | undefined;
    campaignName: string | undefined;
    warehouseName: string | undefined;
    stock: number | undefined;
    blockedStock: number | undefined;
    type: string | undefined;
    type1Name: string | undefined;
    type2Name: string | undefined;
    type3Name: string | undefined;
    type4Name: string | undefined;
    group1Name: string | undefined;
    group2Name: string | undefined;
    merkezOnayliStok: number | undefined;
    onaySureciDevamEdenStok: number | undefined;

    constructor(data?: IProductStockPto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).photoPathSmall = _data["photoPathSmall"];
            (<any>this).photoPathLarge = _data["photoPathLarge"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.businessUnitName = _data["businessUnitName"];
            this.brandName = _data["brandName"];
            this.campaignName = _data["campaignName"];
            this.warehouseName = _data["warehouseName"];
            this.stock = _data["stock"];
            this.blockedStock = _data["blockedStock"];
            this.type = _data["type"];
            this.type1Name = _data["type1Name"];
            this.type2Name = _data["type2Name"];
            this.type3Name = _data["type3Name"];
            this.type4Name = _data["type4Name"];
            this.group1Name = _data["group1Name"];
            this.group2Name = _data["group2Name"];
            this.merkezOnayliStok = _data["merkezOnayliStok"];
            this.onaySureciDevamEdenStok = _data["onaySureciDevamEdenStok"];
        }
    }

    static fromJS(data: any): ProductStockPto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStockPto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["photoPathSmall"] = this.photoPathSmall;
        data["photoPathLarge"] = this.photoPathLarge;
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["businessUnitName"] = this.businessUnitName;
        data["brandName"] = this.brandName;
        data["campaignName"] = this.campaignName;
        data["warehouseName"] = this.warehouseName;
        data["stock"] = this.stock;
        data["blockedStock"] = this.blockedStock;
        data["type"] = this.type;
        data["type1Name"] = this.type1Name;
        data["type2Name"] = this.type2Name;
        data["type3Name"] = this.type3Name;
        data["type4Name"] = this.type4Name;
        data["group1Name"] = this.group1Name;
        data["group2Name"] = this.group2Name;
        data["merkezOnayliStok"] = this.merkezOnayliStok;
        data["onaySureciDevamEdenStok"] = this.onaySureciDevamEdenStok;
        return data;
    }

    clone(): ProductStockPto {
        const json = this.toJSON();
        let result = new ProductStockPto();
        result.init(json);
        return result;
    }
}

export interface IProductStockPto {
    photoPathSmall: string | undefined;
    photoPathLarge: string | undefined;
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
    businessUnitName: string | undefined;
    brandName: string | undefined;
    campaignName: string | undefined;
    warehouseName: string | undefined;
    stock: number | undefined;
    blockedStock: number | undefined;
    type: string | undefined;
    type1Name: string | undefined;
    type2Name: string | undefined;
    type3Name: string | undefined;
    type4Name: string | undefined;
    group1Name: string | undefined;
    group2Name: string | undefined;
    merkezOnayliStok: number | undefined;
    onaySureciDevamEdenStok: number | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    userId: number | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    userId: number | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    waitingForActivation: boolean | undefined;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    waitingForActivation: boolean | undefined;
}

export class TransportBidInfoDto implements ITransportBidInfoDto {
    name: string | undefined;
    yuklemeTarihi: Date | undefined;
    aracCinsi: string | undefined;
    yuklemeYeri: string | undefined;
    bosaltmaYeri: string | undefined;
    tonajCinsi: string | undefined;
    tonajBirim: string | undefined;
    kapasite: string | undefined;
    aciklama: string | undefined;
    ilgiliFirma: string | undefined;
    ilgiliFirmaYetkili: string | undefined;
    ihaleDurum: TransportBidInfoDtoIhaleDurum | undefined;
    id: string | undefined;

    constructor(data?: ITransportBidInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.yuklemeTarihi = _data["yuklemeTarihi"] ? new Date(_data["yuklemeTarihi"].toString()) : <any>undefined;
            this.aracCinsi = _data["aracCinsi"];
            this.yuklemeYeri = _data["yuklemeYeri"];
            this.bosaltmaYeri = _data["bosaltmaYeri"];
            this.tonajCinsi = _data["tonajCinsi"];
            this.tonajBirim = _data["tonajBirim"];
            this.kapasite = _data["kapasite"];
            this.aciklama = _data["aciklama"];
            this.ilgiliFirma = _data["ilgiliFirma"];
            this.ilgiliFirmaYetkili = _data["ilgiliFirmaYetkili"];
            this.ihaleDurum = _data["ihaleDurum"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransportBidInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportBidInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["yuklemeTarihi"] = this.yuklemeTarihi ? this.yuklemeTarihi.toISOString() : <any>undefined;
        data["aracCinsi"] = this.aracCinsi;
        data["yuklemeYeri"] = this.yuklemeYeri;
        data["bosaltmaYeri"] = this.bosaltmaYeri;
        data["tonajCinsi"] = this.tonajCinsi;
        data["tonajBirim"] = this.tonajBirim;
        data["kapasite"] = this.kapasite;
        data["aciklama"] = this.aciklama;
        data["ilgiliFirma"] = this.ilgiliFirma;
        data["ilgiliFirmaYetkili"] = this.ilgiliFirmaYetkili;
        data["ihaleDurum"] = this.ihaleDurum;
        data["id"] = this.id;
        return data;
    }

    clone(): TransportBidInfoDto {
        const json = this.toJSON();
        let result = new TransportBidInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITransportBidInfoDto {
    name: string | undefined;
    yuklemeTarihi: Date | undefined;
    aracCinsi: string | undefined;
    yuklemeYeri: string | undefined;
    bosaltmaYeri: string | undefined;
    tonajCinsi: string | undefined;
    tonajBirim: string | undefined;
    kapasite: string | undefined;
    aciklama: string | undefined;
    ilgiliFirma: string | undefined;
    ilgiliFirmaYetkili: string | undefined;
    ihaleDurum: TransportBidInfoDtoIhaleDurum | undefined;
    id: string | undefined;
}

export class UpdateTransportBidDto implements IUpdateTransportBidDto {
    name: string | undefined;
    teklifDurum: UpdateTransportBidDtoTeklifDurum | undefined;
    teklifTutari: number | undefined;
    teklifZamani: Date | undefined;
    soforCepTelefon: string | undefined;
    soforAdSoyad: string | undefined;
    aracPlakasi: string | undefined;
    id: string | undefined;

    constructor(data?: IUpdateTransportBidDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.teklifDurum = _data["teklifDurum"];
            this.teklifTutari = _data["teklifTutari"];
            this.teklifZamani = _data["teklifZamani"] ? new Date(_data["teklifZamani"].toString()) : <any>undefined;
            this.soforCepTelefon = _data["soforCepTelefon"];
            this.soforAdSoyad = _data["soforAdSoyad"];
            this.aracPlakasi = _data["aracPlakasi"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTransportBidDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTransportBidDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["teklifDurum"] = this.teklifDurum;
        data["teklifTutari"] = this.teklifTutari;
        data["teklifZamani"] = this.teklifZamani ? this.teklifZamani.toISOString() : <any>undefined;
        data["soforCepTelefon"] = this.soforCepTelefon;
        data["soforAdSoyad"] = this.soforAdSoyad;
        data["aracPlakasi"] = this.aracPlakasi;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateTransportBidDto {
        const json = this.toJSON();
        let result = new UpdateTransportBidDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTransportBidDto {
    name: string | undefined;
    teklifDurum: UpdateTransportBidDtoTeklifDurum | undefined;
    teklifTutari: number | undefined;
    teklifZamani: Date | undefined;
    soforCepTelefon: string | undefined;
    soforAdSoyad: string | undefined;
    aracPlakasi: string | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfUserDto implements IPagedResultDtoOfUserDto {
    totalCount: number | undefined;
    items: UserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserDto {
    totalCount: number | undefined;
    items: UserDto[] | undefined;
}

export class UserDto implements IUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean | undefined;
    fullName: string | undefined;
    lastLoginTime: Date | undefined;
    creationTime: Date | undefined;
    roleNames: string[] | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    platomUserId: string | undefined;
    customers: UserCustomerInfoDto[] | undefined;
    assignedPages: UserSelectedPagesDto[] | undefined;
    assignedModuleIds: number[] | undefined;
    id: number | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? new Date(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.platomUserId = _data["platomUserId"];
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers.push(UserCustomerInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["assignedPages"])) {
                this.assignedPages = [] as any;
                for (let item of _data["assignedPages"])
                    this.assignedPages.push(UserSelectedPagesDto.fromJS(item));
            }
            if (Array.isArray(_data["assignedModuleIds"])) {
                this.assignedModuleIds = [] as any;
                for (let item of _data["assignedModuleIds"])
                    this.assignedModuleIds.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["platomUserId"] = this.platomUserId;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedPages)) {
            data["assignedPages"] = [];
            for (let item of this.assignedPages)
                data["assignedPages"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedModuleIds)) {
            data["assignedModuleIds"] = [];
            for (let item of this.assignedModuleIds)
                data["assignedModuleIds"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean | undefined;
    fullName: string | undefined;
    lastLoginTime: Date | undefined;
    creationTime: Date | undefined;
    roleNames: string[] | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    platomUserId: string | undefined;
    customers: UserCustomerInfoDto[] | undefined;
    assignedPages: UserSelectedPagesDto[] | undefined;
    assignedModuleIds: number[] | undefined;
    id: number | undefined;
}

export class UserCustomerInfoDto implements IUserCustomerInfoDto {
    customerId: number | undefined;
    customerName: string | undefined;
    isDefault: boolean | undefined;

    constructor(data?: IUserCustomerInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): UserCustomerInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCustomerInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["isDefault"] = this.isDefault;
        return data;
    }

    clone(): UserCustomerInfoDto {
        const json = this.toJSON();
        let result = new UserCustomerInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserCustomerInfoDto {
    customerId: number | undefined;
    customerName: string | undefined;
    isDefault: boolean | undefined;
}

export class UserSelectedPagesDto implements IUserSelectedPagesDto {
    pageId: number | undefined;
    isDefault: boolean | undefined;

    constructor(data?: IUserSelectedPagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageId = _data["pageId"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): UserSelectedPagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSelectedPagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageId"] = this.pageId;
        data["isDefault"] = this.isDefault;
        return data;
    }

    clone(): UserSelectedPagesDto {
        const json = this.toJSON();
        let result = new UserSelectedPagesDto();
        result.init(json);
        return result;
    }
}

export interface IUserSelectedPagesDto {
    pageId: number | undefined;
    isDefault: boolean | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean | undefined;
    roleNames: string[] | undefined;
    password: string;
    phoneNumber: string | undefined;
    platomUserId: string | undefined;
    assignedPages: UserSelectedPagesDto[] | undefined;
    assignedModuleIds: number[] | undefined;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
            this.phoneNumber = _data["phoneNumber"];
            this.platomUserId = _data["platomUserId"];
            if (Array.isArray(_data["assignedPages"])) {
                this.assignedPages = [] as any;
                for (let item of _data["assignedPages"])
                    this.assignedPages.push(UserSelectedPagesDto.fromJS(item));
            }
            if (Array.isArray(_data["assignedModuleIds"])) {
                this.assignedModuleIds = [] as any;
                for (let item of _data["assignedModuleIds"])
                    this.assignedModuleIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        data["phoneNumber"] = this.phoneNumber;
        data["platomUserId"] = this.platomUserId;
        if (Array.isArray(this.assignedPages)) {
            data["assignedPages"] = [];
            for (let item of this.assignedPages)
                data["assignedPages"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedModuleIds)) {
            data["assignedModuleIds"] = [];
            for (let item of this.assignedModuleIds)
                data["assignedModuleIds"].push(item);
        }
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean | undefined;
    roleNames: string[] | undefined;
    password: string;
    phoneNumber: string | undefined;
    platomUserId: string | undefined;
    assignedPages: UserSelectedPagesDto[] | undefined;
    assignedModuleIds: number[] | undefined;
}

export class ListResultDtoOfRoleDto implements IListResultDtoOfRoleDto {
    items: RoleDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfRoleDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfRoleDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfRoleDto {
    items: RoleDto[] | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class CloneUserDto implements ICloneUserDto {
    clonedUserId: number | undefined;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    platomUserId: string | undefined;

    constructor(data?: ICloneUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clonedUserId = _data["clonedUserId"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.platomUserId = _data["platomUserId"];
        }
    }

    static fromJS(data: any): CloneUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloneUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clonedUserId"] = this.clonedUserId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["platomUserId"] = this.platomUserId;
        return data;
    }

    clone(): CloneUserDto {
        const json = this.toJSON();
        let result = new CloneUserDto();
        result.init(json);
        return result;
    }
}

export interface ICloneUserDto {
    clonedUserId: number | undefined;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    platomUserId: string | undefined;
}

export class LastLoggedUsersDto implements ILastLoggedUsersDto {
    userId: number | undefined;
    userName: string | undefined;
    userSurname: string | undefined;
    customerName: string | undefined;
    firstLogDate: Date | undefined;
    lastLogDate: Date | undefined;
    browserInfo: string | undefined;
    status: boolean | undefined;

    constructor(data?: ILastLoggedUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userSurname = _data["userSurname"];
            this.customerName = _data["customerName"];
            this.firstLogDate = _data["firstLogDate"] ? new Date(_data["firstLogDate"].toString()) : <any>undefined;
            this.lastLogDate = _data["lastLogDate"] ? new Date(_data["lastLogDate"].toString()) : <any>undefined;
            this.browserInfo = _data["browserInfo"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): LastLoggedUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new LastLoggedUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userSurname"] = this.userSurname;
        data["customerName"] = this.customerName;
        data["firstLogDate"] = this.firstLogDate ? this.firstLogDate.toISOString() : <any>undefined;
        data["lastLogDate"] = this.lastLogDate ? this.lastLogDate.toISOString() : <any>undefined;
        data["browserInfo"] = this.browserInfo;
        data["status"] = this.status;
        return data;
    }

    clone(): LastLoggedUsersDto {
        const json = this.toJSON();
        let result = new LastLoggedUsersDto();
        result.init(json);
        return result;
    }
}

export interface ILastLoggedUsersDto {
    userId: number | undefined;
    userName: string | undefined;
    userSurname: string | undefined;
    customerName: string | undefined;
    firstLogDate: Date | undefined;
    lastLogDate: Date | undefined;
    browserInfo: string | undefined;
    status: boolean | undefined;
}

export class UserActionDto implements IUserActionDto {
    orderDetailsId: number | undefined;
    talepTarihi: Date | undefined;
    urunId: number | undefined;
    urunKodu: string | undefined;
    urunAdi: string | undefined;
    talepMiktari: number | undefined;
    cikisDepoKodu: string | undefined;
    cikisDepoAdi: string | undefined;
    hedefAdresId: number | undefined;
    hedefAdresAdi: string | undefined;
    onayDurumId: number | undefined;
    onayDurum: string | undefined;
    onayciUserId: number | undefined;
    isNext: boolean | undefined;
    onayciUser: string | undefined;
    talepDetay: number | undefined;
    talepDetayDurum: string | undefined;

    constructor(data?: IUserActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderDetailsId = _data["orderDetailsId"];
            this.talepTarihi = _data["talepTarihi"] ? new Date(_data["talepTarihi"].toString()) : <any>undefined;
            this.urunId = _data["urunId"];
            this.urunKodu = _data["urunKodu"];
            this.urunAdi = _data["urunAdi"];
            this.talepMiktari = _data["talepMiktari"];
            this.cikisDepoKodu = _data["cikisDepoKodu"];
            this.cikisDepoAdi = _data["cikisDepoAdi"];
            this.hedefAdresId = _data["hedefAdresId"];
            this.hedefAdresAdi = _data["hedefAdresAdi"];
            this.onayDurumId = _data["onayDurumId"];
            this.onayDurum = _data["onayDurum"];
            this.onayciUserId = _data["onayciUserId"];
            this.isNext = _data["isNext"];
            this.onayciUser = _data["onayciUser"];
            this.talepDetay = _data["talepDetay"];
            this.talepDetayDurum = _data["talepDetayDurum"];
        }
    }

    static fromJS(data: any): UserActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderDetailsId"] = this.orderDetailsId;
        data["talepTarihi"] = this.talepTarihi ? this.talepTarihi.toISOString() : <any>undefined;
        data["urunId"] = this.urunId;
        data["urunKodu"] = this.urunKodu;
        data["urunAdi"] = this.urunAdi;
        data["talepMiktari"] = this.talepMiktari;
        data["cikisDepoKodu"] = this.cikisDepoKodu;
        data["cikisDepoAdi"] = this.cikisDepoAdi;
        data["hedefAdresId"] = this.hedefAdresId;
        data["hedefAdresAdi"] = this.hedefAdresAdi;
        data["onayDurumId"] = this.onayDurumId;
        data["onayDurum"] = this.onayDurum;
        data["onayciUserId"] = this.onayciUserId;
        data["isNext"] = this.isNext;
        data["onayciUser"] = this.onayciUser;
        data["talepDetay"] = this.talepDetay;
        data["talepDetayDurum"] = this.talepDetayDurum;
        return data;
    }

    clone(): UserActionDto {
        const json = this.toJSON();
        let result = new UserActionDto();
        result.init(json);
        return result;
    }
}

export interface IUserActionDto {
    orderDetailsId: number | undefined;
    talepTarihi: Date | undefined;
    urunId: number | undefined;
    urunKodu: string | undefined;
    urunAdi: string | undefined;
    talepMiktari: number | undefined;
    cikisDepoKodu: string | undefined;
    cikisDepoAdi: string | undefined;
    hedefAdresId: number | undefined;
    hedefAdresAdi: string | undefined;
    onayDurumId: number | undefined;
    onayDurum: string | undefined;
    onayciUserId: number | undefined;
    isNext: boolean | undefined;
    onayciUser: string | undefined;
    talepDetay: number | undefined;
    talepDetayDurum: string | undefined;
}

export class UserLastLoginDto implements IUserLastLoginDto {
    id: number | undefined;
    userId: number | undefined;
    browserInfo: string | undefined;
    executionTime: Date | undefined;
    executionDuration: number | undefined;
    methodName: string | undefined;
    parameters: string | undefined;

    constructor(data?: IUserLastLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.browserInfo = _data["browserInfo"];
            this.executionTime = _data["executionTime"] ? new Date(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
        }
    }

    static fromJS(data: any): UserLastLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLastLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["browserInfo"] = this.browserInfo;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        return data;
    }

    clone(): UserLastLoginDto {
        const json = this.toJSON();
        let result = new UserLastLoginDto();
        result.init(json);
        return result;
    }
}

export interface IUserLastLoginDto {
    id: number | undefined;
    userId: number | undefined;
    browserInfo: string | undefined;
    executionTime: Date | undefined;
    executionDuration: number | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
}

export class PagedResultDtoOfUserAddressDto implements IPagedResultDtoOfUserAddressDto {
    totalCount: number | undefined;
    items: UserAddressDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserAddressDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserAddressDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserAddressDto {
    totalCount: number | undefined;
    items: UserAddressDto[] | undefined;
}

export class UserAddressDto implements IUserAddressDto {
    name: string | undefined;
    addressId: number | undefined;
    addressPoiId: number | undefined;
    addressName: string | undefined;
    fullAddress: string | undefined;
    categoryName: string | undefined;
    cityName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    authorizationDescription: string | undefined;
    id: number | undefined;

    constructor(data?: IUserAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.addressId = _data["addressId"];
            this.addressPoiId = _data["addressPoiId"];
            this.addressName = _data["addressName"];
            this.fullAddress = _data["fullAddress"];
            this.categoryName = _data["categoryName"];
            this.cityName = _data["cityName"];
            this.authorizationId = _data["authorizationId"];
            this.authorizationName = _data["authorizationName"];
            this.authorizationDescription = _data["authorizationDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["addressId"] = this.addressId;
        data["addressPoiId"] = this.addressPoiId;
        data["addressName"] = this.addressName;
        data["fullAddress"] = this.fullAddress;
        data["categoryName"] = this.categoryName;
        data["cityName"] = this.cityName;
        data["authorizationId"] = this.authorizationId;
        data["authorizationName"] = this.authorizationName;
        data["authorizationDescription"] = this.authorizationDescription;
        data["id"] = this.id;
        return data;
    }

    clone(): UserAddressDto {
        const json = this.toJSON();
        let result = new UserAddressDto();
        result.init(json);
        return result;
    }
}

export interface IUserAddressDto {
    name: string | undefined;
    addressId: number | undefined;
    addressPoiId: number | undefined;
    addressName: string | undefined;
    fullAddress: string | undefined;
    categoryName: string | undefined;
    cityName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    authorizationDescription: string | undefined;
    id: number | undefined;
}

export class UserAddressCitiesAndCategoriesDto implements IUserAddressCitiesAndCategoriesDto {
    cities: SelectListItemDto[] | undefined;
    categoryNames: string[] | undefined;

    constructor(data?: IUserAddressCitiesAndCategoriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities.push(SelectListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["categoryNames"])) {
                this.categoryNames = [] as any;
                for (let item of _data["categoryNames"])
                    this.categoryNames.push(item);
            }
        }
    }

    static fromJS(data: any): UserAddressCitiesAndCategoriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAddressCitiesAndCategoriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        if (Array.isArray(this.categoryNames)) {
            data["categoryNames"] = [];
            for (let item of this.categoryNames)
                data["categoryNames"].push(item);
        }
        return data;
    }

    clone(): UserAddressCitiesAndCategoriesDto {
        const json = this.toJSON();
        let result = new UserAddressCitiesAndCategoriesDto();
        result.init(json);
        return result;
    }
}

export interface IUserAddressCitiesAndCategoriesDto {
    cities: SelectListItemDto[] | undefined;
    categoryNames: string[] | undefined;
}

export class CreateUserAddressDto implements ICreateUserAddressDto {
    name: string | undefined;
    userId: number | undefined;
    authorizationId: number | undefined;
    addressIds: number[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.authorizationId = _data["authorizationId"];
            if (Array.isArray(_data["addressIds"])) {
                this.addressIds = [] as any;
                for (let item of _data["addressIds"])
                    this.addressIds.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["authorizationId"] = this.authorizationId;
        if (Array.isArray(this.addressIds)) {
            data["addressIds"] = [];
            for (let item of this.addressIds)
                data["addressIds"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): CreateUserAddressDto {
        const json = this.toJSON();
        let result = new CreateUserAddressDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserAddressDto {
    name: string | undefined;
    userId: number | undefined;
    authorizationId: number | undefined;
    addressIds: number[] | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfUserAuthorizationDto implements IPagedResultDtoOfUserAuthorizationDto {
    totalCount: number | undefined;
    items: UserAuthorizationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserAuthorizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserAuthorizationDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserAuthorizationDto {
    totalCount: number | undefined;
    items: UserAuthorizationDto[] | undefined;
}

export class UserAuthorizationDto implements IUserAuthorizationDto {
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    authorizationDescription: string | undefined;
    id: number | undefined;

    constructor(data?: IUserAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorizationId = _data["authorizationId"];
            this.authorizationName = _data["authorizationName"];
            this.authorizationDescription = _data["authorizationDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizationId"] = this.authorizationId;
        data["authorizationName"] = this.authorizationName;
        data["authorizationDescription"] = this.authorizationDescription;
        data["id"] = this.id;
        return data;
    }

    clone(): UserAuthorizationDto {
        const json = this.toJSON();
        let result = new UserAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface IUserAuthorizationDto {
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    authorizationDescription: string | undefined;
    id: number | undefined;
}

export class CreateUserAuthorizationDto implements ICreateUserAuthorizationDto {
    userId: number | undefined;
    authorizationIds: number[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["authorizationIds"])) {
                this.authorizationIds = [] as any;
                for (let item of _data["authorizationIds"])
                    this.authorizationIds.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.authorizationIds)) {
            data["authorizationIds"] = [];
            for (let item of this.authorizationIds)
                data["authorizationIds"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): CreateUserAuthorizationDto {
        const json = this.toJSON();
        let result = new CreateUserAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserAuthorizationDto {
    userId: number | undefined;
    authorizationIds: number[] | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfUserCitiesDto implements IPagedResultDtoOfUserCitiesDto {
    totalCount: number | undefined;
    items: UserCitiesDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserCitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserCitiesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserCitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserCitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserCitiesDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserCitiesDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserCitiesDto {
    totalCount: number | undefined;
    items: UserCitiesDto[] | undefined;
}

export class UserCitiesDto implements IUserCitiesDto {
    cityId: number | undefined;
    cityName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    hasCategory: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUserCitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
            this.authorizationId = _data["authorizationId"];
            this.authorizationName = _data["authorizationName"];
            this.hasCategory = _data["hasCategory"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserCitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        data["authorizationId"] = this.authorizationId;
        data["authorizationName"] = this.authorizationName;
        data["hasCategory"] = this.hasCategory;
        data["id"] = this.id;
        return data;
    }

    clone(): UserCitiesDto {
        const json = this.toJSON();
        let result = new UserCitiesDto();
        result.init(json);
        return result;
    }
}

export interface IUserCitiesDto {
    cityId: number | undefined;
    cityName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    hasCategory: boolean | undefined;
    id: number | undefined;
}

export class UpdateUserCitiesDto implements IUpdateUserCitiesDto {
    authorizationId: number | undefined;
    assignedCategories: number[] | undefined;
    id: number | undefined;

    constructor(data?: IUpdateUserCitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorizationId = _data["authorizationId"];
            if (Array.isArray(_data["assignedCategories"])) {
                this.assignedCategories = [] as any;
                for (let item of _data["assignedCategories"])
                    this.assignedCategories.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateUserCitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizationId"] = this.authorizationId;
        if (Array.isArray(this.assignedCategories)) {
            data["assignedCategories"] = [];
            for (let item of this.assignedCategories)
                data["assignedCategories"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateUserCitiesDto {
        const json = this.toJSON();
        let result = new UpdateUserCitiesDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserCitiesDto {
    authorizationId: number | undefined;
    assignedCategories: number[] | undefined;
    id: number | undefined;
}

export class CreateUserCitiesDto implements ICreateUserCitiesDto {
    userId: number | undefined;
    authorizationId: number | undefined;
    cityIds: number[] | undefined;
    categoryIds: number[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserCitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.authorizationId = _data["authorizationId"];
            if (Array.isArray(_data["cityIds"])) {
                this.cityIds = [] as any;
                for (let item of _data["cityIds"])
                    this.cityIds.push(item);
            }
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserCitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["authorizationId"] = this.authorizationId;
        if (Array.isArray(this.cityIds)) {
            data["cityIds"] = [];
            for (let item of this.cityIds)
                data["cityIds"].push(item);
        }
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): CreateUserCitiesDto {
        const json = this.toJSON();
        let result = new CreateUserCitiesDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserCitiesDto {
    userId: number | undefined;
    authorizationId: number | undefined;
    cityIds: number[] | undefined;
    categoryIds: number[] | undefined;
    id: number | undefined;
}

export class UserCityCategoryDto implements IUserCityCategoryDto {
    categoryId: number | undefined;
    categoryName: string | undefined;
    isAssigned: boolean | undefined;

    constructor(data?: IUserCityCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.isAssigned = _data["isAssigned"];
        }
    }

    static fromJS(data: any): UserCityCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCityCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["isAssigned"] = this.isAssigned;
        return data;
    }

    clone(): UserCityCategoryDto {
        const json = this.toJSON();
        let result = new UserCityCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IUserCityCategoryDto {
    categoryId: number | undefined;
    categoryName: string | undefined;
    isAssigned: boolean | undefined;
}

export class UserCitiesCategoriesDto implements IUserCitiesCategoriesDto {
    name: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    categoryId: number | undefined;
    categoryName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    id: number | undefined;

    constructor(data?: IUserCitiesCategoriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.authorizationId = _data["authorizationId"];
            this.authorizationName = _data["authorizationName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserCitiesCategoriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCitiesCategoriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["authorizationId"] = this.authorizationId;
        data["authorizationName"] = this.authorizationName;
        data["id"] = this.id;
        return data;
    }

    clone(): UserCitiesCategoriesDto {
        const json = this.toJSON();
        let result = new UserCitiesCategoriesDto();
        result.init(json);
        return result;
    }
}

export interface IUserCitiesCategoriesDto {
    name: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    categoryId: number | undefined;
    categoryName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfUserCitiesCategoriesDto implements IPagedResultDtoOfUserCitiesCategoriesDto {
    totalCount: number | undefined;
    items: UserCitiesCategoriesDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserCitiesCategoriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserCitiesCategoriesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserCitiesCategoriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserCitiesCategoriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserCitiesCategoriesDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserCitiesCategoriesDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserCitiesCategoriesDto {
    totalCount: number | undefined;
    items: UserCitiesCategoriesDto[] | undefined;
}

export class CreateUserCitiesCategoriesDto implements ICreateUserCitiesCategoriesDto {
    id: number | undefined;

    constructor(data?: ICreateUserCitiesCategoriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserCitiesCategoriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCitiesCategoriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): CreateUserCitiesCategoriesDto {
        const json = this.toJSON();
        let result = new CreateUserCitiesCategoriesDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserCitiesCategoriesDto {
    id: number | undefined;
}

export class PagedResultDtoOfUserCustomerDto implements IPagedResultDtoOfUserCustomerDto {
    totalCount: number | undefined;
    items: UserCustomerDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserCustomerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserCustomerDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserCustomerDto {
    totalCount: number | undefined;
    items: UserCustomerDto[] | undefined;
}

export class UserCustomerDto implements IUserCustomerDto {
    name: string | undefined;
    customerId: number | undefined;
    customerGuid: string | undefined;
    customerCode: string | undefined;
    customerName: string | undefined;
    titleId: number | undefined;
    titleName: string | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    orderApprovalTypeId: number | undefined;
    orderApprovalTypeName: string | undefined;
    isDefault: boolean | undefined;
    customerThemeId: number | undefined;
    customerThemePortalLogoPath: string | undefined;
    customerThemeCustomerLogoPath: string | undefined;
    id: number | undefined;

    constructor(data?: IUserCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.customerGuid = _data["customerGuid"];
            this.customerCode = _data["customerCode"];
            this.customerName = _data["customerName"];
            this.titleId = _data["titleId"];
            this.titleName = _data["titleName"];
            this.isStockView = _data["isStockView"];
            this.isProductLocationOrderHistoryView = _data["isProductLocationOrderHistoryView"];
            this.orderApprovalTypeId = _data["orderApprovalTypeId"];
            this.orderApprovalTypeName = _data["orderApprovalTypeName"];
            this.isDefault = _data["isDefault"];
            this.customerThemeId = _data["customerThemeId"];
            this.customerThemePortalLogoPath = _data["customerThemePortalLogoPath"];
            this.customerThemeCustomerLogoPath = _data["customerThemeCustomerLogoPath"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["customerGuid"] = this.customerGuid;
        data["customerCode"] = this.customerCode;
        data["customerName"] = this.customerName;
        data["titleId"] = this.titleId;
        data["titleName"] = this.titleName;
        data["isStockView"] = this.isStockView;
        data["isProductLocationOrderHistoryView"] = this.isProductLocationOrderHistoryView;
        data["orderApprovalTypeId"] = this.orderApprovalTypeId;
        data["orderApprovalTypeName"] = this.orderApprovalTypeName;
        data["isDefault"] = this.isDefault;
        data["customerThemeId"] = this.customerThemeId;
        data["customerThemePortalLogoPath"] = this.customerThemePortalLogoPath;
        data["customerThemeCustomerLogoPath"] = this.customerThemeCustomerLogoPath;
        data["id"] = this.id;
        return data;
    }

    clone(): UserCustomerDto {
        const json = this.toJSON();
        let result = new UserCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IUserCustomerDto {
    name: string | undefined;
    customerId: number | undefined;
    customerGuid: string | undefined;
    customerCode: string | undefined;
    customerName: string | undefined;
    titleId: number | undefined;
    titleName: string | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    orderApprovalTypeId: number | undefined;
    orderApprovalTypeName: string | undefined;
    isDefault: boolean | undefined;
    customerThemeId: number | undefined;
    customerThemePortalLogoPath: string | undefined;
    customerThemeCustomerLogoPath: string | undefined;
    id: number | undefined;
}

export class CreateUserCustomerDto implements ICreateUserCustomerDto {
    name: string | undefined;
    userId: number | undefined;
    assignedList: UserCustomerAssignDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["assignedList"])) {
                this.assignedList = [] as any;
                for (let item of _data["assignedList"])
                    this.assignedList.push(UserCustomerAssignDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userId"] = this.userId;
        if (Array.isArray(this.assignedList)) {
            data["assignedList"] = [];
            for (let item of this.assignedList)
                data["assignedList"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): CreateUserCustomerDto {
        const json = this.toJSON();
        let result = new CreateUserCustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserCustomerDto {
    name: string | undefined;
    userId: number | undefined;
    assignedList: UserCustomerAssignDto[] | undefined;
    id: number | undefined;
}

export class UserCustomerAssignDto implements IUserCustomerAssignDto {
    customerId: number | undefined;
    titleIds: number[] | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    orderApprovalTypeId: number | undefined;
    customerThemesId: number | undefined;

    constructor(data?: IUserCustomerAssignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["titleIds"])) {
                this.titleIds = [] as any;
                for (let item of _data["titleIds"])
                    this.titleIds.push(item);
            }
            this.isStockView = _data["isStockView"];
            this.isProductLocationOrderHistoryView = _data["isProductLocationOrderHistoryView"];
            this.orderApprovalTypeId = _data["orderApprovalTypeId"];
            this.customerThemesId = _data["customerThemesId"];
        }
    }

    static fromJS(data: any): UserCustomerAssignDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCustomerAssignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        if (Array.isArray(this.titleIds)) {
            data["titleIds"] = [];
            for (let item of this.titleIds)
                data["titleIds"].push(item);
        }
        data["isStockView"] = this.isStockView;
        data["isProductLocationOrderHistoryView"] = this.isProductLocationOrderHistoryView;
        data["orderApprovalTypeId"] = this.orderApprovalTypeId;
        data["customerThemesId"] = this.customerThemesId;
        return data;
    }

    clone(): UserCustomerAssignDto {
        const json = this.toJSON();
        let result = new UserCustomerAssignDto();
        result.init(json);
        return result;
    }
}

export interface IUserCustomerAssignDto {
    customerId: number | undefined;
    titleIds: number[] | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    orderApprovalTypeId: number | undefined;
    customerThemesId: number | undefined;
}

export class UpdateUserCustomerDto implements IUpdateUserCustomerDto {
    userId: number | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    orderApprovalTypeId: number | undefined;
    isDefaultFired: boolean | undefined;
    customerThemeId: number | undefined;
    id: number | undefined;

    constructor(data?: IUpdateUserCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.isStockView = _data["isStockView"];
            this.isProductLocationOrderHistoryView = _data["isProductLocationOrderHistoryView"];
            this.orderApprovalTypeId = _data["orderApprovalTypeId"];
            this.isDefaultFired = _data["isDefaultFired"];
            this.customerThemeId = _data["customerThemeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateUserCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["isStockView"] = this.isStockView;
        data["isProductLocationOrderHistoryView"] = this.isProductLocationOrderHistoryView;
        data["orderApprovalTypeId"] = this.orderApprovalTypeId;
        data["isDefaultFired"] = this.isDefaultFired;
        data["customerThemeId"] = this.customerThemeId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateUserCustomerDto {
        const json = this.toJSON();
        let result = new UpdateUserCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserCustomerDto {
    userId: number | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    orderApprovalTypeId: number | undefined;
    isDefaultFired: boolean | undefined;
    customerThemeId: number | undefined;
    id: number | undefined;
}

export class OrderFormAuthorizationDto implements IOrderFormAuthorizationDto {
    formId: number | undefined;
    formName: string | undefined;
    formDescription: string | undefined;
    isChecked: boolean | undefined;
    readonly selectedShipmentTypesIds: number[] | undefined;
    shipmentTypes: OrderFormAuthorizationShipmentTypesDto[] | undefined;
    warehouses: OrderFormAuthorizationWarehousesDto[] | undefined;
    readonly selectedWarehousesIds: number[] | undefined;
    isOrderDamagedProduct: boolean | undefined;
    isOrderByExpirationDate: boolean | undefined;
    isOrderBySpecialCode: boolean | undefined;
    isOrderByBusinessUnit: boolean | undefined;

    constructor(data?: IOrderFormAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.formName = _data["formName"];
            this.formDescription = _data["formDescription"];
            this.isChecked = _data["isChecked"];
            if (Array.isArray(_data["selectedShipmentTypesIds"])) {
                (<any>this).selectedShipmentTypesIds = [] as any;
                for (let item of _data["selectedShipmentTypesIds"])
                    (<any>this).selectedShipmentTypesIds.push(item);
            }
            if (Array.isArray(_data["shipmentTypes"])) {
                this.shipmentTypes = [] as any;
                for (let item of _data["shipmentTypes"])
                    this.shipmentTypes.push(OrderFormAuthorizationShipmentTypesDto.fromJS(item));
            }
            if (Array.isArray(_data["warehouses"])) {
                this.warehouses = [] as any;
                for (let item of _data["warehouses"])
                    this.warehouses.push(OrderFormAuthorizationWarehousesDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedWarehousesIds"])) {
                (<any>this).selectedWarehousesIds = [] as any;
                for (let item of _data["selectedWarehousesIds"])
                    (<any>this).selectedWarehousesIds.push(item);
            }
            this.isOrderDamagedProduct = _data["isOrderDamagedProduct"];
            this.isOrderByExpirationDate = _data["isOrderByExpirationDate"];
            this.isOrderBySpecialCode = _data["isOrderBySpecialCode"];
            this.isOrderByBusinessUnit = _data["isOrderByBusinessUnit"];
        }
    }

    static fromJS(data: any): OrderFormAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFormAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["formName"] = this.formName;
        data["formDescription"] = this.formDescription;
        data["isChecked"] = this.isChecked;
        if (Array.isArray(this.selectedShipmentTypesIds)) {
            data["selectedShipmentTypesIds"] = [];
            for (let item of this.selectedShipmentTypesIds)
                data["selectedShipmentTypesIds"].push(item);
        }
        if (Array.isArray(this.shipmentTypes)) {
            data["shipmentTypes"] = [];
            for (let item of this.shipmentTypes)
                data["shipmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.warehouses)) {
            data["warehouses"] = [];
            for (let item of this.warehouses)
                data["warehouses"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedWarehousesIds)) {
            data["selectedWarehousesIds"] = [];
            for (let item of this.selectedWarehousesIds)
                data["selectedWarehousesIds"].push(item);
        }
        data["isOrderDamagedProduct"] = this.isOrderDamagedProduct;
        data["isOrderByExpirationDate"] = this.isOrderByExpirationDate;
        data["isOrderBySpecialCode"] = this.isOrderBySpecialCode;
        data["isOrderByBusinessUnit"] = this.isOrderByBusinessUnit;
        return data;
    }

    clone(): OrderFormAuthorizationDto {
        const json = this.toJSON();
        let result = new OrderFormAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface IOrderFormAuthorizationDto {
    formId: number | undefined;
    formName: string | undefined;
    formDescription: string | undefined;
    isChecked: boolean | undefined;
    selectedShipmentTypesIds: number[] | undefined;
    shipmentTypes: OrderFormAuthorizationShipmentTypesDto[] | undefined;
    warehouses: OrderFormAuthorizationWarehousesDto[] | undefined;
    selectedWarehousesIds: number[] | undefined;
    isOrderDamagedProduct: boolean | undefined;
    isOrderByExpirationDate: boolean | undefined;
    isOrderBySpecialCode: boolean | undefined;
    isOrderByBusinessUnit: boolean | undefined;
}

export class OrderFormAuthorizationShipmentTypesDto implements IOrderFormAuthorizationShipmentTypesDto {
    isChecked: boolean | undefined;
    isDisabled: boolean | undefined;
    shipmentTypeId: number | undefined;
    shipmentTypeName: string | undefined;

    constructor(data?: IOrderFormAuthorizationShipmentTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isChecked = _data["isChecked"];
            this.isDisabled = _data["isDisabled"];
            this.shipmentTypeId = _data["shipmentTypeId"];
            this.shipmentTypeName = _data["shipmentTypeName"];
        }
    }

    static fromJS(data: any): OrderFormAuthorizationShipmentTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFormAuthorizationShipmentTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isChecked"] = this.isChecked;
        data["isDisabled"] = this.isDisabled;
        data["shipmentTypeId"] = this.shipmentTypeId;
        data["shipmentTypeName"] = this.shipmentTypeName;
        return data;
    }

    clone(): OrderFormAuthorizationShipmentTypesDto {
        const json = this.toJSON();
        let result = new OrderFormAuthorizationShipmentTypesDto();
        result.init(json);
        return result;
    }
}

export interface IOrderFormAuthorizationShipmentTypesDto {
    isChecked: boolean | undefined;
    isDisabled: boolean | undefined;
    shipmentTypeId: number | undefined;
    shipmentTypeName: string | undefined;
}

export class OrderFormAuthorizationWarehousesDto implements IOrderFormAuthorizationWarehousesDto {
    isChecked: boolean | undefined;
    isDisabled: boolean | undefined;
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    customerIds: number[] | undefined;

    constructor(data?: IOrderFormAuthorizationWarehousesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isChecked = _data["isChecked"];
            this.isDisabled = _data["isDisabled"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            if (Array.isArray(_data["customerIds"])) {
                this.customerIds = [] as any;
                for (let item of _data["customerIds"])
                    this.customerIds.push(item);
            }
        }
    }

    static fromJS(data: any): OrderFormAuthorizationWarehousesDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFormAuthorizationWarehousesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isChecked"] = this.isChecked;
        data["isDisabled"] = this.isDisabled;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        if (Array.isArray(this.customerIds)) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        return data;
    }

    clone(): OrderFormAuthorizationWarehousesDto {
        const json = this.toJSON();
        let result = new OrderFormAuthorizationWarehousesDto();
        result.init(json);
        return result;
    }
}

export interface IOrderFormAuthorizationWarehousesDto {
    isChecked: boolean | undefined;
    isDisabled: boolean | undefined;
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    customerIds: number[] | undefined;
}

export class CreateUserFormsDto implements ICreateUserFormsDto {
    userCustomerId: number | undefined;
    selectedOrderForms: UserFormsAssignedDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserFormsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCustomerId = _data["userCustomerId"];
            if (Array.isArray(_data["selectedOrderForms"])) {
                this.selectedOrderForms = [] as any;
                for (let item of _data["selectedOrderForms"])
                    this.selectedOrderForms.push(UserFormsAssignedDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserFormsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserFormsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCustomerId"] = this.userCustomerId;
        if (Array.isArray(this.selectedOrderForms)) {
            data["selectedOrderForms"] = [];
            for (let item of this.selectedOrderForms)
                data["selectedOrderForms"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): CreateUserFormsDto {
        const json = this.toJSON();
        let result = new CreateUserFormsDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserFormsDto {
    userCustomerId: number | undefined;
    selectedOrderForms: UserFormsAssignedDto[] | undefined;
    id: number | undefined;
}

export class UserFormsAssignedDto implements IUserFormsAssignedDto {
    formId: number | undefined;
    isOrderDamagedProduct: boolean | undefined;
    isOrderByExpirationDate: boolean | undefined;
    isOrderBySpecialCode: boolean | undefined;
    isOrderByBusinessUnit: boolean | undefined;
    shipmenTypeIds: number[] | undefined;
    warehouseIds: number[] | undefined;

    constructor(data?: IUserFormsAssignedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.isOrderDamagedProduct = _data["isOrderDamagedProduct"];
            this.isOrderByExpirationDate = _data["isOrderByExpirationDate"];
            this.isOrderBySpecialCode = _data["isOrderBySpecialCode"];
            this.isOrderByBusinessUnit = _data["isOrderByBusinessUnit"];
            if (Array.isArray(_data["shipmenTypeIds"])) {
                this.shipmenTypeIds = [] as any;
                for (let item of _data["shipmenTypeIds"])
                    this.shipmenTypeIds.push(item);
            }
            if (Array.isArray(_data["warehouseIds"])) {
                this.warehouseIds = [] as any;
                for (let item of _data["warehouseIds"])
                    this.warehouseIds.push(item);
            }
        }
    }

    static fromJS(data: any): UserFormsAssignedDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserFormsAssignedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["isOrderDamagedProduct"] = this.isOrderDamagedProduct;
        data["isOrderByExpirationDate"] = this.isOrderByExpirationDate;
        data["isOrderBySpecialCode"] = this.isOrderBySpecialCode;
        data["isOrderByBusinessUnit"] = this.isOrderByBusinessUnit;
        if (Array.isArray(this.shipmenTypeIds)) {
            data["shipmenTypeIds"] = [];
            for (let item of this.shipmenTypeIds)
                data["shipmenTypeIds"].push(item);
        }
        if (Array.isArray(this.warehouseIds)) {
            data["warehouseIds"] = [];
            for (let item of this.warehouseIds)
                data["warehouseIds"].push(item);
        }
        return data;
    }

    clone(): UserFormsAssignedDto {
        const json = this.toJSON();
        let result = new UserFormsAssignedDto();
        result.init(json);
        return result;
    }
}

export interface IUserFormsAssignedDto {
    formId: number | undefined;
    isOrderDamagedProduct: boolean | undefined;
    isOrderByExpirationDate: boolean | undefined;
    isOrderBySpecialCode: boolean | undefined;
    isOrderByBusinessUnit: boolean | undefined;
    shipmenTypeIds: number[] | undefined;
    warehouseIds: number[] | undefined;
}

export class ShipmentTypeDto implements IShipmentTypeDto {
    name: string | undefined;
    isDefault: boolean | undefined;
    localizationKey: string | undefined;
    id: number | undefined;

    constructor(data?: IShipmentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.localizationKey = _data["localizationKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShipmentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["localizationKey"] = this.localizationKey;
        data["id"] = this.id;
        return data;
    }

    clone(): ShipmentTypeDto {
        const json = this.toJSON();
        let result = new ShipmentTypeDto();
        result.init(json);
        return result;
    }
}

export interface IShipmentTypeDto {
    name: string | undefined;
    isDefault: boolean | undefined;
    localizationKey: string | undefined;
    id: number | undefined;
}

export class OrderCardDto implements IOrderCardDto {
    id: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    description: string | undefined;
    buttonTitle: string | undefined;
    icon: string | undefined;
    isVisible: boolean | undefined;
    relatedFormIds: number[] | undefined;

    constructor(data?: IOrderCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.description = _data["description"];
            this.buttonTitle = _data["buttonTitle"];
            this.icon = _data["icon"];
            this.isVisible = _data["isVisible"];
            if (Array.isArray(_data["relatedFormIds"])) {
                this.relatedFormIds = [] as any;
                for (let item of _data["relatedFormIds"])
                    this.relatedFormIds.push(item);
            }
        }
    }

    static fromJS(data: any): OrderCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["description"] = this.description;
        data["buttonTitle"] = this.buttonTitle;
        data["icon"] = this.icon;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.relatedFormIds)) {
            data["relatedFormIds"] = [];
            for (let item of this.relatedFormIds)
                data["relatedFormIds"].push(item);
        }
        return data;
    }

    clone(): OrderCardDto {
        const json = this.toJSON();
        let result = new OrderCardDto();
        result.init(json);
        return result;
    }
}

export interface IOrderCardDto {
    id: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    description: string | undefined;
    buttonTitle: string | undefined;
    icon: string | undefined;
    isVisible: boolean | undefined;
    relatedFormIds: number[] | undefined;
}

export class UserFormOrderFormTypeDto implements IUserFormOrderFormTypeDto {
    id: number | undefined;
    name: string | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    description: string | undefined;
    icon: string | undefined;
    buttonTitle: string | undefined;
    readonly formComponentName: string | undefined;

    constructor(data?: IUserFormOrderFormTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.buttonTitle = _data["buttonTitle"];
            (<any>this).formComponentName = _data["formComponentName"];
        }
    }

    static fromJS(data: any): UserFormOrderFormTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserFormOrderFormTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["buttonTitle"] = this.buttonTitle;
        data["formComponentName"] = this.formComponentName;
        return data;
    }

    clone(): UserFormOrderFormTypeDto {
        const json = this.toJSON();
        let result = new UserFormOrderFormTypeDto();
        result.init(json);
        return result;
    }
}

export interface IUserFormOrderFormTypeDto {
    id: number | undefined;
    name: string | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    description: string | undefined;
    icon: string | undefined;
    buttonTitle: string | undefined;
    formComponentName: string | undefined;
}

export class UserFormOrderFormTypeAuthDto implements IUserFormOrderFormTypeAuthDto {
    userHasAuth: boolean | undefined;
    form: UserFormOrderFormTypeDto | undefined;

    constructor(data?: IUserFormOrderFormTypeAuthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userHasAuth = _data["userHasAuth"];
            this.form = _data["form"] ? UserFormOrderFormTypeDto.fromJS(_data["form"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserFormOrderFormTypeAuthDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserFormOrderFormTypeAuthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userHasAuth"] = this.userHasAuth;
        data["form"] = this.form ? this.form.toJSON() : <any>undefined;
        return data;
    }

    clone(): UserFormOrderFormTypeAuthDto {
        const json = this.toJSON();
        let result = new UserFormOrderFormTypeAuthDto();
        result.init(json);
        return result;
    }
}

export interface IUserFormOrderFormTypeAuthDto {
    userHasAuth: boolean | undefined;
    form: UserFormOrderFormTypeDto | undefined;
}

export class UserFormsDto implements IUserFormsDto {
    id: number | undefined;

    constructor(data?: IUserFormsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserFormsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserFormsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): UserFormsDto {
        const json = this.toJSON();
        let result = new UserFormsDto();
        result.init(json);
        return result;
    }
}

export interface IUserFormsDto {
    id: number | undefined;
}

export class PagedResultDtoOfUserFormsDto implements IPagedResultDtoOfUserFormsDto {
    totalCount: number | undefined;
    items: UserFormsDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserFormsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserFormsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserFormsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserFormsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserFormsDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserFormsDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserFormsDto {
    totalCount: number | undefined;
    items: UserFormsDto[] | undefined;
}

export class PagedResultDtoOfUserManagementSummaryDto implements IPagedResultDtoOfUserManagementSummaryDto {
    totalCount: number | undefined;
    items: UserManagementSummaryDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserManagementSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserManagementSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserManagementSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserManagementSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserManagementSummaryDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserManagementSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserManagementSummaryDto {
    totalCount: number | undefined;
    items: UserManagementSummaryDto[] | undefined;
}

export class UserManagementSummaryDto implements IUserManagementSummaryDto {
    sectionName: string | undefined;
    content: string | undefined;
    id: number | undefined;

    constructor(data?: IUserManagementSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionName = _data["sectionName"];
            this.content = _data["content"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserManagementSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserManagementSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionName"] = this.sectionName;
        data["content"] = this.content;
        data["id"] = this.id;
        return data;
    }

    clone(): UserManagementSummaryDto {
        const json = this.toJSON();
        let result = new UserManagementSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IUserManagementSummaryDto {
    sectionName: string | undefined;
    content: string | undefined;
    id: number | undefined;
}

export class CreateUserManagementSummaryDto implements ICreateUserManagementSummaryDto {

    constructor(data?: ICreateUserManagementSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateUserManagementSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserManagementSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreateUserManagementSummaryDto {
        const json = this.toJSON();
        let result = new CreateUserManagementSummaryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserManagementSummaryDto {
}

export class PagedResultDtoOfUserModuleDto implements IPagedResultDtoOfUserModuleDto {
    totalCount: number | undefined;
    items: UserModuleDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserModuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserModuleDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserModuleDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserModuleDto {
    totalCount: number | undefined;
    items: UserModuleDto[] | undefined;
}

export class UserModuleDto implements IUserModuleDto {
    userId: number | undefined;
    userName: string | undefined;
    moduleId: number | undefined;
    moduleName: string | undefined;
    isChecked: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUserModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.moduleId = _data["moduleId"];
            this.moduleName = _data["moduleName"];
            this.isChecked = _data["isChecked"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["moduleId"] = this.moduleId;
        data["moduleName"] = this.moduleName;
        data["isChecked"] = this.isChecked;
        data["id"] = this.id;
        return data;
    }

    clone(): UserModuleDto {
        const json = this.toJSON();
        let result = new UserModuleDto();
        result.init(json);
        return result;
    }
}

export interface IUserModuleDto {
    userId: number | undefined;
    userName: string | undefined;
    moduleId: number | undefined;
    moduleName: string | undefined;
    isChecked: boolean | undefined;
    id: number | undefined;
}

export class CreateUserModuleDto implements ICreateUserModuleDto {
    id: number | undefined;

    constructor(data?: ICreateUserModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): CreateUserModuleDto {
        const json = this.toJSON();
        let result = new CreateUserModuleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserModuleDto {
    id: number | undefined;
}

export class ModulePageDto implements IModulePageDto {
    moduleId: number | undefined;
    moduleName: string | undefined;
    pageAuthorizations: PageAuthorizationDto[] | undefined;

    constructor(data?: IModulePageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["moduleId"];
            this.moduleName = _data["moduleName"];
            if (Array.isArray(_data["pageAuthorizations"])) {
                this.pageAuthorizations = [] as any;
                for (let item of _data["pageAuthorizations"])
                    this.pageAuthorizations.push(PageAuthorizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModulePageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModulePageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId;
        data["moduleName"] = this.moduleName;
        if (Array.isArray(this.pageAuthorizations)) {
            data["pageAuthorizations"] = [];
            for (let item of this.pageAuthorizations)
                data["pageAuthorizations"].push(item.toJSON());
        }
        return data;
    }

    clone(): ModulePageDto {
        const json = this.toJSON();
        let result = new ModulePageDto();
        result.init(json);
        return result;
    }
}

export interface IModulePageDto {
    moduleId: number | undefined;
    moduleName: string | undefined;
    pageAuthorizations: PageAuthorizationDto[] | undefined;
}

export class PageAuthorizationDto implements IPageAuthorizationDto {
    pageId: number | undefined;
    pageName: string | undefined;
    pageUrl: string | undefined;
    pageLocalizationKey: string | undefined;
    isChecked: boolean | undefined;
    isDefault: boolean | undefined;
    isDisable: boolean | undefined;
    readonly isAuthorizeWithoutSubPage: boolean | undefined;
    readonly subPageAuthorizationIds: number[] | undefined;
    subPageAuthorizations: PageAuthorizationDto[] | undefined;

    constructor(data?: IPageAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageId = _data["pageId"];
            this.pageName = _data["pageName"];
            this.pageUrl = _data["pageUrl"];
            this.pageLocalizationKey = _data["pageLocalizationKey"];
            this.isChecked = _data["isChecked"];
            this.isDefault = _data["isDefault"];
            this.isDisable = _data["isDisable"];
            (<any>this).isAuthorizeWithoutSubPage = _data["isAuthorizeWithoutSubPage"];
            if (Array.isArray(_data["subPageAuthorizationIds"])) {
                (<any>this).subPageAuthorizationIds = [] as any;
                for (let item of _data["subPageAuthorizationIds"])
                    (<any>this).subPageAuthorizationIds.push(item);
            }
            if (Array.isArray(_data["subPageAuthorizations"])) {
                this.subPageAuthorizations = [] as any;
                for (let item of _data["subPageAuthorizations"])
                    this.subPageAuthorizations.push(PageAuthorizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PageAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageId"] = this.pageId;
        data["pageName"] = this.pageName;
        data["pageUrl"] = this.pageUrl;
        data["pageLocalizationKey"] = this.pageLocalizationKey;
        data["isChecked"] = this.isChecked;
        data["isDefault"] = this.isDefault;
        data["isDisable"] = this.isDisable;
        data["isAuthorizeWithoutSubPage"] = this.isAuthorizeWithoutSubPage;
        if (Array.isArray(this.subPageAuthorizationIds)) {
            data["subPageAuthorizationIds"] = [];
            for (let item of this.subPageAuthorizationIds)
                data["subPageAuthorizationIds"].push(item);
        }
        if (Array.isArray(this.subPageAuthorizations)) {
            data["subPageAuthorizations"] = [];
            for (let item of this.subPageAuthorizations)
                data["subPageAuthorizations"].push(item.toJSON());
        }
        return data;
    }

    clone(): PageAuthorizationDto {
        const json = this.toJSON();
        let result = new PageAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface IPageAuthorizationDto {
    pageId: number | undefined;
    pageName: string | undefined;
    pageUrl: string | undefined;
    pageLocalizationKey: string | undefined;
    isChecked: boolean | undefined;
    isDefault: boolean | undefined;
    isDisable: boolean | undefined;
    isAuthorizeWithoutSubPage: boolean | undefined;
    subPageAuthorizationIds: number[] | undefined;
    subPageAuthorizations: PageAuthorizationDto[] | undefined;
}

export class UserPagesDto implements IUserPagesDto {
    id: number | undefined;

    constructor(data?: IUserPagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserPagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): UserPagesDto {
        const json = this.toJSON();
        let result = new UserPagesDto();
        result.init(json);
        return result;
    }
}

export interface IUserPagesDto {
    id: number | undefined;
}

export class PagedResultDtoOfUserPagesDto implements IPagedResultDtoOfUserPagesDto {
    totalCount: number | undefined;
    items: UserPagesDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserPagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserPagesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserPagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserPagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserPagesDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserPagesDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserPagesDto {
    totalCount: number | undefined;
    items: UserPagesDto[] | undefined;
}

export class CreateUserPagesDto implements ICreateUserPagesDto {
    userId: number | undefined;
    assignedPages: UserSelectedPagesDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserPagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["assignedPages"])) {
                this.assignedPages = [] as any;
                for (let item of _data["assignedPages"])
                    this.assignedPages.push(UserSelectedPagesDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserPagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserPagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.assignedPages)) {
            data["assignedPages"] = [];
            for (let item of this.assignedPages)
                data["assignedPages"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): CreateUserPagesDto {
        const json = this.toJSON();
        let result = new CreateUserPagesDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserPagesDto {
    userId: number | undefined;
    assignedPages: UserSelectedPagesDto[] | undefined;
    id: number | undefined;
}

export class PagedUserPermissionAddressDto implements IPagedUserPermissionAddressDto {
    searchTerm: string | undefined;
    addresses: UserPermissionAddressDto[] | undefined;

    constructor(data?: IPagedUserPermissionAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses.push(UserPermissionAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedUserPermissionAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedUserPermissionAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedUserPermissionAddressDto {
        const json = this.toJSON();
        let result = new PagedUserPermissionAddressDto();
        result.init(json);
        return result;
    }
}

export interface IPagedUserPermissionAddressDto {
    searchTerm: string | undefined;
    addresses: UserPermissionAddressDto[] | undefined;
}

export class UserPermissionAddressDto implements IUserPermissionAddressDto {
    id: number | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    districtId: number | undefined;
    districtName: string | undefined;
    isSelected: boolean | undefined;

    constructor(data?: IUserPermissionAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fullAddress = _data["fullAddress"];
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
            this.districtId = _data["districtId"];
            this.districtName = _data["districtName"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): UserPermissionAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fullAddress"] = this.fullAddress;
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        data["districtId"] = this.districtId;
        data["districtName"] = this.districtName;
        data["isSelected"] = this.isSelected;
        return data;
    }

    clone(): UserPermissionAddressDto {
        const json = this.toJSON();
        let result = new UserPermissionAddressDto();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionAddressDto {
    id: number | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    districtId: number | undefined;
    districtName: string | undefined;
    isSelected: boolean | undefined;
}

export class ToRequestCityDto implements IToRequestCityDto {
    cityId: number | undefined;
    cityName: string | undefined;

    constructor(data?: IToRequestCityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
        }
    }

    static fromJS(data: any): ToRequestCityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ToRequestCityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        return data;
    }

    clone(): ToRequestCityDto {
        const json = this.toJSON();
        let result = new ToRequestCityDto();
        result.init(json);
        return result;
    }
}

export interface IToRequestCityDto {
    cityId: number | undefined;
    cityName: string | undefined;
}

export class UserPermissionCityDistrictDto implements IUserPermissionCityDistrictDto {
    cities: ToRequestCityDto[] | undefined;
    districts: ToRequestDistrictDto[] | undefined;

    constructor(data?: IUserPermissionCityDistrictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities.push(ToRequestCityDto.fromJS(item));
            }
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts.push(ToRequestDistrictDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPermissionCityDistrictDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionCityDistrictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserPermissionCityDistrictDto {
        const json = this.toJSON();
        let result = new UserPermissionCityDistrictDto();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionCityDistrictDto {
    cities: ToRequestCityDto[] | undefined;
    districts: ToRequestDistrictDto[] | undefined;
}

export class ToRequestDistrictDto implements IToRequestDistrictDto {
    districtId: number | undefined;
    districtName: string | undefined;
    cityId: number | undefined;

    constructor(data?: IToRequestDistrictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.districtId = _data["districtId"];
            this.districtName = _data["districtName"];
            this.cityId = _data["cityId"];
        }
    }

    static fromJS(data: any): ToRequestDistrictDto {
        data = typeof data === 'object' ? data : {};
        let result = new ToRequestDistrictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["districtId"] = this.districtId;
        data["districtName"] = this.districtName;
        data["cityId"] = this.cityId;
        return data;
    }

    clone(): ToRequestDistrictDto {
        const json = this.toJSON();
        let result = new ToRequestDistrictDto();
        result.init(json);
        return result;
    }
}

export interface IToRequestDistrictDto {
    districtId: number | undefined;
    districtName: string | undefined;
    cityId: number | undefined;
}

export class UserPermissionFormAuthorizationDto implements IUserPermissionFormAuthorizationDto {
    isOrderDamagedProduct: boolean | undefined;
    isOrderByExpirationDate: boolean | undefined;
    isOrderBySpecialCode: boolean | undefined;
    isOrderByBusinessUnit: boolean | undefined;

    constructor(data?: IUserPermissionFormAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOrderDamagedProduct = _data["isOrderDamagedProduct"];
            this.isOrderByExpirationDate = _data["isOrderByExpirationDate"];
            this.isOrderBySpecialCode = _data["isOrderBySpecialCode"];
            this.isOrderByBusinessUnit = _data["isOrderByBusinessUnit"];
        }
    }

    static fromJS(data: any): UserPermissionFormAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionFormAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOrderDamagedProduct"] = this.isOrderDamagedProduct;
        data["isOrderByExpirationDate"] = this.isOrderByExpirationDate;
        data["isOrderBySpecialCode"] = this.isOrderBySpecialCode;
        data["isOrderByBusinessUnit"] = this.isOrderByBusinessUnit;
        return data;
    }

    clone(): UserPermissionFormAuthorizationDto {
        const json = this.toJSON();
        let result = new UserPermissionFormAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionFormAuthorizationDto {
    isOrderDamagedProduct: boolean | undefined;
    isOrderByExpirationDate: boolean | undefined;
    isOrderBySpecialCode: boolean | undefined;
    isOrderByBusinessUnit: boolean | undefined;
}

export class UserOtherSettingsDto implements IUserOtherSettingsDto {
    userCustomerId: number | undefined;
    customerName: string | undefined;
    titleName: string | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    isOnlyWmsProducts: boolean | undefined;
    isSpecialCodeStockView: boolean | undefined;
    isRequestListStockView: boolean | undefined;
    isShowPalletQuantity: boolean | undefined;
    isShowTotalShipmentPrice: boolean | undefined;

    constructor(data?: IUserOtherSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCustomerId = _data["userCustomerId"];
            this.customerName = _data["customerName"];
            this.titleName = _data["titleName"];
            this.isStockView = _data["isStockView"];
            this.isProductLocationOrderHistoryView = _data["isProductLocationOrderHistoryView"];
            this.isOnlyWmsProducts = _data["isOnlyWmsProducts"];
            this.isSpecialCodeStockView = _data["isSpecialCodeStockView"];
            this.isRequestListStockView = _data["isRequestListStockView"];
            this.isShowPalletQuantity = _data["isShowPalletQuantity"];
            this.isShowTotalShipmentPrice = _data["isShowTotalShipmentPrice"];
        }
    }

    static fromJS(data: any): UserOtherSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOtherSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCustomerId"] = this.userCustomerId;
        data["customerName"] = this.customerName;
        data["titleName"] = this.titleName;
        data["isStockView"] = this.isStockView;
        data["isProductLocationOrderHistoryView"] = this.isProductLocationOrderHistoryView;
        data["isOnlyWmsProducts"] = this.isOnlyWmsProducts;
        data["isSpecialCodeStockView"] = this.isSpecialCodeStockView;
        data["isRequestListStockView"] = this.isRequestListStockView;
        data["isShowPalletQuantity"] = this.isShowPalletQuantity;
        data["isShowTotalShipmentPrice"] = this.isShowTotalShipmentPrice;
        return data;
    }

    clone(): UserOtherSettingsDto {
        const json = this.toJSON();
        let result = new UserOtherSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IUserOtherSettingsDto {
    userCustomerId: number | undefined;
    customerName: string | undefined;
    titleName: string | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    isOnlyWmsProducts: boolean | undefined;
    isSpecialCodeStockView: boolean | undefined;
    isRequestListStockView: boolean | undefined;
    isShowPalletQuantity: boolean | undefined;
    isShowTotalShipmentPrice: boolean | undefined;
}

export class PagedResultDtoOfUserProductAttributeDto implements IPagedResultDtoOfUserProductAttributeDto {
    totalCount: number | undefined;
    items: UserProductAttributeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserProductAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserProductAttributeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserProductAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserProductAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserProductAttributeDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserProductAttributeDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserProductAttributeDto {
    totalCount: number | undefined;
    items: UserProductAttributeDto[] | undefined;
}

export class UserProductAttributeDto implements IUserProductAttributeDto {
    name: string | undefined;
    attributeType: string | undefined;
    customerName: string | undefined;
    productAttributeId: number | undefined;
    id: number | undefined;

    constructor(data?: IUserProductAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.attributeType = _data["attributeType"];
            this.customerName = _data["customerName"];
            this.productAttributeId = _data["productAttributeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserProductAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProductAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["attributeType"] = this.attributeType;
        data["customerName"] = this.customerName;
        data["productAttributeId"] = this.productAttributeId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserProductAttributeDto {
        const json = this.toJSON();
        let result = new UserProductAttributeDto();
        result.init(json);
        return result;
    }
}

export interface IUserProductAttributeDto {
    name: string | undefined;
    attributeType: string | undefined;
    customerName: string | undefined;
    productAttributeId: number | undefined;
    id: number | undefined;
}

export class CreateUserProductAttributeDto implements ICreateUserProductAttributeDto {
    name: string | undefined;
    userId: number | undefined;
    productAttributeIds: number[] | undefined;
    authorizationId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserProductAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["productAttributeIds"])) {
                this.productAttributeIds = [] as any;
                for (let item of _data["productAttributeIds"])
                    this.productAttributeIds.push(item);
            }
            this.authorizationId = _data["authorizationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserProductAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserProductAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userId"] = this.userId;
        if (Array.isArray(this.productAttributeIds)) {
            data["productAttributeIds"] = [];
            for (let item of this.productAttributeIds)
                data["productAttributeIds"].push(item);
        }
        data["authorizationId"] = this.authorizationId;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateUserProductAttributeDto {
        const json = this.toJSON();
        let result = new CreateUserProductAttributeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserProductAttributeDto {
    name: string | undefined;
    userId: number | undefined;
    productAttributeIds: number[] | undefined;
    authorizationId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfUserReportDto implements IPagedResultDtoOfUserReportDto {
    totalCount: number | undefined;
    items: UserReportDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserReportDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserReportDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserReportDto {
    totalCount: number | undefined;
    items: UserReportDto[] | undefined;
}

export class UserReportDto implements IUserReportDto {
    reportId: number | undefined;
    reportName: string | undefined;
    reportTitle: string | undefined;
    reportSubTitle: string | undefined;
    reportDescription: string | undefined;
    reportButtonTitle: string | undefined;
    reportButtonColor: string | undefined;
    reportIconUrl: string | undefined;
    sortIndex: number | undefined;
    moduleId: number | undefined;
    dashboardNumber: number | undefined;
    dashboardNumberEN: number | undefined;
    isOpenNewScreen: boolean | undefined;
    isDynamicDesign: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUserReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportName = _data["reportName"];
            this.reportTitle = _data["reportTitle"];
            this.reportSubTitle = _data["reportSubTitle"];
            this.reportDescription = _data["reportDescription"];
            this.reportButtonTitle = _data["reportButtonTitle"];
            this.reportButtonColor = _data["reportButtonColor"];
            this.reportIconUrl = _data["reportIconUrl"];
            this.sortIndex = _data["sortIndex"];
            this.moduleId = _data["moduleId"];
            this.dashboardNumber = _data["dashboardNumber"];
            this.dashboardNumberEN = _data["dashboardNumberEN"];
            this.isOpenNewScreen = _data["isOpenNewScreen"];
            this.isDynamicDesign = _data["isDynamicDesign"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportName"] = this.reportName;
        data["reportTitle"] = this.reportTitle;
        data["reportSubTitle"] = this.reportSubTitle;
        data["reportDescription"] = this.reportDescription;
        data["reportButtonTitle"] = this.reportButtonTitle;
        data["reportButtonColor"] = this.reportButtonColor;
        data["reportIconUrl"] = this.reportIconUrl;
        data["sortIndex"] = this.sortIndex;
        data["moduleId"] = this.moduleId;
        data["dashboardNumber"] = this.dashboardNumber;
        data["dashboardNumberEN"] = this.dashboardNumberEN;
        data["isOpenNewScreen"] = this.isOpenNewScreen;
        data["isDynamicDesign"] = this.isDynamicDesign;
        data["id"] = this.id;
        return data;
    }

    clone(): UserReportDto {
        const json = this.toJSON();
        let result = new UserReportDto();
        result.init(json);
        return result;
    }
}

export interface IUserReportDto {
    reportId: number | undefined;
    reportName: string | undefined;
    reportTitle: string | undefined;
    reportSubTitle: string | undefined;
    reportDescription: string | undefined;
    reportButtonTitle: string | undefined;
    reportButtonColor: string | undefined;
    reportIconUrl: string | undefined;
    sortIndex: number | undefined;
    moduleId: number | undefined;
    dashboardNumber: number | undefined;
    dashboardNumberEN: number | undefined;
    isOpenNewScreen: boolean | undefined;
    isDynamicDesign: boolean | undefined;
    id: number | undefined;
}

export class CreateUserReportDto implements ICreateUserReportDto {
    name: string | undefined;
    userId: number | undefined;
    reportIds: number[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["reportIds"])) {
                this.reportIds = [] as any;
                for (let item of _data["reportIds"])
                    this.reportIds.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userId"] = this.userId;
        if (Array.isArray(this.reportIds)) {
            data["reportIds"] = [];
            for (let item of this.reportIds)
                data["reportIds"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): CreateUserReportDto {
        const json = this.toJSON();
        let result = new CreateUserReportDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserReportDto {
    name: string | undefined;
    userId: number | undefined;
    reportIds: number[] | undefined;
    id: number | undefined;
}

export class UserReportOpenNewScreenDto implements IUserReportOpenNewScreenDto {
    userReportId: number;
    isOpenNewScreen: boolean;

    constructor(data?: IUserReportOpenNewScreenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userReportId = _data["userReportId"];
            this.isOpenNewScreen = _data["isOpenNewScreen"];
        }
    }

    static fromJS(data: any): UserReportOpenNewScreenDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportOpenNewScreenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userReportId"] = this.userReportId;
        data["isOpenNewScreen"] = this.isOpenNewScreen;
        return data;
    }

    clone(): UserReportOpenNewScreenDto {
        const json = this.toJSON();
        let result = new UserReportOpenNewScreenDto();
        result.init(json);
        return result;
    }
}

export interface IUserReportOpenNewScreenDto {
    userReportId: number;
    isOpenNewScreen: boolean;
}

export class UserRoleDto implements IUserRoleDto {
    roleId: number | undefined;
    roleName: string | undefined;
    isChecked: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.isChecked = _data["isChecked"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["isChecked"] = this.isChecked;
        data["id"] = this.id;
        return data;
    }

    clone(): UserRoleDto {
        const json = this.toJSON();
        let result = new UserRoleDto();
        result.init(json);
        return result;
    }
}

export interface IUserRoleDto {
    roleId: number | undefined;
    roleName: string | undefined;
    isChecked: boolean | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfUserRoleDto implements IPagedResultDtoOfUserRoleDto {
    totalCount: number | undefined;
    items: UserRoleDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserRoleDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserRoleDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserRoleDto {
    totalCount: number | undefined;
    items: UserRoleDto[] | undefined;
}

export class CreateUserRoleDto implements ICreateUserRoleDto {
    id: number | undefined;

    constructor(data?: ICreateUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): CreateUserRoleDto {
        const json = this.toJSON();
        let result = new CreateUserRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserRoleDto {
    id: number | undefined;
}

export class CustomerWarehouseDto implements ICustomerWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    warehousePermissions: WarehousePermissionDto[] | undefined;
    isAuthorized: boolean | undefined;
    id: number | undefined;

    constructor(data?: ICustomerWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            if (Array.isArray(_data["warehousePermissions"])) {
                this.warehousePermissions = [] as any;
                for (let item of _data["warehousePermissions"])
                    this.warehousePermissions.push(WarehousePermissionDto.fromJS(item));
            }
            this.isAuthorized = _data["isAuthorized"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        if (Array.isArray(this.warehousePermissions)) {
            data["warehousePermissions"] = [];
            for (let item of this.warehousePermissions)
                data["warehousePermissions"].push(item.toJSON());
        }
        data["isAuthorized"] = this.isAuthorized;
        data["id"] = this.id;
        return data;
    }

    clone(): CustomerWarehouseDto {
        const json = this.toJSON();
        let result = new CustomerWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    warehousePermissions: WarehousePermissionDto[] | undefined;
    isAuthorized: boolean | undefined;
    id: number | undefined;
}

export class WarehousePermissionDto implements IWarehousePermissionDto {
    name: string | undefined;
    userFriendlyName: string | undefined;
    userFriendlyDescription: string | undefined;
    isSelected: boolean | undefined;
    id: number | undefined;

    constructor(data?: IWarehousePermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userFriendlyName = _data["userFriendlyName"];
            this.userFriendlyDescription = _data["userFriendlyDescription"];
            this.isSelected = _data["isSelected"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WarehousePermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehousePermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userFriendlyName"] = this.userFriendlyName;
        data["userFriendlyDescription"] = this.userFriendlyDescription;
        data["isSelected"] = this.isSelected;
        data["id"] = this.id;
        return data;
    }

    clone(): WarehousePermissionDto {
        const json = this.toJSON();
        let result = new WarehousePermissionDto();
        result.init(json);
        return result;
    }
}

export interface IWarehousePermissionDto {
    name: string | undefined;
    userFriendlyName: string | undefined;
    userFriendlyDescription: string | undefined;
    isSelected: boolean | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfUserWarehouseDto implements IPagedResultDtoOfUserWarehouseDto {
    totalCount: number | undefined;
    items: UserWarehouseDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserWarehouseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserWarehouseDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserWarehouseDto {
    totalCount: number | undefined;
    items: UserWarehouseDto[] | undefined;
}

export class UserWarehouseDto implements IUserWarehouseDto {
    name: string | undefined;
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    authorizationDescription: string | undefined;
    customerNamesText: string | undefined;
    id: number | undefined;

    constructor(data?: IUserWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.authorizationId = _data["authorizationId"];
            this.authorizationName = _data["authorizationName"];
            this.authorizationDescription = _data["authorizationDescription"];
            this.customerNamesText = _data["customerNamesText"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["authorizationId"] = this.authorizationId;
        data["authorizationName"] = this.authorizationName;
        data["authorizationDescription"] = this.authorizationDescription;
        data["customerNamesText"] = this.customerNamesText;
        data["id"] = this.id;
        return data;
    }

    clone(): UserWarehouseDto {
        const json = this.toJSON();
        let result = new UserWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IUserWarehouseDto {
    name: string | undefined;
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    authorizationDescription: string | undefined;
    customerNamesText: string | undefined;
    id: number | undefined;
}

export class CreateUserWarehouseDto implements ICreateUserWarehouseDto {
    name: string | undefined;
    userId: number | undefined;
    authorizationId: number | undefined;
    warehouseIds: number[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.authorizationId = _data["authorizationId"];
            if (Array.isArray(_data["warehouseIds"])) {
                this.warehouseIds = [] as any;
                for (let item of _data["warehouseIds"])
                    this.warehouseIds.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["authorizationId"] = this.authorizationId;
        if (Array.isArray(this.warehouseIds)) {
            data["warehouseIds"] = [];
            for (let item of this.warehouseIds)
                data["warehouseIds"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): CreateUserWarehouseDto {
        const json = this.toJSON();
        let result = new CreateUserWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserWarehouseDto {
    name: string | undefined;
    userId: number | undefined;
    authorizationId: number | undefined;
    warehouseIds: number[] | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfWarehouseDto implements IPagedResultDtoOfWarehouseDto {
    totalCount: number | undefined;
    items: WarehouseDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WarehouseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfWarehouseDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfWarehouseDto {
    totalCount: number | undefined;
    items: WarehouseDto[] | undefined;
}

export class WarehouseDto implements IWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    remoteWarehouseId: number | undefined;
    remoteWarehouseName: string | undefined;
    readonly customerWarehousesText: string | undefined;
    customerWarehouses: WarehouseCustomerDto[] | undefined;
    id: number | undefined;

    constructor(data?: IWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.remoteWarehouseId = _data["remoteWarehouseId"];
            this.remoteWarehouseName = _data["remoteWarehouseName"];
            (<any>this).customerWarehousesText = _data["customerWarehousesText"];
            if (Array.isArray(_data["customerWarehouses"])) {
                this.customerWarehouses = [] as any;
                for (let item of _data["customerWarehouses"])
                    this.customerWarehouses.push(WarehouseCustomerDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["type"] = this.type;
        data["remoteWarehouseId"] = this.remoteWarehouseId;
        data["remoteWarehouseName"] = this.remoteWarehouseName;
        data["customerWarehousesText"] = this.customerWarehousesText;
        if (Array.isArray(this.customerWarehouses)) {
            data["customerWarehouses"] = [];
            for (let item of this.customerWarehouses)
                data["customerWarehouses"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): WarehouseDto {
        const json = this.toJSON();
        let result = new WarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    remoteWarehouseId: number | undefined;
    remoteWarehouseName: string | undefined;
    customerWarehousesText: string | undefined;
    customerWarehouses: WarehouseCustomerDto[] | undefined;
    id: number | undefined;
}

export class WarehouseCustomerDto implements IWarehouseCustomerDto {
    customerId: number | undefined;
    customerName: string | undefined;

    constructor(data?: IWarehouseCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
        }
    }

    static fromJS(data: any): WarehouseCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        return data;
    }

    clone(): WarehouseCustomerDto {
        const json = this.toJSON();
        let result = new WarehouseCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseCustomerDto {
    customerId: number | undefined;
    customerName: string | undefined;
}

export class DependWarehouseDto implements IDependWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    id: number | undefined;

    constructor(data?: IDependWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DependWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DependWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }

    clone(): DependWarehouseDto {
        const json = this.toJSON();
        let result = new DependWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IDependWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    id: number | undefined;
}

export class UpdateWarehouseDto implements IUpdateWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    remoteWarehouseId: number | undefined;
    customerId: number | undefined;
    ownerId: number | undefined;
    id: number | undefined;

    constructor(data?: IUpdateWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.remoteWarehouseId = _data["remoteWarehouseId"];
            this.customerId = _data["customerId"];
            this.ownerId = _data["ownerId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["type"] = this.type;
        data["remoteWarehouseId"] = this.remoteWarehouseId;
        data["customerId"] = this.customerId;
        data["ownerId"] = this.ownerId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateWarehouseDto {
        const json = this.toJSON();
        let result = new UpdateWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    remoteWarehouseId: number | undefined;
    customerId: number | undefined;
    ownerId: number | undefined;
    id: number | undefined;
}

export class CreateWarehouseDto implements ICreateWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    comment: string | undefined;
    isRemote: boolean | undefined;
    addressId: number | undefined;
    dependWarehouseId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.comment = _data["comment"];
            this.isRemote = _data["isRemote"];
            this.addressId = _data["addressId"];
            this.dependWarehouseId = _data["dependWarehouseId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["type"] = this.type;
        data["comment"] = this.comment;
        data["isRemote"] = this.isRemote;
        data["addressId"] = this.addressId;
        data["dependWarehouseId"] = this.dependWarehouseId;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateWarehouseDto {
        const json = this.toJSON();
        let result = new CreateWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    comment: string | undefined;
    isRemote: boolean | undefined;
    addressId: number | undefined;
    dependWarehouseId: number | undefined;
    id: number | undefined;
}

export class ExcelPagedResultDtoOfWarehouseExcelDto implements IExcelPagedResultDtoOfWarehouseExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: WarehouseExcelDto[] | undefined;

    constructor(data?: IExcelPagedResultDtoOfWarehouseExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns.push(ExcelColumn.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WarehouseExcelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExcelPagedResultDtoOfWarehouseExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelPagedResultDtoOfWarehouseExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ExcelPagedResultDtoOfWarehouseExcelDto {
        const json = this.toJSON();
        let result = new ExcelPagedResultDtoOfWarehouseExcelDto();
        result.init(json);
        return result;
    }
}

export interface IExcelPagedResultDtoOfWarehouseExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: WarehouseExcelDto[] | undefined;
}

export class WarehouseExcelDto implements IWarehouseExcelDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    ownerId: number | undefined;
    customerId: number | undefined;
    comment: string | undefined;
    isDefault: boolean | undefined;
    isDepended: boolean | undefined;
    id: number | undefined;

    constructor(data?: IWarehouseExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.ownerId = _data["ownerId"];
            this.customerId = _data["customerId"];
            this.comment = _data["comment"];
            this.isDefault = _data["isDefault"];
            this.isDepended = _data["isDepended"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WarehouseExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["type"] = this.type;
        data["ownerId"] = this.ownerId;
        data["customerId"] = this.customerId;
        data["comment"] = this.comment;
        data["isDefault"] = this.isDefault;
        data["isDepended"] = this.isDepended;
        data["id"] = this.id;
        return data;
    }

    clone(): WarehouseExcelDto {
        const json = this.toJSON();
        let result = new WarehouseExcelDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseExcelDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    ownerId: number | undefined;
    customerId: number | undefined;
    comment: string | undefined;
    isDefault: boolean | undefined;
    isDepended: boolean | undefined;
    id: number | undefined;
}

export class WarehouseOwnerUserDto implements IWarehouseOwnerUserDto {
    userId: number | undefined;
    userName: string | undefined;
    isOwner: boolean | undefined;

    constructor(data?: IWarehouseOwnerUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.isOwner = _data["isOwner"];
        }
    }

    static fromJS(data: any): WarehouseOwnerUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOwnerUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["isOwner"] = this.isOwner;
        return data;
    }

    clone(): WarehouseOwnerUserDto {
        const json = this.toJSON();
        let result = new WarehouseOwnerUserDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseOwnerUserDto {
    userId: number | undefined;
    userName: string | undefined;
    isOwner: boolean | undefined;
}

export class PagedResultDtoOfWarehouseOwnerDto implements IPagedResultDtoOfWarehouseOwnerDto {
    totalCount: number | undefined;
    items: WarehouseOwnerDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWarehouseOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WarehouseOwnerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWarehouseOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWarehouseOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfWarehouseOwnerDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfWarehouseOwnerDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfWarehouseOwnerDto {
    totalCount: number | undefined;
    items: WarehouseOwnerDto[] | undefined;
}

export class WarehouseOwnerDto implements IWarehouseOwnerDto {
    ownerId: number | undefined;
    ownerName: string | undefined;
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    isOwner: boolean | undefined;
    id: number | undefined;

    constructor(data?: IWarehouseOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"];
            this.ownerName = _data["ownerName"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.isOwner = _data["isOwner"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WarehouseOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId;
        data["ownerName"] = this.ownerName;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["isOwner"] = this.isOwner;
        data["id"] = this.id;
        return data;
    }

    clone(): WarehouseOwnerDto {
        const json = this.toJSON();
        let result = new WarehouseOwnerDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseOwnerDto {
    ownerId: number | undefined;
    ownerName: string | undefined;
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    isOwner: boolean | undefined;
    id: number | undefined;
}

export class CreateWarehouseOwnerDto implements ICreateWarehouseOwnerDto {
    warehouseId: number | undefined;
    ownerId: number | undefined;
    customerId: number | undefined;
    isDefault: boolean | undefined;
    id: number | undefined;

    constructor(data?: ICreateWarehouseOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.ownerId = _data["ownerId"];
            this.customerId = _data["customerId"];
            this.isDefault = _data["isDefault"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateWarehouseOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWarehouseOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["ownerId"] = this.ownerId;
        data["customerId"] = this.customerId;
        data["isDefault"] = this.isDefault;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateWarehouseOwnerDto {
        const json = this.toJSON();
        let result = new CreateWarehouseOwnerDto();
        result.init(json);
        return result;
    }
}

export interface ICreateWarehouseOwnerDto {
    warehouseId: number | undefined;
    ownerId: number | undefined;
    customerId: number | undefined;
    isDefault: boolean | undefined;
    id: number | undefined;
}

export class UpdateWarehouseOwnerDto implements IUpdateWarehouseOwnerDto {
    warehouseId: number | undefined;
    ownerId: number | undefined;
    customerId: number | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUpdateWarehouseOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.ownerId = _data["ownerId"];
            this.customerId = _data["customerId"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateWarehouseOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWarehouseOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["ownerId"] = this.ownerId;
        data["customerId"] = this.customerId;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateWarehouseOwnerDto {
        const json = this.toJSON();
        let result = new UpdateWarehouseOwnerDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateWarehouseOwnerDto {
    warehouseId: number | undefined;
    ownerId: number | undefined;
    customerId: number | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    id: number | undefined;
}

export class GorevFormSonucuDto implements IGorevFormSonucuDto {
    name: string | undefined;
    personelAdi: string | undefined;
    projeAdi: string | undefined;

    constructor(data?: IGorevFormSonucuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.personelAdi = _data["personelAdi"];
            this.projeAdi = _data["projeAdi"];
        }
    }

    static fromJS(data: any): GorevFormSonucuDto {
        data = typeof data === 'object' ? data : {};
        let result = new GorevFormSonucuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["personelAdi"] = this.personelAdi;
        data["projeAdi"] = this.projeAdi;
        return data;
    }

    clone(): GorevFormSonucuDto {
        const json = this.toJSON();
        let result = new GorevFormSonucuDto();
        result.init(json);
        return result;
    }
}

export interface IGorevFormSonucuDto {
    name: string | undefined;
    personelAdi: string | undefined;
    projeAdi: string | undefined;
}

export enum Table {
    City = "City",
    Address = "Address",
    Warehouse = "Warehouse",
    ProductAttribute = "ProductAttribute",
}

export enum CategoryType {
    Undefined = "Undefined",
    Address_Category = "Address_Category",
    Order_ApprovalStatus = "Order_ApprovalStatus",
    Order_ShipmentType = "Order_ShipmentType",
    Order_Source = "Order_Source",
    Order_Type = "Order_Type",
    Order_SendType = "Order_SendType",
    Warehouse_Category = "Warehouse_Category",
}

export enum TaskType {
    Uretim_Gorevi = "Uretim_Gorevi",
    Tasarim_Gorevi = "Tasarim_Gorevi",
}

export enum UserUnvanType {
    Koordinator = "Koordinator",
    Spv = "Spv",
}

export enum DamageStatusType {
    Damage = "Damage",
    UnDamage = "UnDamage",
    Destruction = "Destruction",
}

export enum DamageStatusType2 {
    Damage = "Damage",
    UnDamage = "UnDamage",
    Destruction = "Destruction",
}

export enum ComponentType {
    None = "None",
    ToRequestWarehouse = "ToRequestWarehouse",
    ToRequestDistributor = "ToRequestDistributor",
    ToRequestSalesStaticLocation = "ToRequestSalesStaticLocation",
    FromReceiveMobileWarehouse = "FromReceiveMobileWarehouse",
    FromReceiveWarehouse = "FromReceiveWarehouse",
    AddAddressToPersonCategory = "AddAddressToPersonCategory",
    Transfer = "Transfer",
}

export enum DamageStatusType3 {
    Damage = "Damage",
    UnDamage = "UnDamage",
    Destruction = "Destruction",
}

export enum ComponentType2 {
    None = "None",
    ToRequestWarehouse = "ToRequestWarehouse",
    ToRequestDistributor = "ToRequestDistributor",
    ToRequestSalesStaticLocation = "ToRequestSalesStaticLocation",
    FromReceiveMobileWarehouse = "FromReceiveMobileWarehouse",
    FromReceiveWarehouse = "FromReceiveWarehouse",
    AddAddressToPersonCategory = "AddAddressToPersonCategory",
    Transfer = "Transfer",
}

export enum ComponentType3 {
    None = "None",
    ToRequestWarehouse = "ToRequestWarehouse",
    ToRequestDistributor = "ToRequestDistributor",
    ToRequestSalesStaticLocation = "ToRequestSalesStaticLocation",
    FromReceiveMobileWarehouse = "FromReceiveMobileWarehouse",
    FromReceiveWarehouse = "FromReceiveWarehouse",
    AddAddressToPersonCategory = "AddAddressToPersonCategory",
    Transfer = "Transfer",
}

export enum Anonymous {
    Devre_Disi = "Devre_Disi",
    Aktif = "Aktif",
}

export enum Anonymous2 {
    Pazartesi = "Pazartesi",
    Sali = "Sali",
    Carsamba = "Carsamba",
    Persembe = "Persembe",
    Cuma = "Cuma",
    Cumartesi = "Cumartesi",
    Pazar = "Pazar",
}

export enum Anonymous3 {
    Pasif = "Pasif",
    Aktif = "Aktif",
}

export enum Anonymous4 {
    Her_Gun = "Her_Gun",
    Her_Hafta = "Her_Hafta",
    Iki_Haftada_Bir = "Iki_Haftada_Bir",
    Her_Ay = "Her_Ay",
}

export enum IsTenantAvailableOutputState {
    Available = "Available",
    InActive = "InActive",
    NotFound = "NotFound",
}

export enum ResetPasswordRequestInputModule {
    Transpop_Web_Portal = "Transpop_Web_Portal",
    Platom_Portal = "Platom_Portal",
}

export enum DFMFormDtoFormTipi {
    Genel = "Genel",
    Proje = "Proje",
}

export enum CreateMasrafDtoMasrafTipi {
    Normal_Masraf = "Normal_Masraf",
    Is_Avansi = "Is_Avansi",
}

export enum MasrafKalemDtoKdvOrani {
    _0 = "_0",
    _1 = "_1",
    _8 = "_8",
    _18 = "_18",
}

export enum CreateSatinalmaTalepDtoSatinalmaTipi {
    Diger = "Diger",
    Arac_Bakim_Onarim = "Arac_Bakim_Onarim",
}

export enum CreateSatinalmaTalepDtoParaBirimi {
    TL = "TL",
    USD = "USD",
    EUR = "EUR",
}

export enum CreateSatinalmaTalepDtoVade {
    Vade_Yok = "Vade_Yok",
    _30_Gun = "_30_Gun",
    _60_Gun = "_60_Gun",
    _90_Gun = "_90_Gun",
    _120_Gun = "_120_Gun",
}

export enum SatinalmaTalepFaturaBilgiDtoTalepDurum {
    Acik = "Acik",
    Kapatildi = "Kapatildi",
    Muhasebelesti = "Muhasebelesti",
    Talep_Geri_Gonderildi = "Talep_Geri_Gonderildi",
    Iptal_Edildi = "Iptal_Edildi",
}

export enum ReportDataSourceDtoDbModule {
    Platom = "Platom",
    PlatomDwh = "PlatomDwh",
    Transpop = "Transpop",
    WmsNestle = "WmsNestle",
    WmsFerrero = "WmsFerrero",
    WmsPladis = "WmsPladis",
    WmsPg = "WmsPg",
    WmsUnilever = "WmsUnilever",
    WmsGsk = "WmsGsk",
    LogoBordro = "LogoBordro",
    LogoTiger = "LogoTiger",
    Corcial = "Corcial",
}

export enum CreateOrderDtoComponentType {
    None = "None",
    ToRequestWarehouse = "ToRequestWarehouse",
    ToRequestDistributor = "ToRequestDistributor",
    ToRequestSalesStaticLocation = "ToRequestSalesStaticLocation",
    FromReceiveMobileWarehouse = "FromReceiveMobileWarehouse",
    FromReceiveWarehouse = "FromReceiveWarehouse",
    AddAddressToPersonCategory = "AddAddressToPersonCategory",
    Transfer = "Transfer",
}

export enum CreateOrderDtoShipmentType {
    FromWarehouse = "FromWarehouse",
    Cargo = "Cargo",
    Ship = "Ship",
}

export enum CreateOrderDtoProductDamageStatusType {
    Damage = "Damage",
    UnDamage = "UnDamage",
    Destruction = "Destruction",
}

export enum OrderProductTaskDtoApprovedStatus {
    Emtpy = "Emtpy",
    WaitingForApproval = "WaitingForApproval",
    Waiting = "Waiting",
    Approved = "Approved",
    Reject = "Reject",
    Canceled = "Canceled",
    OverStock_Reject = "OverStock_Reject",
    Sent_To_Hangfire = "Sent_To_Hangfire",
    CAP_WarehouseApproved = "CAP_WarehouseApproved",
    CAP_CenterApproved = "CAP_CenterApproved",
    CAP_Waiting = "CAP_Waiting",
    CAP_RegionApproved = "CAP_RegionApproved",
    CAP_Canceled_OverStock = "CAP_Canceled_OverStock",
    CAP_InTransferLocation = "CAP_InTransferLocation",
    CAP_InTransfer = "CAP_InTransfer",
    CAP_ToPrepare = "CAP_ToPrepare",
    CAP_Prepared = "CAP_Prepared",
    CAP_Preparing = "CAP_Preparing",
    CAP_ToReturn = "CAP_ToReturn",
    CAP_AcceptanceOfGoods = "CAP_AcceptanceOfGoods",
    CAP_Approved = "CAP_Approved",
    CAP_RaftanIndirildi = "CAP_RaftanIndirildi",
    CAP_RaftanIndiriliyor = "CAP_RaftanIndiriliyor",
    CAP_OnShipment = "CAP_OnShipment",
    CAP_OrderCancellation = "CAP_OrderCancellation",
    CAP_Completed = "CAP_Completed",
    CAP_OrderNotReceived = "CAP_OrderNotReceived",
    CAP_OrderHasBeenTaken = "CAP_OrderHasBeenTaken",
    CAP_OrderTaking = "CAP_OrderTaking",
    CAP_Delivered = "CAP_Delivered",
    CAP_NotDelivered = "CAP_NotDelivered",
    CAP_Collected = "CAP_Collected",
    CAP_Cancelled = "CAP_Cancelled",
}

export enum OrderApprovalUserDtoApprovalStatusType {
    Emtpy = "Emtpy",
    WaitingForApproval = "WaitingForApproval",
    Waiting = "Waiting",
    Approved = "Approved",
    Reject = "Reject",
    Canceled = "Canceled",
    OverStock_Reject = "OverStock_Reject",
    Sent_To_Hangfire = "Sent_To_Hangfire",
    CAP_WarehouseApproved = "CAP_WarehouseApproved",
    CAP_CenterApproved = "CAP_CenterApproved",
    CAP_Waiting = "CAP_Waiting",
    CAP_RegionApproved = "CAP_RegionApproved",
    CAP_Canceled_OverStock = "CAP_Canceled_OverStock",
    CAP_InTransferLocation = "CAP_InTransferLocation",
    CAP_InTransfer = "CAP_InTransfer",
    CAP_ToPrepare = "CAP_ToPrepare",
    CAP_Prepared = "CAP_Prepared",
    CAP_Preparing = "CAP_Preparing",
    CAP_ToReturn = "CAP_ToReturn",
    CAP_AcceptanceOfGoods = "CAP_AcceptanceOfGoods",
    CAP_Approved = "CAP_Approved",
    CAP_RaftanIndirildi = "CAP_RaftanIndirildi",
    CAP_RaftanIndiriliyor = "CAP_RaftanIndiriliyor",
    CAP_OnShipment = "CAP_OnShipment",
    CAP_OrderCancellation = "CAP_OrderCancellation",
    CAP_Completed = "CAP_Completed",
    CAP_OrderNotReceived = "CAP_OrderNotReceived",
    CAP_OrderHasBeenTaken = "CAP_OrderHasBeenTaken",
    CAP_OrderTaking = "CAP_OrderTaking",
    CAP_Delivered = "CAP_Delivered",
    CAP_NotDelivered = "CAP_NotDelivered",
    CAP_Collected = "CAP_Collected",
    CAP_Cancelled = "CAP_Cancelled",
}

export enum OrderApprovedDtoStatus {
    None = "None",
    Approved_P = "Approved_P",
    NoStock_NT = "NoStock_NT",
    NoRelatedBigSizeProduct_NT = "NoRelatedBigSizeProduct_NT",
}

export enum GridFilterModalFilter_type {
    Esittir = "Esittir",
    Esitdegildir = "Esitdegildir",
    Icerir = "Icerir",
    Icermez = "Icermez",
    Null = "Null",
}

export enum GridFilterModalCondition {
    Ve = "Ve",
    Veya = "Veya",
    Null = "Null",
}

export enum CwfSmsInputEType {
    Personel = "Personel",
    Contact = "Contact",
}

export enum FirmaDurumu {
    PotansiyelFirma = "PotansiyelFirma",
    CalisilanMusteri = "CalisilanMusteri",
    PasifFirma = "PasifFirma",
}

export enum FirmaMusteriOrTedarikci {
    Musteri = "Musteri",
    Tedarikci = "Tedarikci",
    HerIkisi = "HerIkisi",
}

export enum ProjeLogoMasrafDonemi {
    Acik_Proje_Donemi = "Acik_Proje_Donemi",
    Fatura_Tarihi_Donemi = "fatura_Tarihi_Donemi",
}

export enum ProjeMasrafKodAyrimi {
    Merkez_Proje = "Merkez_Proje",
    Musteri_Proje = "Musteri_Proje",
}

export enum EnvanterSahiplikDurumu {
    Stokta = "Stokta",
    Projede = "Projede",
    Zimmette = "Zimmette",
    Servise_Verildi = "Servise_Verildi",
    Iade_Edildi = "Iade_Edildi",
    Kapatildi = "Kapatildi",
    Satildi = "Satildi",
    Hurdaya_Ayrildi = "Hurdaya_Ayrildi",
    Servisten_Geldi = "Servisten_Geldi",
}

export enum EnvanterAracCinsi {
    Otomobil = "Otomobil",
    Kamyon = "Kamyon",
    Kamyonet = "Kamyonet",
    Motosiklet = "Motosiklet",
}

export enum EnvanterYakitFirmasi {
    Shell = "Shell",
    Petrol_Ofisi = "Petrol_Ofisi",
    Opet = "Opet",
}

export enum EnvanterHatTipi {
    Ses_Hatti = "Ses_Hatti",
    Data_Hatti = "Data_Hatti",
    M2M_Hatti = "M2M_Hatti",
    SMS = "SMS",
    Ekip_Mobil = "Ekip_Mobil",
    Odeme = "Odeme",
    Bos = "Bos",
}

export enum EnvanterCihazRamBellek {
    _2_GB = "_2_GB",
    _4_GB = "_4_GB",
    _8_GB = "_8_GB",
    _16_GB = "_16_GB",
    _32_GB = "_32_GB",
    _64_GB = "_64_GB",
}

export enum EnvanterZimmetFormu {
    Yok = "Yok",
    Var = "Var",
    Ekom_da = "Ekom_da",
}

export enum EnvanterDurumu {
    Kira = "Kira",
    Ozmal = "Ozmal",
    Emanet = "Emanet",
    OzmalMusteride = "OzmalMusteride",
}

export enum PersonCinsiyet {
    Erkek = "Erkek",
    Kadin = "Kadin",
}

export enum PersonBugunkiGorevDurumu {
    Undefined = "Undefined",
    Bos = "Bos",
    Izinli = "Izinli",
    Su_Anda_Gorevde = "Su_Anda_Gorevde",
    Tum_Gorevleri_Tamamladi = "Tum_Gorevleri_Tamamladi",
}

export enum PersonCalismaDurumu {
    Henuz_Baslamadi_Ik_Surecinde = "Henuz_Baslamadi_Ik_Surecinde",
    Calisiyor = "Calisiyor",
    Ayrildi = "Ayrildi",
    Musteride_Calisiyor = "Musteride_Calisiyor",
    Aday = "Aday",
    Ayrilma_Surecinde = "Ayrilma_Surecinde",
}

export enum NormKadroKadroDurumu {
    Bos_Norm_Kadro = "Bos_Norm_Kadro",
    Dolu_Norm_Kadro = "Dolu_Norm_Kadro",
    Ise_Alim_Yapiliyor = "Ise_Alim_Yapiliyor",
    Pasife_Alindi = "Pasife_Alindi",
    Kadro_Kapatildi = "Kadro_Kapatildi",
}

export enum NormKadroKadroTipi {
    Belirli_Sureli_Engelli = "Belirli_Sureli_Engelli",
    Belirli_Sureli_Sezonluk = "Belirli_Sureli_Sezonluk",
    Belirsiz_Sureli_Engelli = "Belirsiz_Sureli_Engelli",
    Belirsiz_Sureli_Daimi = "Belirsiz_Sureli_Daimi",
    Kismi_Sureli_Engelli = "Kismi_Sureli_Engelli",
    Kismi_Sureli_Daimi = "Kismi_Sureli_Daimi",
    Belirli_Sureli_Daimi = "Belirli_Sureli_Daimi",
    Belirli_Sureli_Gecici = "Belirli_Sureli_Gecici",
}

export enum NormKadroPersonelMerkezDurumu {
    Merkez = "Merkez",
}

export enum PoiMusteriBugunkiZiyaretDurumu {
    Bos = "Bos",
    Ziyaret_Baslamadi = "Ziyaret_Baslamadi",
    Ziyaret_Basladi = "Ziyaret_Basladi",
    Ziyaret_Tamamlandi = "Ziyaret_Tamamlandi",
    Ziyaret_Yapilamadi = "Ziyaret_Yapilamadi",
}

export enum PoiMusteriMetreKare {
    _Kucuktur400 = "_Kucuktur400",
    _400ile1000Arasi = "_400ile1000Arasi",
    _1000ile2500Arasi = "_1000ile2500Arasi",
    _Buyuktur2500 = "_Buyuktur2500",
}

export enum MasrafKalemiOdemeTipi {
    Nakit = "Nakit",
    Kredi_Karti = "Kredi_Karti",
}

export enum MasrafKalemiKdvOrani {
    _0 = "_0",
    _1 = "_1",
    _8 = "_8",
    _18 = "_18",
}

export enum MasrafKalemiOnayDurumu {
    None = "None",
    Onaylandi = "Onaylandi",
    Reddedildi = "Reddedildi",
}

export enum SozlesmeYenilemeSekli {
    Otomatikyenilenir = "Otomatikyenilenir",
    Yenisozlesmeyaplmasgerekir = "Yenisozlesmeyaplmasgerekir",
}

export enum SozlesmeTipi {
    EkomGroupici = "EkomGroupici",
    MusteriSozlesmesi = "MusteriSozlesmesi",
    TedarikciSozlesmesi = "TedarikciSozlesmesi",
}

export enum SozlesmeDurumu {
    Kapali = "Kapali",
    Aktif = "Aktif",
}

export enum KontratDurumu {
    Acik = "Acik",
    Kapatildi = "Kapatildi",
}

export enum KontratKullanimAmaci {
    Ofis = "Ofis",
    Depo = "Depo",
    Sanal_Ofis = "Sanal_Ofis",
}

export enum IstenCikisGorevCikisTuru {
    Istifa = "Istifa",
    Tazminatli_Istifa = "Tazminatli_Istifa",
    Tazminatli_Cikis = "Tazminatli_Cikis",
    Tazminatsiz_Cikis = "Tazminatsiz_Cikis",
}

export enum IstenCikisGorevGorevDurum {
    _1TalebiolusturIKyagonder = "_1TalebiolusturIKyagonder",
    _2IKEvrakHazrlamaAsamasnda = "_2IKEvrakHazrlamaAsamasnda",
    _3EvraklarImzaiciniletildi = "_3EvraklarImzaiciniletildi",
    _4EvraklarImzalandveCRMeYuklendi = "_4EvraklarImzalandveCRMeYuklendi",
    _5IKCksOnaylad = "_5IKCksOnaylad",
    _9CksIslemiIptaledildi = "_9CksIslemiIptaledildi",
}

export enum IseAlimTalepTalepDurum {
    Ack = "Ack",
    Iptal = "Iptal",
    Kapatld = "Kapatld",
}

export enum IsGorusmesiGorusmeDurumu {
    _1Acik = "_1Acik",
    _2GorusmeAsamasinda = "_2GorusmeAsamasinda",
    _2IseAlimSurecinde = "_2IseAlimSurecinde",
    _3IKTanimlamaSurecinde = "_3IKTanimlamaSurecinde",
    _4Tamamlandi = "_4Tamamlandi",
    AdayGelmedi = "AdayGelmedi",
    AdayVazgecti = "AdayVazgecti",
    BaskaPozisyonlarIcinDegerlendirilebilir = "BaskaPozisyonlarIcinDegerlendirilebilir",
    GorusmeIptalEdildi = "GorusmeIptalEdildi",
    GorusmeTalebiAdayaIletildi = "GorusmeTalebiAdayaIletildi",
    IseAlimdanVazgecildi = "IseAlimdanVazgecildi",
    PozisyonicinUygunDegil = "PozisyonicinUygunDegil",
}

export enum IzinOnayGoreviOnayDurum {
    Onay_Bekliyor = "Onay_Bekliyor",
    Onaylandi = "Onaylandi",
    Reddedildi = "Reddedildi",
    Onaya_Gonderilecek = "Onaya_Gonderilecek",
    Baska_Onayci_Tarafindan_Degistirildi = "Baska_Onayci_Tarafindan_Degistirildi",
    Kadro_Bos = "Kadro_Bos",
    Onceki_Statulerden_Reddedildi = "Onceki_Statulerden_Reddedildi",
    Kendisi_Sildi = "Kendisi_Sildi",
}

export enum MasrafFormuMasrafTip {
    Normal = "Normal",
    Duzenli_Masraf = "Duzenli_Masraf",
}

export enum MasrafFormuOdemeTip {
    Nakit = "Nakit",
    Kredi_Karti = "Kredi_Karti",
}

export enum MasrafFormuOnayDurumu {
    Draft = "Draft",
    Onaya_Gonder = "Onaya_Gonder",
    Onaylandi = "Onaylandi",
    Reddedildi = "Reddedildi",
    Kendisi_Sildi = "Kendisi_Sildi",
}

export enum MasrafFormuIslemTip {
    Normal_Masraf = "Normal_Masraf",
    Is_Avansi = "Is_Avansi",
}

export enum IzinTalepTalepDurumu {
    Talep_Edildi = "Talep_Edildi",
    Onaylandi = "Onaylandi",
    Iptal_Edildi = "Iptal_Edildi",
    Kendisi_Sildi = "Kendisi_Sildi",
}

export enum IzinTalepIzinBaslangicAni {
    None = "None",
    Sabah = "Sabah",
    Ogleden_Sonra = "Ogleden_Sonra",
}

export enum IzinTalepIzinBitisAni {
    None = "None",
    Sabah = "Sabah",
    Ogleden_Sonra = "Ogleden_Sonra",
}

export enum IzinTalepImzaliForm {
    Bekleniyor = "Bekleniyor",
    Form_Geldi = "Form_Geldi",
}

export enum ProjeDonemiDurum {
    Acik = "Acik",
    Kapali = "Kapali",
}

export enum PosmProductionTaskDtoGorevTipi {
    Uretim_Gorevi = "Uretim_Gorevi",
    Tasarim_Gorevi = "Tasarim_Gorevi",
}

export enum PosmProductionTaskDtoDurum {
    Bekliyor = "Bekliyor",
    Devam_Ediyor = "Devam_Ediyor",
    Revize_Bekleniyor = "Revize_Bekleniyor",
    Tamamlandi = "Tamamlandi",
}

export enum CreateRutPlanDetayiDtoRutDetayDurumu {
    Devre_Disi = "Devre_Disi",
    Aktif = "Aktif",
}

export enum CreateRutPlanDetayiDtoCalismaGunu {
    Pazartesi = "Pazartesi",
    Sali = "Sali",
    Carsamba = "Carsamba",
    Persembe = "Persembe",
    Cuma = "Cuma",
    Cumartesi = "Cumartesi",
    Pazar = "Pazar",
}

export enum RutPlanDetayiDtoRutDetayDurum {
    Devre_Disi = "Devre_Disi",
    Aktif = "Aktif",
}

export enum RutPlanDetayiDtoCalismaGunu {
    Pazartesi = "Pazartesi",
    Sali = "Sali",
    Carsamba = "Carsamba",
    Persembe = "Persembe",
    Cuma = "Cuma",
    Cumartesi = "Cumartesi",
    Pazar = "Pazar",
}

export enum UpdateRutPlanDetayiDtoRutDetayDurumu {
    Devre_Disi = "Devre_Disi",
    Aktif = "Aktif",
}

export enum UpdateRutPlanDetayiDtoCalismaGunu {
    Pazartesi = "Pazartesi",
    Sali = "Sali",
    Carsamba = "Carsamba",
    Persembe = "Persembe",
    Cuma = "Cuma",
    Cumartesi = "Cumartesi",
    Pazar = "Pazar",
}

export enum CreateRutPlaniDtoRutPlanDurumu {
    Pasif = "Pasif",
    Aktif = "Aktif",
}

export enum CreateRutPlaniDtoRutFrekansi {
    Her_Gun = "Her_Gun",
    Her_Hafta = "Her_Hafta",
    Iki_Haftada_Bir = "Iki_Haftada_Bir",
    Her_Ay = "Her_Ay",
}

export enum RutPlaniDtoRutPlanDurumu {
    Pasif = "Pasif",
    Aktif = "Aktif",
}

export enum RutPlaniDtoRutFrekansi {
    Her_Gun = "Her_Gun",
    Her_Hafta = "Her_Hafta",
    Iki_Haftada_Bir = "Iki_Haftada_Bir",
    Her_Ay = "Her_Ay",
}

export enum UpdateRutPlaniDtoRutPlanDurumu {
    Pasif = "Pasif",
    Aktif = "Aktif",
}

export enum UpdateRutPlaniDtoRutFrekansi {
    Her_Gun = "Her_Gun",
    Her_Hafta = "Her_Hafta",
    Iki_Haftada_Bir = "Iki_Haftada_Bir",
    Her_Ay = "Her_Ay",
}

export enum TransportBidInfoDtoIhaleDurum {
    Acik = "Acik",
    Teklif_Vermesi_Bekleniyor = "Teklif_Vermesi_Bekleniyor",
    Teklif_Girisi_Yapildi = "Teklif_Girisi_Yapildi",
    Ilgilenmiyor = "Ilgilenmiyor",
    Teklif_Onaylandi = "Teklif_Onaylandi",
}

export enum UpdateTransportBidDtoTeklifDurum {
    Acik = "Acik",
    Teklif_Vermesi_Bekleniyor = "Teklif_Vermesi_Bekleniyor",
    Teklif_Girisi_Yapildi = "Teklif_Girisi_Yapildi",
    Ilgilenmiyor = "Ilgilenmiyor",
    Teklif_Onaylandi = "Teklif_Onaylandi",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}